import React, { useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";
import ReactPlayer from "react-player";
import YouTube from "react-youtube";
import LazyLoad from "react-lazy-load";
import Slider from "react-slick";
import OwlCarousel from "react-owl-carousel";
import LightGallery from 'lightgallery/react';
import lgZoom from 'lightgallery/plugins/zoom';
import MentorsProfile from "../partials/home/MentorsProfile";
import { useIsVisible } from "../hooks/useIsVisible";
import HiringOrganizations from "../partials/home/HiringOrganizations";
import CareerServices from "../partials/home/CareerServices";
import DropdownMenu from "../partials/home/DropdownMenu";
import SiteHeader from "../partials/home/SiteHeader";
import LearningLibrary from "../partials/home/LearningLibrary";
import TechInterviewBanner from "../partials/home/components/TechInterviewBanner";
import InteractiveReviews from "../partials/home/components/InteractiveReviews";
import XmasNewYearDiscount from "../partials/home/components/XmasNewYearDiscount";
import AICommunityCard from "../partials/home/components/AICommunityCard";
import {
  DiwaliBanner,
  DiwaliCardFee,
  DiwaliNote,
  Diya,
} from "../partials/home/components/DiwaliOffer";


/* ===================== AI / ML mentor showcase (Section 2) ===================== */
const aimlMentors = [
  {
    name: "Sourav Karmakar",
    role: "Senior AI Scientist @ Intuit",
    company: "Intuit",
    desc: "Senior AI Scientist at Intuit | Ex - Amazon | M. Tech (CS).",
    tags: ["AI/ML", "Data Science", "GenAI"],
    img: "/react/ai-assets/images//Mohammed-Shirhaan.jpeg",
    logo: "/react/ai-assets/images//intuit1.png",
    linkedin: "https://www.linkedin.com/in/sourav-karmakar-ds/",
    accent: "violet",
  },
  {
    name: "Nitin Nilesh",
    role: "Applied Scientist II @ Amazon Prime Video",
    company: "Amazon",
    desc: "Former Generative AI Tech Lead - Harman, Camera Modelling Research Engineer - Qualcomm India | Research Scholar at IIIT Hyderabad.",
    tags: ["Computer Vision", "DL", "ML", "IoT"],
    img: "/react/ai-assets/images//Aman.jpg",
    logo: "/react/ai-assets/images//amazonicon.png",
    linkedin: "https://www.linkedin.com/in/nitinnilesh/",
    accent: "indigo",
  },
  {
    name: "Ravi Singh",
    role: "AI Architect @ Amazon",
    company: "Amazon",
    desc: "Has led AI initiatives across Amazon & WalmartLabs. Specialises in agentic AI architectures and scalable ML platforms.",
    tags: ["Agentic AI", "AI Systems", "LLM"],
    img: "/react/ai-assets/images//mac/ravi-singh.jpg",
    logo: "/react/ai-assets/images//amazonicon.png",
    linkedin: "https://www.linkedin.com/in/ravi-singh-a430ab29/",
    accent: "blue",
  },
  {
    name: "Vishal Gupta",
    role: "LLM Systems Expert",
    company: "Walmart",
    desc: "Senior engineer teaching LLM systems & applied NLP. 100+ learners cracked top product companies under his guidance.",
    tags: ["LLM", "NLP", "GenAI"],
    img: "/react/ai-assets/images//mac/vishal.jpg",
    logo: "/react/ai-assets/images//walmarticon.png",
    linkedin: "https://www.linkedin.com/in/connect-vishal-gupta/",
    accent: "cyan",
  },
];

const aimlFacultyStyles = `
.aiml-demo-head{max-width:760px;margin:0 auto 8px;text-align:center;font-family:'Inter',-apple-system,BlinkMacSystemFont,'Segoe UI',Roboto,sans-serif;}
.aiml-demo-head__eyebrow{display:inline-block;font-size:12px;font-weight:700;letter-spacing:.16em;text-transform:uppercase;color:#7c3aed;background:linear-gradient(90deg,#ede9fe,#e0e7ff);border:1px solid #ddd6fe;padding:6px 14px;border-radius:999px;margin-bottom:14px;}
.aiml-demo-head__title{font-size:32px;line-height:1.2;font-weight:800;color:#0f172a;margin:0 0 12px;}
.aiml-demo-head__title b{background:linear-gradient(90deg,#7c3aed,#2563eb);-webkit-background-clip:text;background-clip:text;-webkit-text-fill-color:transparent;font-weight:800;}
.aiml-demo-head__sub{font-size:15.5px;line-height:1.65;color:#64748b;margin:0;}
@media(max-width:560px){.aiml-demo-head__title{font-size:24px;}}
.aiml-faculty{--v:#7c3aed;--i:#4f46e5;--b:#2563eb;--c:#06b6d4;max-width:1180px;margin:56px auto 0;padding:0 16px;font-family:'Inter',-apple-system,BlinkMacSystemFont,'Segoe UI',Roboto,sans-serif;text-align:center;}
.aiml-faculty *{box-sizing:border-box;}
.aiml-faculty__eyebrow{display:inline-block;font-size:12px;font-weight:700;letter-spacing:.14em;text-transform:uppercase;color:#7c3aed;margin-bottom:10px;}
.aiml-faculty__title{font-size:30px;font-weight:800;color:#0f172a;margin:0 0 8px;line-height:1.2;}
.aiml-faculty__sub{font-size:15px;color:#64748b;margin:0 auto 36px;max-width:620px;line-height:1.6;}
.aiml-faculty__grid{display:flex;gap:20px;overflow-x:auto;scroll-snap-type:x mandatory;-webkit-overflow-scrolling:touch;padding:6px 4px 22px;scrollbar-width:thin;scrollbar-color:#c4b5fd transparent;scroll-padding-left:4px;}
.aiml-faculty__grid::-webkit-scrollbar{height:8px;}
.aiml-faculty__grid::-webkit-scrollbar-track{background:#eef1fb;border-radius:999px;}
.aiml-faculty__grid::-webkit-scrollbar-thumb{background:linear-gradient(90deg,#a855f7,#6366f1);border-radius:999px;}
.aiml-fcard{position:relative;overflow:hidden;flex:0 0 300px;width:300px;scroll-snap-align:start;text-align:left;background:#fff;border:1px solid #e7eaf3;border-radius:20px;padding:24px 20px 20px;display:flex;flex-direction:column;box-shadow:0 10px 30px -18px rgba(37,55,120,.4);transition:transform .35s ease,box-shadow .35s ease,border-color .35s ease;}
.aiml-fcard:hover{transform:translateY(-8px);box-shadow:0 30px 50px -22px rgba(79,70,229,.5);border-color:#ddd6fe;}
.aiml-fcard__beam{position:absolute;top:0;left:0;right:0;height:4px;border-radius:20px 20px 0 0;background:linear-gradient(90deg,var(--v),var(--b));}
.aiml-fcard--violet .aiml-fcard__beam{background:linear-gradient(90deg,#7c3aed,#a855f7);}
.aiml-fcard--indigo .aiml-fcard__beam{background:linear-gradient(90deg,#4f46e5,#6366f1);}
.aiml-fcard--blue .aiml-fcard__beam{background:linear-gradient(90deg,#2563eb,#3b82f6);}
.aiml-fcard--cyan .aiml-fcard__beam{background:linear-gradient(90deg,#0891b2,#06b6d4);}
.aiml-fcard::after{content:"";position:absolute;width:160px;height:160px;border-radius:50%;right:-70px;top:-40px;background:radial-gradient(circle,rgba(124,58,237,.12),transparent 70%);pointer-events:none;transition:opacity .35s ease;opacity:0;}
.aiml-fcard:hover::after{opacity:1;}
.aiml-fcard__top{display:flex;align-items:center;gap:14px;margin-bottom:16px;}
.aiml-fcard__avatar{position:relative;width:64px;height:64px;flex-shrink:0;}
.aiml-fcard__avatar img{width:64px;height:64px;border-radius:50%;object-fit:cover;border:3px solid #fff;box-shadow:0 0 0 2px #e0e7ff;}
.aiml-fcard__initials{display:flex;align-items:center;justify-content:center;width:64px;height:64px;border-radius:50%;border:3px solid #fff;box-shadow:0 0 0 2px #e0e7ff;background:linear-gradient(135deg,#6d28d9,#2563eb);color:#fff;font-size:22px;font-weight:800;letter-spacing:.02em;}
.aiml-fcard__li{position:absolute;bottom:-2px;right:-2px;width:22px;height:22px;border-radius:7px;background:#0a66c2;color:#fff;display:flex;align-items:center;justify-content:center;border:2px solid #fff;transition:transform .2s ease;}
.aiml-fcard__li:hover{transform:scale(1.12);}
.aiml-fcard__id h4{font-size:17px;font-weight:800;color:#0f172a;margin:0 0 2px;}
.aiml-fcard__id p{font-size:13px;font-weight:600;color:#4f46e5;margin:0;}
.aiml-fcard__desc{font-size:13.5px;line-height:1.6;color:#475569;margin:0 0 16px;flex:1;}
.aiml-fcard__tags{display:flex;flex-wrap:wrap;gap:7px;margin-bottom:18px;}
.aiml-fcard__tag{font-size:11.5px;font-weight:600;color:#4338ca;background:linear-gradient(90deg,#eef2ff,#f5f3ff);border:1px solid #e0e7ff;padding:5px 10px;border-radius:999px;}
.aiml-fcard__foot{padding-top:14px;border-top:1px solid #f1f0f8;display:flex;align-items:center;}
.aiml-fcard__logo{height:26px;width:auto;object-fit:contain;filter:grayscale(15%);}
@media(max-width:560px){.aiml-fcard{flex:0 0 84%;width:84%;}.aiml-faculty__title{font-size:24px;}}
`;


/* ===================== AI career outcomes (Section 3) ===================== */
const aimlStats = [
  {
    num: "₹18–45 LPA",
    label: "Typical AI / ML / GenAI role salary range",
    icon: (
      <svg viewBox="0 0 24 24" width="26" height="26" fill="none" stroke="currentColor" strokeWidth="2"><path strokeLinecap="round" strokeLinejoin="round" d="M12 2v20M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6"/></svg>
    ),
  },
  {
    num: "120%+",
    label: "Salary growth potential moving into AI-focused roles",
    icon: (
      <svg viewBox="0 0 24 24" width="26" height="26" fill="none" stroke="currentColor" strokeWidth="2"><path strokeLinecap="round" strokeLinejoin="round" d="M3 17l6-6 4 4 8-8M21 7h-5M21 7v5"/></svg>
    ),
  },
  {
    num: "3x",
    label: "Increase in AI job openings across GenAI, LLM & Agentic AI",
    icon: (
      <svg viewBox="0 0 24 24" width="26" height="26" fill="none" stroke="currentColor" strokeWidth="2"><circle cx="12" cy="12" r="3"/><path strokeLinecap="round" strokeLinejoin="round" d="M12 2v3M12 19v3M2 12h3M19 12h3M5 5l2 2M17 17l2 2M19 5l-2 2M7 17l-2 2"/></svg>
    ),
  },
  {
    num: "Projects + Prep",
    label: "Hands-on AI projects & interview prep — the career-switch driver",
    icon: (
      <svg viewBox="0 0 24 24" width="26" height="26" fill="none" stroke="currentColor" strokeWidth="2"><rect x="3" y="4" width="18" height="14" rx="2"/><path strokeLinecap="round" strokeLinejoin="round" d="M8 9l2 2-2 2M13 13h3M9 21h6"/></svg>
    ),
  },
];

const aimlImpactStyles = `
.aiml-impact{position:relative;overflow:hidden;margin:64px 0 0;padding:64px 16px;background:linear-gradient(180deg,#f6f8ff 0%,#eef1fb 100%);font-family:'Inter',-apple-system,BlinkMacSystemFont,'Segoe UI',Roboto,sans-serif;}
.aiml-impact *{box-sizing:border-box;}
.aiml-impact__glow{position:absolute;border-radius:50%;filter:blur(90px);pointer-events:none;z-index:0;}
.aiml-impact__glow--l{width:340px;height:340px;background:rgba(124,58,237,.22);top:-100px;left:-80px;}
.aiml-impact__glow--r{width:360px;height:360px;background:rgba(6,182,212,.18);bottom:-120px;right:-80px;}
.aiml-impact__inner{position:relative;z-index:1;max-width:1180px;margin:0 auto;}
.aiml-impact__head{text-align:center;max-width:680px;margin:0 auto 40px;}
.aiml-impact__eyebrow{display:inline-block;font-size:12px;font-weight:700;letter-spacing:.16em;text-transform:uppercase;color:#7c3aed;background:#fff;border:1px solid #ddd6fe;padding:6px 14px;border-radius:999px;margin-bottom:14px;box-shadow:0 6px 16px -8px rgba(124,58,237,.4);}
.aiml-impact__title{font-size:32px;line-height:1.2;font-weight:800;color:#0f172a;margin:0 0 12px;}
.aiml-impact__title b{background:linear-gradient(90deg,#7c3aed,#2563eb,#06b6d4);-webkit-background-clip:text;background-clip:text;-webkit-text-fill-color:transparent;}
.aiml-impact__sub{font-size:15.5px;line-height:1.65;color:#64748b;margin:0;}
.aiml-impact__grid{display:grid;grid-template-columns:repeat(4,1fr);gap:20px;margin-bottom:32px;}
.aiml-stat{position:relative;overflow:hidden;background:rgba(255,255,255,.85);backdrop-filter:blur(8px);border:1px solid #e7eaf3;border-radius:20px;padding:26px 22px;text-align:left;box-shadow:0 12px 30px -20px rgba(37,55,120,.45);transition:transform .35s ease,box-shadow .35s ease,border-color .35s ease;}
.aiml-stat:hover{transform:translateY(-7px);box-shadow:0 26px 46px -22px rgba(79,70,229,.5);border-color:#c7d2fe;}
.aiml-stat__icon{width:52px;height:52px;border-radius:14px;display:flex;align-items:center;justify-content:center;color:#fff;margin-bottom:16px;background:linear-gradient(135deg,#7c3aed,#2563eb);box-shadow:0 10px 20px -8px rgba(79,70,229,.6);}
.aiml-stat:nth-child(2) .aiml-stat__icon{background:linear-gradient(135deg,#2563eb,#06b6d4);}
.aiml-stat:nth-child(3) .aiml-stat__icon{background:linear-gradient(135deg,#4f46e5,#7c3aed);}
.aiml-stat:nth-child(4) .aiml-stat__icon{background:linear-gradient(135deg,#0891b2,#2563eb);}
.aiml-stat__num{font-size:27px;font-weight:800;color:#0f172a;margin:0 0 6px;line-height:1.1;letter-spacing:-.01em;}
.aiml-stat__label{font-size:13.5px;line-height:1.5;color:#5b6577;margin:0;}
.aiml-impact__banner{display:flex;align-items:center;gap:16px;padding:22px 26px;border-radius:18px;color:#fff;background:linear-gradient(100deg,#4f46e5 0%,#7c3aed 55%,#2563eb 100%);box-shadow:0 24px 44px -22px rgba(79,70,229,.7);}
.aiml-impact__banner-icon{flex-shrink:0;width:46px;height:46px;border-radius:12px;display:flex;align-items:center;justify-content:center;background:rgba(255,255,255,.18);color:#fde68a;}
.aiml-impact__banner p{margin:0;font-size:16px;line-height:1.55;font-weight:500;color:rgba(255,255,255,.95);}
.aiml-impact__banner b{color:#fff;font-weight:800;}
@media(max-width:1024px){.aiml-impact__grid{grid-template-columns:repeat(2,1fr);}}
@media(max-width:560px){.aiml-impact__grid{grid-template-columns:1fr;}.aiml-impact__title{font-size:24px;}.aiml-impact__banner{flex-direction:column;text-align:center;}}
`;



const aimlProgramStyles = `
.aiml-pf{position:relative;overflow:hidden;margin:0;padding:72px 16px;background:linear-gradient(180deg,#f7f9ff 0%,#eef1fb 60%,#f4f6ff 100%);font-family:'Inter',-apple-system,BlinkMacSystemFont,'Segoe UI',Roboto,sans-serif;}
.aiml-pf *{box-sizing:border-box;}
.aiml-pf__bg{position:absolute;inset:0;z-index:0;pointer-events:none;background-image:linear-gradient(rgba(99,102,241,.06) 1px,transparent 1px),linear-gradient(90deg,rgba(99,102,241,.06) 1px,transparent 1px);background-size:46px 46px;-webkit-mask-image:radial-gradient(ellipse 80% 70% at 50% 25%,#000 35%,transparent 80%);mask-image:radial-gradient(ellipse 80% 70% at 50% 25%,#000 35%,transparent 80%);}
.aiml-pf__glow{position:absolute;border-radius:50%;filter:blur(95px);pointer-events:none;z-index:0;}
.aiml-pf__glow--l{width:360px;height:360px;background:rgba(124,58,237,.20);top:-110px;left:-90px;animation:aimlpfFloat 9s ease-in-out infinite;}
.aiml-pf__glow--r{width:380px;height:380px;background:rgba(6,182,212,.18);top:40%;right:-110px;animation:aimlpfFloat 11s ease-in-out infinite reverse;}
.aiml-pf__inner{position:relative;z-index:1;max-width:1200px;margin:0 auto;}
.aiml-pf__head{text-align:center;max-width:760px;margin:0 auto 44px;}
.aiml-pf__eyebrow{display:inline-flex;align-items:center;gap:8px;font-size:12px;font-weight:700;letter-spacing:.16em;text-transform:uppercase;color:#7c3aed;background:#fff;border:1px solid #ddd6fe;padding:7px 16px;border-radius:999px;margin-bottom:16px;box-shadow:0 6px 16px -8px rgba(124,58,237,.4);}
.aiml-pf__eyebrow i{width:7px;height:7px;border-radius:50%;background:linear-gradient(135deg,#7c3aed,#06b6d4);box-shadow:0 0 0 3px rgba(124,58,237,.15);animation:aimlpfPulse 2.4s ease-in-out infinite;}
.aiml-pf__title{font-size:34px;line-height:1.2;font-weight:800;color:#0f172a;margin:0 0 14px;letter-spacing:-.01em;}
.aiml-pf__title b{background:linear-gradient(90deg,#7c3aed,#2563eb,#06b6d4);-webkit-background-clip:text;background-clip:text;-webkit-text-fill-color:transparent;}
.aiml-pf__sub{font-size:16px;line-height:1.65;color:#5b6577;margin:0;}
.aiml-pf__layout{display:grid;grid-template-columns:1.55fr 1fr;gap:26px;align-items:stretch;}
.aiml-pf__cards{display:grid;grid-template-columns:repeat(2,1fr);gap:18px;}
.aiml-pf-card{position:relative;background:rgba(255,255,255,.82);backdrop-filter:blur(8px);border:1px solid #e7eaf3;border-radius:20px;padding:24px 22px;box-shadow:0 12px 30px -20px rgba(37,55,120,.45);transition:transform .35s ease,box-shadow .35s ease,border-color .35s ease;overflow:hidden;opacity:0;transform:translateY(22px);animation:aimlpfIn .7s cubic-bezier(.22,1,.36,1) forwards;}
.aiml-pf-card::before{content:"";position:absolute;inset:0;border-radius:20px;padding:1.5px;background:linear-gradient(135deg,#7c3aed,#2563eb,#06b6d4);-webkit-mask:linear-gradient(#fff 0 0) content-box,linear-gradient(#fff 0 0);-webkit-mask-composite:xor;mask-composite:exclude;opacity:0;transition:opacity .35s ease;pointer-events:none;}
.aiml-pf-card:hover{transform:translateY(-8px);box-shadow:0 28px 50px -22px rgba(79,70,229,.5);border-color:transparent;}
.aiml-pf-card:hover::before{opacity:1;}
.aiml-pf-card:nth-child(1){animation-delay:.05s;}
.aiml-pf-card:nth-child(2){animation-delay:.12s;}
.aiml-pf-card:nth-child(3){animation-delay:.19s;}
.aiml-pf-card:nth-child(4){animation-delay:.26s;}
.aiml-pf-card:nth-child(5){animation-delay:.33s;}
.aiml-pf-card:nth-child(6){animation-delay:.40s;}
.aiml-pf-card__icon{width:54px;height:54px;border-radius:15px;display:flex;align-items:center;justify-content:center;color:#fff;margin-bottom:16px;background:linear-gradient(135deg,#7c3aed,#2563eb);box-shadow:0 12px 22px -10px rgba(79,70,229,.65);transition:transform .4s ease;}
.aiml-pf-card:hover .aiml-pf-card__icon{transform:translateY(-3px) scale(1.05);animation:aimlpfBob 2.4s ease-in-out infinite;}
.aiml-pf-card:nth-child(2) .aiml-pf-card__icon{background:linear-gradient(135deg,#2563eb,#06b6d4);}
.aiml-pf-card:nth-child(3) .aiml-pf-card__icon{background:linear-gradient(135deg,#4f46e5,#7c3aed);}
.aiml-pf-card:nth-child(4) .aiml-pf-card__icon{background:linear-gradient(135deg,#0891b2,#4f46e5);}
.aiml-pf-card:nth-child(5) .aiml-pf-card__icon{background:linear-gradient(135deg,#7c3aed,#db2777);}
.aiml-pf-card:nth-child(6) .aiml-pf-card__icon{background:linear-gradient(135deg,#2563eb,#7c3aed);}
.aiml-pf-card__title{font-size:17px;font-weight:700;color:#0f172a;margin:0 0 8px;line-height:1.3;}
.aiml-pf-card__desc{font-size:13.5px;line-height:1.6;color:#5b6577;margin:0 0 14px;}
.aiml-pf-card__chip{display:inline-block;font-size:11px;font-weight:700;letter-spacing:.04em;color:#4f46e5;background:rgba(79,70,229,.08);border:1px solid rgba(79,70,229,.16);padding:4px 11px;border-radius:999px;}
.aiml-pf-cta{position:relative;overflow:hidden;border-radius:24px;padding:36px 30px;color:#fff;background:linear-gradient(155deg,#1e1b4b 0%,#312e81 45%,#4f46e5 100%);box-shadow:0 30px 60px -26px rgba(49,46,129,.9);display:flex;flex-direction:column;}
.aiml-pf-cta__net{position:absolute;inset:0;z-index:0;opacity:.5;}
.aiml-pf-cta__net path,.aiml-pf-cta__net line{stroke:rgba(125,211,252,.35);stroke-width:1;fill:none;stroke-dasharray:5 7;animation:aimlpfDash 7s linear infinite;}
.aiml-pf-cta__net circle{fill:rgba(125,211,252,.55);}
.aiml-pf-cta__orb{position:absolute;width:230px;height:230px;border-radius:50%;top:-70px;right:-70px;z-index:0;background:radial-gradient(circle at 35% 35%,rgba(56,189,248,.55),rgba(124,58,237,.35) 45%,transparent 70%);filter:blur(6px);animation:aimlpfGlow 5.5s ease-in-out infinite;}
.aiml-pf-cta__chips{position:relative;z-index:1;display:flex;flex-wrap:wrap;gap:8px;margin-bottom:18px;}
.aiml-pf-cta__chips span{font-size:11.5px;font-weight:700;letter-spacing:.05em;padding:5px 12px;border-radius:999px;background:rgba(255,255,255,.10);border:1px solid rgba(255,255,255,.22);color:#e0e7ff;backdrop-filter:blur(4px);}
.aiml-pf-cta__chips span:nth-child(odd){animation:aimlpfBob 4s ease-in-out infinite;}
.aiml-pf-cta__chips span:nth-child(even){animation:aimlpfBob 4.6s ease-in-out infinite .4s;}
.aiml-pf-cta__title{position:relative;z-index:1;font-size:25px;line-height:1.25;font-weight:800;margin:0 0 14px;}
.aiml-pf-cta__title b{background:linear-gradient(90deg,#7dd3fc,#a78bfa);-webkit-background-clip:text;background-clip:text;-webkit-text-fill-color:transparent;}
.aiml-pf-cta__text{position:relative;z-index:1;font-size:14.5px;line-height:1.6;color:rgba(224,231,255,.85);margin:0 0 22px;}
.aiml-pf-cta__list{position:relative;z-index:1;list-style:none;margin:0 0 26px;padding:0;display:flex;flex-direction:column;gap:12px;}
.aiml-pf-cta__list li{display:flex;align-items:center;gap:11px;font-size:14px;font-weight:600;color:#f1f5ff;}
.aiml-pf-cta__list li svg{flex-shrink:0;width:22px;height:22px;padding:4px;border-radius:7px;background:rgba(125,211,252,.18);color:#7dd3fc;}
.aiml-pf-cta__actions{position:relative;z-index:1;margin-top:auto;display:flex;flex-direction:column;gap:12px;}
.aiml-pf-cta__btn{position:relative;overflow:hidden;display:inline-flex;align-items:center;justify-content:center;gap:8px;text-decoration:none;font-size:15.5px;font-weight:700;padding:15px 22px;border-radius:13px;color:#fff;background:linear-gradient(100deg,#06b6d4,#7c3aed);box-shadow:0 16px 30px -12px rgba(124,58,237,.8);transition:transform .25s ease,box-shadow .25s ease;}
.aiml-pf-cta__btn:hover{transform:translateY(-2px);color:#fff;box-shadow:0 22px 38px -12px rgba(124,58,237,.9);}
.aiml-pf-cta__btn::after{content:"";position:absolute;top:0;left:-130%;width:60%;height:100%;background:linear-gradient(100deg,transparent,rgba(255,255,255,.45),transparent);transform:skewX(-20deg);transition:left .6s ease;}
.aiml-pf-cta__btn:hover::after{left:140%;}
.aiml-pf-cta__btn--ghost{background:transparent;border:1.5px solid rgba(255,255,255,.30);box-shadow:none;font-weight:600;}
.aiml-pf-cta__btn--ghost:hover{background:rgba(255,255,255,.08);box-shadow:none;}
@keyframes aimlpfIn{to{opacity:1;transform:translateY(0);}}
@keyframes aimlpfFloat{0%,100%{transform:translateY(0);}50%{transform:translateY(26px);}}
@keyframes aimlpfPulse{0%,100%{box-shadow:0 0 0 3px rgba(124,58,237,.15);}50%{box-shadow:0 0 0 6px rgba(124,58,237,.05);}}
@keyframes aimlpfBob{0%,100%{transform:translateY(0);}50%{transform:translateY(-5px);}}
@keyframes aimlpfGlow{0%,100%{opacity:.6;transform:scale(1);}50%{opacity:1;transform:scale(1.12);}}
@keyframes aimlpfDash{to{stroke-dashoffset:-120;}}
@media(max-width:991px){.aiml-pf__layout{grid-template-columns:1fr;}.aiml-pf-cta{margin-top:4px;}}
@media(max-width:600px){.aiml-pf{padding:54px 14px;}.aiml-pf__cards{grid-template-columns:1fr;}.aiml-pf__title{font-size:25px;}.aiml-pf__sub{font-size:14.5px;}.aiml-pf-cta{padding:30px 22px;}.aiml-pf-cta__title{font-size:22px;}.aiml-pf-cta__btn{width:100%;}}
@media(prefers-reduced-motion:reduce){.aiml-pf *{animation:none!important;}.aiml-pf-card{opacity:1;transform:none;}}
`;


const aimlFeeStyles = `
.aimlfee{position:relative;overflow:hidden;width:100%;float:left;padding:74px 16px;background:linear-gradient(180deg,#f7f9ff 0%,#eef1fb 55%,#f4f6ff 100%);font-family:'Inter',-apple-system,BlinkMacSystemFont,'Segoe UI',Roboto,sans-serif;}
.aimlfee *{box-sizing:border-box;}
.aimlfee__bg{position:absolute;inset:0;z-index:0;pointer-events:none;background-image:linear-gradient(rgba(99,102,241,.06) 1px,transparent 1px),linear-gradient(90deg,rgba(99,102,241,.06) 1px,transparent 1px);background-size:46px 46px;-webkit-mask-image:radial-gradient(ellipse 85% 60% at 50% 28%,#000 30%,transparent 80%);mask-image:radial-gradient(ellipse 85% 60% at 50% 28%,#000 30%,transparent 80%);}
.aimlfee__glow{position:absolute;border-radius:50%;filter:blur(95px);pointer-events:none;z-index:0;}
.aimlfee__glow--l{width:340px;height:340px;background:rgba(124,58,237,.18);top:-90px;left:-80px;animation:aimlfeeFloat 9s ease-in-out infinite;}
.aimlfee__glow--r{width:360px;height:360px;background:rgba(6,182,212,.16);bottom:-130px;right:-100px;animation:aimlfeeFloat 11s ease-in-out infinite reverse;}
.aimlfee__inner{position:relative;z-index:1;max-width:1200px;margin:0 auto;}
.aimlfee__head{text-align:center;max-width:840px;margin:0 auto 46px;}
.aimlfee__eyebrow{display:inline-flex;align-items:center;gap:8px;font-size:12px;font-weight:700;letter-spacing:.16em;text-transform:uppercase;color:#7c3aed;background:#fff;border:1px solid #ddd6fe;padding:7px 16px;border-radius:999px;margin-bottom:16px;box-shadow:0 6px 16px -8px rgba(124,58,237,.4);}
.aimlfee__eyebrow i{width:7px;height:7px;border-radius:50%;background:linear-gradient(135deg,#7c3aed,#06b6d4);box-shadow:0 0 0 3px rgba(124,58,237,.15);animation:aimlfeePulse 2.4s ease-in-out infinite;font-style:normal;}
.aimlfee__title{font-size:34px;line-height:1.22;font-weight:800;color:#0f172a;margin:0 0 14px;letter-spacing:-.01em;}
.aimlfee__title b{font-weight:800;background:linear-gradient(90deg,#7c3aed,#2563eb,#06b6d4);-webkit-background-clip:text;background-clip:text;-webkit-text-fill-color:transparent;}
.aimlfee__sub{font-size:16px;line-height:1.65;color:#5b6577;margin:0;}

.aimlfee__hero{display:grid;grid-template-columns:1.04fr 1fr;gap:26px;align-items:stretch;margin-bottom:26px;}

.aimlfee-price{position:relative;overflow:hidden;border-radius:24px;padding:36px 34px;color:#fff;background:linear-gradient(160deg,#1e1b4b 0%,#312e81 48%,#4f46e5 100%);box-shadow:0 30px 60px -26px rgba(49,46,129,.9);display:flex;flex-direction:column;opacity:0;transform:translateY(22px);animation:aimlfeeIn .7s cubic-bezier(.22,1,.36,1) .05s forwards;}
.aimlfee-price__net{position:absolute;inset:0;z-index:0;opacity:.5;}
.aimlfee-price__net line{stroke:rgba(125,211,252,.35);stroke-width:1;fill:none;stroke-dasharray:5 7;animation:aimlfeeDash 7s linear infinite;}
.aimlfee-price__net circle{fill:rgba(125,211,252,.55);}
.aimlfee-price__orb{position:absolute;width:230px;height:230px;border-radius:50%;top:-80px;right:-80px;z-index:0;background:radial-gradient(circle at 35% 35%,rgba(56,189,248,.55),rgba(124,58,237,.35) 45%,transparent 70%);filter:blur(6px);animation:aimlfeeGlow 5.5s ease-in-out infinite;}
.aimlfee-price__inner{position:relative;z-index:1;display:flex;flex-direction:column;height:100%;}
.aimlfee-price__top{display:flex;align-items:flex-start;justify-content:space-between;gap:14px;margin-bottom:16px;}
.aimlfee-price__label{font-size:12px;font-weight:700;letter-spacing:.14em;text-transform:uppercase;color:#a5b4fc;margin:0 0 4px;}
.aimlfee-price__name{font-size:22px;font-weight:800;line-height:1.25;margin:0;color:#fff;}
.aimlfee-price__badge{flex-shrink:0;display:inline-flex;align-items:center;gap:6px;font-size:12px;font-weight:800;letter-spacing:.03em;padding:7px 13px;border-radius:999px;color:#1e1b4b;background:linear-gradient(100deg,#fde68a,#fbbf24);box-shadow:0 0 0 0 rgba(251,191,36,.55);animation:aimlfeeBadge 2s ease-in-out infinite;}
.aimlfee-price__badge svg{width:13px;height:13px;}
.aimlfee-price__offerline{display:inline-flex;align-items:center;gap:8px;font-size:13px;font-weight:600;color:#e0e7ff;background:rgba(255,255,255,.10);border:1px solid rgba(255,255,255,.18);padding:7px 14px;border-radius:999px;margin:2px 0 22px;align-self:flex-start;}
.aimlfee-price__offerline b{color:#fde68a;font-weight:800;}
.aimlfee-price__amounts{display:flex;align-items:flex-end;gap:14px;flex-wrap:wrap;}
.aimlfee-price__orig{font-size:20px;font-weight:600;color:rgba(199,210,254,.7);text-decoration:line-through;text-decoration-color:rgba(248,113,113,.8);margin:0 0 8px;}
.aimlfee-price__now{font-size:50px;font-weight:800;line-height:1;letter-spacing:-.02em;color:#fff;margin:0;}
.aimlfee-price__save{display:inline-flex;align-items:center;gap:8px;margin:16px 0 22px;font-size:13.5px;font-weight:700;color:#a7f3d0;background:rgba(16,185,129,.14);border:1px solid rgba(16,185,129,.3);padding:9px 15px;border-radius:12px;align-self:flex-start;}
.aimlfee-price__save svg{width:16px;height:16px;flex-shrink:0;}
.aimlfee-price__chips{display:flex;flex-wrap:wrap;gap:9px;margin-top:auto;padding-top:6px;}
.aimlfee-price__chips span{font-size:11.5px;font-weight:700;letter-spacing:.03em;padding:6px 13px;border-radius:999px;background:rgba(255,255,255,.10);border:1px solid rgba(255,255,255,.22);color:#e0e7ff;backdrop-filter:blur(4px);}

.aimlfee-emi{position:relative;overflow:hidden;background:rgba(255,255,255,.85);backdrop-filter:blur(8px);border:1px solid #e7eaf3;border-radius:24px;padding:32px 30px;box-shadow:0 18px 40px -24px rgba(37,55,120,.55);display:flex;flex-direction:column;opacity:0;transform:translateY(22px);animation:aimlfeeIn .7s cubic-bezier(.22,1,.36,1) .14s forwards;}
.aimlfee-emi__head{display:flex;align-items:center;justify-content:space-between;gap:12px;margin-bottom:6px;}
.aimlfee-emi__title{font-size:19px;font-weight:800;color:#0f172a;margin:0;}
.aimlfee-emi__zero{flex-shrink:0;font-size:12px;font-weight:800;letter-spacing:.03em;color:#fff;padding:6px 13px;border-radius:999px;background:linear-gradient(100deg,#06b6d4,#7c3aed);box-shadow:0 8px 18px -8px rgba(124,58,237,.7);}
.aimlfee-emi__note{font-size:13.5px;line-height:1.55;color:#5b6577;margin:0 0 4px;}
.aimlfee-emi__options{display:grid;grid-template-columns:1fr 1fr;gap:14px;margin:16px 0 14px;}
.aimlfee-emi__opt{position:relative;border:1px solid #e4e8f2;border-radius:16px;padding:18px 14px;background:linear-gradient(165deg,#fbfcff,#eef2ff);text-align:center;transition:transform .3s ease,box-shadow .3s ease,border-color .3s ease;}
.aimlfee-emi__opt:hover{transform:translateY(-4px);border-color:#c7d2fe;box-shadow:0 18px 30px -18px rgba(79,70,229,.5);}
.aimlfee-emi__opt-term{font-size:11.5px;font-weight:700;text-transform:uppercase;letter-spacing:.07em;color:#7c3aed;}
.aimlfee-emi__opt-amt{font-size:25px;font-weight:800;color:#0f172a;margin:7px 0 0;line-height:1;}
.aimlfee-emi__opt-amt span{font-size:13px;font-weight:600;color:#64748b;}
.aimlfee-emi__trust{list-style:none;margin:6px 0 20px;padding:0;display:flex;flex-direction:column;gap:11px;}
.aimlfee-emi__trust li{display:flex;align-items:center;gap:11px;font-size:14px;font-weight:600;color:#334155;}
.aimlfee-emi__trust li svg{flex-shrink:0;width:24px;height:24px;padding:5px;border-radius:8px;color:#7c3aed;background:rgba(124,58,237,.10);}
.aimlfee-cta__row{display:flex;gap:12px;margin-top:auto;}
.aimlfee-cta__btn{position:relative;overflow:hidden;flex:1;display:inline-flex;align-items:center;justify-content:center;gap:8px;text-decoration:none;font-size:15px;font-weight:700;padding:15px 18px;border-radius:13px;color:#fff;background:linear-gradient(100deg,#06b6d4,#7c3aed);box-shadow:0 16px 30px -12px rgba(124,58,237,.75);transition:transform .25s ease,box-shadow .25s ease;animation:aimlfeeBtnGlow 3.2s ease-in-out infinite;}
.aimlfee-cta__btn:hover{transform:translateY(-2px);color:#fff;box-shadow:0 22px 40px -10px rgba(124,58,237,.95);}
.aimlfee-cta__btn::after{content:"";position:absolute;top:0;left:-130%;width:60%;height:100%;background:linear-gradient(100deg,transparent,rgba(255,255,255,.45),transparent);transform:skewX(-20deg);transition:left .6s ease;}
.aimlfee-cta__btn:hover::after{left:140%;}
.aimlfee-cta__btn--ghost{flex:0 0 auto;color:#4f46e5;background:#fff;border:1.5px solid #d6dcf5;box-shadow:none;animation:none;font-weight:700;}
.aimlfee-cta__btn--ghost:hover{background:#f5f3ff;color:#4f46e5;box-shadow:0 12px 24px -14px rgba(79,70,229,.5);}
.aimlfee-emi__finance{margin:18px 0 0;padding-top:16px;border-top:1px dashed #e2e8f0;}
.aimlfee-emi__finance p{font-size:11.5px;font-weight:600;letter-spacing:.04em;text-transform:uppercase;color:#94a3b8;margin:0 0 12px;}
.aimlfee-emi__finance ul{display:flex;flex-wrap:wrap;align-items:center;gap:22px;padding:0;margin:0;list-style:none;}
.aimlfee-emi__finance li{display:inline-flex;align-items:center;}
.aimlfee-emi__finance img{max-height:24px;width:auto;opacity:.62;filter:grayscale(35%);transition:opacity .3s ease,filter .3s ease;}
.aimlfee-emi__finance li:hover img{opacity:1;filter:grayscale(0);}

.aimlfee__cards{display:grid;grid-template-columns:1fr 1fr;gap:24px;margin-top:8px;}
.aimlfee-info{position:relative;overflow:hidden;background:rgba(255,255,255,.85);backdrop-filter:blur(8px);border:1px solid #e7eaf3;border-radius:22px;padding:30px 30px;box-shadow:0 14px 34px -22px rgba(37,55,120,.5);transition:transform .35s ease,box-shadow .35s ease,border-color .35s ease;opacity:0;transform:translateY(22px);animation:aimlfeeIn .7s cubic-bezier(.22,1,.36,1) .2s forwards;}
.aimlfee-info:nth-child(2){animation-delay:.27s;}
.aimlfee-info::before{content:"";position:absolute;inset:0;border-radius:22px;padding:1.5px;background:linear-gradient(135deg,#7c3aed,#2563eb,#06b6d4);-webkit-mask:linear-gradient(#fff 0 0) content-box,linear-gradient(#fff 0 0);-webkit-mask-composite:xor;mask-composite:exclude;opacity:0;transition:opacity .35s ease;pointer-events:none;}
.aimlfee-info:hover{transform:translateY(-6px);border-color:transparent;box-shadow:0 28px 50px -24px rgba(79,70,229,.5);}
.aimlfee-info:hover::before{opacity:1;}
.aimlfee-info__head{display:flex;align-items:center;gap:13px;margin-bottom:22px;}
.aimlfee-info__icon{flex-shrink:0;width:48px;height:48px;border-radius:13px;display:flex;align-items:center;justify-content:center;color:#fff;background:linear-gradient(135deg,#7c3aed,#2563eb);box-shadow:0 12px 22px -10px rgba(79,70,229,.65);}
.aimlfee-info:nth-child(2) .aimlfee-info__icon{background:linear-gradient(135deg,#2563eb,#06b6d4);}
.aimlfee-info__icon svg{width:24px;height:24px;}
.aimlfee-info__title{font-size:19px;font-weight:800;color:#0f172a;margin:0;line-height:1.25;}
.aimlfee-feat{list-style:none;margin:0;padding:0;display:flex;flex-direction:column;gap:15px;}
.aimlfee-feat li{display:flex;align-items:flex-start;gap:13px;font-size:14.5px;line-height:1.5;font-weight:500;color:#475569;}
.aimlfee-feat li b{color:#0f172a;font-weight:700;}
.aimlfee-feat__ic{flex-shrink:0;width:30px;height:30px;border-radius:9px;display:flex;align-items:center;justify-content:center;color:#7c3aed;background:rgba(124,58,237,.09);margin-top:1px;}
.aimlfee-feat__ic svg{width:16px;height:16px;}
.aimlfee-role__list{display:grid;grid-template-columns:1fr 1fr;gap:11px;}
.aimlfee-role__list span{display:flex;align-items:center;gap:9px;font-size:13.5px;font-weight:600;color:#334155;background:linear-gradient(165deg,#fbfcff,#eef2ff);border:1px solid #e4e8f2;padding:10px 13px;border-radius:11px;transition:transform .25s ease,border-color .25s ease,box-shadow .25s ease;}
.aimlfee-role__list span:hover{transform:translateY(-2px);border-color:#c7d2fe;box-shadow:0 12px 22px -16px rgba(79,70,229,.55);}
.aimlfee-role__list span svg{flex-shrink:0;width:16px;height:16px;color:#06b6d4;}
.aimlfee-role__note{margin:20px 0 0;font-size:13px;line-height:1.6;color:#64748b;border-left:3px solid #c4b5fd;padding-left:14px;}

@keyframes aimlfeeIn{to{opacity:1;transform:translateY(0);}}
@keyframes aimlfeeFloat{0%,100%{transform:translateY(0);}50%{transform:translateY(24px);}}
@keyframes aimlfeePulse{0%,100%{box-shadow:0 0 0 3px rgba(124,58,237,.15);}50%{box-shadow:0 0 0 6px rgba(124,58,237,.05);}}
@keyframes aimlfeeGlow{0%,100%{opacity:.6;transform:scale(1);}50%{opacity:1;transform:scale(1.12);}}
@keyframes aimlfeeDash{to{stroke-dashoffset:-120;}}
@keyframes aimlfeeBadge{0%,100%{box-shadow:0 0 0 0 rgba(251,191,36,.5);}50%{box-shadow:0 0 0 9px rgba(251,191,36,0);}}
@keyframes aimlfeeBtnGlow{0%,100%{box-shadow:0 16px 30px -14px rgba(124,58,237,.7);}50%{box-shadow:0 18px 42px -10px rgba(124,58,237,1);}}
@media(max-width:991px){.aimlfee__hero{grid-template-columns:1fr;}.aimlfee__cards{grid-template-columns:1fr;}}
@media(max-width:600px){.aimlfee{padding:54px 14px;}.aimlfee__title{font-size:25px;}.aimlfee__sub{font-size:14.5px;}.aimlfee-price{padding:30px 24px;}.aimlfee-price__now{font-size:42px;}.aimlfee-price__top{flex-direction:column;}.aimlfee-emi{padding:28px 22px;}.aimlfee-emi__options{grid-template-columns:1fr;}.aimlfee-cta__row{flex-direction:column;}.aimlfee-cta__btn{width:100%;flex:1 1 auto;}.aimlfee-role__list{grid-template-columns:1fr;}.aimlfee-info{padding:26px 22px;}}
@media(prefers-reduced-motion:reduce){.aimlfee *{animation:none!important;}.aimlfee-price,.aimlfee-emi,.aimlfee-info{opacity:1;transform:none;}}
`;



const aiMlCourseSyllabus = [
  {
    moduleNo: "Module 1",
    cardTitle: "Python Foundations",
    cardSubtitle: "Module 1",
    sectionTitle: "Module 1: Basic to Advanced Python",
    chapters: [
      {
        title: "Chapter 1: Python Deep Dive",
        topics: [
          "Working with numbers, booleans and strings",
          "String formatting and string operations",
          "Lists, tuples and dictionaries",
          "Indexing, slicing and matrix operations",
          "Built-in functions and methods",
          "Exercises on lists, tuples and dictionaries"
        ]
      },
      {
        title: "Chapter 2: Functions, Modules and Exception Handling",
        topics: [
          "Functions and reusable code blocks",
          "Python modules and packages",
          "Exception handling",
          "Regular expressions"
        ]
      },
      {
        title: "Chapter 3: NumPy for Machine Learning",
        topics: [
          "Introduction to NumPy",
          "Array creation and printing arrays",
          "Basic NumPy operations",
          "Indexing, slicing and iterating",
          "Shape manipulation",
          "Vector stacking and broadcasting",
          "Statistical operations using NumPy"
        ]
      },
      {
        title: "Chapter 4: Pandas for Data Analysis",
        topics: [
          "Introduction to Pandas",
          "Pandas DataFrames",
          "Indexing DataFrames",
          "Basic DataFrame operations",
          "Subsetting and filtering data",
          "Data analysis using Pandas"
        ]
      },
      {
        title: "Chapter 5: Data Visualization",
        topics: [
          "Matplotlib setup and configuration",
          "Plotting graphs using plot()",
          "Controlling line properties",
          "Subplots and multiple plots",
          "Working with multiple figures",
          "Introduction to Seaborn",
          "Visualizing statistical relationships",
          "Plotting categorical data",
          "Visualizing linear relationships",
          "Seaborn exercises"
        ]
      }
    ]
  },

  {
    moduleNo: "Module 2",
    cardTitle: "Math & Statistics",
    cardSubtitle: "Module 2",
    sectionTitle: "Module 2: Applied Statistics in Machine Learning",
    chapters: [
      {
        title: "Chapter 1: Fundamentals of Math and Probability",
        topics: [
          "Variables and random variables",
          "Population, sample and mean",
          "Population distribution and sample distribution",
          "Mean, median and mode",
          "Range, variance and measures of dispersion",
          "Probability density function"
        ]
      },
      {
        title: "Chapter 2: Probability Distributions",
        topics: [
          "Standard normal distribution",
          "Z-score and standard deviation",
          "Gaussian distribution",
          "Cumulative distribution function",
          "Central limit theorem",
          "Covariance",
          "Pearson correlation coefficient",
          "Spearman rank coefficient"
        ]
      },
      {
        title: "Chapter 3: Statistical Thinking",
        topics: [
          "Q-Q plot",
          "Skewness of data",
          "Discrete and continuous distributions",
          "Bernoulli and binomial distribution",
          "Log-normal distribution",
          "Box-Cox transformation",
          "Poisson distribution",
          "Application of non-Gaussian distribution"
        ]
      },
      {
        title: "Chapter 4: Hypothesis Testing and Projects",
        topics: [
          "Hypothesis testing",
          "Plotting statistical graphs",
          "Statistical analysis of health insurance pricing forecast",
          "Climate change impact on global food supply",
          "Statistical analysis of road accidents in India"
        ]
      }
    ]
  },

  {
    moduleNo: "Module 3",
    cardTitle: "Machine Learning",
    cardSubtitle: "Module 3",
    sectionTitle: "Module 3: Machine Learning",
    chapters: [
      {
        title: "Chapter 1: Machine Learning Introduction",
        topics: [
          "Introduction to Machine Learning",
          "Machine Learning vs traditional programming",
          "Supervised learning",
          "Unsupervised learning",
          "Model-based learning approach"
        ]
      },
      {
        title: "Chapter 2: Regression Algorithms",
        topics: [
          "Linear regression",
          "Ridge regression",
          "Lasso regression",
          "Logistic regression",
          "Support Vector Machine",
          "Regression fundamentals: data and models",
          "Feature selection in model building"
        ]
      },
      {
        title: "Chapter 3: Classification Algorithms",
        topics: [
          "Decision trees",
          "Naive Bayes",
          "Linear classifiers",
          "Decision boundaries",
          "K-Nearest Neighbours",
          "Random Forest",
          "Confusion matrix for multi-class classification"
        ]
      },
      {
        title: "Chapter 4: ML Model Evaluation",
        topics: [
          "Training and testing split",
          "Overfitting and underfitting",
          "Training and test curves",
          "Regression ML block diagram",
          "Model performance evaluation"
        ]
      },
      {
        title: "Chapter 5: Unsupervised Learning",
        topics: [
          "K-Means clustering",
          "Hierarchical clustering",
          "Mean-shift algorithm",
          "Principal Component Analysis",
          "Independent Component Analysis",
          "Dimensionality reduction using PCA"
        ]
      },
      {
        title: "Chapter 6: Association and Recommendation Systems",
        topics: [
          "Association rule learning",
          "FP-growth algorithm",
          "Collaborative filtering",
          "Co-occurrence matrices",
          "Matrix completion task",
          "Recommendation system ML block diagram"
        ]
      },
      {
        title: "Chapter 7: Machine Learning Projects",
        topics: [
          "House price prediction using regression",
          "Stock price prediction using linear regression",
          "Spam mail detector",
          "Car price prediction using PyTorch and SVC",
          "Wine quality prediction using logistic regression",
          "Loan approval prediction",
          "Credit card fraud detection",
          "Water quality evaluation using Random Forest",
          "Customer purchase prediction using Random Forest",
          "Music recommendation using K-Means clustering",
          "Twitter customer review topic modelling",
          "Banknote authenticity detection",
          "E-commerce product record linkage"
        ]
      }
    ]
  },

  {
    moduleNo: "Module 4",
    cardTitle: "Deep Learning",
    cardSubtitle: "Module 4",
    sectionTitle: "Module 4: Deep Learning Using TensorFlow",
    chapters: [
      {
        title: "Chapter 1: Deep Learning Foundations",
        topics: [
          "Deep Learning overview",
          "Machine Learning vs Deep Learning",
          "Artificial Neural Networks",
          "Deep Learning algorithms",
          "Introduction to TensorFlow"
        ]
      },
      {
        title: "Chapter 2: TensorFlow, Keras and PyTorch",
        topics: [
          "TensorFlow, Keras and PyTorch overview",
          "Installing TensorFlow",
          "Simple computations in TensorFlow",
          "Constants and variables",
          "TensorFlow file formats",
          "TensorFlow classification examples"
        ]
      },
      {
        title: "Chapter 3: Neural Network Architectures",
        topics: [
          "Artificial Neural Networks",
          "Recurrent Neural Networks",
          "Convolutional Neural Networks",
          "Autoencoders",
          "Boltzmann Machines"
        ]
      },
      {
        title: "Chapter 4: Computer Vision with OpenCV",
        topics: [
          "Computer Vision introduction",
          "OpenCV basics",
          "Reading, writing and displaying images",
          "HAAR Cascade Classifier",
          "Pedestrian detection using OpenCV",
          "Face recognition using OpenCV"
        ]
      },
      {
        title: "Chapter 5: Deep Learning Projects",
        topics: [
          "Speech recognition with Deep Learning",
          "Human face identification model",
          "Music genre classification",
          "Image classification using CIFAR dataset",
          "Chatbot learning human-to-human dialogue",
          "Pedestrian detection using OpenCV"
        ]
      }
    ]
  },

  {
    moduleNo: "Module 5",
    cardTitle: "Generative AI",
    cardSubtitle: "Module 5",
    sectionTitle: "Module 5: Generative AI, LLMs and RAG",
    chapters: [
      {
        title: "Chapter 1: Introduction to Generative AI",
        topics: [
          "Introduction to Generative AI",
          "Discriminative vs generative models",
          "Types of generative models",
          "Autoregressive models",
          "Autoencoding models",
          "GANs",
          "Diffusion models"
        ]
      },
      {
        title: "Chapter 2: Large Language Models",
        topics: [
          "Large Language Models overview",
          "GPT-2, GPT-3 and GPT-4 overview",
          "Transformer architecture",
          "Decoder-only GPT models",
          "Encoder-decoder models like T5",
          "BERT and XLNet",
          "Pretraining, fine-tuning and instruction tuning"
        ]
      },
      {
        title: "Chapter 3: Prompt Engineering and Alignment",
        topics: [
          "Prompt engineering basics",
          "Learning from human feedback",
          "RLHF",
          "Content generation use cases",
          "LLM evaluation basics"
        ]
      },
      {
        title: "Chapter 4: Hugging Face and OpenAI APIs",
        topics: [
          "Hugging Face Transformers",
          "Hugging Face Datasets",
          "OpenAI APIs",
          "GPT API usage",
          "DALL·E for image generation",
          "Whisper for speech processing"
        ]
      },
      {
        title: "Chapter 5: Advanced GenAI and Multimodal AI",
        topics: [
          "Stable Diffusion text-to-image pipeline",
          "DALL·E 2 and Midjourney overview",
          "BLIP for image-to-text",
          "Bark for text-to-audio",
          "RunwayML and Sora for video synthesis",
          "GAN types: DCGAN, StyleGAN and CycleGAN",
          "Evaluation metrics: FID and Inception Score"
        ]
      },
      {
        title: "Chapter 6: Fine-Tuning and RAG",
        topics: [
          "Fine-tuning with LoRA",
          "PEFT techniques",
          "RAG-based chatbot",
          "Memory-based document Q&A",
          "Building GenAI apps using LLMs"
        ]
      },
      {
        title: "Chapter 7: Generative AI Projects",
        topics: [
          "AI story generator using GPT",
          "Personalized meme generator",
          "Music or voice style transfer",
          "RAG chatbot with memory and document Q&A",
          "AI video generator from script using DALL·E, TTS and Synthesia"
        ]
      }
    ]
  },

  {
    moduleNo: "Module 6",
    cardTitle: "Agentic AI",
    cardSubtitle: "Module 6",
    sectionTitle: "Module 6: Agentic AI and Multi-Agent Systems",
    chapters: [
      {
        title: "Chapter 1: Agentic AI Foundations",
        topics: [
          "Introduction to Agentic AI",
          "Autonomous agents",
          "Planning, memory and tool usage",
          "Multi-agent architecture",
          "Agent workflow design"
        ]
      },
      {
        title: "Chapter 2: LangChain Agents",
        topics: [
          "LangChain agents",
          "Tools and chains",
          "Agent memory",
          "Tool calling",
          "Building agentic workflows"
        ]
      },
      {
        title: "Chapter 3: AutoGPT and BabyAGI",
        topics: [
          "AutoGPT goals and planning",
          "Memory and task queues",
          "BabyAGI task prioritization",
          "Agent execution loop",
          "Autonomous productivity workflows"
        ]
      },
      {
        title: "Chapter 4: CrewAI and LangGraph",
        topics: [
          "CrewAI role-based collaboration",
          "Multi-agent task delegation",
          "OpenAgents overview",
          "LangGraph for complex multi-agent flows",
          "Building stateful agent systems"
        ]
      },
      {
        title: "Chapter 5: Agentic AI Projects",
        topics: [
          "Multi-agent research assistant with debate mode",
          "Legal document review bot with multi-step reasoning",
          "Autonomous financial analyst",
          "AI health intake and triage assistant",
          "AutoGPT-based productivity assistant"
        ]
      }
    ]
  }
];

// "What you'll learn" tabs, built from the Generative AI and Agentic AI syllabus modules above.
const learnTracks = [
  { key: "genai", label: "Generative AI", module: aiMlCourseSyllabus.find((m) => m.cardTitle === "Generative AI") },
  { key: "agentic", label: "Agentic AI", module: aiMlCourseSyllabus.find((m) => m.cardTitle === "Agentic AI") },
];

const Home = () => {
  const [learnTab, setLearnTab] = useState("genai");
  const [countdownText, setCountdownText] = useState("");
  const [showCourses, setShowCourses] = useState(false);
  const [flippedCard, setFlippedCard] = useState(null);

  const handleCardFlip = (index) => {
    setFlippedCard(flippedCard === index ? null : index);
  };
  const mentorSection = useRef();
  const isVisibleMentor = useIsVisible(mentorSection);

  const overviewSection = useRef();
  const isVisibleOverview = useIsVisible(overviewSection);

  // Once the live-program cards have animated into view, keep them revealed.
  // The IntersectionObserver flips back to false when the (tall, on mobile)
  // section scrolls out of view, which otherwise re-hides the cards.
  const [hasRevealedOverview, setHasRevealedOverview] = useState(false);
  useEffect(() => {
    if (isVisibleOverview) setHasRevealedOverview(true);
  }, [isVisibleOverview]);

  const overCourses = useRef();
  const isVisibleCourses = useIsVisible(overCourses);

  const overDemoClasses = useRef();
  const isVisibleDemo = useIsVisible(overDemoClasses);

  const overSyllabus = useRef();
  const isVisibleSyllabus = useIsVisible(overSyllabus);

  const overCurriculum = useRef();
  const isVisibleCurriculum = useIsVisible(overCurriculum);

  const overContacts = useRef();
  const isVisibleContact = useIsVisible(overContacts);

  const overFee = useRef();
  const isVisibleFee = useIsVisible(overFee);

  const overReview = useRef();
  const isVisibleReview = useIsVisible(overReview);

  const navRef = useRef(null);
  const navRef2 = useRef(null);


  const settings = {
    arrows: false,
    dots: true,
    infinite: false,
    speed: 250,
    slidesToShow: 1,
    slidesToScroll: 1,
  };
  const settings2 = {
    arrows: true,
    swipe: false,
    dots: false,
    infinite: false,
    speed: 250,
    slidesToShow: 1,
    slidesToScroll: 1,
  };
  const syllabusSlideshowContainerRef = useRef(null);

  useEffect(() => {
    const syllabusSlideshowContainer = syllabusSlideshowContainerRef.current;

    

    const toggleSyllabusButtonsVisibility = (entries) => {
      const leftBtn = document.querySelectorAll(
        "#syllabus-slides-container .slick-arrow.slick-prev"
      )[0];
      const rightBtn = document.querySelectorAll(
        "#syllabus-slides-container .slick-arrow.slick-next"
      )[0];

      const isVisible = entries[0].isIntersecting;

      syllabusSlideshowContainer.classList.toggle("show-buttons", isVisible);

      if (leftBtn) leftBtn.style.display = isVisible ? "inline-block" : "none";
      if (rightBtn) rightBtn.style.display = isVisible ? "inline-block" : "none";
    };

    const isSmallScreen = window.innerWidth < 767;

    if (isSmallScreen) {
      const syllabusContainerHeight = syllabusSlideshowContainer.clientHeight;
      const syllabusThreshold = 500 / syllabusContainerHeight;



      const options = {
        threshold: [syllabusThreshold],
      };

      if (syllabusThreshold <= 0.5) {
        const syllabusObserver = new IntersectionObserver(
          toggleSyllabusButtonsVisibility,
          options
        );
        syllabusObserver.observe(syllabusSlideshowContainer);
      } else {
        console.error("Syllabus threshold exceeds 1. Please adjust the value.");
      }
    }

    return () => {
      const syllabusObserver = new IntersectionObserver(
        toggleSyllabusButtonsVisibility
      );
      syllabusObserver.unobserve(syllabusSlideshowContainer);
    };
    
  
 
 
},
  []);

  useEffect(() => {
    const activeItem = document.querySelector('.scrollble-tab-li.active');
    if (activeItem) {
      const list = document.getElementById('scrollble-ul-page');
      const scrollLeft = activeItem.offsetLeft - (list.offsetWidth / 2) + (activeItem.offsetWidth / 2);
      setTimeout(() => {
        list.scrollLeft = scrollLeft;
      }, 750)
      
    }
  }, [
    isVisibleOverview, isVisibleCourses, isVisibleDemo, isVisibleSyllabus,isVisibleCurriculum, isVisibleFee, isVisibleReview, isVisibleContact])



  return (
    <div>
      {/* Site header for all viewports (replaces the banner navbar and the legacy navbars).
          Kept first so its spacer reserves room for the fixed bar at the top of the page. */}
      <SiteHeader />

      {/* Diwali Special Offer: flat 20% OFF banner directly below the navigation */}
      <DiwaliBanner />

      <TechInterviewBanner />

      {/* Batch Announcement Banner: GenAI & Agentic AI */}
      <div className="bab_strip bab_strip_genai">
        <div className="bab_glow_top"></div>
        <div className="bab_glow_bot"></div>
        <div className="bab_genai_grid"></div>
        <div className="bab_inner">
          <div className="bab_left">
            <div className="bab_live_badge">
              <span className="bab_pulse_dot"></span>
              New Batch Announced
            </div>
            <h3 className="bab_heading">
              Batch for <span className="bab_highlight">LogicMojo GenAI & Agentic AI Course</span> Live Classes
            </h3>
            <p className="bab_sub">Master Generative AI, RAG, LLMs, AI Agents & Multi-Agent Systems with hands-on live weekend classes</p>
            <div className="bab_spec">
              <div className="bab_spec_cell">
                <span className="bab_spec_label"><i className="fa fa-clock-o"></i> Duration</span>
                <span className="bab_spec_value">4 Months</span>
                <span className="bab_spec_note">Weekend Classes</span>
              </div>
              <div className="bab_spec_cell bab_spec_goal">
                <span className="bab_spec_label"><i className="fa fa-bullseye"></i> Goal</span>
                <div className="bab_spec_tags">
                  <span>Agentic AI Engineer</span>
                  <span>Gen AI Engineer</span>
                  <span>AI Agent Developer</span>
                </div>
              </div>
            </div>
          </div>
          <div className="bab_right">
            <div className="bab_date_card">
              <span className="bab_date_label">Starts On</span>
              <span className="bab_date_value">14th Nov</span>
              <span className="bab_date_detail"><i className="fa fa-calendar"></i> Weekend Live Classes</span>
            </div>
            <a
              href="https://api.whatsapp.com/send?phone=+918088975867&text=Hi%20Logicmojo"
              className="bab_cta"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img
                src="/react/ai-assets/images//whatsapplogo.png"
                width="30"
                alt="Chat on WhatsApp"
              />
            </a>
          </div>
        </div>
      </div>

      {/* Batch Announcement Banner: AI & ML */}
       <div className="bab_strip bab_strip_ai">
        <div className="bab_glow_top"></div>
        <div className="bab_glow_bot"></div>
        <div className="bab_bg_orbs"><span></span><span></span><span></span><span></span></div>
        <div className="bab_inner">
          <div className="bab_left">
            <div className="bab_live_badge">
              <span className="bab_pulse_dot"></span>
              New Batch Announced
            </div>
            <h3 className="bab_heading">
              Batch for <span className="bab_highlight">LogicMojo AI & ML Course</span> Live Classes
            </h3>
            <p className="bab_sub">Master Machine Learning, Deep Learning, NLP, Generative AI & AgenticAI with hands-on live weekend classes</p>
            <div className="bab_meta">
              <div className="bab_meta_row">
                <span className="bab_meta_label"><i className="fa fa-clock-o"></i> Duration</span>
                <span className="bab_meta_value">7 Months <em>Weekend Classes</em></span>
              </div>
              <div className="bab_meta_row">
                <span className="bab_meta_label"><i className="fa fa-bullseye"></i> Goal</span>
                <div className="bab_chips">
                  <span className="bab_chip">AI Engineer</span>
                  <span className="bab_chip">AI Research Scientist</span>
                  <span className="bab_chip">Data Scientist</span>
                  <span className="bab_chip">ML Engineer</span>
                </div>
              </div>
            </div>
          </div>
          <div className="bab_right">
            <div className="bab_date_card">
              <span className="bab_date_label">Starts On</span>
              <span className="bab_date_value">14th Nov</span>
              <span className="bab_date_detail"><i className="fa fa-clock-o"></i> Weekend 9 AM - 12 PM IST</span>
            </div>

            <a
    href="https://api.whatsapp.com/send?phone=+918088975867&text=Hi%20Logicmojo"
    className="bab_cta"
    target="_blank"
    rel="noopener noreferrer"
  >
    <img
      src="/react/ai-assets/images//whatsapplogo.png"
      width="30"
      alt="Chat on WhatsApp"
    />
  </a>

          </div>
        </div>
      </div>

      <div className="footerstrip-formob">
        <a href="https://api.whatsapp.com/send?phone=+918088975867&amp;text=Hi%20Logicmojo">
          Chat with us{" "}
          <img
            src="/react/ai-assets/images//whatsapplogo.png"
            width="30"
          />
        </a>{" "}
        |{" "}
        <a
          target="_default"
          //data-target="#counsellingpopup"
          //data-toggle="modal"
          href="https://calendly.com/logicmojo/schedule-call-back-from-experts-for-live-classes?month=2026-06"
        >
         <b> Request a Call</b>{" "}
          <img
            src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQ_iRdNR098BeHs9symwbCwLZ3YJCYDfVeqjQ&amp;usqp=CAU"
            width="30"
          />
        </a>
      </div>
      <div className="footerstrip-formob">
        <a target="_default" href="https://calendly.com/logicmojo/schedule-call-back-from-experts-for-live-classes?month=2026-06">
        Request a Call{" "}
          <img
            loading="lazy"
            src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQ_iRdNR098BeHs9symwbCwLZ3YJCYDfVeqjQ&usqp=CAU"
            width="30"
          />
        </a>
        <span className="d-sm-block d-none mr-2">|</span>
        <a href="https://api.whatsapp.com/send?phone=+918088975867&text=Hi%20Logicmojo">
           Chat with us{" "}
          <img
            loading="lazy"
            src="/react/ai-assets/images//whatsapplogo.png"
            width="30"
          />
        </a>
      </div> 
      
      <div className="footerstrip">
        <a
          target="_default"
          //data-target="#counsellingpopup"
          //data-toggle="modal"
          href="https://calendly.com/logicmojo/schedule-call-back-from-experts-for-live-classes?month=2026-06"
        >
          <span>
            <i className="fa fa-hand-o-right" aria-hidden="true"></i>{" "}
            <b>
              <u>+91 8088975867</u>
            </b>
          </span>
          <span>
            <i className="fa fa-volume-control-phone" aria-hidden="true"></i>{" "}
            <b>Talk To Our Tech Team</b>{" "}
          </span>
          <span>
            <i className="fa fa-question-circle" aria-hidden="true"></i> Any
            query related to live classes
          </span>
        </a>
      </div>
     
      <div className="modal" id="welcomepopup">
        <div className="wp_popup">
          {/* Animated gradient border */}
          <div className="wp_border_glow"></div>

          {/* Close button */}
          <button type="button" className="wp_close" data-dismiss="modal">
            <i className="fa fa-times"></i>
          </button>

          {/* Floating particles */}
          <div className="wp_particles">
            <span></span><span></span><span></span><span></span><span></span>
          </div>

          {/* Discount badge */}
          <div className="wp_badge_wrap">
            <span className="wp_badge">
              Diwali Special Offer — Flat 20% OFF
            </span>
          </div>

          {/* Course cards */}
          <div className="wp_courses">
            <div className="wp_course_card">
              <div className="wp_course_icon wp_icon_ai">
                <i className="fa fa-microchip"></i>
              </div>
              <div className="wp_course_details">
                <h4>LogicMojo AI & ML Course</h4>
                <p>AI, Machine Learning & GenAI</p>
              </div>
              <span className="wp_duration"><i className="fa fa-clock-o"></i> 7 months</span>
            </div>
            <div className="wp_course_card">
              <div className="wp_course_icon">
                <i className="fa fa-magic"></i>
              </div>
              <div className="wp_course_details">
                <h4>GenAI & Agentic Course</h4>
                <p>Weekdays Batch</p>
              </div>
              <span className="wp_duration"><i className="fa fa-clock-o"></i> 4 months</span>
            </div>
          </div>

          {/* Batch info */}
          <div className="wp_batch_info">
            <div className="wp_batch_row">
              <span className="wp_batch_label"><i className="fa fa-calendar"></i> Batch starts</span>
              <span className="wp_batch_date">14th Nov</span>
            </div>
            <div className="wp_batch_row">
              <span className="wp_batch_label"><i className="fa fa-clock-o"></i> Weekend Classes</span>
              <span className="wp_batch_time">9 AM - 12 PM (IST)</span>
            </div>
          </div>

          {/* CTA */}
          <a href="https://calendly.com/logicmojo/schedule-call-back-from-experts-for-live-classes?month=2026-06" className="wp_cta" target="_blank" rel="noopener noreferrer">
            Grab the Offer <i className="fa fa-arrow-right"></i>
          </a>
        </div>
      </div>

      <div className="modal allcoursemodal" id="CourseModalJavaExp">
        <div className="modal-dialog modal-lg">
          <div className="modal-content">
            <div className="modal-header">
              <h4 className="modal-title">Cracking the Coding Interviews</h4>
              <button type="button" className="close" data-dismiss="modal">
                &times;
              </button>
            </div>

            <div className="modal-body">
              <div className="exper-candidate-bg">
                <span>Experienced Candidate</span>
                <div className="exper-candidate-bg-content">
                  <div className="exper-candidate-top">
                    <ul className="w65">
                      <li>
                        <i className="fa fa-flag" aria-hidden="true"></i>{" "}
                        Accesibiliy: Life Time Access Course (260+ Lectures)
                      </li>
                      <li>
                        <i className="fa fa-users" aria-hidden="true"></i>{" "}
                        Eligibility: 1+ to 15 years of work exp. in any domain
                      </li>
                    </ul>
                    <ul className="w35">
                      <li>
                        <i className="fa fa-globe" aria-hidden="true"></i> Mode:
                        Self-Paced Course
                      </li>
                      <li>
                        <i
                          className="fa fa-graduation-cap"
                          aria-hidden="true"
                        ></i>{" "}
                        Language: Java
                      </li>
                    </ul>
                  </div>
                  <div className="exper-candidate-bottom">
                    <h3>Course Features</h3>
                    <ul className="w70">
                      <li>
                        complete course of data structures algorithms & system
                        design
                      </li>
                      <li>Assignments &amp; assignments discussion</li>
                      <li>Doubt clearing sessions</li>
                      <li>Code analysis tool</li>
                      <li>Editor for Practice</li>
                      <li>Certification of completion</li>
                    </ul>
                    <ul className="w30">
                      <li>Weekly coding test</li>
                      <li>Referral job assistance</li>
                      <li>Resume guidelines</li>
                      <li>Mock interview</li>
                      <li>Regular updates</li>
                      <li>Faq of lectures</li>
                    </ul>
                  </div>
                </div>
              </div>

              <a
                href="https://logicmojo.com/purchase/38"
                className="chckbtns02"
              >
                Enroll now
              </a>
            </div>
          </div>
        </div>
      </div>

      <div className="modal allcoursemodal" id="CourseModalJavaFresher">
        <div className="modal-dialog modal-lg">
          <div className="modal-content">
            <div className="modal-header">
              <h4 className="modal-title">Cracking the Placement Interviews</h4>
              <button type="button" className="close" data-dismiss="modal">
                &times;
              </button>
            </div>

            <div className="modal-body">
              <div className="exper-candidate-bg">
                <span>Freshers Candidate</span>
                <div className="exper-candidate-bg-content">
                  <div className="exper-candidate-top">
                    <ul className="w65">
                      <li>
                        <i className="fa fa-flag" aria-hidden="true"></i>{" "}
                        Accesibiliy: Life Time Access Course (240+ Lectures)
                      </li>
                      <li>
                        <i className="fa fa-users" aria-hidden="true"></i>{" "}
                        Eligibility: Undergraduates, Fresher, 1 Year exp
                      </li>
                    </ul>
                    <ul className="w35">
                      <li>
                        <i className="fa fa-globe" aria-hidden="true"></i> Mode:
                        Self-Paced Course
                      </li>
                      <li>
                        <i
                          className="fa fa-graduation-cap"
                          aria-hidden="true"
                        ></i>{" "}
                        Language: Java
                      </li>
                    </ul>
                  </div>
                  <div className="exper-candidate-bottom">
                    <h3>Course Features</h3>
                    <ul className="w70">
                      <li>
                        complete course of data structures,algorithms &
                        competitive programming
                      </li>
                      <li>Assignments &amp; assignments discussion</li>
                      <li>Doubt clearing sessions</li>
                      <li>Code analysis tool</li>
                      <li>Editor for Practice</li>
                      <li>Certification of completion</li>
                    </ul>
                    <ul className="w30">
                      <li>Weekly coding test</li>
                      <li>Referral job assistance</li>
                      <li>Resume guidelines</li>
                      <li>Mock interview</li>
                      <li>Regular updates</li>
                      <li>Faq of lectures</li>
                    </ul>
                  </div>
                </div>
              </div>

              <a
                href="https://logicmojo.com/purchase/43"
                className="chckbtns02"
              >
                Enroll now
              </a>
            </div>
          </div>
        </div>
      </div>

      <div className="modal allcoursemodal" id="CourseModalPythonFresher">
        <div className="modal-dialog modal-lg">
          <div className="modal-content">
            <div className="modal-header">
              <h4 className="modal-title">Cracking the Placement Interviews</h4>
              <button type="button" className="close" data-dismiss="modal">
                &times;
              </button>
            </div>

            <div className="modal-body">
              <div className="exper-candidate-bg">
                <span>Freshers Candidates</span>
                <div className="exper-candidate-bg-content">
                  <div className="exper-candidate-top">
                    <ul className="w65">
                      <li>
                        <i className="fa fa-flag" aria-hidden="true"></i>{" "}
                        Accesibiliy: Life Time Access Course (240+ Lectures)
                      </li>
                      <li>
                        <i className="fa fa-users" aria-hidden="true"></i>{" "}
                        Eligibility: Undergraduates, Fresher, 1 Year exp
                      </li>
                    </ul>
                    <ul className="w35">
                      <li>
                        <i className="fa fa-globe" aria-hidden="true"></i> Mode:
                        Self-Paced Course
                      </li>
                      <li>
                        <i
                          className="fa fa-graduation-cap"
                          aria-hidden="true"
                        ></i>{" "}
                        Language: Python
                      </li>
                    </ul>
                  </div>
                  <div className="exper-candidate-bottom">
                    <h3>Course Features</h3>
                    <ul className="w70">
                      <li>
                        complete course of data structures, algorithms &
                        competitive programming
                      </li>
                      <li>Assignments &amp; assignments discussion</li>
                      <li>Doubt clearing sessions</li>
                      <li>Code analysis tool</li>
                      <li>Editor for Practice</li>
                      <li>Certification of completion</li>
                    </ul>
                    <ul className="w30">
                      <li>Weekly coding test</li>
                      <li>Referral job assistance</li>
                      <li>Resume guidelines</li>
                      <li>Mock interview</li>
                      <li>Regular updates</li>
                      <li>Faq of lectures</li>
                    </ul>
                  </div>
                </div>
              </div>

              <a
                href="https://logicmojo.com/purchase/44"
                className="chckbtns02"
              >
                Enroll now
              </a>
            </div>
          </div>
        </div>
      </div>

      <div className="modal allcoursemodal" id="CourseModalPythonExp">
        <div className="modal-dialog modal-lg">
          <div className="modal-content">
            <div className="modal-header">
              <h4 className="modal-title">Cracking the Coding Interview</h4>
              <button type="button" className="close" data-dismiss="modal">
                &times;
              </button>
            </div>

            <div className="modal-body">
              <div className="exper-candidate-bg">
                <span>Experienced Candidate</span>
                <div className="exper-candidate-bg-content">
                  <div className="exper-candidate-top">
                    <ul className="w65">
                      <li>
                        <i className="fa fa-flag" aria-hidden="true"></i>{" "}
                        Accesibiliy: Life Time Access Course (260+ Lectures)
                      </li>
                      <li>
                        <i className="fa fa-users" aria-hidden="true"></i>{" "}
                        Eligibility: 1+ to 15 years of work exp. in any domain
                      </li>
                    </ul>
                    <ul className="w35">
                      <li>
                        <i className="fa fa-globe" aria-hidden="true"></i> Mode:
                        Self-Paced Course
                      </li>
                      <li>
                        <i
                          className="fa fa-graduation-cap"
                          aria-hidden="true"
                        ></i>{" "}
                        Language: Python
                      </li>
                    </ul>
                  </div>
                  <div className="exper-candidate-bottom">
                    <h3>Course Features</h3>
                    <ul className="w70">
                      <li>
                        complete course of data structures algorithms and system
                        design
                      </li>
                      <li>Assignments &amp; assignments discussion</li>
                      <li>Doubt clearing sessions</li>
                      <li>Code analysis tool</li>
                      <li>Editor for Practice</li>
                      <li>Certification of completion</li>
                    </ul>
                    <ul className="w30">
                      <li>Weekly coding test</li>
                      <li>Referral job assistance</li>
                      <li>Resume guidelines</li>
                      <li>Mock interview</li>
                      <li>Regular updates</li>
                      <li>Faq of lectures</li>
                    </ul>
                  </div>
                </div>
              </div>

              <a
                href="https://logicmojo.com/purchase/45"
                className="chckbtns02"
              >
                Enroll now
              </a>
            </div>
          </div>
        </div>
      </div>

      <div className="modal allcoursemodal" id="CourseModalCplusFresher">
        <div className="modal-dialog modal-lg">
          <div className="modal-content">
            <div className="modal-header">
              <h4 className="modal-title">Cracking the Placement Interviews</h4>
              <button type="button" className="close" data-dismiss="modal">
                &times;
              </button>
            </div>

            <div className="modal-body">
              <div className="exper-candidate-bg">
                <span>Freshers Candidates</span>
                <div className="exper-candidate-bg-content">
                  <div className="exper-candidate-top">
                    <ul className="w65">
                      <li>
                        <i className="fa fa-flag" aria-hidden="true"></i>{" "}
                        Accesibiliy: Life Time Access Course (240+ Lectures)
                      </li>
                      <li>
                        <i className="fa fa-users" aria-hidden="true"></i>{" "}
                        Eligibility: Undergraduates, Fresher, 1 Year exp
                      </li>
                    </ul>
                    <ul className="w35">
                      <li>
                        <i className="fa fa-globe" aria-hidden="true"></i> Mode:
                        Self-Paced Course
                      </li>
                      <li>
                        <i
                          className="fa fa-graduation-cap"
                          aria-hidden="true"
                        ></i>{" "}
                        Code Explanation : C/C++
                      </li>
                    </ul>
                  </div>
                  <div className="exper-candidate-bottom">
                    <h3>Course Features</h3>
                    <ul className="w70">
                      <li>
                        complete course of data structures, algorithms &
                        competitive programming
                      </li>
                      <li>Assignments &amp; assignments discussion</li>
                      <li>Doubt clearing sessions</li>
                      <li>Code analysis tool</li>
                      <li>Editor for Practice</li>
                      <li>Certification of completion</li>
                    </ul>
                    <ul className="w30">
                      <li>Weekly coding test</li>
                      <li>Referral job assistance</li>
                      <li>Resume guidelines</li>
                      <li>Mock interview</li>
                      <li>Regular updates</li>
                      <li>Faq of lectures</li>
                    </ul>
                  </div>
                </div>
              </div>

              <a
                href="https://logicmojo.com/purchase/46"
                className="chckbtns02"
              >
                Enroll now
              </a>
            </div>
          </div>
        </div>
      </div>

      <div className="modal allcoursemodal" id="CourseModalCplusExp">
        <div className="modal-dialog modal-lg">
          <div className="modal-content">
            <div className="modal-header">
              <h4 className="modal-title">
                Cracking the Coding & System Design Interview
              </h4>
              <button type="button" className="close" data-dismiss="modal">
                &times;
              </button>
            </div>

            <div className="modal-body">
              <div className="exper-candidate-bg">
                <span>Experienced Candidate</span>
                <div className="exper-candidate-bg-content">
                  <div className="exper-candidate-top">
                    <ul className="w65">
                      <li>
                        <i className="fa fa-flag" aria-hidden="true"></i>{" "}
                        Accesibiliy: Life Time Access Course (260+ Lectures)
                      </li>
                      <li>
                        <i className="fa fa-users" aria-hidden="true"></i>{" "}
                        Eligibility: 1+ to 15 years of work exp. in any domain
                      </li>
                    </ul>
                    <ul className="w35">
                      <li>
                        <i className="fa fa-globe" aria-hidden="true"></i> Mode:
                        Self-Paced Course
                      </li>
                      <li>
                        <i
                          className="fa fa-graduation-cap"
                          aria-hidden="true"
                        ></i>
                        Code Explanation : C/C++
                      </li>
                    </ul>
                  </div>
                  <div className="exper-candidate-bottom">
                    <h3>Course Features</h3>
                    <ul className="w70">
                      <li>
                        complete course of data structures algorithms and system
                        design
                      </li>
                      <li>Assignments &amp; assignments discussion</li>
                      <li>Doubt clearing sessions</li>
                      <li>Code analysis tool</li>
                      <li>Editor for Practice</li>
                      <li>Certification of completion</li>
                    </ul>
                    <ul className="w30">
                      <li>Weekly coding test</li>
                      <li>Referral job assistance</li>
                      <li>Resume guidelines</li>
                      <li>Mock interview</li>
                      <li>Regular updates</li>
                      <li>Faq of lectures</li>
                    </ul>
                  </div>
                </div>
              </div>

              <a
                href="https://logicmojo.com/purchase/47"
                className="chckbtns02"
              >
                Enroll now
              </a>
            </div>
          </div>
        </div>
      </div>

      <div className="modal fade" id="booktry">
        <div className="modal-dialog modal-lg">
          <div className="modal-content">
            <div className="modal-body">
              <div className="booktrialpopup">
                <button type="button" className="close" data-dismiss="modal">
                  ×
                </button>
                <div className="booktrial-coursedetails">
                  <h1>Advanced Data Science and AI Master's Program</h1>
                  <p>Duration: 7 months (Weekend Online Live Classes)</p>
                  <p>Time: 9 AM - 12 PM (IST)</p>
                </div>

                <div className="booktrial-features">
                  <h3>Course Features</h3>
                  <ul>
                    <li>
                      {" "}
                      <span>
                        <img src="https://logicmojo.com/assets/home/images/featureicon1.png" />
                      </span>{" "}
                      250+ Hours of Live sessions
                    </li>
                    <li>
                      {" "}
                      <span>
                        <img src="https://logicmojo.com/assets/home/images/featureicon2.png" />
                      </span>{" "}
                      1:1 Doubt Session
                    </li>
                    <li>
                      {" "}
                      <span>
                        <img src="https://logicmojo.com/assets/home/images/featureicon3.png" />
                      </span>{" "}
                      Practice during class
                    </li>
                    <li>
                      {" "}
                      <span>
                        <img src="https://logicmojo.com/assets/home/images/featureicon4.png" />
                      </span>{" "}
                      Lifetime accessibility class recordin
                    </li>
                  </ul>
                  <ul>
                    <li>
                      {" "}
                      <span>
                        <img src="https://logicmojo.com/assets/home/images/featureicon5.png" />
                      </span>{" "}
                      Multiple Batches Options
                    </li>
                    <li>
                      {" "}
                      <span>
                        <img src="https://logicmojo.com/assets/home/images/featureicon6.png" />
                      </span>{" "}
                      20+ Projects
                    </li>
                    <li>
                      {" "}
                      <span>
                        <img src="https://logicmojo.com/assets/home/images/featureicon7.png" />
                      </span>{" "}
                      Job Referrals Program
                    </li>
                    <li>
                      {" "}
                      <span>
                        <img src="https://logicmojo.com/assets/home/images/featureicon8.png" />
                      </span>{" "}
                      Mock Interviews
                    </li>
                  </ul>
                  <ul>
                    <li>
                      {" "}
                      <span>
                        <img src="https://logicmojo.com/assets/home/images/featureicon9.png" />
                      </span>{" "}
                      Resume Preparation
                    </li>
                    <li>
                      {" "}
                      <span>
                        <img src="https://logicmojo.com/assets/home/images/featureicon10.png" />
                      </span>{" "}
                      Weekly Assignments
                    </li>
                    <li>
                      {" "}
                      <span>
                        <img src="https://logicmojo.com/assets/home/images/featureicon11.png" />
                      </span>{" "}
                      Complete code explanation
                    </li>
                    <li>
                      {" "}
                      <span>
                        <img src="https://logicmojo.com/assets/home/images/featureicon3.png" />
                      </span>{" "}
                      Regular Progress Tests
                    </li>
                  </ul>
                </div>

                <div className="btngrp02">
                  <div className="row">
                    <div className="col-md-4">
                      <a
                        target="_default"
                        href="https://drive.google.com/file/d/1SzaTFL3QiyuRzbtjI7e0dzMDCnLxtr0A/view"
                      >
                        Course Brochure
                      </a>
                    </div>
                    <div className="col-md-4">
                      <a
                        target="_default"
                        href="https://drive.google.com/file/d/1SzaTFL3QiyuRzbtjI7e0dzMDCnLxtr0A/view"
                      >
                        Placement Report
                      </a>
                    </div>
                    <div className="col-md-4">
                      <a
                        target="_default"
                        href="https://drive.google.com/file/d/1SzaTFL3QiyuRzbtjI7e0dzMDCnLxtr0A/view"
                      >
                        Syllabus
                      </a>
                    </div>
                  </div>
                </div>

                <div className="booktrial-paymentoptions">
                  <h3>Payment Options</h3>
                  <div className="row">
                    <div className="col-md-4">
                      <div className="booktrialbox">
                        <h3>Total:INR 87000</h3>
                        <h4>EMI 5,410/month</h4>
                        <h5>No Cost EMI</h5>
                        <p>Pay on a monthly basis</p>
                        <h3 style={{ color: "#0d4a9b" }}>Up to 6 months</h3>
                      </div>
                    </div>

                    <div className="col-md-4">
                      <div className="booktrialbox">
                        <h3>Total:INR 87000</h3>
                        <h4>EMI 7,200/month</h4>
                        <h5>No Cost EMI</h5>
                        <p>Pay on a monthly basis</p>
                        <h3 style={{ color: "#0d4a9b" }}>Up to 9 months</h3>
                      </div>
                    </div>

                    <div className="col-md-4">
                      <div className="booktrialbox">
                        <h3>Total:INR 87000</h3>
                        <h4>EMI 10,800/month</h4>
                        <h5>No Cost EMI</h5>
                        <p>Pay on a monthly basis</p>
                        <h3 style={{ color: "#0d4a9b" }}>Up to 3 months</h3>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="row">
                  <div className="col-lg-8 d-none">
                    <div className="booktrial-genraldetails">
                      <h3>Apply Discount</h3>
                      <div className="booktrial-genraldetails-form">
                        <div className="payment_form">
                          <input
                            type="text"
                            name="promo_code_yearly"
                            className="field promo_code_yearly promo_code_yearly promo_code_yearly promo_code_yearly_2"
                            placeholder="Enter promo code"
                          />
                          <div className="valid_promo_code_yearly valid_promo_code_yearly_2"></div>
                        </div>
                        <p style={{ width: "98%" }}>
                          <input
                            className="booktrial-submit apply_promocode_yearly_new_page"
                            data_id="2"
                            type="submit"
                            value="Submit"
                          />
                        </p>
                      </div>
                    </div>
                  </div>

                  <div className="col-12">
                    <div className="booktrial-ordersummery">
                      <h3>Order Summary</h3>
                      Net amount <span>INR 87000.00</span>
                      <div className="discount_section_yearly ">
                        <p style={{ color: "#00cc00" }}>
                          LogicMojo Diwali Special Offer (20% OFF) <span>17400.00</span>
                        </p>
                        <p
                          className="applypopup-total"
                          style={{ color: "#00cc00" }}
                        >
                          Total After Discount<span>69600.00</span>
                        </p>

                        <input
                          type="hidden"
                          className="discount_amount_yearly"
                          value="5000"
                        />
                        <input
                          type="hidden"
                          className="after_discount_amount_yearly"
                          value="60000.00"
                        />
                        <input
                          type="hidden"
                          className="discount_type_yearly"
                          value="yearly"
                        />
                        <input
                          type="hidden"
                          className="country_currency"
                          value="country_currency"
                        />
                        <input
                          type="hidden"
                          className="country"
                          value="country"
                        />
                        <input
                          type="hidden"
                          className="yearly_discount_status"
                          value="yearly_discount_status"
                        />
                        <input
                          type="hidden"
                          className="monthly_discount_status"
                          value="monthly_discount_status"
                        />
                        <input
                          type="hidden"
                          className="discount_id_yearly"
                          value="4"
                        />

                        <input
                          type="hidden"
                          className="discount_id_yearly"
                          value="2"
                        />
                      </div>
                      <div className="booktrial-ordersummery-btns">
                        <div className="proceedtopay_with_dis d-none">
                          <form
                            action="https://logicmojo.com/complete_course_payment_page"
                            method="post"
                          >
                            <input type="hidden" name="discount" value="1" />
                            <input
                              type="hidden"
                              name="country_currency"
                              value="INR"
                            />
                            <button
                              type="submit"
                              style={{
                                background: "#e51316",
                                color: "#fff",
                                border: "none",
                                padding: "10px",
                                borderRadius: "5px",
                                textAlign: "center",
                                width: "100%",
                                display: "inline-block",
                                marginBottom: "5px",
                              }}
                              className="float-left buy_now withDiscountClass"
                            >
                              Proceed To Pay &gt;&gt;
                            </button>
                          </form>
                        </div>

                        <div className="proceedtopay_without_dis d-none">
                          <form
                            action="https://logicmojo.com/complete_course_payment_page"
                            method="post"
                          >
                            <input type="hidden" name="discount" value="0" />
                            <input
                              type="hidden"
                              name="country_currency"
                              value="INR"
                            />
                            <button
                              type="submit"
                              style={{
                                background: "#e51316",
                                color: "#fff",
                                border: "none",
                                padding: "10px",
                                borderRadius: "5px",
                                textAlign: "center",
                                width: "100%",
                                display: "inline-block",
                              }}
                            >
                              Proceed To Pay &gt;&gt;
                            </button>
                          </form>
                        </div>

                        <a
                          href="https://logicmojo.com/data_science_ai_master_exp"
                          className="float-right modal-payNow-btn"
                          target="_blank"
                        >
                          Pay Now
                        </a>
                        <a
                          href="#"
                          className="float-right"
                          data-dismiss="modal"
                        >
                          Close
                        </a>
                      </div>
                    </div>
                  </div>

                  <form method="post">
                    <div
                      className="col-lg-12 col-md-12 apply_yearly_discount_paypal d-none"
                      style={{ margin: "0 0 0 16px" }}
                    >
                      <span className="radio-label">
                        <button type="submit" style={{ border: "none" }}>
                          <img
                            loading="lazy"
                            src="/react/ai-assets/images//papal.png"
                            height="45"
                            className="paypal_btn"
                            style={{ margin: "2px 0 0 0" }}
                          />
                        </button>
                      </span>
                    </div>
                  </form>

                  <div className="booktrial-ordersummery-btns">
                    <a
                      href="javascript:void(0)"
                      style={{ background: "#0d4a9b", color: "#fff" }}
                      className="float-left buy_now apply_yearly_discount withDiscountClass d-none"
                    >
                      Pay
                    </a>
                    <a
                      href="javascript:void(0)"
                      style={{ background: "#0d4a9b", color: "#fff" }}
                      className="float-left buy_now apply_yearly_amount d-none withoutDiscountClass"
                    >
                      Pay
                    </a>
                  </div>

                  <div className="proceedtopay_with_dis d-none">
                    <form
                      action="https://logicmojo.com/complete_course_payment_page"
                      method="post"
                    >
                      <input type="hidden" name="discount" value="1" />
                      <input type="hidden" name="country_currency" value="" />
                      <button
                        type="submit"
                        className="float-left buy_now withDiscountClass"
                      >
                        Proceed To Pay
                      </button>
                    </form>
                  </div>

                  <div className="proceedtopay_without_dis d-none">
                    <form
                      action="https://logicmojo.com/complete_course_payment_page"
                      method="post"
                    >
                      <input type="hidden" name="discount" value="0" />
                      <input type="hidden" name="country_currency" value="" />
                      <button
                        type="submit"
                        className="float-left buy_now withoutDiscountClass"
                      >
                        Proceed To Pay
                      </button>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="modal fade" id="booktry3">
        <div className="modal-dialog modal-lg">
          <div className="modal-content">
            <div className="modal-body">
              <div className="booktrialpopup">
                <button type="button" className="close" data-dismiss="modal">
                  ×
                </button>
                <div className="booktrial-coursedetails">
                  <h1>Advanced Course of System Design(HLD + LLD)</h1>
                  <h4>BATCH WILL STARTS FROM 14th Nov</h4>
                  <p>Duration: 3 Months (Weekend Online Live Classes)</p>
                  <p>Time: 9 AM - 12 PM (IST)</p>
                </div>

                <div className="booktrial-features">
                  <h3>Course Features</h3>
                  <ul>
                    <li>
                      {" "}
                      <span>
                        <img src="https://logicmojo.com/assets/home/images/featureicon1.png" />
                      </span>{" "}
                      120+ Hours of Live sessions
                    </li>
                    <li>
                      {" "}
                      <span>
                        <img src="https://logicmojo.com/assets/home/images/featureicon2.png" />
                      </span>{" "}
                      1:1 Doubt Session
                    </li>
                    <li>
                      {" "}
                      <span>
                        <img src="https://logicmojo.com/assets/home/images/featureicon3.png" />
                      </span>{" "}
                      Practice during class
                    </li>
                    <li>
                      {" "}
                      <span>
                        <img src="https://logicmojo.com/assets/home/images/featureicon4.png" />
                      </span>{" "}
                      Lifetime accessibility class recordin
                    </li>
                  </ul>
                  <ul>
                    <li>
                      {" "}
                      <span>
                        <img src="https://logicmojo.com/assets/home/images/featureicon5.png" />
                      </span>{" "}
                      Multiple Batches Options
                    </li>
                    <li>
                      {" "}
                      <span>
                        <img src="https://logicmojo.com/assets/home/images/featureicon6.png" />
                      </span>{" "}
                      4+ Projects
                    </li>
                    <li>
                      {" "}
                      <span>
                        <img src="https://logicmojo.com/assets/home/images/featureicon7.png" />
                      </span>{" "}
                      Job Referrals Program
                    </li>
                    <li>
                      {" "}
                      <span>
                        <img src="https://logicmojo.com/assets/home/images/featureicon8.png" />
                      </span>{" "}
                      Mock Interviews
                    </li>
                  </ul>
                  <ul>
                    <li>
                      {" "}
                      <span>
                        <img src="https://logicmojo.com/assets/home/images/featureicon9.png" />
                      </span>{" "}
                      Resume Preparation
                    </li>
                    <li>
                      {" "}
                      <span>
                        <img src="https://logicmojo.com/assets/home/images/featureicon10.png" />
                      </span>{" "}
                      Weekly Assignments
                    </li>
                    <li>
                      {" "}
                      <span>
                        <img src="https://logicmojo.com/assets/home/images/featureicon11.png" />
                      </span>{" "}
                      Complete code explanation
                    </li>
                    <li>
                      {" "}
                      <span>
                        <img src="https://logicmojo.com/assets/home/images/featureicon3.png" />
                      </span>{" "}
                      Regular Progress Tests
                    </li>
                  </ul>
                </div>

                <div className="btngrp02">
                  <div className="row">
                    <div className="col-md-4">
                      <a
                        target="_default"
                        href="https://drive.google.com/file/d/1SzaTFL3QiyuRzbtjI7e0dzMDCnLxtr0A/view"
                      >
                        Course Brochure
                      </a>
                    </div>
                    <div className="col-md-4">
                      <a
                        target="_default"
                        href="https://drive.google.com/file/d/1SzaTFL3QiyuRzbtjI7e0dzMDCnLxtr0A/view"
                      >
                        Placement Report
                      </a>
                    </div>
                    <div className="col-md-4">
                      <a
                        target="_default"
                        href="https://drive.google.com/file/d/1SzaTFL3QiyuRzbtjI7e0dzMDCnLxtr0A/view"
                      >
                        Syllabus
                      </a>
                    </div>
                  </div>
                </div>

                <div className="booktrial-paymentoptions">
                  <h3>Payment Options</h3>
                  <div className="row">
                    <div className="col-md-4">
                      <div className="booktrialbox">
                        <h3>Total:INR 30000</h3>
                        <h4>EMI 5,000/month</h4>
                        <h5>No Cost EMI</h5>
                        <p>Pay on a monthly basis</p>
                        <h3 style={{ color: "#0d4a9b" }}>Up to 6 months</h3>
                      </div>
                    </div>

                    <div className="col-md-4">
                      <div className="booktrialbox">
                        <h3>Total:INR 30000</h3>
                        <h4>EMI 3,330/month</h4>
                        <h5>No Cost EMI</h5>
                        <p>Pay on a monthly basis</p>
                        <h3 style={{ color: "#0d4a9b" }}>Up to 9 months</h3>
                      </div>
                    </div>

                    <div className="col-md-4">
                      <div className="booktrialbox">
                        <h3>Total:INR 30000</h3>
                        <h4>EMI 10,000/month</h4>
                        <h5>No Cost EMI</h5>
                        <p>Pay on a monthly basis</p>
                        <h3 style={{ color: "#0d4a9b" }}>Up to 3 months</h3>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="row">
                  <div className="col-lg-8 d-none">
                    <div className="booktrial-genraldetails">
                      <h3>Apply Discount</h3>
                      <div className="booktrial-genraldetails-form">
                        <div className="payment_form">
                          <input
                            type="text"
                            name="promo_code_yearly"
                            className="field promo_code_yearly promo_code_yearly promo_code_yearly promo_code_yearly_2"
                            placeholder="Enter promo code"
                          />
                          <div className="valid_promo_code_yearly valid_promo_code_yearly_2"></div>
                        </div>
                        <p style={{ width: "98%" }}>
                          <input
                            className="booktrial-submit apply_promocode_yearly_new_page"
                            data_id="2"
                            type="submit"
                            value="Submit"
                          />
                        </p>
                      </div>
                    </div>
                  </div>

                  <div className="col-12">
                    <div className="booktrial-ordersummery">
                      <h3>Order Summary</h3>
                      Net amount <span>30000</span>
                      <div className="discount_section_yearly ">
                        <p style={{ color: "#00cc00" }}>
                          LogicMojo Diwali Special Offer (20% OFF) <span>6000.00</span>
                        </p>
                        <p
                          className="applypopup-total"
                          style={{ color: "#00cc00" }}
                        >
                          Total After Discount<span>24000.00</span>
                        </p>

                        <input
                          type="hidden"
                          className="discount_amount_yearly"
                          value="5000"
                        />
                        <input
                          type="hidden"
                          className="after_discount_amount_yearly"
                          value="47000.00"
                        />
                        <input
                          type="hidden"
                          className="discount_type_yearly"
                          value="yearly"
                        />
                        <input
                          type="hidden"
                          className="country_currency"
                          value="country_currency"
                        />
                        <input
                          type="hidden"
                          className="country"
                          value="country"
                        />
                        <input
                          type="hidden"
                          className="yearly_discount_status"
                          value="yearly_discount_status"
                        />
                        <input
                          type="hidden"
                          className="monthly_discount_status"
                          value="monthly_discount_status"
                        />
                        <input
                          type="hidden"
                          className="discount_id_yearly"
                          value="4"
                        />

                        <input
                          type="hidden"
                          className="discount_id_yearly"
                          value="2"
                        />
                      </div>
                      <div className="booktrial-ordersummery-btns">
                        <div className="proceedtopay_with_dis d-none">
                          <form
                            action="https://logicmojo.com/complete_course_payment_page"
                            method="post"
                          >
                            <input type="hidden" name="discount" value="1" />
                            <input
                              type="hidden"
                              name="country_currency"
                              value="INR"
                            />
                            <button
                              type="submit"
                              style={{
                                background: "#e51316",
                                color: "#fff",
                                border: "none",
                                padding: "10px",
                                borderRadius: "5px",
                                textAlign: "center",
                                width: "100%",
                                display: "inline-block",
                                marginBottom: "5px",
                              }}
                              className="float-left buy_now withDiscountClass"
                            >
                              Proceed To Pay &gt;&gt;
                            </button>
                          </form>
                        </div>

                        <div className="proceedtopay_without_dis d-none">
                          <form
                            action="https://logicmojo.com/complete_course_payment_page"
                            method="post"
                          >
                            <input type="hidden" name="discount" value="0" />
                            <input
                              type="hidden"
                              name="country_currency"
                              value="INR"
                            />
                            <button
                              type="submit"
                              style={{
                                background: "#e51316",
                                color: "#fff",
                                border: "none",
                                padding: "10px",
                                borderRadius: "5px",
                                textAlign: "center",
                                width: "100%",
                                display: "inline-block",
                              }}
                            >
                              Proceed To Pay &gt;&gt;
                            </button>
                          </form>
                        </div>

                        <a
                          href="https://logicmojo.com/advance_course_system_design_exp"
                          className="float-right modal-payNow-btn"
                          target="_blank"
                        >
                          Pay Now
                        </a>

                        <a
                          href="#"
                          className="float-right"
                          data-dismiss="modal"
                        >
                          Close
                        </a>
                      </div>
                    </div>
                  </div>

                  <form method="post">
                    <div
                      className="col-lg-12 col-md-12 apply_yearly_discount_paypal d-none"
                      style={{ margin: "0 0 0 16px" }}
                    >
                      <span className="radio-label">
                        <button type="submit" style={{ border: "none" }}>
                          <img
                            loading="lazy"
                            src="/react/ai-assets/images//papal.png"
                            height="45"
                            className="paypal_btn"
                            style={{ margin: "2px 0 0 0" }}
                          />
                        </button>
                      </span>
                    </div>
                  </form>

                  <div className="booktrial-ordersummery-btns">
                    <a
                      href="javascript:void(0)"
                      style={{ background: "#0d4a9b", color: "#fff" }}
                      className="float-left buy_now apply_yearly_discount withDiscountClass d-none"
                    >
                      Pay
                    </a>
                    <a
                      href="javascript:void(0)"
                      style={{ background: "#0d4a9b", color: "#fff" }}
                      className="float-left buy_now apply_yearly_amount d-none withoutDiscountClass"
                    >
                      Pay
                    </a>
                  </div>

                  <div className="proceedtopay_with_dis d-none">
                    <form
                      action="https://logicmojo.com/complete_course_payment_page"
                      method="post"
                    >
                      <input type="hidden" name="discount" value="1" />
                      <input type="hidden" name="country_currency" value="" />
                      <button
                        type="submit"
                        className="float-left buy_now withDiscountClass"
                      >
                        Proceed To Pay
                      </button>
                    </form>
                  </div>

                  <div className="proceedtopay_without_dis d-none">
                    <form
                      action="https://logicmojo.com/complete_course_payment_page"
                      method="post"
                    >
                      <input type="hidden" name="discount" value="0" />
                      <input type="hidden" name="country_currency" value="" />
                      <button
                        type="submit"
                        className="float-left buy_now withoutDiscountClass"
                      >
                        Proceed To Pay
                      </button>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="modal fade" id="booktry2">
        <div className="modal-dialog modal-lg ">
          <div className="modal-content">
            <div className="modal-body">
              <div className="booktrialpopup">
                <button type="button" className="close" data-dismiss="modal">
                  
                </button>
                <div className="booktrial-coursedetails">
                  <h1>
                    Advanced Course of Data Structures, Algorithms & Problem
                    Solving
                  </h1>
                  <h4>BATCH WILL STARTS FROM 14th Nov</h4>
                  <p>Duration: 4 Months (Weekend Online Live Classes)</p>
                  <p>Time: 9 AM - 12 PM (IST)</p>
                </div>

                <div className="booktrial-features">
                  <h3>Course Features</h3>
                  <ul>
                    <li>
                      {" "}
                      <span>
                        <img src="https://logicmojo.com/assets/home/images/featureicon1.png" />
                      </span>{" "}
                      110+ Hours of Live sessions
                    </li>
                    <li>
                      {" "}
                      <span>
                        <img src="https://logicmojo.com/assets/home/images/featureicon2.png" />
                      </span>{" "}
                      1:1 Doubt Session
                    </li>
                    <li>
                      {" "}
                      <span>
                        <img src="https://logicmojo.com/assets/home/images/featureicon3.png" />
                      </span>{" "}
                      Practice during class
                    </li>
                    <li>
                      {" "}
                      <span>
                        <img src="https://logicmojo.com/assets/home/images/featureicon4.png" />
                      </span>{" "}
                      Lifetime accessibility class recordin
                    </li>
                  </ul>
                  <ul>
                    <li>
                      {" "}
                      <span>
                        <img src="https://logicmojo.com/assets/home/images/featureicon5.png" />
                      </span>{" "}
                      Multiple Batches Options
                    </li>
                    <li>
                      {" "}
                      <span>
                        <img src="https://logicmojo.com/assets/home/images/featureicon6.png" />
                      </span>{" "}
                      4+ Projects
                    </li>
                    <li>
                      {" "}
                      <span>
                        <img src="https://logicmojo.com/assets/home/images/featureicon7.png" />
                      </span>{" "}
                      Job Referrals Program
                    </li>
                    <li>
                      {" "}
                      <span>
                        <img src="https://logicmojo.com/assets/home/images/featureicon8.png" />
                      </span>{" "}
                      Mock Interviews
                    </li>
                  </ul>
                  <ul>
                    <li>
                      {" "}
                      <span>
                        <img src="https://logicmojo.com/assets/home/images/featureicon9.png" />
                      </span>{" "}
                      Resume Preparation
                    </li>
                    <li>
                      {" "}
                      <span>
                        <img src="https://logicmojo.com/assets/home/images/featureicon10.png" />
                      </span>{" "}
                      Weekly Assignments
                    </li>
                    <li>
                      {" "}
                      <span>
                        <img src="https://logicmojo.com/assets/home/images/featureicon11.png" />
                      </span>{" "}
                      Complete code explanation
                    </li>
                    <li>
                      {" "}
                      <span>
                        <img src="https://logicmojo.com/assets/home/images/featureicon3.png" />
                      </span>{" "}
                      Regular Progress Tests
                    </li>
                  </ul>
                </div>

                <div className="btngrp02">
                  <div className="row">
                    <div className="col-md-4">
                      <a
                        target="_default"
                        href="https://drive.google.com/file/d/1SzaTFL3QiyuRzbtjI7e0dzMDCnLxtr0A/view"
                      >
                        Course Brochure
                      </a>
                    </div>
                    <div className="col-md-4">
                      <a
                        target="_default"
                        href="https://drive.google.com/file/d/1SzaTFL3QiyuRzbtjI7e0dzMDCnLxtr0A/view"
                      >
                        Placement Report
                      </a>
                    </div>
                    <div className="col-md-4">
                      <a
                        target="_default"
                        href="https://drive.google.com/file/d/1SzaTFL3QiyuRzbtjI7e0dzMDCnLxtr0A/view"
                      >
                        Syllabus
                      </a>
                    </div>
                  </div>
                </div>

                <div className="booktrial-paymentoptions">
                  <h3>Payment Options</h3>
                  <div className="row">
                    <div className="col-md-4">
                      <div className="booktrialbox">
                        <h3>Total:INR 32000</h3>
                        <h4>EMI 5,330/month</h4>
                        <h5>No Cost EMI</h5>
                        <p>Pay on a monthly basis</p>
                        <h3 style={{ color: "#0d4a9b" }}>Up to 6 months</h3>
                      </div>
                    </div>

                    <div className="col-md-4">
                      <div className="booktrialbox">
                        <h3>Total:INR 32000</h3>
                        <h4>EMI 3,550/month</h4>
                        <h5>No Cost EMI</h5>
                        <p>Pay on a monthly basis</p>
                        <h3 style={{ color: "#0d4a9b" }}>Up to 9 months</h3>
                      </div>
                    </div>

                    <div className="col-md-4">
                      <div className="booktrialbox">
                        <h3>Total:INR 32000</h3>
                        <h4>EMI 10,660/month</h4>
                        <h5>No Cost EMI</h5>
                        <p>Pay on a monthly basis</p>
                        <h3 style={{ color: "#0d4a9b" }}>Up to 3 months</h3>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="row">
                  <div className="col-lg-8 d-none">
                    <div className="booktrial-genraldetails">
                      <h3>Apply Discount</h3>
                      <div className="booktrial-genraldetails-form">
                        <div className="payment_form">
                          <input
                            type="text"
                            className="field name_yearly name_yearly_2"
                            name="name_yearly"
                            placeholder="Your Name*"
                          />
                          <div className="error1"></div>
                        </div>

                        <div className="payment_form">
                          <input
                            type="text"
                            className="field faginput whats_app_number_yearly whats_app_number_yearly_2"
                            id="whatsapp_number_yaerly_second_course"
                            name="whats_app_number_yearly"
                            placeholder="Whatsapp Number*"
                          />
                          <div className="error2"></div>
                        </div>
                        <span className="error_msg2"></span>
                        <br />
                        <p className="error-msg" id="error-msg"></p>
                        <p className="valid-msg" id="valid-msg"></p>
                        <input
                          type="hidden"
                          className="flag"
                          name="flag"
                          value="iti__in"
                        />
                        <input
                          type="hidden"
                          className="dialcode"
                          name="dialcode"
                          value="+91"
                        />

                        <div className="payment_form">
                          <input
                            type="text"
                            name="email_yearly"
                            id="email_id_yearly"
                            className="field email_id_yearly email_id_yearly_2"
                            placeholder="Email Address"
                          />
                          <div className="error3"></div>
                        </div>

                        <div className="payment_form">
                          <input
                            type="text"
                            name="promo_code_yearly"
                            className="field promo_code_yearly promo_code_yearly promo_code_yearly promo_code_yearly_2"
                            placeholder="Enter promo code"
                          />
                          <div className="valid_promo_code_yearly valid_promo_code_yearly_2"></div>
                        </div>
                        <p style={{ width: "98%" }}>
                          <input
                            className="booktrial-submit apply_promocode_yearly_new_page"
                            data_id="2"
                            type="submit"
                            value="Submit"
                          />
                        </p>
                      </div>
                    </div>
                  </div>

                  <div className="col-12">
                    <div className="booktrial-ordersummery">
                      <h3>Order Summary</h3>
                      Net amount <span>32000</span>
                      <div className="discount_section_yearly ">
                        <p style={{ color: "#00cc00" }}>
                          LogicMojo Diwali Special Offer (20% OFF) <span>6400.00</span>
                        </p>
                        <p
                          className="applypopup-total"
                          style={{ color: "#00cc00" }}
                        >
                          Total After Discount<span>25600.00</span>
                        </p>

                        <input
                          type="hidden"
                          className="discount_amount_yearly"
                          value="5000"
                        />
                        <input
                          type="hidden"
                          className="after_discount_amount_yearly"
                          value="47000.00"
                        />
                        <input
                          type="hidden"
                          className="discount_type_yearly"
                          value="yearly"
                        />
                        <input
                          type="hidden"
                          className="country_currency"
                          value="country_currency"
                        />
                        <input
                          type="hidden"
                          className="country"
                          value="country"
                        />
                        <input
                          type="hidden"
                          className="yearly_discount_status"
                          value="yearly_discount_status"
                        />
                        <input
                          type="hidden"
                          className="monthly_discount_status"
                          value="monthly_discount_status"
                        />
                        <input
                          type="hidden"
                          className="discount_id_yearly"
                          value="4"
                        />

                        <input
                          type="hidden"
                          className="discount_id_yearly"
                          value="2"
                        />
                      </div>
                      <div className="booktrial-ordersummery-btns">
                        <div className="proceedtopay_with_dis d-none">
                          <form
                            action="https://logicmojo.com/complete_course_payment_page"
                            method="post"
                          >
                            <input type="hidden" name="discount" value="1" />
                            <input
                              type="hidden"
                              name="country_currency"
                              value="INR"
                            />
                            <button
                              type="submit"
                              style={{
                                background: "#e51316",
                                color: "#fff",
                                border: "none",
                                padding: "10px",
                                borderRadius: "5px",
                                textAlign: "center",
                                width: "100%",
                                display: "inline-block",
                                marginBottom: "5px",
                              }}
                              className="float-left buy_now withDiscountClass"
                            >
                              Proceed To Pay &gt;&gt;
                            </button>
                          </form>
                        </div>

                        <div className="proceedtopay_without_dis d-none">
                          <form
                            action="https://logicmojo.com/complete_course_payment_page"
                            method="post"
                          >
                            <input type="hidden" name="discount" value="0" />
                            <input
                              type="hidden"
                              name="country_currency"
                              value="INR"
                            />
                            <button
                              type="submit"
                              style={{
                                background: "#e51316",
                                color: "#fff",
                                border: "none",
                                padding: "10px",
                                borderRadius: "5px",
                                textAlign: "center",
                                width: "100%",
                                display: "inline-block",
                              }}
                            >
                              Proceed To Pay &gt;&gt;
                            </button>
                          </form>
                        </div>
                        <a
                          href="https://logicmojo.com/advance_course_structure_alorithm_fresher"
                          className="float-right modal-payNow-btn"
                          target="_blank"
                        >
                          Pay Now
                        </a>
                        <a
                          href="#"
                          className="float-right"
                          data-dismiss="modal"
                        >
                          Close
                        </a>
                      </div>
                    </div>
                  </div>

                  <form method="post">
                    <div
                      className="col-lg-12 col-md-12 apply_yearly_discount_paypal d-none"
                      style={{ margin: "0 0 0 16px" }}
                    >
                      <span className="radio-label">
                        <button type="submit" style={{ border: "none" }}>
                          <img
                            loading="lazy"
                            src="/react/ai-assets/images//papal.png"
                            height="45"
                            className="paypal_btn"
                            style={{ margin: "2px 0 0 0" }}
                          />
                        </button>
                      </span>
                    </div>
                  </form>

                  <div className="booktrial-ordersummery-btns">
                    <a
                      href="javascript:void(0)"
                      style={{ background: "#0d4a9b", color: "#fff" }}
                      className="float-left buy_now apply_yearly_discount withDiscountClass d-none"
                    >
                      Pay
                    </a>
                    <a
                      href="javascript:void(0)"
                      style={{ background: "#0d4a9b", color: "#fff" }}
                      className="float-left buy_now apply_yearly_amount d-none withoutDiscountClass"
                    >
                      Pay
                    </a>
                  </div>

                  <div className="proceedtopay_with_dis d-none">
                    <form
                      action="https://logicmojo.com/complete_course_payment_page"
                      method="post"
                    >
                      <input type="hidden" name="discount" value="1" />
                      <input type="hidden" name="country_currency" value="" />
                      <button
                        type="submit"
                        className="float-left buy_now withDiscountClass"
                      >
                        Proceed To Pay
                      </button>
                    </form>
                  </div>

                  <div className="proceedtopay_without_dis d-none">
                    <form
                      action="https://logicmojo.com/complete_course_payment_page"
                      method="post"
                    >
                      <input type="hidden" name="discount" value="0" />
                      <input type="hidden" name="country_currency" value="" />
                      <button
                        type="submit"
                        className="float-left buy_now withoutDiscountClass"
                      >
                        Proceed To Pay
                      </button>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="modal fade" id="booktry1">
        <div className="modal-dialog modal-lg">
          <div className="modal-content">
            <div className="modal-body">
              <div className="booktrialpopup">
                <button
                  type="button"
                  className="close"
                  data-dismiss="modal"
                ></button>
                <div className="booktrial-coursedetails">
                  <h1>
                    Advanced Course of Data Structures, Algorithms, Problem
                    Solving & System Design (HLD + LLD)
                  </h1>
                  <h4>BATCH WILL STARTS FROM 14th Nov</h4>
                  <p>Duration: 7 Months (Weekend Online Live Classes)</p>
                  <p>Time: 9 AM - 12 PM (IST)</p>
                </div>

                <div className="booktrial-features">
                  <h3>Course Features</h3>
                  <ul>
                    <li>
                      {" "}
                      <span>
                        <img
                          loading="lazy"
                          src="/react/ai-assets/images//featureicon1.png"
                        />
                      </span>{" "}
                      200+ Hours of Live sessions
                    </li>
                    <li>
                      {" "}
                      <span>
                        <img
                          loading="lazy"
                          src="/react/ai-assets/images//featureicon2.png"
                        />
                      </span>{" "}
                      1:1 Doubt Session
                    </li>
                    <li>
                      {" "}
                      <span>
                        <img
                          loading="lazy"
                          src="/react/ai-assets/images//featureicon3.png"
                        />
                      </span>{" "}
                      Practice during class
                    </li>
                    <li>
                      {" "}
                      <span>
                        <img
                          loading="lazy"
                          src="/react/ai-assets/images//featureicon4.png"
                        />
                      </span>{" "}
                      Lifetime accessibility class recordin
                    </li>
                  </ul>
                  <ul>
                    <li>
                      {" "}
                      <span>
                        <img
                          loading="lazy"
                          src="/react/ai-assets/images//featureicon5.png"
                        />
                      </span>{" "}
                      Multiple Batches Options
                    </li>
                    <li>
                      {" "}
                      <span>
                        <img
                          loading="lazy"
                          src="/react/ai-assets/images//featureicon6.png"
                        />
                      </span>{" "}
                      4+ Projects
                    </li>
                    <li>
                      {" "}
                      <span>
                        <img
                          loading="lazy"
                          src="/react/ai-assets/images//featureicon7.png"
                        />
                      </span>{" "}
                      Job Referrals Program
                    </li>
                    <li>
                      {" "}
                      <span>
                        <img
                          loading="lazy"
                          src="/react/ai-assets/images//featureicon8.png"
                        />
                      </span>{" "}
                      Mock Interviews
                    </li>
                  </ul>
                  <ul>
                    <li>
                      {" "}
                      <span>
                        <img
                          loading="lazy"
                          src="/react/ai-assets/images//featureicon9.png"
                        />
                      </span>{" "}
                      Resume Preparation
                    </li>
                    <li>
                      {" "}
                      <span>
                        <img
                          loading="lazy"
                          src="/react/ai-assets/images//featureicon10.png"
                        />
                      </span>{" "}
                      Weekly Assignments
                    </li>
                    <li>
                      {" "}
                      <span>
                        <img
                          loading="lazy"
                          src="/react/ai-assets/images//featureicon11.png"
                        />
                      </span>{" "}
                      Complete code explanation
                    </li>
                    <li>
                      {" "}
                      <span>
                        <img
                          loading="lazy"
                          src="/react/ai-assets/images//featureicon3.png"
                        />
                      </span>{" "}
                      Regular Progress Tests
                    </li>
                  </ul>
                </div>

                <div className="btngrp02">
                  <div className="row">
                    <div className="col-md-4">
                      <a
                        target="_default"
                        href="https://drive.google.com/file/d/1SzaTFL3QiyuRzbtjI7e0dzMDCnLxtr0A/view"
                      >
                        Course Brochure
                      </a>
                    </div>
                    <div className="col-md-4">
                      <a
                        target="_default"
                        href="https://drive.google.com/file/d/1SzaTFL3QiyuRzbtjI7e0dzMDCnLxtr0A/view"
                      >
                        Placement Report
                      </a>
                    </div>
                    <div className="col-md-4">
                      <a
                        target="_default"
                        href="https://drive.google.com/file/d/1SzaTFL3QiyuRzbtjI7e0dzMDCnLxtr0A/view"
                      >
                        Syllabus
                      </a>
                    </div>
                  </div>
                </div>

                <div className="booktrial-paymentoptions">
                  <h3>Payment Options</h3>
                  <div className="row">
                    <div className="col-md-4">
                      <div className="booktrialbox">
                        <h3>Total:INR 75000</h3>
                        <h4>EMI 8,660/month</h4>
                        <h5>No Cost EMI</h5>
                        <p>Pay on a monthly basis</p>
                        <h3 style={{ color: "#0d4a9b" }}>Up to 6 months</h3>
                      </div>
                    </div>

                    <div className="col-md-4">
                      <div className="booktrialbox">
                        <h3>Total:INR 75000</h3>
                        <h4>EMI 5,770/month</h4>
                        <h5>No Cost EMI</h5>
                        <p>Pay on a monthly basis</p>
                        <h3 style={{ color: "#0d4a9b" }}>Up to 9 months</h3>
                      </div>
                    </div>

                    <div className="col-md-4">
                      <div className="booktrialbox">
                        <h3>Total:INR 75000</h3>
                        <h4>EMI 17,330/month</h4>
                        <h5>No Cost EMI</h5>
                        <p>Pay on a monthly basis</p>
                        <h3 style={{ color: "#0d4a9b" }}>Up to 3 months</h3>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="row">
                  <div className="col-lg-8 d-none">
                    <div className="booktrial-genraldetails">
                      <h3>Apply Discount</h3>
                      <div className="booktrial-genraldetails-form">
                        <div className="payment_form">
                          <input
                            type="text"
                            name="promo_code_yearly"
                            className="field promo_code_yearly promo_code_yearly promo_code_yearly promo_code_yearly_2"
                            placeholder="Enter promo code"
                          />
                          <div className="valid_promo_code_yearly valid_promo_code_yearly_2"></div>
                        </div>
                        <p style={{ width: "98%" }}>
                          <input
                            className="booktrial-submit apply_promocode_yearly_new_page"
                            data_id="2"
                            type="submit"
                            value="Submit"
                          />
                        </p>
                      </div>
                    </div>
                  </div>

                  <div className="col-12">
                    <div className="booktrial-ordersummery">
                      <h3>Order Summary</h3>
                      Net amount <span>INR 75000.00</span>
                      <div className="discount_section_yearly ">
                        <p style={{ color: "#00cc00" }}>
                          LogicMojo Diwali Special Offer (20% OFF) <span>15000.00</span>
                        </p>
                        <p
                          className="applypopup-total"
                          style={{ color: "#00cc00" }}
                        >
                          Total After Discount<span>60000.00</span>
                        </p>

                        <input
                          type="hidden"
                          className="discount_amount_yearly"
                          value="5000"
                        />
                        <input
                          type="hidden"
                          className="after_discount_amount_yearly"
                          value="47000.00"
                        />
                        <input
                          type="hidden"
                          className="discount_type_yearly"
                          value="yearly"
                        />
                        <input
                          type="hidden"
                          className="country_currency"
                          value="country_currency"
                        />
                        <input
                          type="hidden"
                          className="country"
                          value="country"
                        />
                        <input
                          type="hidden"
                          className="yearly_discount_status"
                          value="yearly_discount_status"
                        />
                        <input
                          type="hidden"
                          className="monthly_discount_status"
                          value="monthly_discount_status"
                        />
                        <input
                          type="hidden"
                          className="discount_id_yearly"
                          value="4"
                        />

                        <input
                          type="hidden"
                          className="discount_id_yearly"
                          value="2"
                        />
                      </div>
                      <div className="booktrial-ordersummery-btns">
                        <div className="proceedtopay_with_dis d-none">
                          <form
                            action="https://logicmojo.com/complete_course_payment_page"
                            method="post"
                          >
                            <input type="hidden" name="discount" value="1" />
                            <input
                              type="hidden"
                              name="country_currency"
                              value="INR"
                            />
                            <button
                              type="submit"
                              style={{
                                background: "#e51316",
                                color: "#fff",
                                border: "none",
                                padding: "10px",
                                borderRadius: "5px",
                                textAlign: "center",
                                width: "100%",
                                display: "inline-block",
                                marginBottom: "5px",
                              }}
                              className="float-left buy_now withDiscountClass"
                            >
                              Proceed To Pay &gt;&gt;
                            </button>
                          </form>
                        </div>

                        <div className="proceedtopay_without_dis d-none">
                          <form
                            action="https://logicmojo.com/complete_course_payment_page"
                            method="post"
                          >
                            <input type="hidden" name="discount" value="0" />
                            <input
                              type="hidden"
                              name="country_currency"
                              value="INR"
                            />
                            <button
                              type="submit"
                              style={{
                                background: "#e51316",
                                color: "#fff",
                                border: "none",
                                padding: "10px",
                                borderRadius: "5px",
                                textAlign: "center",
                                width: "100%",
                                display: "inline-block",
                              }}
                            >
                              Proceed To Pay &gt;&gt;
                            </button>
                          </form>
                        </div>

                        <a
                          href="https://logicmojo.com/complete_course_payment_page"
                          className="float-right modal-payNow-btn"
                          target="_blank"
                        >
                          Pay Now
                        </a>

                        <a
                          href="#"
                          className="float-right"
                          data-dismiss="modal"
                        >
                          Close
                        </a>
                      </div>
                    </div>
                  </div>

                  <form method="post">
                    <div
                      className="col-lg-12 col-md-12 apply_yearly_discount_paypal d-none"
                      style={{ margin: "0 0 0 16px" }}
                    >
                      <span className="radio-label">
                        <button type="submit" style={{ border: "none" }}>
                          <img
                            loading="lazy"
                            src="/react/ai-assets/images//papal.png"
                            height="45"
                            className="paypal_btn"
                            style={{ margin: "2px 0 0 0" }}
                          />
                        </button>
                      </span>
                    </div>
                  </form>

                  <div className="booktrial-ordersummery-btns">
                    <a
                      href="javascript:void(0)"
                      style={{ background: "#0d4a9b", color: "#fff" }}
                      className="float-left buy_now apply_yearly_discount withDiscountClass d-none"
                    >
                      Pay
                    </a>
                    <a
                      href="javascript:void(0)"
                      style={{ background: "#0d4a9b", color: "#fff" }}
                      className="float-left buy_now apply_yearly_amount d-none withoutDiscountClass"
                    >
                      Pay
                    </a>
                  </div>

                  <div className="proceedtopay_with_dis d-none">
                    <form
                      action="https://logicmojo.com/complete_course_payment_page"
                      method="post"
                    >
                      <input type="hidden" name="discount" value="1" />
                      <input type="hidden" name="country_currency" value="" />
                      <button
                        type="submit"
                        className="float-left buy_now withDiscountClass"
                      >
                        Proceed To Pay
                      </button>
                    </form>
                  </div>

                  <div className="proceedtopay_without_dis d-none">
                    <form
                      action="https://logicmojo.com/complete_course_payment_page"
                      method="post"
                    >
                      <input type="hidden" name="discount" value="0" />
                      <input type="hidden" name="country_currency" value="" />
                      <button
                        type="submit"
                        className="float-left buy_now withoutDiscountClass"
                      >
                        Proceed To Pay
                      </button>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="modal" id="EnrollModal1">
        <div className="modal-dialog modal-lg modal-dialog-scrollable">
          <div className="modal-content">
            <button
              type="button"
              style={{ padding: "10px 15px" }}
              className="close text-right"
              data-dismiss="modal"
            >
              ×
            </button>

            <div className="modal-body">
              <div className="program-need-popupbtn">
                <h1>Select the Course to achieve your goal</h1>

                <ul
                  className="nav nav-pills mb-3"
                  id="pills-tab"
                  role="tablist"
                >
                  <li className="nav-item" role="presentation">
                    <a
                      className="nav-link booktrialbtn  program-btnleft"
                      id="live_class_tab"
                      data-toggle="pill"
                      href="#live_class_tab_id"
                      role="tab"
                      aria-controls="pills-profile"
                      aria-selected="false"
                    >
                      <span>
                        <i className="fa fa-play" aria-hidden="true"></i>
                      </span>{" "}
                      Join Live Courses
                    </a>
                  </li>

                  <li className="nav-item" role="presentation">
                    <a
                      className="nav-link program-btnrihgt"
                      id="pills-profile-tab02"
                      data-toggle="pill"
                      href="#pills-profile02"
                      role="tab"
                      aria-controls="pills-profile"
                      aria-selected="false"
                    >
                      <span>
                        <i
                          className="fa fa-graduation-cap"
                          aria-hidden="true"
                        ></i>
                      </span>{" "}
                      Self Paced Courses
                    </a>
                  </li>
                </ul>

                <div className="tab-content" id="pills-tabContent">
                  <div
                    className="tab-pane fade"
                    id="pills-profile02"
                    role="tabpanel"
                    aria-labelledby="pills-profile-tab02"
                  >
                    <div className="enrollbg">
                      <div className="choose-lang">
                        <h2>Choose a Language</h2>
                        <div className="choose-lang-tab">
                          <ul className="nav nav-tabs" role="tablist">
                            <li className="nav-item">
                              <a
                                className="nav-link"
                                data-toggle="tab"
                                href="#tab11"
                              >
                                <span>
                                  <i
                                    className="fa fa-check-circle-o"
                                    aria-hidden="true"
                                  ></i>
                                </span>
                                <img
                                  loading="lazy"
                                  src="/react/ai-assets/images//java-lang.png"
                                  alt=""
                                />
                              </a>
                            </li>
                            <li className="nav-item">
                              <a
                                className="nav-link"
                                data-toggle="tab"
                                href="#tab33"
                              >
                                <span>
                                  <i
                                    className="fa fa-check-circle-o"
                                    aria-hidden="true"
                                  ></i>
                                </span>
                                <img
                                  loading="lazy"
                                  src="/react/ai-assets/images//C++.webp"
                                  alt=""
                                />
                              </a>
                            </li>
                            <li className="nav-item">
                              <a
                                className="nav-link"
                                data-toggle="tab"
                                href="#tab22"
                              >
                                <span>
                                  <i
                                    className="fa fa-check-circle-o"
                                    aria-hidden="true"
                                  ></i>
                                </span>
                                <img
                                  loading="lazy"
                                  src="/react/ai-assets/images//python-lang.png"
                                  alt=""
                                />
                              </a>
                            </li>
                          </ul>

                          <div className="tab-content">
                            <div id="tab0" className="tab-pane active">
                              <br />
                              <div className="step1content">
                                <div className="step1content-img">
                                  <img
                                    loading="lazy"
                                    src="/react/ai-assets/images//step1img.webp"
                                    alt=""
                                  />
                                </div>
                                <div className="step1content-content">
                                  <h3>
                                    Experts to solve your doubts in Lectures &
                                    Assignments
                                  </h3>
                                  <p>
                                    Solve your everyday’s doubts by <br />
                                    By Team of Top tech developers of 10+ exp.
                                  </p>
                                </div>
                              </div>
                            </div>
                            <div id="tab11" className="tab-pane">
                              <br />
                              <div className="selcourse">
                                <div className="choose-lang-tab">
                                  <h2>Select a course to achieve your goals</h2>
                                  <br />
                                  <ul
                                    className="nav nav-tabs my-0"
                                    role="tablist"
                                  >
                                    <li className="nav-item w48">
                                      <a
                                        className="nav-link"
                                        href="#"
                                        data-toggle="modal"
                                        data-target="#CourseModalJavaExp"
                                      >
                                        <div className="leftimg">
                                          <img
                                            loading="lazy"
                                            className="imgim01"
                                            src="/react/ai-assets/images//courseicon01.png"
                                            alt=""
                                          />
                                        </div>
                                        <div className="rightsing">
                                          Cracking the Coding & System Design
                                          Interviews
                                          <div style={{ clear: "both" }}></div>
                                          <p>
                                            <b>Course Fee : 5,000/-</b>
                                          </p>
                                          <div className="explabel">
                                            For Working Professional
                                          </div>
                                        </div>
                                      </a>
                                    </li>
                                    <li className="nav-item w48">
                                      <a
                                        className="nav-link"
                                        href="#"
                                        data-toggle="modal"
                                        data-target="#CourseModalJavaFresher"
                                      >
                                        <div className="leftimg">
                                          <img
                                            loading="lazy"
                                            className="courseicon imgim01"
                                            src="/react/ai-assets/images//courseicon02.png"
                                            alt=""
                                          />
                                        </div>
                                        <div className="rightsing">
                                          Cracking the Placement Interviews
                                          <div style={{ clear: "both" }}></div>
                                          <p>
                                            <b>Course Fee : 4,000/-</b>
                                          </p>
                                          <div className="explabel">
                                            For Freshers
                                          </div>
                                        </div>
                                      </a>
                                    </li>
                                  </ul>
                                </div>
                              </div>
                            </div>
                            <div id="tab22" className="tab-pane fade">
                              <br />
                              <div className="selcourse">
                                <div className="choose-lang-tab">
                                  <h2>Select a course to achieve your goals</h2>
                                  <br />
                                  <ul
                                    className="nav nav-tabs my-0"
                                    role="tablist"
                                  >
                                    <li className="nav-item w48">
                                      <a
                                        className="nav-link"
                                        href="#"
                                        data-toggle="modal"
                                        data-target="#CourseModalPythonExp"
                                      >
                                        <div className="leftimg">
                                          <img
                                            loading="lazy"
                                            className="imgim01"
                                            src="/react/ai-assets/images///courseicon01.png"
                                            alt=""
                                          />
                                        </div>
                                        <div className="rightsing">
                                          Cracking the Coding Interview
                                          <div style={{ clear: "both" }}></div>
                                          <p>
                                            <b>Course Fee : 5,000/-</b>
                                          </p>
                                          <div className="explabel">
                                            For Working Professional
                                          </div>
                                        </div>
                                      </a>
                                    </li>
                                    <li className="nav-item w48">
                                      <a
                                        className="nav-link"
                                        href="#"
                                        data-toggle="modal"
                                        data-target="#CourseModalPythonFresher"
                                      >
                                        <div className="leftimg">
                                          <img
                                            loading="lazy"
                                            className="imgim01"
                                            src="/react/ai-assets/images///courseicon02.png"
                                            alt=""
                                          />
                                        </div>
                                        <div className="rightsing">
                                          Cracking the Placement Interviews
                                          <div style={{ clear: "both" }}></div>
                                          <p>
                                            <b>Course Fee : 4,000/-</b>
                                          </p>
                                          <div className="explabel">
                                            For Freshers
                                          </div>
                                        </div>
                                      </a>
                                    </li>
                                  </ul>
                                </div>
                              </div>
                            </div>

                            <div id="tab33" className="tab-pane fade">
                              <br />
                              <div className="selcourse">
                                <div className="choose-lang-tab">
                                  <h2>Select a course to achieve your goals</h2>
                                  <br />
                                  <ul
                                    className="nav nav-tabs my-0"
                                    role="tablist"
                                  >
                                    <li className="nav-item w48">
                                      <a
                                        className="nav-link"
                                        href="#"
                                        data-toggle="modal"
                                        data-target="#CourseModalCplusExp"
                                      >
                                        <div className="leftimg">
                                          <img
                                            loading="lazy"
                                            src="/react/ai-assets/images///courseicon01.png"
                                            alt=""
                                          />
                                        </div>
                                        <div className="rightsing">
                                          Cracking the Coding & System Design
                                          Interviews
                                          <p>
                                            <b>Course Fee : 5,000/-</b>
                                          </p>
                                          <div className="explabel">
                                            For Working Professional
                                          </div>
                                        </div>
                                      </a>
                                    </li>
                                    <li className="nav-item w48">
                                      <a
                                        className="nav-link"
                                        href="#"
                                        data-toggle="modal"
                                        data-target="#CourseModalCplusFresher"
                                      >
                                        <div className="leftimg">
                                          <img
                                            loading="lazy"
                                            className="courseicon"
                                            src="/react/ai-assets/images///courseicon02.png"
                                            alt=""
                                          />
                                        </div>
                                        <div className="rightsing">
                                          Cracking the Placement Interviews
                                          <div style={{ clear: "both" }}></div>
                                          <p>
                                            <b>Course Fee : 4,000/-</b>
                                          </p>
                                          <div className="explabel">
                                            For Freshers
                                          </div>
                                        </div>
                                      </a>
                                    </li>
                                  </ul>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div
                    className="tab-pane fade"
                    id="live_class_tab_id"
                    role="tabpanel"
                    aria-labelledby="live_class_tab"
                  >
                    <div className="enrollbg">
                      <div className="choose-lang">
                        <h2>Choose a Live Course</h2>
                        <div className="choose-lang-tab">
                          <div className="selcourse">
                            <div className="choose-lang-tab">
                              <h2>Select a course to achieve your goals</h2>
                              <br />

                              <ul className="nav nav-tabs my-0" role="tablist">
                                <li className="nav-item w48">
                                  <a
                                    className="nav-link"
                                    data-toggle="modal"
                                    href="#booktry2"
                                  >
                                    <div className="leftimg">
                                      <img
                                        loading="lazy"
                                        className="imgim01"
                                        src="/react/ai-assets/images//courseicon01.png"
                                        alt=""
                                      />
                                    </div>
                                    <div className="rightsing">
                                      Advanced Data Structure Algorithms &
                                      Problem Solving.
                                      <div style={{ clear: "both" }}></div>
                                      <div className="explabel">
                                        4 Months Duration
                                      </div>
                                    </div>
                                  </a>
                                </li>
                                <li className="nav-item w48">
                                  <a
                                    className="nav-link"
                                    data-toggle="modal"
                                    href="#booktry1"
                                  >
                                    <div className="leftimg">
                                      <img
                                        loading="lazy"
                                        className="courseicon imgim01"
                                        src="/react/ai-assets/images//courseicon02.png"
                                        alt=""
                                      />
                                    </div>
                                    <div className="rightsing">
                                      Advanced Data Structure Algorithms Problem
                                      Solving & System design(HLD + LLD)
                                      <div style={{ clear: "both" }}></div>
                                      <div className="explabel">
                                        7 Months Duration
                                      </div>
                                    </div>
                                  </a>
                                </li>
                              </ul>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="modal" id="AssignmentModal">
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header">
              <h4 className="modal-title">
                Move all zeros present in an array to the end
              </h4>
              <button type="button" className="close" data-dismiss="modal">
                &times;
              </button>
            </div>

            <div className="modal-body">
              <div className="assignment-content">
                <p>
                  <span>Assignment</span>
                </p>
                <p>
                  Given an array of integers, move all zeros present in the
                  array to the end. The solution should maintain the relative
                  order of items in the array.
                </p>
                <p>
                  Asked in: <span>Yahoo</span> <span>Amazon</span>
                </p>
                <p>
                  Code: <a href="#">Java</a> <a href="#">Python</a>
                </p>
                <p>
                  <span>Assignment Discussion</span>
                </p>
                <p>
                  <img
                    loading="lazy"
                    src="/react/ai-assets/images//classvideo02.webp"
                    alt=""
                    width="100%"
                  />
                </p>
              </div>
            </div>

            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-danger"
                data-dismiss="modal"
              >
                Close
              </button>
            </div>
          </div>
        </div>
      </div>

      <div className="modal" id="brochureModal">
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header">
              <h4 className="modal-title">Download Brochure Section</h4>
              <button type="button" className="close" data-dismiss="modal">
                &times;
              </button>
            </div>

            <div className="modal-body">
              <div className="usertype">
                <p>Which Course ?</p>
                <p>
                  <a
                    href="https://drive.google.com/file/d/1a4W3x9BNMPAZlJFuiOBPJ17TK1_3GP8r/view"
                    target="_blank"
                    rel="noopener"
                  >
                    Live Course
                  </a>{" "}
                  or{" "}
                  <a
                    href="https://drive.google.com/file/d/1DFE0ft8U2qvGSXFiSGbC_NUDJ7-KlmOg/view"
                    target="_blank"
                    rel="noopener"
                  >
                    Self-Paced Course
                  </a>
                </p>
              </div>
            </div>

            <div className="modal-footer">
              <button type="button" className="btn" data-dismiss="modal">
                Close
              </button>
            </div>
          </div>
        </div>
      </div>

      <div className="modal" id="chooseLanguageFreshers">
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header">
              <h4 className="modal-title"></h4>
              <button type="button" className="close" data-dismiss="modal">
                &times;
              </button>
            </div>

            <div className="modal-body">
              <div className="usertype">
                <p>Choose Language</p>
                <p>
                  <a
                    href="https://logicmojo.com/java-freshers-course"
                    target="_blank"
                    rel="noopener"
                  >
                    Java
                  </a>{" "}
                  or{" "}
                  <a
                    href="https://logicmojo.com/cpp-freshers-course"
                    target="_blank"
                    rel="noopener"
                  >
                    C/C++
                  </a>{" "}
                  or{" "}
                  <a
                    href="https://logicmojo.com/python-freshers-course"
                    target="_blank"
                    rel="noopener"
                  >
                    Python
                  </a>
                </p>
              </div>
            </div>

            <div className="modal-footer">
              <button type="button" className="btn" data-dismiss="modal">
                Close
              </button>
            </div>
          </div>
        </div>
      </div>

      <div className="modal" id="chooseLanguageExperienced">
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header">
              <h4 className="modal-title"></h4>
              <button type="button" className="close" data-dismiss="modal">
                &times;
              </button>
            </div>

            <div className="modal-body">
              <div className="usertype">
                <p>Choose Language</p>
                <p>
                  <a
                    href="https://logicmojo.com/cracking_interview"
                    target="_blank"
                    rel="noopener"
                  >
                    Java
                  </a>{" "}
                  or{" "}
                  <a
                    href="https://logicmojo.com/cpp-experienced-course"
                    target="_blank"
                    rel="noopener"
                  >
                    C/C++
                  </a>{" "}
                  or{" "}
                  <a
                    href="https://logicmojo.com/python-experienced-course"
                    target="_blank"
                    rel="noopener"
                  >
                    Python
                  </a>
                </p>
              </div>
            </div>

            <div className="modal-footer">
              <button type="button" className="btn" data-dismiss="modal">
                Close
              </button>
            </div>
          </div>
        </div>
      </div>

      <div className="modal" id="SchduleMeeting">
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header">
              <div className="usertype">
                <p className="modal-title">
                  <b>Ask all queries from career counsellor</b>
                </p>
              </div>

              <button type="button" className="close" data-dismiss="modal">
                &times;
              </button>
            </div>
          </div>
        </div>
      </div>

      <div className="modal" id="MoreModal">
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-body">
              <div className="morevidimg">
                <img
                  loading="lazy"
                  src="/react/ai-assets/images//arrayProblems2.png"
                  alt=""
                  style={{ width: "width:100%" }}
                />
                <a href="javascript:void(0)" className="lockicon">
                  <i className="fa fa-lock" aria-hidden="true"></i>
                  <span className="lockhovertext">
                    Please click on Enroll Now to view all lectures
                  </span>
                </a>

                <p>
                  You can access all lectures of course after purchase
                  subscription.
                </p>
                <p>
                  <a
                    style={{
                      textTransform: "uppercase",
                      fontSize: "12px",
                      fontWeight: "600",
                    }}
                    // href="https://logicmojo.com/register"
                    className="btn btn-danger enrollbutton"
                    data-toggle="modal"
                    href="#EnrollModal1"
                  >
                    Enroll Now
                  </a>
                </p>
                <p>
                  <a href="javascript:void(0)" className="btn btn-danger">
                    Enroll Now
                  </a>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <a id="call_now_btn" href="tel:+918088975867" style={{ display: "none" }}>
        <div>
          <i className="fa fa-phone mr-2"></i>Call Now
        </div>
      </a>

      <div id="myCModal1" className="modal fade" role="dialog">
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header">
              <h4 className="modal-title">
                Move all zeros present in an array to the end
              </h4>
              <button type="button" className="close" data-dismiss="modal">
                &times;
              </button>
            </div>
            <div className="modal-body">
              <div className="row col-sm-12">
                <p>
                  <span className="custom-badge">Assignment</span>
                </p>
                <p>
                  <b>
                    Given an array of integers, move all zeros present in the
                    array to the end. The solution should maintain the relative
                    order of items in the array.
                  </b>
                </p>
                <p>
                  <b>Asked in: </b>
                  <span className="custom-badge"> Yahoo</span>
                  <span className="custom-badge"> Amazon</span>
                </p>
                <br />
              </div>
              <div className="row col-sm-12">
                <div className="col-sm-8 text-left p-0 mb-3">
                  <span className="font_14">
                    <b>Code: </b>
                  </span>
                  <a
                    className="btn assignment-btn"
                    style={{ margin: "0 10px 0 0" }}
                    target="_blank"
                    rel="noopener"
                    href="https://logicmojo.com/home-problem/1/2/1"
                  >
                    Java
                  </a>
                  <a
                    className="btn assignment-btn"
                    style={{ margin: "0 10px 0 0" }}
                    target="_blank"
                    rel="noopener"
                    href="https://logicmojo.com/home-problem/1/2/2"
                  >
                    Python
                  </a>
                  <a
                    className="btn assignment-btn"
                    target="_blank"
                    rel="noopener"
                    href="https://logicmojo.com/home-problem/1/2/3"
                  >
                    C++
                  </a>
                </div>
                <br />
                <p>
                  <span className="custom-badge">Assignment Discussion</span>
                </p>
                <div className="col-sm-4 text-right p-0 mt-3 mb-3 d-none">
                  <a
                    className="downbtninfoss1"
                    style={{ margin: "0", display: "inline-block" }}
                    href="javascript:void(0);"
                  >
                    Assignment
                  </a>
                </div>
              </div>

              <div
                id="myCModal1Video"
                style={{ height: "350px", width: "100%" }}
              ></div>
              {/* <video width="100%" controls>
                <source
                  src="/react/ai-assets/video/SumTreeComplete.mov"
                  type="video/mp4"
                />
              </video> */}
              <p>
                Lorem Ipsum is simply dummy text of the printing and typesetting
                industry. Lorem Ipsum has been the industry's standard dummy
                text ever since the 1500s, when an unknown printer took a galley
                of type and scrambled it to make a type specimen book.
              </p>
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-default viewcousebtn2"
                data-dismiss="modal"
              >
                Close
              </button>
            </div>
          </div>
        </div>
      </div>

      <div id="myCModal2" className="modal fade" role="dialog">
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header">
              <h4 className="modal-title">Design Blackjack Game </h4>
              <button type="button" className="close" data-dismiss="modal">
                &times;
              </button>
            </div>
            <div className="modal-body">
              <div className="row col-sm-12">
                <p>
                  <span className="custom-badge">Assignment</span>
                </p>
                <p>
                  <b>
                    Design Object Oriented Design for Backjack Game using Deck
                    of cards.
                  </b>
                </p>
                <p>
                  <b>Asked in: </b>
                  <span className="custom-badge"> Flipkart</span>
                  <span className="custom-badge"> Uber</span>
                </p>
                <br />
                <p>
                  <span className="custom-badge">Assignment Discussion</span>
                </p>
              </div>
              <div
                id="myCModal2Video"
                style={{ height: "350px", width: "100%" }}
              ></div>
              {/* <video width="100%" controls>
                <source
                  src="/react/ai-assets/video/DesignBlackJack.mov"
                  type="video/mp4"
                />
              </video> */}
              <p>
                Lorem Ipsum is simply dummy text of the printing and typesetting
                industry. Lorem Ipsum has been the industry's standard dummy
                text ever since the 1500s, when an unknown printer took a galley
                of type and scrambled it to make a type specimen book.
              </p>
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-default viewcousebtn2"
                data-dismiss="modal"
              >
                Close
              </button>
            </div>
          </div>
        </div>
      </div>

      <div id="myCModal3" className="modal fade" role="dialog">
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header">
              <h4 className="modal-title">
                Design data structure that support Insert,remove(),
                findMiddle(), deleteMiddle() operation in O(1)
              </h4>
              <button type="button" className="close" data-dismiss="modal">
                &times;
              </button>
            </div>
            <div className="modal-body">
              <div className="row col-sm-12">
                <p>
                  <span className="custom-badge">Assignment</span>
                </p>
                <p>
                  <b>
                    You need to design a data structure which support below
                    operation in O(1) time complexity
                    <br />
                    1) Insert() which adds an element to the data structure
                    <br />
                    2) remove() which removes an element from the data structure
                    <br />
                    3) findMiddle() which will return middle element
                  </b>
                </p>
                <p>
                  <b>Asked in: </b>
                  <span className="custom-badge"> Amazon</span>
                  <span className="custom-badge"> Intuit</span>
                  <span className="custom-badge"> Adobe</span>
                </p>
                <div className="row col-sm-12">
                  <div className="col-sm-12 text-left p-0 mb-3">
                    <span className="font_14">
                      <b>Code: </b>
                    </span>
                    <a
                      className="btn assignment-btn"
                      style={{ margin: "0 10px 0 0", width: "100%" }}
                      target="_blank"
                      rel="noopener"
                      href="https://logicmojo.com/home-problem/2/1/1"
                    >
                      Java
                    </a>
                    <a
                      className="btn assignment-btn"
                      style={{ margin: "0 10px 0 0" }}
                      target="_blank"
                      rel="noopener"
                      href="https://logicmojo.com/home-problem/2/1/2"
                    >
                      Python
                    </a>
                    <a
                      className="btn assignment-btn"
                      target="_blank"
                      rel="noopener"
                      href="https://logicmojo.com/home-problem/2/2/3"
                    >
                      C++
                    </a>
                  </div>
                  <div className="col-sm-4 text-right p-0 mt-3 mb-3 d-none">
                    <a
                      className="downbtninfoss1"
                      style={{ margin: "0", display: "inline-block" }}
                      href="javascript:void(0);"
                    >
                      Assignment
                    </a>
                  </div>
                </div>
                <br />
                <p>
                  <span className="custom-badge">Assignment Discussion</span>
                </p>
              </div>

              <div
                id="myCModal3Video"
                style={{ height: "350px", width: "100%" }}
              ></div>
              {/* <video width="100%" controls>
                <source
                  src="/react/ai-assets/video/FindMiddleInO(n).mov"
                  type="video/mp4"
                />
              </video> */}
              <p>
                Lorem Ipsum is simply dummy text of the printing and typesetting
                industry. Lorem Ipsum has been the industry's standard dummy
                text ever since the 1500s, when an unknown printer took a galley
                of type and scrambled it to make a type specimen book.
              </p>
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-default viewcousebtn2"
                data-dismiss="modal"
              >
                Close
              </button>
            </div>
          </div>
        </div>
      </div>

      <div id="myCModal_45_3" className="modal fade" role="dialog">
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header">
              <h4 className="modal-title">
                Data Structure which support Insert delete, Random in O(1) time
              </h4>
              <button type="button" className="close" data-dismiss="modal">
                &times;
              </button>
            </div>
            <div className="modal-body">
              <div className="row col-sm-12">
                <p>
                  <span className="custom-badge">Assignment</span>
                </p>
                <p>
                  <b>
                    You need to design a data structure which support below
                    operation in O(1) time complexity
                    <br />
                    1) Insert() which adds an element to the data structure
                    <br />
                    2) remove() which removes an element from the data structure
                    <br />
                    3) getRandom: Returns a random element from current set of
                    elements
                  </b>
                </p>
                <p>
                  <b>Asked in: </b>
                  <span className="custom-badge"> Amazon</span>
                  <span className="custom-badge"> Intuit</span>
                  <span className="custom-badge"> Adobe</span>
                </p>
                <br />
                <p>
                  <span className="custom-badge">Assignment Discussion</span>
                </p>
              </div>
              <div className="row col-sm-12">
                <div className="col-sm-12 text-left p-0 mb-3">
                  <span className="font_14">
                    <b>Code: </b>
                  </span>
                  <a
                    className="btn assignment-btn"
                    style={{ margin: "0 10px 0 0" }}
                    target="_blank"
                    rel="noopener"
                    href="https://logicmojo.com/home-problem/2/2/1"
                  >
                    Java
                  </a>
                  <a
                    className="btn assignment-btn"
                    style={{ margin: "0 10px 0 0" }}
                    target="_blank"
                    rel="noopener"
                    href="https://logicmojo.com/home-problem/2/2/2"
                  >
                    Python
                  </a>
                  <a
                    className="btn assignment-btn"
                    target="_blank"
                    rel="noopener"
                    href="https://logicmojo.com/home-problem/2/2/3"
                  >
                    C++
                  </a>
                </div>
                <div className="col-sm-4 text-right p-0 mt-3 mb-3 d-none">
                  <a
                    className="downbtninfoss1"
                    style={{ margin: "0", display: "inline-block" }}
                    href="javascript:void(0);"
                  >
                    Assignment
                  </a>
                </div>
              </div>
              <div
                id="myCModal_45_3Video"
                style={{ height: "350px", width: "100%" }}
              ></div>
              {/* <video width="100%" controls>
                <source
                  src="/react/ai-assets/video/FindMiddleInO(n).mov"
                  type="video/mp4"
                />
              </video> */}
              <p>
                Lorem Ipsum is simply dummy text of the printing and typesetting
                industry. Lorem Ipsum has been the industry's standard dummy
                text ever since the 1500s, when an unknown printer took a galley
                of type and scrambled it to make a type specimen book.
              </p>
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-default viewcousebtn2"
                data-dismiss="modal"
              >
                Close
              </button>
            </div>
          </div>
        </div>
      </div>

      <div id="myCModal4" className="modal fade" role="dialog">
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header">
              <h4 className="modal-title">Design Deck of Card </h4>
              <button type="button" className="close" data-dismiss="modal">
                &times;
              </button>
            </div>
            <div className="modal-body">
              <div className="row col-sm-12">
                <p>
                  <span className="custom-badge">Assignment</span>
                </p>
                <p>
                  <b>Design Object Oriented Design for Deck of cards.</b>
                </p>
                <p>
                  <b>Asked in: </b>
                  <span className="custom-badge"> Flipkart</span>
                  <span className="custom-badge"> Uber</span>
                </p>
                <br />
                <p>
                  <span className="custom-badge">Assignment Discussion</span>
                </p>
              </div>
              <div
                id="myCModal4Video"
                style={{ height: "350px", width: "100%" }}
              ></div>
            
              <p>
                Lorem Ipsum is simply dummy text of the printing and typesetting
                industry. Lorem Ipsum has been the industry's standard dummy
                text ever since the 1500s, when an unknown printer took a galley
                of type and scrambled it to make a type specimen book.
              </p>
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-default viewcousebtn2"
                data-dismiss="modal"
              >
                Close
              </button>
            </div>
          </div>
        </div>
      </div>

      <div id="myCModal5" className="modal fade" role="dialog">
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header">
              <h4 className="modal-title">
                Print all the boundary nodes of Binary Tree{" "}
              </h4>
              <button type="button" className="close" data-dismiss="modal">
                &times;
              </button>
            </div>
            <div className="modal-body">
              <div className="row col-sm-12">
                <p>
                  <span className="custom-badge">Assignment</span>
                </p>
                <p>
                  <b>
                    Print all the boundary nodes in the binary tree.Boundary
                    includes left boundary, leaves, and right boundary in anti
                    clockwise direction in O(n) Time Complexity.
                  </b>
                </p>
                <p>
                  <b>Asked in: </b>
                  <span className="custom-badge"> Flipkart</span>
                  <span className="custom-badge"> OLA</span>
                </p>
                <br />
                <div className="row col-sm-12">
                  <div className="col-sm-12 text-left p-0 mb-3">
                    <span className="font_14">
                      <b>Code: </b>
                    </span>
                    <a
                      className="btn assignment-btn"
                      style={{ margin: "0 10px 0 0" }}
                      target="_blank"
                      rel="noopener"
                      href="https://logicmojo.com/home-problem/2/2/1"
                    >
                      Java
                    </a>
                    <a
                      className="btn assignment-btn"
                      style={{ margin: "0 10px 0 0" }}
                      target="_blank"
                      rel="noopener"
                      href="https://logicmojo.com/home-problem/2/2/2"
                    >
                      Python
                    </a>
                    <a
                      className="btn assignment-btn"
                      target="_blank"
                      rel="noopener"
                      href="https://logicmojo.com/home-problem/4/2/3"
                    >
                      C++
                    </a>
                  </div>
                  <div className="col-sm-4 text-right p-0 mt-3 mb-3 d-none">
                    <a
                      className="downbtninfoss1"
                      style={{ margin: "0", display: "inline-block" }}
                      href="javascript:void(0);"
                    >
                      Assignment
                    </a>
                  </div>
                </div>
                <p>
                  <span className="custom-badge">Assignment Discussion</span>
                </p>
              </div>
              <div
                id="myCModal5Video"
                style={{ height: "350px", width: "100%" }}
              ></div>
              <br />

              {/* <video width="100%" controls>
                <source
                  src="/react/ai-assets/video/DesignBlackJack.mov"
                  type="video/mp4"
                />
              </video> */}
              <p>
                Lorem Ipsum is simply dummy text of the printing and typesetting
                industry. Lorem Ipsum has been the industry's standard dummy
                text ever since the 1500s, when an unknown printer took a galley
                of type and scrambled it to make a type specimen book.
              </p>
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-default viewcousebtn2"
                data-dismiss="modal"
              >
                Close
              </button>
            </div>
          </div>
        </div>
      </div>

      <div className="modal fade" id="introvideo">
        <div className="modal-dialog modal-dialog-centered modal-lg">
          <div className="modal-content">
            <div className="modal-body">
              <button type="button" className="close" data-dismiss="modal">
                &times;
              </button>
              
              <LazyLoad height={500} offsetVertical={300}>
                <div>
                  <YouTube
                    videoId={"F9Lf-mejfdA"}
                    opts={{
                      width: "100%",
                      height: "500px",
                      playerVars: {
                        autoplay: 0,
                      },
                    }}
                  />
                </div>
              </LazyLoad>
            </div>
          </div>
        </div>
      </div>

      <div className="modal fade" id="counsellingpopup">
        <div className="modal-dialog modal-lg modal_width">
          <div className="modal-content">
            <div className="modal-body">
              <div className="counsellingpopupbg">
                <button type="button" className="close" data-dismiss="modal">
                  &times;
                </button>
                <div className="counsellingpopupbg-img">
                  <img
                    loading="lazy"
                    src="/react/ai-assets/images//counselling_new.jpeg"
                    alt="counselling_new"
                  />
                </div>
                <div className="counsellingpopupbg-form counseling_thanks">
                  <h1>
                    Schedule Call Back From Experts For Live Classes Queries
                  </h1>

                 
                  <iframe
                    src="https://logicmojo.com/counsellingpopup"
                    className="counsellingpopupbgIframe"
                    title="popup form"
                  ></iframe>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="modal" id="brochureModal">
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header">
              <h4 className="modal-title">Brochure Section</h4>
              <button type="button" className="close" data-dismiss="modal">
                &times;
              </button>
            </div>

            <div className="modal-body">
              <div className="usertype">
                <p className="usertype-heading">Are you a</p>
                <p>
                  <a
                    href="https://drive.google.com/file/d/13P_eSsVdGGZKd-3JOnM-SMT2lO2wX2rR/view"
                    target="_blank"
                    rel="noopener"
                    className="btnfresher"
                  >
                    Fresher
                  </a>{" "}
                  or{" "}
                  <a
                    href="https://drive.google.com/file/d/1DFE0ft8U2qvGSXFiSGbC_NUDJ7-KlmOg/view"
                    target="_blank"
                    rel="noopener"
                    className="btnfresher"
                  >
                    Experienced
                  </a>
                </p>
              </div>
            </div>

            <div className="modal-footer">
              <button type="button" className="btn" data-dismiss="modal">
                Close
              </button>
            </div>
          </div>
        </div>
      </div>

      <div className="modal" id="EnrollModal">
        <div className="modal-dialog modal-lg padwidbox">
          <div className="modal-content">
            <button
              type="button"
              className="close applyclose"
              data-dismiss="modal"
            >
              &times;
            </button>

            <div className="modal-body padpop">
              <div className="applyinfobox">
                <div className="row">
                  <div className="col-lg-6 col-md-6">
                    <div className="popleftimg">
                      <img
                        loading="lazy"
                        src="/react/ai-assets/images//applyimg.jpg"
                        alt=""
                      />
                    </div>
                  </div>
                  <div className="col-lg-6 col-md-6">
                    <div className="applynowform">
                      <h2>Apply For Profile Review</h2>
                      <p>
                        Please enter the following details to initiate your
                        application{" "}
                      </p>
                      <div className="forminfoss">
                        <div className="row">
                          <div className="col-lg-12">
                            <input
                              type="text"
                              placeholder="Full Name*"
                              name=""
                              className="applyinput"
                            />
                          </div>
                          <div className="col-lg-12">
                            <input
                              type="text"
                              placeholder="Email*"
                              name=""
                              className="applyinput"
                            />
                          </div>
                          <div className="col-lg-12">
                            <input
                              type="text"
                              placeholder="Mobile No.*"
                              name=""
                              className="applyinput"
                            />
                          </div>
                          <div className="col-lg-12">
                            <select className="applyinput">
                              <option>Select Your Work Experience</option>
                              <option>Work Experience</option>
                              <option>College Student</option>
                              <option>Fresher(less than 1 year)</option>
                              <option>1 to 3 year</option>
                              <option>3 to 7 year</option>
                            </select>
                          </div>
                          <div className="col-lg-12">
                            <select className="applyinput">
                              <option>Select Course</option>
                            </select>
                          </div>
                          <h3>Schedule Your Appointment *</h3>
                          <div className="col-lg-6 col-md-6">
                            <input
                              type="date"
                              name=""
                              placeholder="select date"
                              className="applyinput"
                            />
                          </div>
                          <div className="col-lg-6 col-md-6">
                            <input
                              type="time"
                              name=""
                              placeholder="select Time"
                              className="applyinput"
                            />
                          </div>
                          <span>
                            By submitting the form, you agree to our Terms and
                            Conditions
                            <br /> and our Privacy Policy.
                          </span>
                          <div className="col-lg-12">
                            <input
                              type="submit"
                              value="Apply Now"
                              name=""
                              className="btnapply"
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>


      <div className="fulltrakmenu sticky firstmenu" id="menufixinfo">
  <div className="container">
    <nav className="navbar navbar-expand-md navbar-light trakmenu">
      
      <a className="navbar-brand" href="index.html">
        
        <img
          src="https://logicmojo.com/assets/dist/new_index_design/images/LogicmojoLogo.png"
          alt="Mobile Logo"
          className="new_logo d-md-none d-block"
        />
      </a>

     
      <div className="right-btn d-md-none d-block">
      <a
    href="#"
    className="enroll-btn btn btn-danger"
    onClick={(e) => {
      e.preventDefault(); // Prevents page reload
      window.open('https://calendly.com/logicmojo/schedule-call-back-from-experts-for-live-classes?month=2026-06', '_blank', 'noopener,noreferrer');
    }}
  >
    <b>Request a Call</b>
  </a>
        <button
          className="navbar-toggler"
          type="button"
          data-toggle="collapse"
          data-target="#mainnav1"
          aria-controls="mainnav1"
          aria-expanded="false"
          aria-label="Toggle navigation"
        >
          <span className="navbar-toggler-icon"></span>
        </button>
      </div>

      
      <div className="collapse navbar-collapse padtrkss" id="mainnav1">
        <ul className="navbar-nav ml-auto">
          <li>
            <a
              target="_default"
              className="mobclose live-course-link"
              href="https://calendly.com/logicmojo/schedule-call-back-from-experts-for-live-classes?month=2026-06"
            >
              Live Course<span className="newclass">New Batch</span>
            </a>
          </li>
          <li className="nav-item dropdown megamenubg">
            <DropdownMenu />
          </li>
          <li><a className="mobclose" href="#Demo">Demo Session</a></li>
          <li>
            <a
              target="_default"
              className="mobclose"
              href="https://drive.google.com/file/d/1SzaTFL3QiyuRzbtjI7e0dzMDCnLxtr0A/view"
            >
              Course Brochure
            </a>
          </li>
          
          <li><a className="mobclose" href="#Review">Review</a></li>
          <li><a className="mobclose" href="#Contact">Contact Us</a></li>
          <li className="applynow">
            <a data-toggle="modal" href="#EnrollModal1">Enroll Now</a>
          </li>
          <li className="applynow loginbtn">
            <a target="_default" href="https://logicmojo.com/user" className="my-login">Log In</a>
          </li>
        </ul>
      </div>
    </nav>
  </div>
</div>


      
      

     

      <div className="fulltrakmenu sticky secondmenu d-none" id="menufixinfo12">
        <div className="container">
          <nav className="navbar navbar-expand-md navbar-light trakmenu">
            <a className="navbar-brand" href="index.html">
            <img
          src="https://logicmojo.com/assets/dist/new_index_design/images/LogicmojoLogo.png"
          alt="Mobile Logo"
          className="new_logo d-md-none d-block"
        />
            </a>
            <div className="right-btn d-md-none d-block">
            <a
    href="#"
    className="enroll-btn btn btn-danger"
    onClick={(e) => {
      e.preventDefault(); // Prevents page reload
      window.open('https://calendly.com/logicmojo/schedule-call-back-from-experts-for-live-classes?month=2026-06', '_blank', 'noopener,noreferrer');
    }}
  >
    <b>Request a Call</b>
  </a>
  
              <button
                className="navbar-toggler"
                type="button"
                data-toggle="collapse"
                data-target="#mainnav1"
                aria-controls="mainnav1"
                aria-expanded="false"
                aria-label="Toggle navigation"
              >
                {" "}
                <span className="navbar-toggler-icon"></span>{" "}
              </button>
            </div>

            <div className="collapse navbar-collapse padtrkss" id="mainnav1">
        <ul className="navbar-nav ml-auto">
          <li>
            <a
              target="_default"
              className="mobclose live-course-link"
              href="https://calendly.com/logicmojo/schedule-call-back-from-experts-for-live-classes?month=2026-06"
            >
              Live Course<span className="newclass">New Batch</span>
            </a>
          </li>
          <li className="nav-item dropdown megamenubg">
            <DropdownMenu />
          </li>
          <li><a className="mobclose" href="#Demo">Demo Session</a></li>
          <li>
            <a
              target="_default"
              className="mobclose"
              href="https://drive.google.com/file/d/1SzaTFL3QiyuRzbtjI7e0dzMDCnLxtr0A/view"
            >
              Course Brochure
            </a>
          </li>
          
          <li><a className="mobclose" href="#Review">Review</a></li>
          <li>
                  <a className="mobclose" href="#Syllabus">
                    Syllabus
                  </a>
                </li>
          <li><a className="mobclose" href="#Contact">Contact Us</a></li>
          <li className="applynow">
  <a
    href="#"
    className="enroll-btn btn btn-danger"
    onClick={(e) => {
      e.preventDefault(); // Prevents page reload
      window.open('https://calendly.com/logicmojo/schedule-call-back-from-experts-for-live-classes?month=2026-06', '_blank', 'noopener,noreferrer');
    }}
  >
    <b>Request a Call</b>
  </a>
</li>
          
        </ul>
      </div>
          </nav>
        </div>
      </div>

     

      
     
    
       <section className="sec-navbar d-none">
        <nav className="container d-flex justify-content-between align-items-center">
          
          <ul id="scrollble-ul-page">
          <li className={`scrollble-tab-li ${isVisibleOverview ? "active" : ""}`}>
              <a href="#Overview">Overview</a>
            </li>

            <li className={`scrollble-tab-li ${isVisibleCourses ? "active" : ""}`}>
              <a href="#LiveCourse">Courses</a>
            </li>

            <li className={`scrollble-tab-li ${isVisibleDemo ? "active" : ""}`}>
              <a href="#Demo">Demo Class</a>
            </li>

            <li className="">
              <a
                target="_default"
                href="https://drive.google.com/file/d/1SzaTFL3QiyuRzbtjI7e0dzMDCnLxtr0A/view"
              >
                Course Brochure
              </a>
            </li>

            <li className={`scrollble-tab-li ${isVisibleSyllabus ? "active" : ""}`}>
              <a href="#Syllabus">Syllabus</a>
            </li>

            <li className={`scrollble-tab-li ${isVisibleFee ? "active" : ""}`}>
              <a href="#Fee">Fee</a>
            </li>
            <li className={`scrollble-tab-li ${isVisibleReview ? "active" : ""}`}>
              <a href="#Review">Review</a>
            </li>

            <li className={`scrollble-tab-li ${isVisibleCurriculum ? "active" : ""}`}>
              <a href="#Curriculum">Curriculum</a>
            </li>

            <li className={`scrollble-tab-li ${isVisibleContact ? "active" : ""}`}>
              <a href="#Contacts">Contacts</a>
            </li>

            
            
            
            <li className="">
              <a href="#FAQ">FAQ</a>
            </li>
          </ul>
        </nav>
        
      </section>
      
      
      
     

    
      

     {/*<div className="clientsquotes" id="expertshail">
        <div className="container">
          <h3> Our students have gotten job offers from :</h3>

          <ul>
            <li>
              <img
                loading="lazy"
                src="/react/ai-assets/images//quateslogo1.png"
                alt=""
              />
            </li>

            <li>
              <img
                loading="lazy"
                src="/react/ai-assets/images//quateslogo2.png"
                alt=""
              />
            </li>

            <li>
              <img
                loading="lazy"
                src="/react/ai-assets/images//quateslogo3.png"
                alt=""
              />
            </li>

            <li>
              <img
                loading="lazy"
                src="/react/ai-assets/images//quateslogo4.png"
                alt=""
              />
            </li>

            <li>
              <img
                loading="lazy"
                src="/react/ai-assets/images//quateslogo5.png"
                alt=""
              />
            </li>
          </ul>

          <div className="ourexprtsilder">
            <OwlCarousel
              className="owl-theme"
              loop
              margin={10}
              nav
              dots={false}
              navText={[
                " ",
                " ",
              ]}
              responsive={{
                0: {
                  items: 1,
                },
                600: {
                  items: 2,
                },
                960: {
                  items: 3,
                },
                1200: {
                  items: 3,
                },
              }}
            >
              <div className="item">
                <div className="quotesinner">
                  <img
                    loading="lazy"
                    src="/react/ai-assets/images//quote.png"
                    alt=""
                  />

                  <p>
                    Must recommend for the aspirants who are preparing for
                    Amazon, Google, Microsoft, and Top Product Based Company
                    interview. Logicmojo focus on techniques of solving data
                    structures & system design problems
                  </p>

                  <div className="clientspic">
                    <img
                      loading="lazy"
                      src="/react/ai-assets/images//anjani.png"
                      alt=""
                    />
                    <label>Anjani Kumar</label>
                  </div>

                  <span>
                    <img
                      loading="lazy"
                      src="/react/ai-assets/images//amazonlogo.jpg"
                      alt=""
                    />
                  </span>
                </div>
              </div>

              <div className="item">
                <div className="quotesinner">
                  <img
                    loading="lazy"
                    src="/react/ai-assets/images//quote.png"
                    alt=""
                  />

                  <p>
                    The course curriculum is of the best quality along with the
                    best learning experience from my tutor. Best course to
                    prepare for MAANG companies interview. I cracked Paytm,
                    Adobe, Intuit, and Microsoft. Finally joined Microsoft at
                    1.3 Cr LPA Hyderabad MS IDC
                  </p>

                  <div className="clientspic">
                    <img
                      loading="lazy"
                      src="/react/ai-assets/images//piyush.png"
                      alt=""
                    />
                    <label>Piyush</label>
                  </div>

                  <span>
                    <img
                      loading="lazy"
                      src="/react/ai-assets/images//microsoftlogo1.png"
                      alt=""
                    />
                  </span>
                </div>
              </div>

              <div className="item">
                <div className="quotesinner">
                  <img
                    loading="lazy"
                    src="/react/ai-assets/images//quote.png"
                    alt=""
                  />

                  <p>
                    Excellent course for interview preparation, very straight to
                    the point ,in depth coverage of every point. Nice way of
                    explaining solutions to very complex problems in easy way.
                    It helps me to land at Architect Position in WalmartLabs as
                    well as VISA.
                  </p>

                  <div className="clientspic">
                    <img
                      loading="lazy"
                      src="/react/ai-assets/images//diwakar.png"
                      alt=""
                    />
                    <label>Diwakar Choudhary</label>
                  </div>

                  <span>
                    <img
                      loading="lazy"
                      src="/react/ai-assets/images//walmartlbslogo.jpg"
                      alt=""
                    />
                  </span>
                </div>
              </div>

              <div className="item">
                <div className="quotesinner">
                  <img
                    loading="lazy"
                    src="/react/ai-assets/images//quote.png"
                    alt=""
                  />

                  <p>
                    I would say the best part is the explanation by the
                    instructor, concise and clear. Great quality of online
                    materials and classes, it covers all algorithms and system
                    design problems asked during interviews
                  </p>

                  <div className="clientspic">
                    <img
                      loading="lazy"
                      src="/react/ai-assets/images//arvindo.jpg"
                      alt=""
                    />
                    <label>Aravindo Swain</label>
                  </div>

                  <span>
                    <img
                      loading="lazy"
                      src="/react/ai-assets/images//microsoftlogo.jpg"
                      alt=""
                    />
                  </span>
                </div>
              </div>

              <div className="item">
                <div className="quotesinner">
                  <img
                    loading="lazy"
                    src="/react/ai-assets/images//quote.png"
                    alt=""
                  />

                  <p>
                    Great course! Definitely helped me open some new doors in
                    understanding how algorithms work and implementing solutions
                    for the different exercises
                  </p>

                  <div className="clientspic">
                    <img
                      loading="lazy"
                      src="/react/ai-assets/images//rajnish.jpg"
                      alt=""
                    />
                    <label>Rajnish Kumar</label>
                  </div>

                  <span>
                    <img
                      loading="lazy"
                      src="/react/ai-assets/images//flipcart.jpg"
                      alt=""
                    />
                  </span>
                </div>
              </div>

              <div className="item">
                <div className="quotesinner">
                  <img
                    loading="lazy"
                    src="/react/ai-assets/images//quote.png"
                    alt=""
                  />

                  <p>
                    Must recommend for the aspirants who are preparing for
                    Amazon, Google, Microsoft and Top Product Based Company
                    interview
                  </p>

                  <div className="clientspic">
                    <img
                      loading="lazy"
                      src="/react/ai-assets/images//Ranjan-kumar.png"
                      alt=""
                    />
                    <label>Ranjan Kumar</label>
                  </div>

                  <span>
                    <img
                      loading="lazy"
                      src="/react/ai-assets/images//amazonlogo.jpg"
                      alt=""
                    />
                  </span>
                </div>
              </div>

              <div className="item">
                <div className="quotesinner">
                  <img
                    loading="lazy"
                    src="/react/ai-assets/images//quote.png"
                    alt=""
                  />

                  <p>
                    The course curriculum is of best quality along with good
                    coding problems.It's like a quick interview preparation
                    guide
                  </p>

                  <div className="clientspic">
                    <img
                      loading="lazy"
                      src="/react/ai-assets/images//priya1.png"
                      alt=""
                    />
                    <label>Priya Singh</label>
                  </div>

                  <span>
                    <img
                      loading="lazy"
                      src="/react/ai-assets/images//ciscologo.jpg"
                      alt=""
                    />
                  </span>
                </div>
              </div>

              <div className="item">
                <div className="quotesinner">
                  <img
                    loading="lazy"
                    src="/react/ai-assets/images//quote.png"
                    alt=""
                  />

                  <p>
                    Excellent course for interview preparation, very straight to
                    the point ,in depth coverage of every point. Nice way of
                    explaining solutions to very complex problems in easy way
                  </p>

                  <div className="clientspic">
                    <img
                      loading="lazy"
                      src="/react/ai-assets/images//diwakar.png"
                      alt=""
                    />
                    <label>Diwakar Choudhary</label>
                  </div>

                  <span>
                    <img
                      loading="lazy"
                      src="/react/ai-assets/images//walmartlbslogo.jpg"
                      alt=""
                    />
                  </span>
                </div>
              </div>

              <div className="item">
                <div className="quotesinner">
                  <img
                    loading="lazy"
                    src="/react/ai-assets/images//quote.png"
                    alt=""
                  />

                  <p>
                    Very well-arranged course and its amazing lectures. Focus on
                    lectures concepts & techniques than solving thousands of
                    problems of Leetcode. Problems set in the course is more
                    than enough for top tech companies interviews.
                  </p>

                  <div className="clientspic">
                    <img
                      loading="lazy"
                      src="/react/ai-assets/images//Ranjan-kumar.png"
                      alt=""
                    />
                    <label>Ranjan kumar</label>
                  </div>

                  <span>
                    <img
                      loading="lazy"
                      src="/react/ai-assets/images//amazonlogo.jpg"
                      alt=""
                    />
                  </span>
                </div>
              </div>
            </OwlCarousel>

          </div>
        </div>
      </div>*/}

      

      {/*<XmasNewYearDiscount />*/}


      <div className="coursesbg liveprogrambg">
        <div className="container">
          <ul className="nav nav-pills mb-3" id="pills-tab" role="tablist">
            <li className="nav-item" role="presentation">
              <a
                className="nav-link active m-0"
                id="pills-home-tab002"
                data-toggle="pill"
                href="#pills-home002"
                role="tab"
                aria-controls="pills-home"
                aria-selected="true"
              >
                Live Classes
              </a>
            </li>
          </ul>

      
          <div className="tab-content" id="pills-tabContent">
            <div
              className="tab-pane fade active show"
              id="pills-home002"
              role="tabpanel"
              aria-labelledby="pills-home-tab002"
            >
              <div className="liveprogram-innerbg">
                <h1>
                  We have designed a <span>live interactive program</span> for
                  you
                </h1>

                <div className={`row align-items-center justify-content-center ${hasRevealedOverview ? "liveprogram-visible" : ""}`} ref={overviewSection}>
                  <div className="col-lg-3 col-md-4">
                    <div className={`flip-card ${flippedCard === 0 ? "flipped" : ""}`} onClick={() => handleCardFlip(0)}>
                      <div className="flip-card-inner">
                        <div className="flip-card-front">
                          <img
                            loading="lazy"
                            src="/react/ai-assets/images//live-interactive.png"
                            alt=""
                          />
                          <h3>Live Interactive Sessions</h3>
                        </div>
                        <div className="flip-card-back">
                          Get Trained by MAANG Industry Experts Live classes
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="col-lg-3 col-md-4">
                    <div className={`flip-card ${flippedCard === 1 ? "flipped" : ""}`} onClick={() => handleCardFlip(1)}>
                      <div className="flip-card-inner">
                        <div className="flip-card-front">
                          <img
                            loading="lazy"
                            src="/react/ai-assets/images//liveicon-1.png"
                            alt=""
                          />
                          <h3> Practical experience through Projects</h3>
                        </div>
                        <div className="flip-card-back">
                          Practical experience through real-time projects
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="col-lg-3 col-md-4">
                    <div className={`flip-card ${flippedCard === 2 ? "flipped" : ""}`} onClick={() => handleCardFlip(2)}>
                      <div className="flip-card-inner">
                        <div className="flip-card-front">
                          <img
                            loading="lazy"
                            src="/react/ai-assets/images//liveicon-2.png"
                            alt=""
                          />
                          <h3> 1:1 doubt clearing sessions</h3>
                        </div>
                        <div className="flip-card-back">
                          Personalized programs with Live classes and 1:1 doubt
                          clearing sessions/mentorship sessions.
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="col-lg-3 col-md-4">
                    <div className={`flip-card ${flippedCard === 3 ? "flipped" : ""}`} onClick={() => handleCardFlip(3)}>
                      <div className="flip-card-inner">
                        <div className="flip-card-front">
                          <img
                            loading="lazy"
                            src="/react/ai-assets/images//liveicon-3.png"
                            alt=""
                          />
                          <h3>Job Assistance Program</h3>
                        </div>
                        <div className="flip-card-back">
                          Job Referrals in Product Companies, Resume Preparation
                          Session and Mock interviews
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="col-lg-3 col-md-4">
                    <div className={`flip-card ${flippedCard === 4 ? "flipped" : ""}`} onClick={() => handleCardFlip(4)}>
                      <div className="flip-card-inner">
                        <div className="flip-card-front">
                          <img
                            loading="lazy"
                            src="/react/ai-assets/images//liveicon-4.png"
                            alt=""
                          />
                          <h3>Missed Classes ?</h3>
                        </div>
                        <div className="flip-card-back">
                          Get Access of All Classes Recording Life Time Access
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="col-lg-3 col-md-4">
                    <div className={`flip-card ${flippedCard === 5 ? "flipped" : ""}`} onClick={() => handleCardFlip(5)}>
                      <div className="flip-card-inner">
                        <div className="flip-card-front">
                          <img
                            loading="lazy"
                            src="/react/ai-assets/images//liveicon-5.png"
                            alt=""
                          />
                          <h3>Life Time Access</h3>
                        </div>
                        <div className="flip-card-back">
                          Missed Classes, get lifetime access recorded lectures
                          of all classes
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="col-lg-3 col-md-4">
                    <div className={`flip-card ${flippedCard === 6 ? "flipped" : ""}`} onClick={() => handleCardFlip(6)}>
                      <div className="flip-card-inner">
                        <div className="flip-card-front">
                          <img
                            loading="lazy"
                            src="/react/ai-assets/images//liveicon-6.png"
                            alt=""
                          />
                          <h3>peer to Peer Learning?</h3>
                        </div>
                        <div className="flip-card-back">
                          Slack group for peer-to-peer learning & discussion
                          with batchmates. Hackerrank for 1:1 tests & GitHub for
                          Code review.
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="col-lg-3 col-md-4">
                    <div className={`flip-card ${flippedCard === 7 ? "flipped" : ""}`} onClick={() => handleCardFlip(7)}>
                      <div className="flip-card-inner">
                        <div className="flip-card-front">
                          <img
                            loading="lazy"
                            src="/react/ai-assets/images//liveicon-7.png"
                            alt=""
                          />
                          <h3>Flexible Pay</h3>
                        </div>
                        <div className="flip-card-back">
                          Flexible EMI options on Credit cards and loan options
                          on debit cards.
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="col-lg-3 col-md-4">
                    <div className={`flip-card ${flippedCard === 8 ? "flipped" : ""}`} onClick={() => handleCardFlip(8)}>
                      <div className="flip-card-inner">
                        <div className="flip-card-front">
                          <img
                            loading="lazy"
                            src="/react/ai-assets/images//selfpaced-2.png"
                            alt=""
                          />
                          <h3>Assignments for Practise After Class</h3>
                        </div>
                        <div className="flip-card-back">
                          Practise question is key to crack interviews.
                          Instructor provides assignments for all the topics
                          covered in the class.
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="col-lg-3 col-md-4">
                    <div className={`flip-card ${flippedCard === 9 ? "flipped" : ""}`} onClick={() => handleCardFlip(9)}>
                      <div className="flip-card-inner">
                        <div className="flip-card-front">
                          <img
                            loading="lazy"
                            src="/react/ai-assets/images//selfpaced-6.png"
                            alt=""
                          />
                          <h3>Competitive Coding Tests</h3>
                        </div>
                        <div className="flip-card-back">
                          Evaluate yourself in competitive coding tests with
                          your batchmates.
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          
         
   
          <div className="recurtstrip">
            <div className="container">
              <h2>Get Assured Interview Call from Top Recruiters</h2>
              <h4>Over 500+ Hiring Partners</h4>
              {/*
              <div className="reclogoinfo">
                <ul>
                  <li>
                    <div className="reclogdiv">
                      <a href="#">
                        <img
                          loading="lazy"
                          src="/react/ai-assets/images///rec-logo1.png"
                          alt=""
                        />
                      </a>
                    </div>
                  </li>
                  <li>
                    <div className="reclogdiv">
                      <a href="#">
                        <img
                          loading="lazy"
                          src="/react/ai-assets/images///rec-logo2.png"
                          alt=""
                        />
                      </a>
                    </div>
                  </li>
                  <li>
                    <div className="reclogdiv">
                      <a href="#">
                        <img
                          loading="lazy"
                          src="/react/ai-assets/images///rec-logo3.png"
                          alt=""
                        />
                      </a>
                    </div>
                  </li>
                  <li>
                    <div className="reclogdiv">
                      <a href="#">
                        <img
                          loading="lazy"
                          src="/react/ai-assets/images///rec-logo4.png"
                          alt=""
                        />
                      </a>
                    </div>
                  </li>
                  <li>
                    <div className="reclogdiv">
                      <a href="#">
                        <img
                          loading="lazy"
                          src="/react/ai-assets/images///rec-logo5.png"
                          alt=""
                        />
                      </a>
                    </div>
                  </li>

                  <li>
                    <div className="reclogdiv">
                      <a href="#">
                        <img
                          loading="lazy"
                          src="/react/ai-assets/images///googlelogoLatest.jpeg"
                          alt=""
                        />
                      </a>
                    </div>
                  </li>
                  <li>
                    <div className="reclogdiv">
                      <a href="#">
                        <img
                          loading="lazy"
                          src="/react/ai-assets/images///paypallogoLatest.jpeg"
                          alt=""
                        />
                      </a>
                    </div>
                  </li>
                  <li>
                    <div className="reclogdiv">
                      <a href="#">
                        <img
                          loading="lazy"
                          src="/react/ai-assets/images///flipkartlogo.jpeg"
                          alt=""
                        />
                      </a>
                    </div>
                  </li>
                  <li>
                    <div className="reclogdiv">
                      <a href="#">
                        <img
                          loading="lazy"
                          src="/react/ai-assets/images///adobelogo.jpeg"
                          alt=""
                        />
                      </a>
                    </div>
                  </li>
                  <li>
                    <div className="reclogdiv">
                      <a href="#">
                        <img
                          loading="lazy"
                          src="/react/ai-assets/images///metalogo.jpeg"
                          alt=""
                        />
                      </a>
                    </div>
                  </li>
                </ul>
              </div>
*/}
            </div>
          </div>
        </div>

        <br/>
   <HiringOrganizations />
   <br/>
   <br/>
   <InteractiveReviews />
   <br/>
   <br/>

        <div style={{ width: "250px", margin: "0 auto" }}>
          {/* <a
            target="_default"
            href="https://calendly.com/logicmojo/schedule-call-back-from-experts-for-live-classes?month=2026-06"
            className="counsbtn2"
          >
            Apply For Live Classes{" "}
            <i className="fa fa-angle-right arrowclass" aria-hidden="true"></i>
          </a> */}

          <a
            target="_default"
            className="counsbtn2"
            href="https://calendly.com/logicmojo/schedule-call-back-from-experts-for-live-classes?month=2026-06"
          //data-toggle="modal"
         // data-target="#counsellingpopup"
          >
            {" "}
            Apply For Live Classes
            <i className="fa fa-angle-right arrowclass" aria-hidden="true"></i>
          </a>
        </div>
      </div>

     

     
      <div className="popularcourses-bg2" ref={overCourses}>
        <div className="container" id="LiveCourse">
          <div className="d-md-block d-none">
            <div className="plc_section">
              <h2 className="plc_heading">Popular <span>Live Courses</span></h2>
              <p className="plc_subheading">Industry-relevant programs designed by MAANG experts to accelerate your career</p>

              <div className={`plc_grid ${isVisibleCourses ? "plc_visible" : ""}`}>

                {/* Card 1 - GenAI + Agentic AI */}
                <div className="plc_card plc_card_3">
  <div className="plc_card_accent"></div>
  <div className="plc_card_content">
    <div className="plc_card_top">
      <span className="plc_badge_live">LIVE</span>
      <span className="plc_badge_cat">Working Professionals</span>
      <span className="plc_rating">
        <span className="plc_stars">&#9733;&#9733;&#9733;&#9733;&#9733;</span> 4.8 
        <span className="plc_review_count">(3.4k reviews)</span>
      </span>
    </div>
    <div className="plc_learners">15,000+ learners enrolled</div>
    <h3 className="plc_card_title">GenAI + Agentic AI Course</h3>
    <p className="plc_card_desc">Master Generative AI, Agentic AI, LLM, and RAG with real-world industry projects.</p>
    <div className="plc_urgency">
      <span className="plc_batch"><i className="fa fa-calendar"></i> Next Batch: 14th Nov</span>
    </div>
    <div className="plc_card_meta">
      <div className="plc_meta_item"><span className="plc_meta_icon">⏱</span> 4 Months</div>
      <div className="plc_meta_item"><span className="plc_meta_icon">📅</span> Weekday Classes</div>
      <div className="plc_meta_item plc_meta_outcome"><span className="plc_meta_icon">🗓</span> 3 Days/Week</div>
    </div>
    <div className="plc_card_tags">
      <span>GenAI</span><span>Agentic AI</span><span>LLM</span><span>RAG</span>
    </div>
    <div className="plc_services">
      <span><i className="fa fa-check-circle"></i> Placement Assistance</span>
      <span><i className="fa fa-check-circle"></i> 15+ Industry Projects</span>
      <span><i className="fa fa-check-circle"></i> Mock Interviews</span>
    </div>
    <div className="plc_pricing">
      <DiwaliCardFee fee={70000} />
      <div className="plc_emi_row">
        <i className="fa fa-tag"></i> No-Cost EMI at <strong>₹4,500/month</strong>
      </div>
    </div>
    <div className="plc_card_actions">
      <a href="https://logicmojo.com/generative-ai-course/" className="plc_btn_learn">Learn More <i className="fa fa-arrow-right"></i></a>
      <a className="plc_btn_enroll" data-toggle="modal" href="https://logicmojo.com/generative-ai-course/">Enroll Now <i className="fa fa-arrow-right"></i></a>
    </div>
  </div>
</div>

                {/* Card 2 - AI & ML */}
                <div className="plc_card plc_card_2">
                  <div className="plc_card_accent"></div>
                  <div className="plc_card_content">
                    <div className="plc_card_top">
                      <span className="plc_badge_live">LIVE</span>
                      <span className="plc_badge_cat">Working Professionals</span>
                      <span className="plc_rating"><span className="plc_stars">&#9733;&#9733;&#9733;&#9733;&#9733;</span> 4.9 <span className="plc_review_count">(2.8k reviews)</span></span>
                    </div>
                    <div className="plc_learners">18,000+ learners enrolled</div>
                    <h3 className="plc_card_title">LogicMojo AI & ML <span>Course</span></h3>
                    <p className="plc_card_desc">Learn Basic to Advanced AI Concepts with practical 10+ projects, Machine Learning, Deep Learning, GenAI, AgenticAI etc</p>
                    <div className="plc_urgency">
                      <span className="plc_batch"><i className="fa fa-calendar"></i> Next Batch: 14th Nov</span>
                    </div>
                    <div className="plc_card_meta">
                      <div className="plc_meta_item"><span className="plc_meta_icon">⏱</span> 7 months</div>
                      <div className="plc_meta_item"><span className="plc_meta_icon">👤</span> Live Mentorship</div>
                      <div className="plc_meta_item plc_meta_outcome"><span className="plc_meta_icon">📈</span> Avg. hike: 120%</div>
                    </div>
                    <div className="plc_card_tags">
                      <span>ML</span><span>Deep Learning</span><span>GenAI</span><span>AgenticAI</span>
                    </div>
                    <div className="plc_services">
                      <span><i className="fa fa-check-circle"></i> Mock Interviews</span>
                      <span><i className="fa fa-check-circle"></i> Resume Building</span>
                      <span><i className="fa fa-check-circle"></i> Job Assistance</span>
                    </div>
                    <div className="plc_pricing">
                      <DiwaliCardFee fee={87000} />
                      <div className="plc_emi_row">
                        <i className="fa fa-tag"></i> Starting at <strong>₹5,499/month</strong> EMI
                      </div>
                    </div>
                    <div className="plc_card_actions">
                      <a href="https://logicmojo.com/artificial-intelligence-course/" className="plc_btn_learn">Learn More <i className="fa fa-arrow-right"></i></a>
                      <a className="plc_btn_enroll" data-toggle="modal" href="#booktry">Enroll Now <i className="fa fa-arrow-right"></i></a>
                    </div>
                  </div>
                </div>

              </div>
            </div>
          </div>

          {/* Mobile View - Popular Live Courses */}
          <div className="d-md-none d-block">
            <div className="plc_section">
              <h2 className="plc_mobile_heading">Popular <span>Live Courses</span></h2>
              <p className="plc_mobile_sub">MAANG-expert designed programs to accelerate your career</p>

              <div className={`plc_mobile_grid ${isVisibleCourses ? "plc_visible" : ""}`}>

                {/* Mobile Card 1 - GenAI + Agentic AI */}
                <div className="plc_card plc_card_3">
                  <div className="plc_card_accent"></div>
                  <div className="plc_card_content">
                    <div className="plc_card_top">
                      <span className="plc_badge_live">LIVE</span>
                      <span className="plc_badge_cat">Working Professionals</span>
                      <span className="plc_rating"><span className="plc_stars">&#9733;&#9733;&#9733;&#9733;&#9733;</span> 4.9 <span className="plc_review_count">(2.1k)</span></span>
                    </div>
                    <div className="plc_learners">10,000+ learners enrolled</div>
                    <h3 className="plc_card_title">GenAI + Agentic AI Course</h3>
                    <p className="plc_card_desc">Master Generative AI, Agentic AI, LLM, and RAG with real-world industry projects.</p>
                    <div className="plc_urgency">
                      <span className="plc_batch"><i className="fa fa-calendar"></i> Next Batch: 14th Nov</span>
                    </div>
                    <div className="plc_card_meta">
                      <div className="plc_meta_item"><span className="plc_meta_icon">⏱</span> 4 Months</div>
                      <div className="plc_meta_item"><span className="plc_meta_icon">📅</span> Weekday Classes</div>
                      <div className="plc_meta_item plc_meta_outcome"><span className="plc_meta_icon">🗓</span> 3 Days/Week</div>
                    </div>
                    <div className="plc_card_tags">
                      <span>GenAI</span><span>Agentic AI</span><span>LLM</span><span>RAG</span>
                    </div>
                    <div className="plc_services">
                      <span><i className="fa fa-check-circle"></i> Mock Interviews</span>
                      <span><i className="fa fa-check-circle"></i> Resume Building</span>
                      <span><i className="fa fa-check-circle"></i> Job Assistance</span>
                    </div>
                    <div className="plc_pricing">
                      <DiwaliCardFee fee={70000} />
                      <div className="plc_emi_row">
                        <i className="fa fa-tag"></i> Starting at <strong>₹3,999/month</strong> EMI
                      </div>
                    </div>
                    <div className="plc_card_actions">
                      <a href="https://logicmojo.com/generative-ai-course/" className="plc_btn_learn">Learn More <i className="fa fa-arrow-right"></i></a>
                      <a className="plc_btn_enroll" data-toggle="modal" href="https://logicmojo.com/generative-ai-course/">Enroll Now <i className="fa fa-arrow-right"></i></a>
                    </div>
                  </div>
                </div>

                {/* Mobile Card 2 - AI & ML */}
                <div className="plc_card plc_card_2">
                  <div className="plc_card_accent"></div>
                  <div className="plc_card_content">
                    <div className="plc_card_top">
                      <span className="plc_badge_live">LIVE</span>
                      <span className="plc_badge_cat">Working Professionals</span>
                      <span className="plc_rating"><span className="plc_stars">&#9733;&#9733;&#9733;&#9733;&#9733;</span> 4.8 <span className="plc_review_count">(1.8k)</span></span>
                    </div>
                    <div className="plc_learners">8,000+ learners enrolled</div>
                    <h3 className="plc_card_title">LogicMojo AI & ML <span>Course</span></h3>
                    <p className="plc_card_desc">Learn Basic to Advanced AI Concepts with practical 10+ projects, Machine Learning, Deep Learning, GenAI, AgenticAI etc</p>
                    <div className="plc_urgency">
                      <span className="plc_batch"><i className="fa fa-calendar"></i> Next Batch: 14th Nov</span>
                    </div>
                    <div className="plc_card_meta">
                      <div className="plc_meta_item"><span className="plc_meta_icon">⏱</span> 7 months</div>
                      <div className="plc_meta_item"><span className="plc_meta_icon">👤</span> Live Mentorship</div>
                      <div className="plc_meta_item plc_meta_outcome"><span className="plc_meta_icon">📈</span> Avg. hike: 120%</div>
                    </div>
                    <div className="plc_card_tags">
                      <span>ML</span><span>Deep Learning</span><span>GenAI</span><span>AgenticAI</span>
                    </div>
                    <div className="plc_services">
                      <span><i className="fa fa-check-circle"></i> Mock Interviews</span>
                      <span><i className="fa fa-check-circle"></i> Resume Building</span>
                      <span><i className="fa fa-check-circle"></i> Job Assistance</span>
                    </div>
                    <div className="plc_pricing">
                      <DiwaliCardFee fee={87000} />
                      <div className="plc_emi_row">
                        <i className="fa fa-tag"></i> Starting at <strong>₹4,500/month</strong> EMI
                      </div>
                    </div>
                    <div className="plc_card_actions">
                      <a href="https://logicmojo.com/artificial-intelligence-course/" className="plc_btn_learn">Learn More <i className="fa fa-arrow-right"></i></a>
                      <a className="plc_btn_enroll" data-toggle="modal" href="#booktry">Enroll Now <i className="fa fa-arrow-right"></i></a>
                    </div>
                  </div>
                </div>

              </div>
            </div>
          </div>

          <div className="col-lg-12 col-md-12 padtopss">
            <a
              target="_default"
              href="https://calendly.com/logicmojo/schedule-call-back-from-experts-for-live-classes?month=2026-06"
              className="applnowbtn"
            //data-toggle="modal"
            //data-target="#counsellingpopup"
            >
              Apply For Live Classes
              <i
                className="fa fa-angle-right arrowclass"
                aria-hidden="true"
              ></i>
            </a>
          </div>
        </div>
      </div>
      <div className="review-courses-block">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-ld-7 col-md-10">
              <div className="row">
                <div className="col-4">
                  <div className="review-div">
                    <div className="review-logo">
                      <img
                        src="/react/ai-assets/images//course-report.png"
                        alt="course-report"
                      />
                    </div>
                    <p>
                      4.7{" "}
                      <span>
                        <i className="fa fa-star"></i>
                      </span>
                    </p>
                  </div>
                </div>
                <div className="col-4">
                  <div className="review-div">
                    <div className="review-logo">
                      <img
                        src="/react/ai-assets/images//switch-UP.png"
                        alt="switch-UP"
                      />
                    </div>
                    <p>
                      4.8{" "}
                      <span>
                        <i className="fa fa-star"></i>
                      </span>
                    </p>
                  </div>
                </div>
                <div className="col-4">
                  <div className="review-div">
                    <div className="review-logo">
                      <img
                        src="/react/ai-assets/images//Google-review.png"
                        alt="Google-review"
                      />
                    </div>
                    <p>
                      4.8{" "}
                      <span>
                        <i className="fa fa-star"></i>
                      </span>
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="container clearfix">
        <AICommunityCard />
        <div id="Syllabus" className="float-left w-100">
        <div className="d-md-block d-none float-left w-100">
          <div className="syllabusbg-new">
            <div className="container">
              <ul
                className="nav nav-pills mb-3"
                id="pills-tab"
                role="tablist"
              >
                <li className="nav-item" role="presentation">
                  <a
                    className="nav-link active"
                    id="pills-home-tab02"
                    data-toggle="pill"
                    href="#tab0004"
                    role="tab"
                    aria-controls="pills-home"
                    aria-selected="false"
                  >
                    Advanced DSA & Problem Solving
                    <br />
                    <center>
                      <u>Syllabus</u>
                    </center>
                  </a>
                </li>

                <li className="nav-item" role="presentation">
                  <a
                    className="nav-link"
                    id="pills-profile-tab02"
                    data-toggle="pill"
                    href="#tab0003"
                    role="tab"
                    aria-controls="pills-profile"
                    aria-selected="true"
                  >
                    Advanced Scalable System Design
                    <center>
                      <u>Syllabus</u>
                    </center>
                  </a>
                </li>
              </ul>

              <div className="tab-content">
                <div
                  className="tab-pane fade active show"
                  id="tab0004"
                  role="tabpane2"
                  aria-labelledby="pills-home-tab02"
                >
                  <div className="row mt-5">
                    <div className="col-lg-7 col-md-12">
                      <h2>Detail Syllabus - Live Classes</h2>

                      <div style={{ clear: "both" }}></div>

                      <div className="row">
                        <div className="col-lg-8 col-md-8">
                          <p>
                            <b>
                              Artificial Intelligence & Machine Learning
                              course
                            </b>
                          </p>
                          <p>
                            <b>(Duration - 4 months)</b>
                          </p>
                          <p>
                            This course is curated by leading faculties and
                            industry leaders to provide practical learning
                            experience with live interactive classes and
                            projects.
                          </p>
                        </div>

                        <div className="col-lg-4 col-md-4">
                          <a
                            target="_blank"
                            rel="noopener"
                            href="https://drive.google.com/file/d/1SzaTFL3QiyuRzbtjI7e0dzMDCnLxtr0A/view"
                            className="brochbtn"
                          >
                            <img
                              loading="lazy"
                              src="/react/ai-assets/images//downloadicon.png"
                              alt=""
                              className="dowbtn"
                            />{" "}
                            Download brochure
                          </a>
                        </div>
                      </div>

                      <div className="salbustabingmain">
                        <div className="tab modules-tab">
                          <ul
                            className="nav nav-tabs border-0"
                            id="myTab"
                            role="tablist"
                          >
                            {aiMlCourseSyllabus.map((mod, m) => {
                              const iconNum = (m % 5) + 1;
                              return (
                                <li
                                  className="nav-item"
                                  role="presentation"
                                  key={`aimltab-${m}`}
                                >
                                  <button
                                    className={`nav-link${
                                      m === 0 ? " active" : ""
                                    }`}
                                    id={`aimlModule${m}-tab`}
                                    data-toggle="tab"
                                    data-target={`#aimlModule${m}`}
                                    type="button"
                                    role="tab"
                                    aria-controls={`aimlModule${m}`}
                                    aria-selected={m === 0 ? "true" : "false"}
                                  >
                                    <div className="blueimg2 tab-blueimg">
                                      <img
                                        loading="lazy"
                                        src={`/react/ai-assets/images//salubicon0${iconNum}.png`}
                                        alt=""
                                      />
                                    </div>

                                    <div className="whitimg6  whiteblueimage2 tab-whiteimg">
                                      <img
                                        loading="lazy"
                                        src={`/react/ai-assets/images//salubiconhov0${iconNum}.png`}
                                        alt=""
                                      />
                                    </div>

                                    <span>
                                      {mod.cardTitle}
                                      <p style={{ font: "12px" }}>
                                        {mod.cardSubtitle}
                                      </p>
                                    </span>
                                  </button>
                                </li>
                              );
                            })}
                          </ul>
                          <div className="tab-content" id="myTabContent">
                            {aiMlCourseSyllabus.map((mod, m) => (
                              <div
                                className={`tab-pane fade${
                                  m === 0 ? " show active" : ""
                                }`}
                                id={`aimlModule${m}`}
                                role="tabpanel"
                                aria-labelledby={`aimlModule${m}-tab`}
                                key={`aimlpane-${m}`}
                              >
                                <div className="tabinginfodetails">
                                  <div className="faq">
                                    <div
                                      className="accordion"
                                      id={`aimlAccordion${m}`}
                                    >
                                      <div className="card">
                                        <div
                                          className="card-header"
                                          id={`aimlModHead${m}`}
                                        >
                                          <h2 className="mb-0">
                                            <button
                                              type="button"
                                              className="btn btn-link"
                                              data-toggle="collapse"
                                              data-target={`#aimlModCollapse${m}`}
                                            >
                                              <i className="fa fa-angle-down"></i>{" "}
                                              {mod.sectionTitle}
                                            </button>
                                          </h2>
                                        </div>

                                        <div
                                          id={`aimlModCollapse${m}`}
                                          className="collapse show"
                                          aria-labelledby={`aimlModHead${m}`}
                                          data-parent={`#aimlAccordion${m}`}
                                        >
                                          <div className="card-body">
                                            <div className="faqcontent">
                                              <div className="faqinside">
                                                <div
                                                  className="accordion"
                                                  id={`aimlChapAcc${m}`}
                                                >
                                                  {mod.chapters.map((ch, c) => (
                                                    <div
                                                      className="card"
                                                      key={`aimlchap-${m}-${c}`}
                                                    >
                                                      <div
                                                        className="card-header faqpadbotm"
                                                        id={`aimlChapHead${m}_${c}`}
                                                      >
                                                        <h2 className="mb-0">
                                                          <button
                                                            type="button"
                                                            className={`btn btn-link borderfaq${
                                                              c === 0
                                                                ? ""
                                                                : " collapsed"
                                                            }`}
                                                            data-toggle="collapse"
                                                            data-target={`#aimlChapCollapse${m}_${c}`}
                                                          >
                                                            <i className="fa fa-angle-down favicons"></i>{" "}
                                                            {ch.title}
                                                          </button>
                                                        </h2>
                                                      </div>

                                                      <div
                                                        id={`aimlChapCollapse${m}_${c}`}
                                                        className={`collapse${
                                                          c === 0 ? " show" : ""
                                                        }`}
                                                        aria-labelledby={`aimlChapHead${m}_${c}`}
                                                        data-parent={`#aimlChapAcc${m}`}
                                                      >
                                                        <div className="card-body paddetop">
                                                          <div className="faqinsidecontent">
                                                            <div className="topics-grid">
                                                              {ch.topics.map(
                                                                (topic, t) => (
                                                                  <div
                                                                    className="topic-item"
                                                                    style={{
                                                                      animationDelay: `${t * 0.05}s`,
                                                                    }}
                                                                    key={`aimltopic-${m}-${c}-${t}`}
                                                                  >
                                                                    <span className="topic-check">
                                                                      <svg viewBox="0 0 24 24">
                                                                        <path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z" />
                                                                      </svg>
                                                                    </span>
                                                                    <span className="topic-text">
                                                                      {topic}
                                                                    </span>
                                                                  </div>
                                                                )
                                                              )}
                                                            </div>
                                                          </div>
                                                        </div>
                                                      </div>
                                                    </div>
                                                  ))}
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            ))}
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="col-md-5">
                      <div className="program-highlights-new">
                        <h3>Program Highlights</h3>
                        <ul>
                          <li>
                            <span>
                              <img
                                loading="lazy"
                                src="/react/ai-assets/images//highlight-icon1.png"
                                alt=""
                              />
                            </span>{" "}
                            110+ Hours Live sessions
                          </li>
                          <li>
                            <span>
                              <img
                                loading="lazy"
                                src="/react/ai-assets/images//highlight-icon1.png"
                                alt=""
                              />
                            </span>{" "}
                            1:1 Doubt Session
                          </li>
                          <li>
                            <span>
                              <img
                                loading="lazy"
                                src="/react/ai-assets/images//highlight-icon2.png"
                                alt=""
                              />
                            </span>{" "}
                            4+ Projects
                          </li>
                          <li>
                            <span>
                              <img
                                loading="lazy"
                                src="/react/ai-assets/images//highlight-icon2.png"
                                alt=""
                              />
                            </span>{" "}
                            Multiple Batches Options
                          </li>
                          <li>
                            <span>
                              <img
                                loading="lazy"
                                src="/react/ai-assets/images//highlight-icon3.png"
                                alt=""
                              />
                            </span>{" "}
                            Life time accessibility
                          </li>
                          <li>
                            <span>
                              <img
                                loading="lazy"
                                src="/react/ai-assets/images//highlight-icon3.png"
                                alt=""
                              />
                            </span>{" "}
                            Job Referrals Program
                          </li>
                          <li>
                            <span>
                              <img
                                loading="lazy"
                                src="/react/ai-assets/images//highlight-icon4.png"
                                alt=""
                              />
                            </span>{" "}
                            Peer to peer Learning
                          </li>
                          <li>
                            <span>
                              <img
                                loading="lazy"
                                src="/react/ai-assets/images//highlight-icon4.png"
                                alt=""
                              />
                            </span>{" "}
                            Mock Interviews
                          </li>
                          <li>
                            <span>
                              <img
                                loading="lazy"
                                src="/react/ai-assets/images//highlight-icon3.png"
                                alt=""
                              />
                            </span>{" "}
                            Resume Preparation
                          </li>
                          <li>
                            <span>
                              <img
                                loading="lazy"
                                src="/react/ai-assets/images//highlight-icon3.png"
                                alt=""
                              />
                            </span>{" "}
                            Weekly Assignments
                          </li>
                          <li>
                            <span>
                              <img
                                loading="lazy"
                                src="/react/ai-assets/images//highlight-icon2.png"
                                alt=""
                              />
                            </span>{" "}
                            Regular Progress Tests
                          </li>
                          <li>
                            <span>
                              <img
                                loading="lazy"
                                src="/react/ai-assets/images//highlight-icon2.png"
                                alt=""
                              />
                            </span>{" "}
                            Code Explanation
                          </li>
                        </ul>
                      </div>
                      <div className="bookbtn02">
                        <a
                          target="_default"
                          className="booktrialbtn"
                          href="https://calendly.com/logicmojo/schedule-call-back-from-experts-for-live-classes?month=2026-06"
                        //data-toggle="modal"
                        //data-target="#counsellingpopup"
                        >
                          <img
                            loading="lazy"
                            src="/react/ai-assets/images//callicons.png"
                            alt=""
                            className="callico"
                          />{" "}
                          Apply For Live Classes{" "}
                          <i
                            className="fa fa-angle-right"
                            aria-hidden="true"
                          ></i>
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  className="tab-pane fade"
                  id="tab0003"
                  role="tabpanel"
                  aria-labelledby="pills-profile-tab02"
                >
                  <div className="row mt-5">
                    <div className="col-lg-7 col-md-12">
                      <h2>Detail Syllabus - Live Classes</h2>

                      <div style={{ clear: "both" }}></div>

                      <div className="row">
                        <div className="col-lg-8 col-md-8">
                          <p>
                            <b>Scalable System Design with HLD + LLD</b>
                          </p>
                          <p>
                            <b>(Duration - 3 months)</b>
                          </p>
                          <p>
                            This course is curated by leading faculties and
                            industry leaders to provide practical learning
                            experience with live interactive classes and
                            projects.
                          </p>
                        </div>

                        <div className="col-lg-4 col-md-4">
                          <a
                            target="_default"
                            rel="noopener"
                            href="https://drive.google.com/file/d/1SzaTFL3QiyuRzbtjI7e0dzMDCnLxtr0A/view"
                            className="brochbtn"
                          >
                            <img
                              loading="lazy"
                              src="/react/ai-assets/images//downloadicon.png"
                              alt=""
                              className="dowbtn"
                            />{" "}
                            Download brochure
                          </a>
                        </div>
                      </div>

                      <div className="salbustabingmain">
                        <div className="tab modules-tab">
                          <ul
                            className="nav nav-tabs border-0"
                            id="myTab"
                            role="tablist"
                          >
                            <li className="nav-item" role="presentation">
                              <a
                                className="nav-link active"
                                id="systemDesign-sm-tab"
                                data-toggle="tab"
                                href="#systemDesign-sm"
                                type="button"
                                role="tab"
                                aria-controls="systemDesign-sm"
                                aria-selected="true"
                              >
                                <div className="blueimg2 tab-blueimg">
                                  <img
                                    loading="lazy"
                                    src="/react/ai-assets/images//salubicon01.png"
                                    alt=""
                                  />
                                </div>

                                <div className="whitimg6  whiteblueimage2 tab-whiteimg">
                                  <img
                                    loading="lazy"
                                    src="/react/ai-assets/images//salubiconhov01.png"
                                    alt=""
                                  />
                                </div>

                                <span>
                                  System Design
                                  <br /> Basics
                                  <p style={{ font: "12px" }}>Module 6</p>
                                </span>
                              </a>
                            </li>

                            <li className="nav-item" role="presentation">
                              <a
                                className="nav-link"
                                id="distributedSystem-sm-2-tab"
                                data-toggle="tab"
                                href="#distributedSystem-sm-2"
                                type="button"
                                role="tab"
                                aria-controls="distributedSystem-sm-2"
                                aria-selected="false"
                              >
                                <div className="blueimg2 tab-blueimg">
                                  <img
                                    loading="lazy"
                                    src="/react/ai-assets/images//salubicon02.png"
                                    alt=""
                                  />
                                </div>

                                <div className="whitimg6  whiteblueimage2 tab-whiteimg">
                                  <img
                                    loading="lazy"
                                    src="/react/ai-assets/images//salubiconhov02.png"
                                    alt=""
                                  />
                                </div>

                                <span>
                                  Distributed System
                                  <p style={{ font: "12px" }}>Module 7</p>
                                </span>
                              </a>
                            </li>

                            <li className="nav-item" role="presentation">
                              <a
                                className="nav-link"
                                id="hldlld-sm-tab"
                                data-toggle="tab"
                                href="#hldlld-sm"
                                type="button"
                                role="tab"
                                aria-controls="hldlld-sm"
                                aria-selected="false"
                              >
                                <div className="blueimg2 tab-blueimg">
                                  <img
                                    loading="lazy"
                                    src="/react/ai-assets/images//salubicon03.png"
                                    alt=""
                                  />
                                </div>

                                <div className="whitimg6  whiteblueimage2 tab-whiteimg">
                                  <img
                                    loading="lazy"
                                    src="/react/ai-assets/images//salubiconhov03.png"
                                    alt=""
                                  />
                                </div>

                                <span>
                                  HLD & LLD Design
                                  <p style={{ font: "12px" }}>Module 8</p>
                                </span>
                              </a>
                            </li>

                            <li className="nav-item" role="presentation">
                              <a
                                className="nav-link"
                                id="designPattern-sm-tab"
                                data-toggle="tab"
                                href="#designPattern-sm"
                                type="button"
                                role="tab"
                                aria-controls="designPattern-sm"
                                aria-selected="false"
                              >
                                <div className="blueimg2 tab-blueimg">
                                  <img
                                    loading="lazy"
                                    src="/react/ai-assets/images//salubicon04.png"
                                    alt=""
                                  />
                                </div>

                                <div className="whitimg6  whiteblueimage2 tab-whiteimg">
                                  <img
                                    loading="lazy"
                                    src="/react/ai-assets/images//salubiconhov04.png"
                                    alt=""
                                  />
                                </div>

                                <span>
                                  Design Pattern & OOPS Design
                                  <p style={{ font: "12px" }}>Module 9</p>
                                </span>
                              </a>
                            </li>

                            <li className="nav-item" role="presentation">
                              <a
                                className="nav-link"
                                id="cloudTechnology-sm-tab"
                                data-toggle="tab"
                                href="#cloudTechnology-sm"
                                type="button"
                                role="tab"
                                aria-controls="cloudTechnology-sm"
                                aria-selected="false"
                              >
                                <div className="blueimg2 tab-blueimg">
                                  <img
                                    loading="lazy"
                                    src="/react/ai-assets/images//salubicon05.png"
                                    alt=""
                                  />
                                </div>

                                <div className="whitimg6  whiteblueimage2 tab-whiteimg">
                                  <img
                                    loading="lazy"
                                    src="/react/ai-assets/images//salubiconhov05.png"
                                    alt=""
                                  />
                                </div>

                                <span>
                                  Cloud Technology
                                  <p style={{ font: "12px" }}>Module 10</p>
                                </span>
                              </a>
                            </li>
                          </ul>
                          <div className="tab-content" id="myTabContent">
                            <div
                              className="tab-pane fade show active"
                              id="systemDesign-sm"
                              role="tabpanel"
                              aria-labelledby="systemDesign-sm-tab"
                            >
                              <div className="tabinginfodetails">
                                <div className="faq">
                                  <div
                                    className="accordion"
                                    id="accordionExample"
                                  >
                                    <div className="card">
                                      <div
                                        className="card-header"
                                        id="heading001"
                                      >
                                        <h2 className="mb-0">
                                          <button
                                            type="button"
                                            className="btn btn-link collapsed"
                                            data-toggle="collapse"
                                            data-target="#collapse001"
                                          >
                                            <i className="fa fa-angle-down"></i>{" "}
                                            Module 1: Introduction of Design{" "}
                                          </button>
                                        </h2>
                                      </div>

                                      <div
                                        id="collapse001"
                                        className="collapse"
                                        aria-labelledby="heading001"
                                        data-parent="#accordionExample"
                                      >
                                        <div className="card-body">
                                          <div className="faqcontent">
                                            <div className="faqinside">
                                              <div
                                                className="accordion"
                                                id="accordioninside1"
                                              >
                                                <div className="card">
                                                  <div
                                                    className="card-header faqpadbotm"
                                                    id="datainsidehead1"
                                                  >
                                                    <h2 className="mb-0">
                                                      <button
                                                        type="button"
                                                        className="btn btn-link collapsed borderfaq"
                                                        data-toggle="collapse"
                                                        data-target="#collapsinside1"
                                                      >
                                                        <i className="fa fa-angle-down"></i>{" "}
                                                        Chapter 1: How to
                                                        approach for system
                                                        design problem{" "}
                                                      </button>
                                                    </h2>
                                                  </div>

                                                  <div
                                                    id="collapsinside1"
                                                    className="collapse"
                                                    aria-labelledby="datainsidehead1"
                                                    data-parent="#accordioninside1"
                                                  >
                                                    <div className="card-body paddetop">
                                                      <div className="faqinsidecontent">
                                                        <ul>
                                                          <li>
                                                            {" "}
                                                            • Techniques to
                                                            start discussing
                                                            the problem
                                                            statement scope
                                                          </li>
                                                          <li>
                                                            {" "}
                                                            • Define all
                                                            design constraints
                                                            in the system
                                                          </li>
                                                          <li>
                                                            {" "}
                                                            • Finalizing the
                                                            scalability, the
                                                            system will
                                                            support{" "}
                                                          </li>
                                                        </ul>
                                                      </div>
                                                    </div>
                                                  </div>
                                                </div>

                                                <div className="card">
                                                  <div
                                                    className="card-header faqpadbotm"
                                                    id="datainsidehead2"
                                                  >
                                                    <h2 className="mb-0">
                                                      <button
                                                        type="button"
                                                        className="btn btn-link borderfaq"
                                                        data-toggle="collapse"
                                                        data-target="#collapsinside2"
                                                      >
                                                        <i className="fa fa-angle-down favicons"></i>
                                                        Chapter 2: How to
                                                        discuss
                                                        Requirement/Goal of
                                                        the system{" "}
                                                      </button>
                                                    </h2>
                                                  </div>

                                                  <div
                                                    id="collapsinside2"
                                                    className="collapse"
                                                    aria-labelledby="datainsidehead2"
                                                    data-parent="#accordioninside1"
                                                  >
                                                    <div className="card-body paddetop">
                                                      <div className="faqinsidecontent">
                                                        <ul>
                                                          <li>
                                                            {" "}
                                                            • System
                                                            capacity/size
                                                            estimation with
                                                            number of users
                                                            access it
                                                          </li>
                                                          <li>
                                                            {" "}
                                                            • Finalizing the
                                                            target environment
                                                            (Tools, library or
                                                            open sources)
                                                          </li>
                                                          <li>
                                                            {" "}
                                                            • Concise the
                                                            problem, support
                                                            the scalability
                                                          </li>
                                                        </ul>
                                                      </div>
                                                    </div>
                                                  </div>
                                                </div>

                                                <div className="card">
                                                  <div
                                                    className="card-header faqpadbotm"
                                                    id="datainsidehead3"
                                                  >
                                                    <h2 className="mb-0">
                                                      <button
                                                        type="button"
                                                        className="btn btn-link borderfaq"
                                                        data-toggle="collapse"
                                                        data-target="#collapsinside3"
                                                      >
                                                        <i className="fa fa-angle-down favicons"></i>
                                                        Chapter 3: How to
                                                        Design an API For a
                                                        System
                                                      </button>
                                                    </h2>
                                                  </div>

                                                  <div
                                                    id="collapsinside3"
                                                    className="collapse"
                                                    aria-labelledby="datainsidehead3"
                                                    data-parent="#accordioninside1"
                                                  >
                                                    <div className="card-body paddetop">
                                                      <div className="faqinsidecontent">
                                                        <ul>
                                                          <li>
                                                            • Identify system
                                                            level REST API to
                                                            access the
                                                            recourses.
                                                          </li>
                                                          <li>
                                                            • Define
                                                            parameters, return
                                                            types JSON
                                                          </li>
                                                          <li>
                                                            • Finalize
                                                            read/write/delete/paste
                                                            API possible in
                                                            the system
                                                          </li>
                                                        </ul>
                                                      </div>
                                                    </div>
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>

                                    <div className="card">
                                      <div
                                        className="card-header"
                                        id="heading002"
                                      >
                                        <h2 className="mb-0">
                                          <button
                                            type="button"
                                            className="btn btn-link"
                                            data-toggle="collapse"
                                            data-target="#collapse002"
                                          >
                                            <i className="fa fa-angle-down favicons"></i>{" "}
                                            Module 2: Data Models & Latency,
                                            Fault tolerance{" "}
                                          </button>
                                        </h2>
                                      </div>

                                      <div
                                        id="collapse002"
                                        className="collapse"
                                        aria-labelledby="heading002"
                                        data-parent="#accordionExample"
                                      >
                                        <div className="card-body">
                                          <div className="faqcontent">
                                            <div className="faqinside">
                                              <div
                                                className="accordion"
                                                id="accordioninside2"
                                              >
                                                <div className="card">
                                                  <div
                                                    className="card-header faqpadbotm"
                                                    id="datainsidehead5"
                                                  >
                                                    <h2 className="mb-0">
                                                      <button
                                                        type="button"
                                                        className="btn btn-link collapsed borderfaq"
                                                        data-toggle="collapse"
                                                        data-target="#collapsinside5"
                                                      >
                                                        <i className="fa fa-angle-down"></i>{" "}
                                                        Chapter 1: Data model,
                                                        system components &
                                                        system interface
                                                      </button>
                                                    </h2>
                                                  </div>

                                                  <div
                                                    id="collapsinside5"
                                                    className="collapse"
                                                    aria-labelledby="datainsidehead5"
                                                    data-parent="#accordioninside2"
                                                  >
                                                    <div className="card-body paddetop">
                                                      <div className="faqinsidecontent">
                                                        <div className="innerfaqlist">
                                                          <ul>
                                                            <li>
                                                              Identify all the
                                                              data models &
                                                              business logic
                                                              involved in
                                                              backend
                                                            </li>
                                                            <li>
                                                              Identify all
                                                              functional/Non-functional
                                                              components
                                                              involved
                                                            </li>
                                                            <li>
                                                              Finalize state
                                                              machine, service
                                                              layer &
                                                              interfaces
                                                            </li>
                                                          </ul>
                                                        </div>
                                                      </div>
                                                    </div>
                                                  </div>
                                                </div>

                                                <div className="card">
                                                  <div
                                                    className="card-header faqpadbotm"
                                                    id="datainsidehead6"
                                                  >
                                                    <h2 className="mb-0">
                                                      <button
                                                        type="button"
                                                        className="btn btn-link borderfaq"
                                                        data-toggle="collapse"
                                                        data-target="#collapsinside6"
                                                      >
                                                        <i className="fa fa-angle-down favicons"></i>
                                                        Chapter 2:
                                                        Consistency,
                                                        Availability, Latency
                                                        of System
                                                      </button>
                                                    </h2>
                                                  </div>

                                                  <div
                                                    id="collapsinside6"
                                                    className="collapse"
                                                    aria-labelledby="datainsidehead6"
                                                    data-parent="#accordioninside2"
                                                  >
                                                    <div className="card-body paddetop">
                                                      <div className="faqinsidecontent">
                                                        <div className="innerfaqlist">
                                                          <ul>
                                                            <li>
                                                              Check
                                                              reliability and
                                                              redundancy
                                                            </li>
                                                            <li>
                                                              Components
                                                              required to make
                                                              low latency
                                                              system{" "}
                                                            </li>
                                                            <li>
                                                              Database
                                                              finalization,
                                                              Metadata
                                                              Sharding etc.{" "}
                                                            </li>
                                                          </ul>
                                                        </div>
                                                      </div>
                                                    </div>
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>

                                    <div className="card">
                                      <div
                                        className="card-header"
                                        id="heading003"
                                      >
                                        <h2 className="mb-0">
                                          <button
                                            type="button"
                                            className="btn btn-link collapsed"
                                            data-toggle="collapse"
                                            data-target="#collapse003"
                                          >
                                            <i className="fa fa-angle-down"></i>{" "}
                                            Module 3 - Architecture Design
                                            Paradigm
                                          </button>
                                        </h2>
                                      </div>

                                      <div
                                        id="collapse003"
                                        className="collapse"
                                        aria-labelledby="heading003"
                                        data-parent="#accordionExample"
                                      >
                                        <div className="card-body">
                                          <div className="faqcontent">
                                            <div className="faqinside">
                                              <div
                                                className="accordion"
                                                id="accordioninside3"
                                              >
                                                <div className="card">
                                                  <div
                                                    className="card-header faqpadbotm"
                                                    id="datainsidehead9"
                                                  >
                                                    <h2 className="mb-0">
                                                      <button
                                                        type="button"
                                                        className="btn btn-link collapsed borderfaq"
                                                        data-toggle="collapse"
                                                        data-target="#collapsinside9"
                                                      >
                                                        <i className="fa fa-angle-down"></i>{" "}
                                                        Chapter 1: Storage
                                                        system, Distributed
                                                        Cache, Cache Eviction
                                                        Policies
                                                      </button>
                                                    </h2>
                                                  </div>

                                                  <div
                                                    id="collapsinside9"
                                                    className="collapse"
                                                    aria-labelledby="datainsidehead9"
                                                    data-parent="#accordioninside3"
                                                  >
                                                    <div className="card-body paddetop">
                                                      <div className="faqinsidecontent">
                                                        <div className="innerfaqlist">
                                                          <ul>
                                                            <li>
                                                              Distributed Hash
                                                              Table, LRU,
                                                              In-memory Data
                                                              Lookup
                                                            </li>

                                                            <li>
                                                              Memcache,
                                                              Read-Through,
                                                              Write-Through
                                                              Cache
                                                            </li>
                                                          </ul>
                                                        </div>
                                                      </div>
                                                    </div>
                                                  </div>
                                                </div>

                                                <div className="card">
                                                  <div
                                                    className="card-header faqpadbotm"
                                                    id="datainsidehead10"
                                                  >
                                                    <h2 className="mb-0">
                                                      <button
                                                        type="button"
                                                        className="btn btn-link borderfaq"
                                                        data-toggle="collapse"
                                                        data-target="#collapsinside10"
                                                      >
                                                        <i className="fa fa-angle-down favicons"></i>
                                                        Chapter 2:
                                                        Client-Server Model
                                                        Architecture
                                                      </button>
                                                    </h2>
                                                  </div>

                                                  <div
                                                    id="collapsinside10"
                                                    className="collapse"
                                                    aria-labelledby="datainsidehead10"
                                                    data-parent="#accordioninside3"
                                                  >
                                                    <div className="card-body paddetop">
                                                      <div className="faqinsidecontent">
                                                        <div className="innerfaqlist">
                                                          <ul>
                                                            <li>
                                                              http/https, DOS,
                                                              web server,
                                                              abstraction
                                                              layer
                                                            </li>

                                                            <li>
                                                              Scheduling algo,
                                                              Round robin,
                                                              FCFS
                                                            </li>
                                                            <li>
                                                              One to Many,
                                                              Many to One
                                                              Communication
                                                            </li>
                                                          </ul>
                                                        </div>
                                                      </div>
                                                    </div>
                                                  </div>
                                                </div>

                                                <div className="card">
                                                  <div
                                                    className="card-header faqpadbotm"
                                                    id="datainsidehead11"
                                                  >
                                                    <h2 className="mb-0">
                                                      <button
                                                        type="button"
                                                        className="btn btn-link borderfaq"
                                                        data-toggle="collapse"
                                                        data-target="#collapsinside11"
                                                      >
                                                        <i className="fa fa-angle-down favicons"></i>
                                                        Chapter 3: Scalability
                                                        (Latency, Throughput,
                                                        vertical scaling,
                                                        Horizontal scaling)
                                                      </button>
                                                    </h2>
                                                  </div>

                                                  <div
                                                    id="collapsinside11"
                                                    className="collapse"
                                                    aria-labelledby="datainsidehead11"
                                                    data-parent="#accordioninside3"
                                                  >
                                                    <div className="card-body paddetop">
                                                      <div className="faqinsidecontent">
                                                        <div className="innerfaqlist">
                                                          <ul>
                                                            <li>
                                                              Vertical
                                                              scaling,
                                                              Horizontal
                                                              scaling, which
                                                              is better
                                                            </li>

                                                            <li>
                                                              Minimize Latency
                                                              & Increase
                                                              Throughput Of
                                                              System
                                                            </li>
                                                            <li>
                                                              Factors Need to
                                                              be considered
                                                              for Scalable
                                                              System Design
                                                            </li>
                                                          </ul>
                                                        </div>
                                                      </div>
                                                    </div>
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>

                                    <div className="card">
                                      <div
                                        className="card-header"
                                        id="heading004"
                                      >
                                        <h2 className="mb-0">
                                          <button
                                            type="button"
                                            className="btn btn-link collapsed"
                                            data-toggle="collapse"
                                            data-target="#collapse004"
                                          >
                                            <i className="fa fa-angle-down"></i>
                                            Module 4: Scalable System Design
                                            Components{" "}
                                          </button>
                                        </h2>
                                      </div>

                                      <div
                                        id="collapse004"
                                        className="collapse"
                                        aria-labelledby="heading004"
                                        data-parent="#accordionExample"
                                      >
                                        <div className="card-body">
                                          <div className="faqcontent">
                                            <div className="faqinside">
                                              <div
                                                className="accordion"
                                                id="accordioninside4"
                                              >
                                                <div className="card">
                                                  <div
                                                    className="card-header faqpadbotm"
                                                    id="datainsidehead13"
                                                  >
                                                    <h2 className="mb-0">
                                                      <button
                                                        type="button"
                                                        className="btn btn-link collapsed borderfaq"
                                                        data-toggle="collapse"
                                                        data-target="#collapsinside13"
                                                      >
                                                        <i className="fa fa-angle-down"></i>{" "}
                                                        Chapter 1: Scalable
                                                        Architecture Basic
                                                        Design{" "}
                                                      </button>
                                                    </h2>
                                                  </div>

                                                  <div
                                                    id="collapsinside13"
                                                    className="collapse"
                                                    aria-labelledby="datainsidehead13"
                                                    data-parent="#accordioninside4"
                                                  >
                                                    <div className="card-body paddetop">
                                                      <div className="faqinsidecontent">
                                                        <div className="innerfaqlist">
                                                          <ul>
                                                            <li>
                                                              High
                                                              Availability
                                                              Clustering
                                                            </li>

                                                            <li>
                                                              Desinging &
                                                              Configuring
                                                              Distributed
                                                              Cache
                                                            </li>
                                                            <li>
                                                              Abstraction &
                                                              Consistency
                                                              Model
                                                            </li>
                                                          </ul>
                                                        </div>
                                                      </div>
                                                    </div>
                                                  </div>
                                                </div>

                                                <div className="card">
                                                  <div
                                                    className="card-header faqpadbotm"
                                                    id="datainsidehead14"
                                                  >
                                                    <h2 className="mb-0">
                                                      <button
                                                        type="button"
                                                        className="btn btn-link borderfaq"
                                                        data-toggle="collapse"
                                                        data-target="#collapsinside14"
                                                      >
                                                        <i className="fa fa-angle-down favicons"></i>
                                                        Chapter 2: Message
                                                        Queues, CDN, Load
                                                        balancer{" "}
                                                      </button>
                                                    </h2>
                                                  </div>

                                                  <div
                                                    id="collapsinside14"
                                                    className="collapse"
                                                    aria-labelledby="datainsidehead14"
                                                    data-parent="#accordioninside4"
                                                  >
                                                    <div className="card-body paddetop">
                                                      <div className="faqinsidecontent">
                                                        <div className="innerfaqlist">
                                                          <ul>
                                                            <li>
                                                              Introduction &
                                                              Configuration of
                                                              Pub-Sub Model
                                                            </li>
                                                            <li>
                                                              Real-Time
                                                              Streaming,
                                                              Active
                                                              MQ,Message
                                                              Broker
                                                            </li>
                                                            <li>
                                                              Configuration
                                                              Load Balancer,
                                                              Set up CDN{" "}
                                                            </li>
                                                          </ul>
                                                        </div>
                                                      </div>
                                                    </div>
                                                  </div>
                                                </div>

                                                <div className="card">
                                                  <div
                                                    className="card-header faqpadbotm"
                                                    id="datainsidehead15"
                                                  >
                                                    <h2 className="mb-0">
                                                      <button
                                                        type="button"
                                                        className="btn btn-link borderfaq"
                                                        data-toggle="collapse"
                                                        data-target="#collapsinside15"
                                                      >
                                                        <i className="fa fa-angle-down favicons"></i>
                                                        Chapter 3: DNS, HTTPS,
                                                        Zookeeper, Kubernetes
                                                        Architecture
                                                      </button>
                                                    </h2>
                                                  </div>

                                                  <div
                                                    id="collapsinside15"
                                                    className="collapse"
                                                    aria-labelledby="datainsidehead15"
                                                    data-parent="#accordioninside4"
                                                  >
                                                    <div className="card-body paddetop">
                                                      <div className="faqinsidecontent">
                                                        <div className="innerfaqlist">
                                                          <ul>
                                                            <li>
                                                              Basic
                                                              Architecture of
                                                              Kubernetes
                                                            </li>
                                                            <li>
                                                              Kubectl
                                                              Describe,
                                                              Configuration of
                                                              Zookeeper
                                                            </li>
                                                            <li>
                                                              Root Nameserver,
                                                              Authoritative
                                                              nameserver, DNS
                                                              Resolver
                                                            </li>
                                                          </ul>
                                                        </div>
                                                      </div>
                                                    </div>
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>

                                    <div className="card">
                                      <div
                                        className="card-header"
                                        id="heading005"
                                      >
                                        <h2 className="mb-0">
                                          <button
                                            type="button"
                                            className="btn btn-link collapsed"
                                            data-toggle="collapse"
                                            data-target="#collapse005"
                                          >
                                            <i className="fa fa-angle-down"></i>{" "}
                                            Module 5 - Web Architecture
                                          </button>
                                        </h2>
                                      </div>

                                      <div
                                        id="collapse005"
                                        className="collapse"
                                        aria-labelledby="heading005"
                                        data-parent="#accordionExample"
                                      >
                                        <div className="card-body">
                                          <div className="faqcontent">
                                            <div className="faqinside">
                                              <div
                                                className="accordion"
                                                id="accordioninside5"
                                              >
                                                <div className="card">
                                                  <div
                                                    className="card-header faqpadbotm"
                                                    id="datainsidehead17"
                                                  >
                                                    <h2 className="mb-0">
                                                      <button
                                                        type="button"
                                                        className="btn btn-link collapsed borderfaq"
                                                        data-toggle="collapse"
                                                        data-target="#collapsinside17"
                                                      >
                                                        <i className="fa fa-angle-down"></i>{" "}
                                                        Chapter 1: Configure
                                                        Web Architecture{" "}
                                                      </button>
                                                    </h2>
                                                  </div>

                                                  <div
                                                    id="collapsinside17"
                                                    className="collapse"
                                                    aria-labelledby="datainsidehead17"
                                                    data-parent="#accordioninside5"
                                                  >
                                                    <div className="card-body paddetop">
                                                      <div className="faqinsidecontent">
                                                        <div className="innerfaqlist">
                                                          <ul>
                                                            <li>
                                                              Client Side vs
                                                              Server Side
                                                              Rendering
                                                            </li>
                                                            <li>
                                                              Adding,deleting
                                                              and Finding
                                                              Specific Nodes
                                                            </li>
                                                          </ul>
                                                        </div>
                                                      </div>
                                                    </div>
                                                  </div>
                                                </div>

                                                <div className="card">
                                                  <div
                                                    className="card-header faqpadbotm"
                                                    id="datainsidehead18"
                                                  >
                                                    <h2 className="mb-0">
                                                      <button
                                                        type="button"
                                                        className="btn btn-link borderfaq"
                                                        data-toggle="collapse"
                                                        data-target="#collapsinside18"
                                                      >
                                                        <i className="fa fa-angle-down favicons"></i>
                                                        REST API Configuration
                                                      </button>
                                                    </h2>
                                                  </div>

                                                  <div
                                                    id="collapsinside18"
                                                    className="collapse"
                                                    aria-labelledby="datainsidehead18"
                                                    data-parent="#accordioninside5"
                                                  >
                                                    <div className="card-body paddetop">
                                                      <div className="faqinsidecontent">
                                                        <div className="innerfaqlist">
                                                          <ul>
                                                            <li>
                                                              REST API - CORS
                                                              and Enabling
                                                              CORS
                                                            </li>
                                                            <li>
                                                              REST-PUT,DELETE,GET,POST
                                                              Configuration
                                                            </li>
                                                            <li>
                                                              Serialization vs
                                                              De-Serialization,Working
                                                              with JSON
                                                            </li>
                                                            <li>
                                                              POSTMAN,Swagger
                                                              Configuration
                                                            </li>
                                                            <li>
                                                              Restful Web
                                                              Services
                                                              Implementation
                                                            </li>
                                                          </ul>
                                                        </div>
                                                      </div>
                                                    </div>
                                                  </div>
                                                </div>

                                                <div className="card">
                                                  <div
                                                    className="card-header faqpadbotm"
                                                    id="datainsidehead19"
                                                  >
                                                    <h2 className="mb-0">
                                                      <button
                                                        type="button"
                                                        className="btn btn-link borderfaq"
                                                        data-toggle="collapse"
                                                        data-target="#collapsinside19"
                                                      >
                                                        <i className="fa fa-angle-down favicons"></i>
                                                        HTTP PUSH/PULL,
                                                        Polling{" "}
                                                      </button>
                                                    </h2>
                                                  </div>

                                                  <div
                                                    id="collapsinside19"
                                                    className="collapse"
                                                    aria-labelledby="datainsidehead19"
                                                    data-parent="#accordioninside5"
                                                  >
                                                    <div className="card-body paddetop">
                                                      <div className="faqinsidecontent">
                                                        <div className="innerfaqlist">
                                                          <ul>
                                                            <li>
                                                              Key Data Store
                                                            </li>
                                                            <li>
                                                              Pull and Push
                                                              Models
                                                              Implementations
                                                            </li>
                                                            <li>
                                                              HTTP keep-alive
                                                              vs long polling
                                                            </li>
                                                          </ul>
                                                        </div>
                                                      </div>
                                                    </div>
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>

                            <div
                              className="tab-pane fade"
                              id="distributedSystem-sm-2"
                              role="tabpanel"
                              aria-labelledby="distributedSystem-sm-2-tab"
                            >
                              <div className="tabinginfodetails">
                                <div className="faq">
                                  <div
                                    className="accordion"
                                    id="alog_accordionExample"
                                  >
                                    <div className="card">
                                      <div
                                        className="card-header"
                                        id="algo_heading001_tab2"
                                      >
                                        <h2 className="mb-0">
                                          <button
                                            type="button"
                                            className="btn btn-link collapsed"
                                            data-toggle="collapse"
                                            data-target="#algo_collapse001_tab2"
                                          >
                                            <i className="fa fa-angle-down"></i>{" "}
                                            Module 1: Basic of Distributed
                                            System
                                          </button>
                                        </h2>
                                      </div>
                                      <div
                                        id="algo_collapse001_tab2"
                                        className="collapse"
                                        aria-labelledby="algo_heading001_tab2"
                                        data-parent="#alog_accordionExample_tab2"
                                      >
                                        <div className="card-body">
                                          <div className="faqcontent">
                                            <div className="faqinside">
                                              <div
                                                className="accordion"
                                                id="algo_accordioninside1_tab2"
                                              >
                                                <div className="card">
                                                  <div
                                                    className="card-header faqpadbotm"
                                                    id="algo_datainsidehead1_tab2"
                                                  >
                                                    <h2 className="mb-0">
                                                      <button
                                                        type="button"
                                                        className="btn btn-link collapsed borderfaq"
                                                        data-toggle="collapse"
                                                        data-target="#algo_collapsinside1"
                                                      >
                                                        <i className="fa fa-angle-down"></i>{" "}
                                                        Chapter 1: Distributed
                                                        Database, Distributed
                                                        Cache{" "}
                                                      </button>
                                                    </h2>
                                                  </div>

                                                  <div
                                                    id="algo_collapsinside1"
                                                    className="collapse"
                                                    aria-labelledby="algo_datainsidehead1_tab2"
                                                    data-parent="#algo_accordioninside1_tab2"
                                                  >
                                                    <div className="card-body paddetop">
                                                      <div className="faqinsidecontent">
                                                        <ul>
                                                          <li>
                                                            • Optimizing
                                                            algorithms & find
                                                            time complexity of
                                                            algorithms.
                                                          </li>
                                                          <li>
                                                            • Complexity
                                                            Analysis of
                                                            exponential &
                                                            factorial runtime
                                                          </li>
                                                        </ul>
                                                      </div>
                                                    </div>
                                                  </div>
                                                </div>

                                                <div className="card">
                                                  <div
                                                    className="card-header faqpadbotm"
                                                    id="algo_datainsidehead2_tab2"
                                                  >
                                                    <h2 className="mb-0">
                                                      <button
                                                        type="button"
                                                        className="btn btn-link collapsed borderfaq"
                                                        data-toggle="collapse"
                                                        data-target="#algo_collapsinside2_tab2"
                                                      >
                                                        <i className="fa fa-angle-down"></i>{" "}
                                                        Chapter 2: Load
                                                        Balancer, CDN, Cache
                                                        Eviction Policies{" "}
                                                      </button>
                                                    </h2>
                                                  </div>

                                                  <div
                                                    id="algo_collapsinside2_tab2"
                                                    className="collapse"
                                                    aria-labelledby="algo_datainsidehead2_tab2"
                                                    data-parent="#algo_accordioninside1_tab2"
                                                  >
                                                    <div className="card-body paddetop">
                                                      <div className="faqinsidecontent">
                                                        <ul>
                                                          <li>
                                                            • Space time
                                                            complexity of
                                                            algorithms.
                                                          </li>
                                                          <li>
                                                            • Techniques to
                                                            find time & space
                                                            complexity
                                                          </li>
                                                        </ul>
                                                      </div>
                                                    </div>
                                                  </div>
                                                </div>

                                                <div className="card">
                                                  <div
                                                    className="card-header faqpadbotm"
                                                    id="datainsidehead11"
                                                  >
                                                    <h2 className="mb-0">
                                                      <button
                                                        type="button"
                                                        className="btn btn-link borderfaq"
                                                        data-toggle="collapse"
                                                        data-target="#collapsinside11"
                                                      >
                                                        <i className="fa fa-angle-down favicons"></i>
                                                        Chapter 3: Push & Pull
                                                        Mechanism, Pooling &
                                                        Streaming Concepts
                                                      </button>
                                                    </h2>
                                                  </div>

                                                  <div
                                                    id="collapsinside11"
                                                    className="collapse"
                                                    aria-labelledby="datainsidehead11"
                                                    data-parent="#algo_accordioninside1_tab2"
                                                  >
                                                    <div className="card-body paddetop">
                                                      <div className="faqinsidecontent">
                                                        <div className="innerfaqlist">
                                                          <ul>
                                                            <li>
                                                              Push, Poll
                                                              architecture,
                                                              pooling,
                                                              webhooks
                                                            </li>

                                                            <li>
                                                              Polling and
                                                              Streaming, Long
                                                              pooling,
                                                              webSocket
                                                            </li>
                                                          </ul>
                                                        </div>
                                                      </div>
                                                    </div>
                                                  </div>
                                                </div>

                                                <div className="card">
                                                  <div
                                                    className="card-header faqpadbotm"
                                                    id="datainsidehead12"
                                                  >
                                                    <h2 className="mb-0">
                                                      <button
                                                        type="button"
                                                        className="btn btn-link borderfaq"
                                                        data-toggle="collapse"
                                                        data-target="#collapsinside12"
                                                      >
                                                        <i className="fa fa-angle-down favicons"></i>
                                                        Chapter 4: Leader and
                                                        Follower, Heartbeat,
                                                        CheckSum
                                                      </button>
                                                    </h2>
                                                  </div>

                                                  <div
                                                    id="collapsinside12"
                                                    className="collapse"
                                                    aria-labelledby="datainsidehead12"
                                                    data-parent="#algo_accordioninside1_tab2"
                                                  >
                                                    <div className="card-body paddetop">
                                                      <div className="faqinsidecontent">
                                                        <div className="innerfaqlist">
                                                          <ul>
                                                            <li>
                                                              Master slave
                                                              architecture,
                                                              Leader Follow
                                                              Architecture
                                                            </li>

                                                            <li>
                                                              Message ordering
                                                              in pubsub,
                                                              Kafka, ActiveMQ
                                                            </li>
                                                          </ul>
                                                        </div>
                                                      </div>
                                                    </div>
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>

                                    <div className="card">
                                      <div
                                        className="card-header"
                                        id="heading002"
                                      >
                                        <h2 className="mb-0">
                                          <button
                                            type="button"
                                            className="btn btn-link"
                                            data-toggle="collapse"
                                            data-target="#collapse002"
                                          >
                                            <i className="fa fa-angle-down favicons"></i>{" "}
                                            Module 2: Concurrency &
                                            Scalability{" "}
                                          </button>
                                        </h2>
                                      </div>

                                      <div
                                        id="collapse002"
                                        className="collapse"
                                        aria-labelledby="heading002"
                                        data-parent="#alog_accordionExample"
                                      >
                                        <div className="card-body">
                                          <div className="faqcontent">
                                            <div className="faqinside">
                                              <div
                                                className="accordion"
                                                id="accordioninside272"
                                              >
                                                <div className="card">
                                                  <div
                                                    className="card-header faqpadbotm"
                                                    id="datainsidehead5"
                                                  >
                                                    <h2 className="mb-0">
                                                      <button
                                                        type="button"
                                                        className="btn btn-link collapsed borderfaq"
                                                        data-toggle="collapse"
                                                        data-target="#collapsinside5272"
                                                      >
                                                        <i className="fa fa-angle-down"></i>{" "}
                                                        Chapter 1: Concurrency
                                                        Control And Recovery
                                                      </button>
                                                    </h2>
                                                  </div>

                                                  <div
                                                    id="collapsinside5272"
                                                    className="collapse"
                                                    aria-labelledby="datainsidehead5"
                                                    data-parent="#accordioninside272"
                                                  >
                                                    <div className="card-body paddetop">
                                                      <div className="faqinsidecontent">
                                                        <ul>
                                                          <li>
                                                            How to Handle
                                                            concurrency issues
                                                            in System, Handle
                                                            fault tolerant
                                                            issues
                                                          </li>

                                                          <li>
                                                            Service Handle
                                                            millions of
                                                            request/response,
                                                            Handle latency
                                                            issues
                                                          </li>
                                                        </ul>
                                                      </div>
                                                    </div>
                                                  </div>
                                                </div>

                                                <div className="card">
                                                  <div
                                                    className="card-header faqpadbotm"
                                                    id="datainsidehead6"
                                                  >
                                                    <h2 className="mb-0">
                                                      <button
                                                        type="button"
                                                        className="btn btn-link collapsed borderfaq"
                                                        data-toggle="collapse"
                                                        data-target="#collapsinside6272"
                                                      >
                                                        <i className="fa fa-angle-down"></i>{" "}
                                                        Chapter 2: Handling
                                                        Concurrent Access in
                                                        Scalable System{" "}
                                                      </button>
                                                    </h2>
                                                  </div>

                                                  <div
                                                    id="collapsinside6272"
                                                    className="collapse"
                                                    aria-labelledby="datainsidehead6"
                                                    data-parent="#accordioninside272"
                                                  >
                                                    <div className="card-body paddetop">
                                                      <div className="faqinsidecontent">
                                                        <p>
                                                          • Database
                                                          Transaction
                                                          Isolation During
                                                          concurrency
                                                        </p>
                                                        <p>
                                                          • Client Side
                                                          Monitoring System
                                                        </p>
                                                      </div>
                                                    </div>
                                                  </div>
                                                </div>

                                                <div className="card">
                                                  <div
                                                    className="card-header faqpadbotm"
                                                    id="datainsidehead6"
                                                  >
                                                    <h2 className="mb-0">
                                                      <button
                                                        type="button"
                                                        className="btn btn-link collapsed borderfaq"
                                                        data-toggle="collapse"
                                                        data-target="#collapsinside11272"
                                                      >
                                                        <i className="fa fa-angle-down"></i>{" "}
                                                        Chapter 3: Scalability
                                                      </button>
                                                    </h2>
                                                  </div>

                                                  <div
                                                    id="collapsinside11272"
                                                    className="collapse"
                                                    aria-labelledby="datainsidehead6"
                                                    data-parent="#accordioninside272"
                                                  >
                                                    <div className="card-body paddetop">
                                                      <div className="faqinsidecontent">
                                                        <p>
                                                          • Which Scalability
                                                          Approach is Right
                                                          for our Applications
                                                        </p>
                                                        <p>
                                                          • How to Improve and
                                                          Test the Scalability
                                                          of our Applications
                                                        </p>
                                                        <p>
                                                          • Achieving High
                                                          Availability - Fault
                                                          Tolerance
                                                        </p>
                                                      </div>
                                                    </div>
                                                  </div>
                                                </div>

                                                <div className="card">
                                                  <div
                                                    className="card-header faqpadbotm"
                                                    id="datainsidehead7"
                                                  >
                                                    <h2 className="mb-0">
                                                      <button
                                                        type="button"
                                                        className="btn btn-link collapsed borderfaq"
                                                        data-toggle="collapse"
                                                        data-target="#collapsinside7272"
                                                      >
                                                        <i className="fa fa-angle-down"></i>{" "}
                                                        Chapter 4: Synchronous
                                                        and Asynchronous
                                                      </button>
                                                    </h2>
                                                  </div>

                                                  <div
                                                    id="collapsinside7272"
                                                    className="collapse"
                                                    aria-labelledby="datainsidehead7"
                                                    data-parent="#accordioninside272"
                                                  >
                                                    <div className="card-body paddetop">
                                                      <div className="faqinsidecontent">
                                                        <p>
                                                          Locking, Thread
                                                          Safety, Interrupt
                                                          Signals
                                                        </p>
                                                        <p>
                                                          Non-Blocking
                                                          Synchronization
                                                        </p>
                                                      </div>
                                                    </div>
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>

                                    <div className="card">
                                      <div
                                        className="card-header"
                                        id="heading003"
                                      >
                                        <h2 className="mb-0">
                                          <button
                                            type="button"
                                            className="btn btn-link collapsed"
                                            data-toggle="collapse"
                                            data-target="#collapse003"
                                          >
                                            <i className="fa fa-angle-down"></i>{" "}
                                            Module 3: Advanced Distributed
                                            system
                                          </button>
                                        </h2>
                                      </div>

                                      <div
                                        id="collapse003"
                                        className="collapse"
                                        aria-labelledby="heading003"
                                        data-parent="#alog_accordionExample"
                                      >
                                        <div className="card-body">
                                          <div className="faqcontent">
                                            <div className="faqinside">
                                              <div
                                                className="accordion"
                                                id="accordioninside3010"
                                              >
                                                <div className="card">
                                                  <div
                                                    className="card-header faqpadbotm"
                                                    id="datainsidehead9"
                                                  >
                                                    <h2 className="mb-0">
                                                      <button
                                                        type="button"
                                                        className="btn btn-link collapsed borderfaq"
                                                        data-toggle="collapse"
                                                        data-target="#collapsinside9010"
                                                      >
                                                        <i className="fa fa-angle-down"></i>{" "}
                                                        Chapter 1: Zookeeper,
                                                        Consistent Hashing
                                                      </button>
                                                    </h2>
                                                  </div>

                                                  <div
                                                    id="collapsinside9010"
                                                    className="collapse"
                                                    aria-labelledby="datainsidehead9"
                                                    data-parent="#accordioninside3010"
                                                  >
                                                    <div className="card-body paddetop">
                                                      <div className="faqinsidecontent">
                                                        <p>
                                                          • Distributed
                                                          Hashing Scheme Using
                                                          Consistent Hashing{" "}
                                                        </p>
                                                        <p>
                                                          Configuration of
                                                          Zookeeper & Uses in
                                                          a Cluster of Machine
                                                        </p>
                                                      </div>
                                                    </div>
                                                  </div>
                                                </div>

                                                <div className="card">
                                                  <div
                                                    className="card-header faqpadbotm"
                                                    id="datainsidehead10"
                                                  >
                                                    <h2 className="mb-0">
                                                      <button
                                                        type="button"
                                                        className="btn btn-link collapsed borderfaq"
                                                        data-toggle="collapse"
                                                        data-target="#collapsinside10010"
                                                      >
                                                        <i className="fa fa-angle-down"></i>{" "}
                                                        Chapter 2: Memcached &
                                                        Radis
                                                      </button>
                                                    </h2>
                                                  </div>

                                                  <div
                                                    id="collapsinside10010"
                                                    className="collapse"
                                                    aria-labelledby="datainsidehead10"
                                                    data-parent="#accordioninside3010"
                                                  >
                                                    <div className="card-body paddetop">
                                                      <div className="faqinsidecontent">
                                                        <p>
                                                          • Memcached
                                                          Configuration, Key
                                                          Value Store
                                                        </p>
                                                        <p>
                                                          • Redis Details &
                                                          How to Use it{" "}
                                                        </p>
                                                      </div>
                                                    </div>
                                                  </div>
                                                </div>

                                                <div className="card">
                                                  <div
                                                    className="card-header faqpadbotm"
                                                    id="datainsidehead11"
                                                  >
                                                    <h2 className="mb-0">
                                                      <button
                                                        type="button"
                                                        className="btn btn-link collapsed borderfaq"
                                                        data-toggle="collapse"
                                                        data-target="#collapsinside11010"
                                                      >
                                                        <i className="fa fa-angle-down"></i>{" "}
                                                        Chapter 3: Message
                                                        Queue, Active MQ
                                                      </button>
                                                    </h2>
                                                  </div>

                                                  <div
                                                    id="collapsinside11010"
                                                    className="collapse"
                                                    aria-labelledby="datainsidehead11"
                                                    data-parent="#accordioninside3010"
                                                  >
                                                    <div className="card-body paddetop">
                                                      <div className="faqinsidecontent">
                                                        <p>
                                                          • How to Configure &
                                                          Send Message using
                                                          Messages Queue{" "}
                                                        </p>
                                                        <p>
                                                          • ActiveMQ ,
                                                          RabbitMQ
                                                          Implementation
                                                        </p>
                                                      </div>
                                                    </div>
                                                  </div>
                                                </div>

                                                <div className="card">
                                                  <div
                                                    className="card-header faqpadbotm"
                                                    id="datainsidehead12"
                                                  >
                                                    <h2 className="mb-0">
                                                      <button
                                                        type="button"
                                                        className="btn btn-link collapsed borderfaq"
                                                        data-toggle="collapse"
                                                        data-target="#collapsinside12010"
                                                      >
                                                        <i className="fa fa-angle-down"></i>{" "}
                                                        Chapter 4: Kafka
                                                        Architecture
                                                      </button>
                                                    </h2>
                                                  </div>

                                                  <div
                                                    id="collapsinside12010"
                                                    className="collapse"
                                                    aria-labelledby="datainsidehead12"
                                                    data-parent="#accordioninside3010"
                                                  >
                                                    <div className="card-body paddetop">
                                                      <div className="faqinsidecontent">
                                                        <p>
                                                          Kafka Broker
                                                          Configuration{" "}
                                                        </p>
                                                        <p>
                                                          Kafka
                                                          Producer,Consumer &
                                                          Topic
                                                        </p>
                                                        <p>
                                                          CallBack &
                                                          Acknowledgment
                                                        </p>
                                                        <p>
                                                          Real Time Stream
                                                          Processing
                                                        </p>
                                                        <p>
                                                          Complex Problems
                                                          Kafka Applications
                                                        </p>
                                                      </div>
                                                    </div>
                                                  </div>
                                                </div>

                                                <div className="card">
                                                  <div
                                                    className="card-header faqpadbotm"
                                                    id="datainsidehead13"
                                                  >
                                                    <h2 className="mb-0">
                                                      <button
                                                        type="button"
                                                        className="btn btn-link collapsed borderfaq"
                                                        data-toggle="collapse"
                                                        data-target="#collapsinside13010"
                                                      >
                                                        <i className="fa fa-angle-down"></i>{" "}
                                                        Chapter 5: Apache
                                                        Spark Architecture
                                                      </button>
                                                    </h2>
                                                  </div>

                                                  <div
                                                    id="collapsinside13010"
                                                    className="collapse"
                                                    aria-labelledby="datainsidehead13"
                                                    data-parent="#accordioninside3010"
                                                  >
                                                    <div className="card-body paddetop">
                                                      <div className="faqinsidecontent">
                                                        <p>
                                                          Spark Cluster and
                                                          Runtime Architecture{" "}
                                                        </p>
                                                        <p>
                                                          Spark SQL Engine and
                                                          Query Planning
                                                        </p>
                                                        <p>
                                                          Spark Memory
                                                          Allocation, Spark
                                                          Schedulers
                                                        </p>
                                                        <p>
                                                          Repartition and
                                                          Coalesce, Spark
                                                          Schedulers
                                                        </p>
                                                      </div>
                                                    </div>
                                                  </div>
                                                </div>

                                                <div className="card">
                                                  <div
                                                    className="card-header faqpadbotm"
                                                    id="datainsidehead14"
                                                  >
                                                    <h2 className="mb-0">
                                                      <button
                                                        type="button"
                                                        className="btn btn-link collapsed borderfaq"
                                                        data-toggle="collapse"
                                                        data-target="#collapsinside14010"
                                                      >
                                                        <i className="fa fa-angle-down"></i>
                                                        Chapter 6: Distributed
                                                        Transactions
                                                      </button>
                                                    </h2>
                                                  </div>

                                                  <div
                                                    id="collapsinside14010"
                                                    className="collapse"
                                                    aria-labelledby="datainsidehead14"
                                                    data-parent="#accordioninside3010"
                                                  >
                                                    <div className="card-body paddetop">
                                                      <div className="faqinsidecontent">
                                                        <p>
                                                          Atomicity,
                                                          Consistency,
                                                          Isolation,
                                                          Persistence
                                                        </p>
                                                        <p>
                                                          Two-Phase Commit
                                                          Architecture{" "}
                                                        </p>
                                                        <p>
                                                          Orchestration
                                                          Architecture
                                                        </p>
                                                        <p>
                                                          Saga Architecture,
                                                          Transactional
                                                          Messaging
                                                        </p>
                                                        <p>
                                                          Best-effort
                                                          Notification,
                                                          Sub-Transaction
                                                          Barriers
                                                        </p>
                                                      </div>
                                                    </div>
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div
                              className="tab-pane fade"
                              id="hldlld-sm"
                              role="tabpanel"
                              aria-labelledby="hldlld-sm-tab"
                            >
                              <div className="tabinginfodetails">
                                <div className="faq">
                                  <div
                                    className="accordion"
                                    id="oops_accordionExample"
                                  >
                                    <div className="card">
                                      <div
                                        className="card-header"
                                        id="oops_heading001"
                                      >
                                        <h2 className="mb-0">
                                          <button
                                            type="button"
                                            className="btn btn-link collapsed"
                                            data-toggle="collapse"
                                            data-target="#oops_collapse001"
                                          >
                                            <i className="fa fa-angle-down"></i>{" "}
                                            Module 1 : High level Design (HLD)
                                            + LLD (Low Level Design){" "}
                                          </button>
                                        </h2>
                                      </div>
                                      <div
                                        id="oops_collapse001"
                                        className="collapse"
                                        aria-labelledby="oops_heading001"
                                        data-parent="#oops_accordionExample"
                                      >
                                        <div className="card-body">
                                          <div className="faqcontent">
                                            <div className="faqinside">
                                              <div
                                                className="accordion"
                                                id="oops_accordioninside1"
                                              >
                                                <div className="card">
                                                  <div
                                                    className="card-header faqpadbotm"
                                                    id="datainsidehead13"
                                                  >
                                                    <h2 className="mb-0">
                                                      <button
                                                        type="button"
                                                        className="btn btn-link collapsed borderfaq"
                                                        data-toggle="collapse"
                                                        data-target="#collapsinside13"
                                                      >
                                                        <i className="fa fa-angle-down"></i>{" "}
                                                        Chapter 1: Design
                                                        video streaming
                                                        service
                                                        YouTube/Netflix{" "}
                                                      </button>
                                                    </h2>
                                                  </div>

                                                  <div
                                                    id="collapsinside13"
                                                    className="collapse"
                                                    aria-labelledby="datainsidehead13"
                                                    data-parent="#oops_accordioninside1"
                                                  >
                                                    <div className="card-body paddetop">
                                                      <div className="faqinsidecontent">
                                                        <div className="innerfaqlist">
                                                          <ul>
                                                            <li>
                                                              Design video
                                                              streaming
                                                              service
                                                              YouTube/Netflix
                                                            </li>
                                                          </ul>
                                                        </div>
                                                      </div>
                                                    </div>
                                                  </div>
                                                </div>

                                                <div className="card">
                                                  <div
                                                    className="card-header faqpadbotm"
                                                    id="datainsidehead14"
                                                  >
                                                    <h2 className="mb-0">
                                                      <button
                                                        type="button"
                                                        className="btn btn-link borderfaq"
                                                        data-toggle="collapse"
                                                        data-target="#collapsinside14"
                                                      >
                                                        <i className="fa fa-angle-down favicons"></i>
                                                        Chapter 2: Design
                                                        TinyURL Service{" "}
                                                      </button>
                                                    </h2>
                                                  </div>

                                                  <div
                                                    id="collapsinside14"
                                                    className="collapse"
                                                    aria-labelledby="datainsidehead14"
                                                    data-parent="#oops_accordioninside1"
                                                  >
                                                    <div className="card-body paddetop">
                                                      <div className="faqinsidecontent">
                                                        <div className="innerfaqlist">
                                                          <ul>
                                                            <li>
                                                              Design TinyURL
                                                              Service with
                                                              scalable HLD and
                                                              LLD design{" "}
                                                            </li>
                                                          </ul>
                                                        </div>
                                                      </div>
                                                    </div>
                                                  </div>
                                                </div>

                                                <div className="card">
                                                  <div
                                                    className="card-header faqpadbotm"
                                                    id="datainsidehead15"
                                                  >
                                                    <h2 className="mb-0">
                                                      <button
                                                        type="button"
                                                        className="btn btn-link borderfaq"
                                                        data-toggle="collapse"
                                                        data-target="#collapsinside15"
                                                      >
                                                        <i className="fa fa-angle-down favicons"></i>
                                                        Chapter 3: Design Ride
                                                        sharing service
                                                        Uber/Ola
                                                      </button>
                                                    </h2>
                                                  </div>

                                                  <div
                                                    id="collapsinside15"
                                                    className="collapse"
                                                    aria-labelledby="datainsidehead15"
                                                    data-parent="#oops_accordioninside1"
                                                  >
                                                    <div className="card-body paddetop">
                                                      <div className="faqinsidecontent">
                                                        <div className="innerfaqlist">
                                                          <ul>
                                                            <li>
                                                              Design Ride
                                                              sharing service
                                                              Uber/Ola{" "}
                                                            </li>
                                                          </ul>
                                                        </div>
                                                      </div>
                                                    </div>
                                                  </div>
                                                </div>

                                                <div className="card">
                                                  <div
                                                    className="card-header faqpadbotm"
                                                    id="datainsidehead16"
                                                  >
                                                    <h2 className="mb-0">
                                                      <button
                                                        type="button"
                                                        className="btn btn-link borderfaq"
                                                        data-toggle="collapse"
                                                        data-target="#collapsinside16"
                                                      >
                                                        <i className="fa fa-angle-down favicons"></i>
                                                        Chapter 4: Design
                                                        Search engine Like
                                                        Google,Yahoo,Bing etc{" "}
                                                      </button>
                                                    </h2>
                                                  </div>

                                                  <div
                                                    id="collapsinside16"
                                                    className="collapse"
                                                    aria-labelledby="datainsidehead16"
                                                    data-parent="#oops_accordioninside1"
                                                  >
                                                    <div className="card-body paddetop">
                                                      <div className="faqinsidecontent">
                                                        <div className="innerfaqlist">
                                                          <ul>
                                                            <li>
                                                              Design Online
                                                              Search engine
                                                              and there page
                                                              ranking & web
                                                              crawler features
                                                              architecture.{" "}
                                                            </li>
                                                          </ul>
                                                        </div>
                                                      </div>
                                                    </div>
                                                  </div>
                                                </div>

                                                <div className="card">
                                                  <div
                                                    className="card-header faqpadbotm"
                                                    id="datainsidehead17"
                                                  >
                                                    <h2 className="mb-0">
                                                      <button
                                                        type="button"
                                                        className="btn btn-link borderfaq"
                                                        data-toggle="collapse"
                                                        data-target="#collapsinside17"
                                                      >
                                                        <i className="fa fa-angle-down favicons"></i>
                                                        Chapter 5: Design
                                                        Geographical location
                                                        system Google
                                                        Maps/Swiggy map
                                                      </button>
                                                    </h2>
                                                  </div>

                                                  <div
                                                    id="collapsinside17"
                                                    className="collapse"
                                                    aria-labelledby="datainsidehead17"
                                                    data-parent="#oops_accordioninside1"
                                                  >
                                                    <div className="card-body paddetop">
                                                      <div className="faqinsidecontent">
                                                        <div className="innerfaqlist">
                                                          <ul>
                                                            <li>
                                                              Design System
                                                              with geolocation
                                                              mapping system{" "}
                                                            </li>
                                                          </ul>
                                                        </div>
                                                      </div>
                                                    </div>
                                                  </div>
                                                </div>

                                                <div className="card">
                                                  <div
                                                    className="card-header faqpadbotm"
                                                    id="datainsidehead18"
                                                  >
                                                    <h2 className="mb-0">
                                                      <button
                                                        type="button"
                                                        className="btn btn-link borderfaq"
                                                        data-toggle="collapse"
                                                        data-target="#collapsinside18"
                                                      >
                                                        <i className="fa fa-angle-down favicons"></i>
                                                        Chapter 6: Design
                                                        Newsfeed Service in
                                                        Facebook
                                                      </button>
                                                    </h2>
                                                  </div>

                                                  <div
                                                    id="collapsinside18"
                                                    className="collapse"
                                                    aria-labelledby="datainsidehead18"
                                                    data-parent="#oops_accordioninside1"
                                                  >
                                                    <div className="card-body paddetop">
                                                      <div className="faqinsidecontent">
                                                        <div className="innerfaqlist">
                                                          <ul>
                                                            <li>
                                                              Design Newsfeed
                                                              Service in
                                                              Facebook{" "}
                                                            </li>
                                                          </ul>
                                                        </div>
                                                      </div>
                                                    </div>
                                                  </div>
                                                </div>

                                                <div className="card">
                                                  <div
                                                    className="card-header faqpadbotm"
                                                    id="datainsidehead19"
                                                  >
                                                    <h2 className="mb-0">
                                                      <button
                                                        type="button"
                                                        className="btn btn-link borderfaq"
                                                        data-toggle="collapse"
                                                        data-target="#collapsinside19"
                                                      >
                                                        <i className="fa fa-angle-down favicons"></i>
                                                        Chapter 7: Design
                                                        Twitter like social
                                                        networking service &
                                                        its tweet search
                                                        features
                                                      </button>
                                                    </h2>
                                                  </div>

                                                  <div
                                                    id="collapsinside19"
                                                    className="collapse"
                                                    aria-labelledby="datainsidehead19"
                                                    data-parent="#oops_accordioninside1"
                                                  >
                                                    <div className="card-body paddetop">
                                                      <div className="faqinsidecontent">
                                                        <div className="innerfaqlist">
                                                          <ul>
                                                            <li>
                                                              Design Twitter
                                                              like social
                                                              networking
                                                              service & its
                                                              tweet search
                                                              features{" "}
                                                            </li>
                                                          </ul>
                                                        </div>
                                                      </div>
                                                    </div>
                                                  </div>
                                                </div>

                                                <div className="card">
                                                  <div
                                                    className="card-header faqpadbotm"
                                                    id="datainsidehead20"
                                                  >
                                                    <h2 className="mb-0">
                                                      <button
                                                        type="button"
                                                        className="btn btn-link borderfaq"
                                                        data-toggle="collapse"
                                                        data-target="#collapsinside20"
                                                      >
                                                        <i className="fa fa-angle-down favicons"></i>
                                                        Chapter 8: Design
                                                        Instagram social
                                                        networking service
                                                      </button>
                                                    </h2>
                                                  </div>

                                                  <div
                                                    id="collapsinside20"
                                                    className="collapse"
                                                    aria-labelledby="datainsidehead20"
                                                    data-parent="#oops_accordioninside1"
                                                  >
                                                    <div className="card-body paddetop">
                                                      <div className="faqinsidecontent">
                                                        <div className="innerfaqlist">
                                                          <ul>
                                                            <li>
                                                              Design Instagram
                                                              social
                                                              networking
                                                              service{" "}
                                                            </li>
                                                          </ul>
                                                        </div>
                                                      </div>
                                                    </div>
                                                  </div>
                                                </div>

                                                <div className="card">
                                                  <div
                                                    className="card-header faqpadbotm"
                                                    id="datainsidehead21"
                                                  >
                                                    <h2 className="mb-0">
                                                      <button
                                                        type="button"
                                                        className="btn btn-link borderfaq"
                                                        data-toggle="collapse"
                                                        data-target="#collapsinside21"
                                                      >
                                                        <i className="fa fa-angle-down favicons"></i>
                                                        Chapter 9: Design API
                                                        Rate Late Limiter
                                                      </button>
                                                    </h2>
                                                  </div>

                                                  <div
                                                    id="collapsinside21"
                                                    className="collapse"
                                                    aria-labelledby="datainsidehead21"
                                                    data-parent="#oops_accordioninside1"
                                                  >
                                                    <div className="card-body paddetop">
                                                      <div className="faqinsidecontent">
                                                        <div className="innerfaqlist">
                                                          <ul>
                                                            <li>
                                                              Design API Rate
                                                              Late Limiter{" "}
                                                            </li>
                                                          </ul>
                                                        </div>
                                                      </div>
                                                    </div>
                                                  </div>
                                                </div>

                                                <div className="card">
                                                  <div
                                                    className="card-header faqpadbotm"
                                                    id="datainsidehead22"
                                                  >
                                                    <h2 className="mb-0">
                                                      <button
                                                        type="button"
                                                        className="btn btn-link borderfaq"
                                                        data-toggle="collapse"
                                                        data-target="#collapsinside22"
                                                      >
                                                        <i className="fa fa-angle-down favicons"></i>
                                                        Chapter 10: Design
                                                        WhatsApp/Facebook Chat
                                                        Service
                                                      </button>
                                                    </h2>
                                                  </div>

                                                  <div
                                                    id="collapsinside22"
                                                    className="collapse"
                                                    aria-labelledby="datainsidehead22"
                                                    data-parent="#oops_accordioninside1"
                                                  >
                                                    <div className="card-body paddetop">
                                                      <div className="faqinsidecontent">
                                                        <div className="innerfaqlist">
                                                          <ul>
                                                            <li>
                                                              Design
                                                              WhatsApp/Facebook
                                                              Chat Service{" "}
                                                            </li>
                                                          </ul>
                                                        </div>
                                                      </div>
                                                    </div>
                                                  </div>
                                                </div>

                                                <div className="card">
                                                  <div
                                                    className="card-header faqpadbotm"
                                                    id="datainsidehead23"
                                                  >
                                                    <h2 className="mb-0">
                                                      <button
                                                        type="button"
                                                        className="btn btn-link borderfaq"
                                                        data-toggle="collapse"
                                                        data-target="#collapsinside23"
                                                      >
                                                        <i className="fa fa-angle-down favicons"></i>
                                                        Chapter 11: Design
                                                        Mailing service Like
                                                        Gmail/Yahoo{" "}
                                                      </button>
                                                    </h2>
                                                  </div>

                                                  <div
                                                    id="collapsinside23"
                                                    className="collapse"
                                                    aria-labelledby="datainsidehead23"
                                                    data-parent="#oops_accordioninside1"
                                                  >
                                                    <div className="card-body paddetop">
                                                      <div className="faqinsidecontent">
                                                        <div className="innerfaqlist">
                                                          <ul>
                                                            <li>
                                                              Design Mailing
                                                              service Like
                                                              Gmail/Yahoo{" "}
                                                            </li>
                                                          </ul>
                                                        </div>
                                                      </div>
                                                    </div>
                                                  </div>
                                                </div>

                                                <div className="card">
                                                  <div
                                                    className="card-header faqpadbotm"
                                                    id="datainsidehead24"
                                                  >
                                                    <h2 className="mb-0">
                                                      <button
                                                        type="button"
                                                        className="btn btn-link borderfaq"
                                                        data-toggle="collapse"
                                                        data-target="#collapsinside24"
                                                      >
                                                        <i className="fa fa-angle-down favicons"></i>
                                                        Chapter 12: Event
                                                        Based Architecture
                                                      </button>
                                                    </h2>
                                                  </div>

                                                  <div
                                                    id="collapsinside24"
                                                    className="collapse"
                                                    aria-labelledby="datainsidehead24"
                                                    data-parent="#oops_accordioninside1"
                                                  >
                                                    <div className="card-body paddetop">
                                                      <div className="faqinsidecontent">
                                                        <div className="innerfaqlist">
                                                          <ul>
                                                            <li>
                                                              Design System
                                                              that supports
                                                              Event Based
                                                              Architecture{" "}
                                                            </li>
                                                          </ul>
                                                        </div>
                                                      </div>
                                                    </div>
                                                  </div>
                                                </div>

                                                <div className="card">
                                                  <div
                                                    className="card-header faqpadbotm"
                                                    id="datainsidehead25"
                                                  >
                                                    <h2 className="mb-0">
                                                      <button
                                                        type="button"
                                                        className="btn btn-link borderfaq"
                                                        data-toggle="collapse"
                                                        data-target="#collapsinside25"
                                                      >
                                                        <i className="fa fa-angle-down favicons"></i>
                                                        Chapter 13: Design
                                                        Calendar booking
                                                        service like Google
                                                        Calendar
                                                      </button>
                                                    </h2>
                                                  </div>

                                                  <div
                                                    id="collapsinside25"
                                                    className="collapse"
                                                    aria-labelledby="datainsidehead25"
                                                    data-parent="#oops_accordioninside1"
                                                  >
                                                    <div className="card-body paddetop">
                                                      <div className="faqinsidecontent">
                                                        <div className="innerfaqlist">
                                                          <ul>
                                                            <li>
                                                              Design Calendar
                                                              booking service
                                                              like Google
                                                              Calendar{" "}
                                                            </li>
                                                          </ul>
                                                        </div>
                                                      </div>
                                                    </div>
                                                  </div>
                                                </div>

                                                <div className="card">
                                                  <div
                                                    className="card-header faqpadbotm"
                                                    id="datainsidehead26"
                                                  >
                                                    <h2 className="mb-0">
                                                      <button
                                                        type="button"
                                                        className="btn btn-link borderfaq"
                                                        data-toggle="collapse"
                                                        data-target="#collapsinside26"
                                                      >
                                                        <i className="fa fa-angle-down favicons"></i>
                                                        Chapter 14: Design
                                                        Railway reservation
                                                        system Like IRCTC
                                                      </button>
                                                    </h2>
                                                  </div>

                                                  <div
                                                    id="collapsinside26"
                                                    className="collapse"
                                                    aria-labelledby="datainsidehead26"
                                                    data-parent="#oops_accordioninside1"
                                                  >
                                                    <div className="card-body paddetop">
                                                      <div className="faqinsidecontent">
                                                        <div className="innerfaqlist">
                                                          <ul>
                                                            <li>
                                                              Design Railway
                                                              reservation
                                                              system Like
                                                              IRCTC{" "}
                                                            </li>
                                                          </ul>
                                                        </div>
                                                      </div>
                                                    </div>
                                                  </div>
                                                </div>

                                                <div className="card">
                                                  <div
                                                    className="card-header faqpadbotm"
                                                    id="datainsidehead27"
                                                  >
                                                    <h2 className="mb-0">
                                                      <button
                                                        type="button"
                                                        className="btn btn-link borderfaq"
                                                        data-toggle="collapse"
                                                        data-target="#collapsinside27"
                                                      >
                                                        <i className="fa fa-angle-down favicons"></i>
                                                        Chapter 15: Design
                                                        Online bus booking
                                                        system like RedBus
                                                      </button>
                                                    </h2>
                                                  </div>

                                                  <div
                                                    id="collapsinside27"
                                                    className="collapse"
                                                    aria-labelledby="datainsidehead27"
                                                    data-parent="#oops_accordioninside1"
                                                  >
                                                    <div className="card-body paddetop">
                                                      <div className="faqinsidecontent">
                                                        <div className="innerfaqlist">
                                                          <ul>
                                                            <li>
                                                              Design Online
                                                              bus booking
                                                              system like
                                                              RedBus{" "}
                                                            </li>
                                                          </ul>
                                                        </div>
                                                      </div>
                                                    </div>
                                                  </div>
                                                </div>

                                                <div className="card">
                                                  <div
                                                    className="card-header faqpadbotm"
                                                    id="datainsidehead28"
                                                  >
                                                    <h2 className="mb-0">
                                                      <button
                                                        type="button"
                                                        className="btn btn-link borderfaq"
                                                        data-toggle="collapse"
                                                        data-target="#collapsinside28"
                                                      >
                                                        <i className="fa fa-angle-down favicons"></i>
                                                        Chapter 16: Design
                                                        Online ticket booking
                                                        system like BookMyShow
                                                      </button>
                                                    </h2>
                                                  </div>

                                                  <div
                                                    id="collapsinside28"
                                                    className="collapse"
                                                    aria-labelledby="datainsidehead28"
                                                    data-parent="#oops_accordioninside1"
                                                  >
                                                    <div className="card-body paddetop">
                                                      <div className="faqinsidecontent">
                                                        <div className="innerfaqlist">
                                                          <ul>
                                                            <li>
                                                              Design Online
                                                              ticket booking
                                                              system like
                                                              BookMyShow{" "}
                                                            </li>
                                                          </ul>
                                                        </div>
                                                      </div>
                                                    </div>
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>

                                    <div className="card">
                                      <div
                                        className="card-header"
                                        id="oops_heading002"
                                      >
                                        <h2 className="mb-0">
                                          <button
                                            type="button"
                                            className="btn btn-link"
                                            data-toggle="collapse"
                                            data-target="#oops_collapse002222"
                                          >
                                            <i className="fa fa-angle-down favicons"></i>{" "}
                                            Module 2: Microservice
                                            Architecture{" "}
                                          </button>
                                        </h2>
                                      </div>

                                      <div
                                        id="oops_collapse002222"
                                        className="collapse"
                                        aria-labelledby="oops_heading002"
                                        data-parent="#oops_accordionExample"
                                      >
                                        <div className="card-body">
                                          <div className="faqcontent">
                                            <div className="faqinside">
                                              <div
                                                className="accordion"
                                                id="oops_accordioninside222"
                                              >
                                                <div className="card">
                                                  <div
                                                    className="card-header faqpadbotm"
                                                    id="datainsidehead40"
                                                  >
                                                    <h2 className="mb-0">
                                                      <button
                                                        type="button"
                                                        className="btn btn-link borderfaq"
                                                        data-toggle="collapse"
                                                        data-target="#collapsinside40222"
                                                      >
                                                        <i className="fa fa-angle-down favicons"></i>
                                                        Chapter 1: Choose Best
                                                        Architecture for
                                                        System Design
                                                      </button>
                                                    </h2>
                                                  </div>

                                                  <div
                                                    id="collapsinside40222"
                                                    className="collapse"
                                                    aria-labelledby="datainsidehead40"
                                                    data-parent="#oops_accordioninside222"
                                                  >
                                                    <div className="card-body paddetop">
                                                      <div className="faqinsidecontent">
                                                        <div className="innerfaqlist">
                                                          <ul>
                                                            <li>
                                                              How Microservice
                                                              Architecture is
                                                              Better than
                                                              Monolithic
                                                              Architecture
                                                            </li>
                                                            <li>
                                                              Event-Driven
                                                              Architecture,
                                                              Microservice
                                                              Architecture
                                                              Introduction
                                                            </li>
                                                          </ul>
                                                        </div>
                                                      </div>
                                                    </div>
                                                  </div>
                                                </div>

                                                <div className="card">
                                                  <div
                                                    className="card-header faqpadbotm"
                                                    id="datainsidehead41"
                                                  >
                                                    <h2 className="mb-0">
                                                      <button
                                                        type="button"
                                                        className="btn btn-link borderfaq"
                                                        data-toggle="collapse"
                                                        data-target="#collapsinside41222"
                                                      >
                                                        <i className="fa fa-angle-down favicons"></i>
                                                        Chapter 2:
                                                        Micro-Service
                                                        Architectures
                                                        Introduction
                                                      </button>
                                                    </h2>
                                                  </div>

                                                  <div
                                                    id="collapsinside41222"
                                                    className="collapse"
                                                    aria-labelledby="datainsidehead41"
                                                    data-parent="#oops_accordioninside222"
                                                  >
                                                    <div className="card-body paddetop">
                                                      <div className="faqinsidecontent">
                                                        <div className="innerfaqlist">
                                                          <ul>
                                                            <li>
                                                              Design Patterns
                                                              for
                                                              Microservices
                                                            </li>
                                                          </ul>
                                                        </div>
                                                      </div>
                                                    </div>
                                                  </div>
                                                </div>

                                                <div className="card">
                                                  <div
                                                    className="card-header faqpadbotm"
                                                    id="datainsidehead42"
                                                  >
                                                    <h2 className="mb-0">
                                                      <button
                                                        type="button"
                                                        className="btn btn-link borderfaq"
                                                        data-toggle="collapse"
                                                        data-target="#collapsinside42222"
                                                      >
                                                        <i className="fa fa-angle-down favicons"></i>
                                                        Chapter 2:
                                                        Micro-service vs
                                                        Monolithic
                                                        Architecture
                                                      </button>
                                                    </h2>
                                                  </div>

                                                  <div
                                                    id="collapsinside42222"
                                                    className="collapse"
                                                    aria-labelledby="datainsidehead42"
                                                    data-parent="#oops_accordioninside222"
                                                  >
                                                    <div className="card-body paddetop">
                                                      <div className="faqinsidecontent">
                                                        <div className="innerfaqlist">
                                                          <ul>
                                                            <li>
                                                              Migrate
                                                              Monolithic
                                                              Application to
                                                              Microservices
                                                            </li>
                                                          </ul>
                                                        </div>
                                                      </div>
                                                    </div>
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div
                              className="tab-pane fade"
                              id="designPattern-sm"
                              role="tabpanel"
                              aria-labelledby="designPattern-sm-tab"
                            >
                              <div className="tabinginfodetails">
                                <div className="faq">
                                  <div
                                    className="accordion"
                                    id="code_mgmt_accordionExample"
                                  >
                                    <div className="card">
                                      <div
                                        className="card-header"
                                        id="code_mgmt_heading001"
                                      >
                                        <h2 className="mb-0">
                                          <button
                                            type="button"
                                            className="btn btn-link collapsed"
                                            data-toggle="collapse"
                                            data-target="#code_mgmt_collapse001"
                                          >
                                            <i className="fa fa-angle-down"></i>{" "}
                                            Design Pattern Problems{" "}
                                          </button>
                                        </h2>
                                      </div>
                                      <div
                                        id="code_mgmt_collapse001"
                                        className="collapse"
                                        aria-labelledby="code_mgmt_heading001"
                                        data-parent="#code_mgmt_accordionExample"
                                      >
                                        <div className="card-body">
                                          <div className="faqcontent">
                                            <div className="faqinside">
                                              <div
                                                className="accordion"
                                                id="code_mgmt_accordioninside1"
                                              >
                                                <div className="card">
                                                  <div
                                                    className="card-header faqpadbotm"
                                                    id="datainsidehead21"
                                                  >
                                                    <h2 className="mb-0">
                                                      <button
                                                        type="button"
                                                        className="btn btn-link collapsed borderfaq"
                                                        data-toggle="collapse"
                                                        data-target="#collapsinside21"
                                                      >
                                                        <i className="fa fa-angle-down"></i>{" "}
                                                        Chapter 1: SOLID
                                                        design pattern &
                                                        principle{" "}
                                                      </button>
                                                    </h2>
                                                  </div>

                                                  <div
                                                    id="collapsinside21"
                                                    className="collapse"
                                                    aria-labelledby="datainsidehead21"
                                                    data-parent="#code_mgmt_accordioninside1"
                                                  >
                                                    <div className="card-body paddetop">
                                                      <div className="faqinsidecontent">
                                                        <div className="innerfaqlist">
                                                          <ul>
                                                            <li>
                                                              Single-Responsibility
                                                              Principle.
                                                            </li>

                                                            <li>
                                                              Open-Closed
                                                              Principle
                                                            </li>

                                                            <li>
                                                              Liskov
                                                              Substitution
                                                              Principle
                                                            </li>
                                                            <li>
                                                              Interface
                                                              Segregation
                                                              Principle
                                                            </li>
                                                            <li>
                                                              Dependency
                                                              Inversion
                                                              Principle
                                                            </li>
                                                          </ul>
                                                        </div>
                                                      </div>
                                                    </div>
                                                  </div>
                                                </div>

                                                <div className="card">
                                                  <div
                                                    className="card-header faqpadbotm"
                                                    id="datainsidehead22"
                                                  >
                                                    <h2 className="mb-0">
                                                      <button
                                                        type="button"
                                                        className="btn btn-link borderfaq"
                                                        data-toggle="collapse"
                                                        data-target="#collapsinside22"
                                                      >
                                                        <i className="fa fa-angle-down favicons"></i>
                                                        Chapter 2: Singleton
                                                        Design Pattern
                                                      </button>
                                                    </h2>
                                                  </div>

                                                  <div
                                                    id="collapsinside22"
                                                    className="collapse"
                                                    aria-labelledby="datainsidehead22"
                                                    data-parent="#code_mgmt_accordioninside1"
                                                  >
                                                    <div className="card-body paddetop">
                                                      <div className="faqinsidecontent">
                                                        <div className="innerfaqlist">
                                                          <ul>
                                                            <li>
                                                              Design &
                                                              implement
                                                              Singleton Design
                                                              Pattern
                                                            </li>
                                                          </ul>
                                                        </div>
                                                      </div>
                                                    </div>
                                                  </div>
                                                </div>

                                                <div className="card">
                                                  <div
                                                    className="card-header faqpadbotm"
                                                    id="datainsidehead23"
                                                  >
                                                    <h2 className="mb-0">
                                                      <button
                                                        type="button"
                                                        className="btn btn-link borderfaq"
                                                        data-toggle="collapse"
                                                        data-target="#collapsinside23"
                                                      >
                                                        <i className="fa fa-angle-down favicons"></i>
                                                        Chapter 3: Factory
                                                        Design Pattern{" "}
                                                      </button>
                                                    </h2>
                                                  </div>

                                                  <div
                                                    id="collapsinside23"
                                                    className="collapse"
                                                    aria-labelledby="datainsidehead23"
                                                    data-parent="#code_mgmt_accordioninside1"
                                                  >
                                                    <div className="card-body paddetop">
                                                      <div className="faqinsidecontent">
                                                        <div className="innerfaqlist">
                                                          <ul>
                                                            <li>
                                                              Design &
                                                              implement
                                                              Factory Design
                                                              Pattern
                                                            </li>
                                                          </ul>
                                                        </div>
                                                      </div>
                                                    </div>
                                                  </div>
                                                </div>

                                                <div className="card">
                                                  <div
                                                    className="card-header faqpadbotm"
                                                    id="datainsidehead24"
                                                  >
                                                    <h2 className="mb-0">
                                                      <button
                                                        type="button"
                                                        className="btn btn-link borderfaq"
                                                        data-toggle="collapse"
                                                        data-target="#collapsinside24"
                                                      >
                                                        <i className="fa fa-angle-down favicons"></i>
                                                        Chapter 4: Abstract
                                                        Factory Design Pattern{" "}
                                                      </button>
                                                    </h2>
                                                  </div>

                                                  <div
                                                    id="collapsinside24"
                                                    className="collapse"
                                                    aria-labelledby="datainsidehead24"
                                                    data-parent="#code_mgmt_accordioninside1"
                                                  >
                                                    <div className="card-body paddetop">
                                                      <div className="faqinsidecontent">
                                                        <div className="innerfaqlist">
                                                          <ul>
                                                            <li>
                                                              Design &
                                                              implement
                                                              abstract factory
                                                              design pattern
                                                            </li>
                                                          </ul>
                                                        </div>
                                                      </div>
                                                    </div>
                                                  </div>
                                                </div>

                                                <div className="card">
                                                  <div
                                                    className="card-header faqpadbotm"
                                                    id="datainsidehead25"
                                                  >
                                                    <h2 className="mb-0">
                                                      <button
                                                        type="button"
                                                        className="btn btn-link borderfaq"
                                                        data-toggle="collapse"
                                                        data-target="#collapsinside25"
                                                      >
                                                        <i className="fa fa-angle-down favicons"></i>
                                                        Chapter 5: Observer
                                                        Design Pattern{" "}
                                                      </button>
                                                    </h2>
                                                  </div>

                                                  <div
                                                    id="collapsinside25"
                                                    className="collapse"
                                                    aria-labelledby="datainsidehead25"
                                                    data-parent="#code_mgmt_accordioninside1"
                                                  >
                                                    <div className="card-body paddetop">
                                                      <div className="faqinsidecontent">
                                                        <div className="innerfaqlist">
                                                          <ul>
                                                            <li>
                                                              Design &
                                                              implement
                                                              Observer Design
                                                              Pattern{" "}
                                                            </li>
                                                          </ul>
                                                        </div>
                                                      </div>
                                                    </div>
                                                  </div>
                                                </div>

                                                <div className="card">
                                                  <div
                                                    className="card-header faqpadbotm"
                                                    id="datainsidehead26"
                                                  >
                                                    <h2 className="mb-0">
                                                      <button
                                                        type="button"
                                                        className="btn btn-link borderfaq"
                                                        data-toggle="collapse"
                                                        data-target="#collapsinside26"
                                                      >
                                                        <i className="fa fa-angle-down favicons"></i>
                                                        Chapter 6: Strategy
                                                        Design Pattern
                                                      </button>
                                                    </h2>
                                                  </div>

                                                  <div
                                                    id="collapsinside26"
                                                    className="collapse"
                                                    aria-labelledby="datainsidehead26"
                                                    data-parent="#code_mgmt_accordioninside1"
                                                  >
                                                    <div className="card-body paddetop">
                                                      <div className="faqinsidecontent">
                                                        <div className="innerfaqlist">
                                                          <ul>
                                                            <li>
                                                              Design &
                                                              implement
                                                              Strategy Design
                                                              Pattern{" "}
                                                            </li>
                                                          </ul>
                                                        </div>
                                                      </div>
                                                    </div>
                                                  </div>
                                                </div>

                                                <div className="card">
                                                  <div
                                                    className="card-header faqpadbotm"
                                                    id="datainsidehead27"
                                                  >
                                                    <h2 className="mb-0">
                                                      <button
                                                        type="button"
                                                        className="btn btn-link borderfaq"
                                                        data-toggle="collapse"
                                                        data-target="#collapsinside27"
                                                      >
                                                        <i className="fa fa-angle-down favicons"></i>
                                                        Chapter 7: Decorator
                                                        Design Pattern
                                                      </button>
                                                    </h2>
                                                  </div>

                                                  <div
                                                    id="collapsinside27"
                                                    className="collapse"
                                                    aria-labelledby="datainsidehead27"
                                                    data-parent="#code_mgmt_accordioninside1"
                                                  >
                                                    <div className="card-body paddetop">
                                                      <div className="faqinsidecontent">
                                                        <div className="innerfaqlist">
                                                          <ul>
                                                            <li>
                                                              Design &
                                                              implement
                                                              Decorator Design
                                                              Pattern{" "}
                                                            </li>
                                                          </ul>
                                                        </div>
                                                      </div>
                                                    </div>
                                                  </div>
                                                </div>

                                                <div className="card">
                                                  <div
                                                    className="card-header faqpadbotm"
                                                    id="datainsidehead28"
                                                  >
                                                    <h2 className="mb-0">
                                                      <button
                                                        type="button"
                                                        className="btn btn-link borderfaq"
                                                        data-toggle="collapse"
                                                        data-target="#collapsinside28"
                                                      >
                                                        <i className="fa fa-angle-down favicons"></i>
                                                        Chapter 8: Adapter
                                                        Design Pattern
                                                      </button>
                                                    </h2>
                                                  </div>

                                                  <div
                                                    id="collapsinside28"
                                                    className="collapse"
                                                    aria-labelledby="datainsidehead28"
                                                    data-parent="#code_mgmt_accordioninside1"
                                                  >
                                                    <div className="card-body paddetop">
                                                      <div className="faqinsidecontent">
                                                        <div className="innerfaqlist">
                                                          <ul>
                                                            <li>
                                                              Design &
                                                              implement
                                                              Adapter Design
                                                              Pattern{" "}
                                                            </li>
                                                          </ul>
                                                        </div>
                                                      </div>
                                                    </div>
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div
                              className="tab-pane fade"
                              id="cloudTechnology-sm"
                              role="tabpanel"
                              aria-labelledby="cloudTechnology-sm-tab"
                            >
                              <div className="tabinginfodetails">
                                <div className="faq">
                                  <div
                                    className="accordion"
                                    id="code_mgmt_accordionExample_cloud"
                                  >
                                    <div className="card">
                                      <div
                                        className="card-header"
                                        id="code_mgmt_heading001"
                                      >
                                        <h2 className="mb-0">
                                          <button
                                            type="button"
                                            className="btn btn-link collapsed"
                                            data-toggle="collapse"
                                            data-target="#code_mgmt_collapse001"
                                          >
                                            <i className="fa fa-angle-down"></i>{" "}
                                            Cloud Technology Architecture{" "}
                                          </button>
                                        </h2>
                                      </div>

                                      <div
                                        id="code_mgmt_collapse001"
                                        className="collapse"
                                        aria-labelledby="code_mgmt_heading001"
                                        data-parent="#code_mgmt_accordionExample_cloud"
                                      >
                                        <div className="card-body">
                                          <div className="faqcontent">
                                            <div className="faqinside">
                                              <div
                                                className="accordion"
                                                id="code_mgmt_accordioninside1232"
                                              >
                                                <div className="card">
                                                  <div
                                                    className="card-header faqpadbotm"
                                                    id="datainsidehead25"
                                                  >
                                                    <h2 className="mb-0">
                                                      <button
                                                        type="button"
                                                        className="btn btn-link collapsed borderfaq"
                                                        data-toggle="collapse"
                                                        data-target="#collapsinside25"
                                                      >
                                                        <i className="fa fa-angle-down"></i>{" "}
                                                        Chapter 1: Docker
                                                        configuration{" "}
                                                      </button>
                                                    </h2>
                                                  </div>

                                                  <div
                                                    id="collapsinside25"
                                                    className="collapse"
                                                    aria-labelledby="datainsidehead25"
                                                    data-parent="#code_mgmt_accordioninside1232"
                                                  >
                                                    <div className="card-body paddetop">
                                                      <div className="faqinsidecontent">
                                                        <div className="innerfaqlist">
                                                          <ul>
                                                            <li>
                                                              Container,
                                                              Images, Use
                                                              configs with a
                                                              Nginx service.
                                                            </li>
                                                            <li>
                                                              Configuring
                                                              Docker
                                                              environment,
                                                              create Docker
                                                              image
                                                            </li>
                                                          </ul>
                                                        </div>
                                                      </div>
                                                    </div>
                                                  </div>
                                                </div>

                                                <div className="card">
                                                  <div
                                                    className="card-header faqpadbotm"
                                                    id="datainsidehead36"
                                                  >
                                                    <h2 className="mb-0">
                                                      <button
                                                        type="button"
                                                        className="btn btn-link borderfaq"
                                                        data-toggle="collapse"
                                                        data-target="#collapsinside36"
                                                      >
                                                        <i className="fa fa-angle-down favicons"></i>
                                                        Chapter 2: Launching
                                                        EC2 Instance,
                                                        Connecting to EC2
                                                        instance
                                                      </button>
                                                    </h2>
                                                  </div>

                                                  <div
                                                    id="collapsinside36"
                                                    className="collapse"
                                                    aria-labelledby="datainsidehead36"
                                                    data-parent="#code_mgmt_accordioninside1232"
                                                  >
                                                    <div className="card-body paddetop">
                                                      <div className="faqinsidecontent">
                                                        <div className="innerfaqlist">
                                                          <ul>
                                                            <li>
                                                              Connect &
                                                              connect to EC2
                                                              instance using
                                                              SSH
                                                            </li>
                                                          </ul>
                                                        </div>
                                                      </div>
                                                    </div>
                                                  </div>
                                                </div>

                                                <div className="card">
                                                  <div
                                                    className="card-header faqpadbotm"
                                                    id="datainsidehead34"
                                                  >
                                                    <h2 className="mb-0">
                                                      <button
                                                        type="button"
                                                        className="btn btn-link borderfaq"
                                                        data-toggle="collapse"
                                                        data-target="#collapsinside34"
                                                      >
                                                        <i className="fa fa-angle-down favicons"></i>
                                                        Chapter 3: Managing
                                                        Container with Docker
                                                        Commands
                                                      </button>
                                                    </h2>
                                                  </div>

                                                  <div
                                                    id="collapsinside34"
                                                    className="collapse"
                                                    aria-labelledby="datainsidehead34"
                                                    data-parent="#code_mgmt_accordioninside1232"
                                                  >
                                                    <div className="card-body paddetop">
                                                      <div className="faqinsidecontent">
                                                        <div className="innerfaqlist">
                                                          <ul>
                                                            <li>
                                                              Managing
                                                              Container with
                                                              Docker Commands
                                                            </li>
                                                          </ul>
                                                        </div>
                                                      </div>
                                                    </div>
                                                  </div>
                                                </div>

                                                <div className="card">
                                                  <div
                                                    className="card-header faqpadbotm"
                                                    id="datainsidehead28"
                                                  >
                                                    <h2 className="mb-0">
                                                      <button
                                                        type="button"
                                                        className="btn btn-link borderfaq"
                                                        data-toggle="collapse"
                                                        data-target="#collapsinside28"
                                                      >
                                                        <i className="fa fa-angle-down favicons"></i>
                                                        Chapter 4: Running Web
                                                        App in docker
                                                        container
                                                      </button>
                                                    </h2>
                                                  </div>

                                                  <div
                                                    id="collapsinside28"
                                                    className="collapse"
                                                    aria-labelledby="datainsidehead28"
                                                    data-parent="#code_mgmt_accordioninside1232"
                                                  >
                                                    <div className="card-body paddetop">
                                                      <div className="faqinsidecontent">
                                                        <div className="innerfaqlist">
                                                          <ul>
                                                            <li>
                                                              Running Web App
                                                              in docker
                                                              container
                                                            </li>
                                                          </ul>
                                                        </div>
                                                      </div>
                                                    </div>
                                                  </div>
                                                </div>

                                                <div className="card">
                                                  <div
                                                    className="card-header faqpadbotm"
                                                    id="datainsidehead29"
                                                  >
                                                    <h2 className="mb-0">
                                                      <button
                                                        type="button"
                                                        className="btn btn-link borderfaq"
                                                        data-toggle="collapse"
                                                        data-target="#collapsinside29"
                                                      >
                                                        <i className="fa fa-angle-down favicons"></i>
                                                        Chapter 5: Deployment
                                                        App using
                                                        docker-compose{" "}
                                                      </button>
                                                    </h2>
                                                  </div>

                                                  <div
                                                    id="collapsinside29"
                                                    className="collapse"
                                                    aria-labelledby="datainsidehead29"
                                                    data-parent="#code_mgmt_accordioninside1232"
                                                  >
                                                    <div className="card-body paddetop">
                                                      <div className="faqinsidecontent">
                                                        <div className="innerfaqlist">
                                                          <ul>
                                                            <li>
                                                              Deployment App
                                                              using
                                                              docker-compose
                                                            </li>
                                                          </ul>
                                                        </div>
                                                      </div>
                                                    </div>
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>

                                    <div className="card">
                                      <div
                                        className="card-header"
                                        id="code_mgmt_heading003"
                                      >
                                        <h2 className="mb-0">
                                          <button
                                            type="button"
                                            className="btn btn-link collapsed"
                                            data-toggle="collapse"
                                            data-target="#code_mgmt_collapse003"
                                          >
                                            <i className="fa fa-angle-down"></i>{" "}
                                            AWS Cloud Architecture{" "}
                                          </button>
                                        </h2>
                                      </div>
                                      <div
                                        id="code_mgmt_collapse003"
                                        className="collapse"
                                        aria-labelledby="code_mgmt_heading003"
                                        data-parent="#code_mgmt_accordionExample_cloud"
                                      >
                                        <div className="card-body">
                                          <div className="faqcontent">
                                            <div className="faqinside">
                                              <div
                                                className="accordion"
                                                id="code_mgmt_accordioninside2"
                                              >
                                                <div className="card">
                                                  <div
                                                    className="card-header faqpadbotm"
                                                    id="datainsidehead82"
                                                  >
                                                    <h2 className="mb-0">
                                                      <button
                                                        type="button"
                                                        className="btn btn-link collapsed borderfaq"
                                                        data-toggle="collapse"
                                                        data-target="#collapsinside82"
                                                      >
                                                        <i className="fa fa-angle-down"></i>{" "}
                                                        Chapter 1: Introducing
                                                        AWS Cloud
                                                        Infrastructure
                                                      </button>
                                                    </h2>
                                                  </div>

                                                  <div
                                                    id="collapsinside82"
                                                    className="collapse"
                                                    aria-labelledby="datainsidehead82"
                                                    data-parent="#code_mgmt_accordioninside2"
                                                  >
                                                    <div className="card-body paddetop">
                                                      <div className="faqinsidecontent">
                                                        <div className="innerfaqlist">
                                                          <ul>
                                                            <li>
                                                              Creating Service
                                                              in AWS
                                                            </li>

                                                            <li>
                                                              Managing Your
                                                              AWS Cluster
                                                            </li>
                                                            <li>
                                                              Route Table,
                                                              Internet Gateway
                                                              Configuration in
                                                              AWS
                                                            </li>
                                                            <li>
                                                              Elastic IP and
                                                              NAT Gateway in
                                                              AWS
                                                            </li>
                                                            <li>
                                                              AWS RBAC Role
                                                              Based Access
                                                              Control
                                                            </li>
                                                            <li>
                                                              Shared
                                                              Responsibilty
                                                              Model
                                                            </li>
                                                            <li>
                                                              Users, Groups,
                                                              Roles and
                                                              Policies
                                                              Stiching
                                                            </li>
                                                            <li>
                                                              EC2 Instance
                                                              Configurations
                                                            </li>
                                                            <li>
                                                              EC2 Networking,
                                                              Security and
                                                              Monitoring
                                                            </li>
                                                            <li>
                                                              Amazon DynamoDB
                                                              and DAX
                                                            </li>
                                                          </ul>
                                                        </div>
                                                      </div>
                                                    </div>
                                                  </div>
                                                </div>

                                                <div className="card">
                                                  <div
                                                    className="card-header faqpadbotm"
                                                    id="datainsidehead81"
                                                  >
                                                    <h2 className="mb-0">
                                                      <button
                                                        type="button"
                                                        className="btn btn-link borderfaq"
                                                        data-toggle="collapse"
                                                        data-target="#collapsinside81"
                                                      >
                                                        <i className="fa fa-angle-down favicons"></i>
                                                        Chapter 2:
                                                        Introduction to NoSQL
                                                        – Key/Value Model
                                                      </button>
                                                    </h2>
                                                  </div>

                                                  <div
                                                    id="collapsinside81"
                                                    className="collapse"
                                                    aria-labelledby="datainsidehead81"
                                                    data-parent="#code_mgmt_accordioninside2"
                                                  >
                                                    <div className="card-body paddetop">
                                                      <div className="faqinsidecontent">
                                                        <div className="innerfaqlist">
                                                          <ul>
                                                            <li>
                                                              Key-value
                                                              stores, such as
                                                              Redis and
                                                              DynamoDB
                                                            </li>
                                                            <li>
                                                              Document
                                                              databases, such
                                                              as MongoDB and
                                                              CouchDB
                                                            </li>
                                                            <li>
                                                              Wide-column
                                                              databases, such
                                                              as Cassandra and
                                                              HBase
                                                            </li>
                                                            <li>
                                                              Graph databases,
                                                              such as Neo4J
                                                              and Infinite
                                                              Graph
                                                            </li>
                                                          </ul>
                                                        </div>
                                                      </div>
                                                    </div>
                                                  </div>
                                                </div>

                                                <div className="card">
                                                  <div
                                                    className="card-header faqpadbotm"
                                                    id="datainsidehead31"
                                                  >
                                                    <h2 className="mb-0">
                                                      <button
                                                        type="button"
                                                        className="btn btn-link borderfaq"
                                                        data-toggle="collapse"
                                                        data-target="#collapsinside31"
                                                      >
                                                        <i className="fa fa-angle-down favicons"></i>
                                                        Chapter 3: Cassandra,
                                                        MongoDB, Redis etc{" "}
                                                      </button>
                                                    </h2>
                                                  </div>

                                                  <div
                                                    id="collapsinside31"
                                                    className="collapse"
                                                    aria-labelledby="datainsidehead31"
                                                    data-parent="#code_mgmt_accordioninside2"
                                                  >
                                                    <div className="card-body paddetop">
                                                      <div className="faqinsidecontent">
                                                        <div className="innerfaqlist">
                                                          <ul>
                                                            <li>
                                                              Scalability, Low
                                                              Latency, Fault
                                                              Tolerant
                                                            </li>
                                                            <li>
                                                              Cassandra vs
                                                              MongoDB vs Redis
                                                            </li>
                                                            <li>
                                                              Uses and
                                                              application of
                                                              Cassandra
                                                            </li>
                                                            <li>
                                                              Uses and
                                                              application of
                                                              MongoDB
                                                            </li>
                                                            <li>
                                                              Uses and
                                                              application of
                                                              Redis
                                                            </li>
                                                            <li>
                                                              Uses and
                                                              application of
                                                              Memcached
                                                            </li>
                                                            <li>
                                                              Uses and
                                                              application of
                                                              DynamoDB
                                                            </li>
                                                          </ul>
                                                        </div>
                                                      </div>
                                                    </div>
                                                  </div>
                                                </div>

                                                <div className="card">
                                                  <div
                                                    className="card-header faqpadbotm"
                                                    id="datainsidehead32"
                                                  >
                                                    <h2 className="mb-0">
                                                      <button
                                                        type="button"
                                                        className="btn btn-link borderfaq"
                                                        data-toggle="collapse"
                                                        data-target="#collapsinside32"
                                                      >
                                                        <i className="fa fa-angle-down favicons"></i>
                                                        Chapter 4: SQL ,
                                                        No-SQL Queries,
                                                        Scalable database
                                                        models
                                                      </button>
                                                    </h2>
                                                  </div>

                                                  <div
                                                    id="collapsinside32"
                                                    className="collapse"
                                                    aria-labelledby="datainsidehead32"
                                                    data-parent="#code_mgmt_accordioninside2"
                                                  >
                                                    <div className="card-body paddetop">
                                                      <div className="faqinsidecontent">
                                                        <div className="innerfaqlist">
                                                          <ul>
                                                            <li>
                                                              Big Data
                                                              Architecture,
                                                              Database
                                                              Sharding
                                                            </li>

                                                            <li>
                                                              Database Scaling
                                                              – Horizontal vs.
                                                              Vertical{" "}
                                                            </li>
                                                            <li>
                                                              Database Read
                                                              Replicas,
                                                              Database Caching
                                                            </li>
                                                          </ul>
                                                        </div>
                                                      </div>
                                                    </div>
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>

                                    <div className="card">
                                      <div
                                        className="card-header"
                                        id="code_mgmt_heading002"
                                      >
                                        <h2 className="mb-0">
                                          <button
                                            type="button"
                                            className="btn btn-link collapsed"
                                            data-toggle="collapse"
                                            data-target="#code_mgmt_collapse002"
                                          >
                                            <i className="fa fa-angle-down"></i>{" "}
                                            Database Management(SQL/No-SQL){" "}
                                          </button>
                                        </h2>
                                      </div>
                                      <div
                                        id="code_mgmt_collapse002"
                                        className="collapse"
                                        aria-labelledby="code_mgmt_heading002"
                                        data-parent="#code_mgmt_accordionExample_cloud"
                                      >
                                        <div className="card-body">
                                          <div className="faqcontent">
                                            <div className="faqinside">
                                              <div
                                                className="accordion"
                                                id="code_mgmt_accordioninside5"
                                              >
                                                <div className="card">
                                                  <div
                                                    className="card-header faqpadbotm"
                                                    id="datainsidehead71"
                                                  >
                                                    <h2 className="mb-0">
                                                      <button
                                                        type="button"
                                                        className="btn btn-link collapsed borderfaq"
                                                        data-toggle="collapse"
                                                        data-target="#collapsinside71"
                                                      >
                                                        <i className="fa fa-angle-down"></i>{" "}
                                                        Chapter 1: SQL-
                                                        Relational/Non-
                                                        Relational Database
                                                      </button>
                                                    </h2>
                                                  </div>

                                                  <div
                                                    id="collapsinside71"
                                                    className="collapse"
                                                    aria-labelledby="datainsidehead71"
                                                    data-parent="#code_mgmt_accordioninside5"
                                                  >
                                                    <div className="card-body paddetop">
                                                      <div className="faqinsidecontent">
                                                        <div className="innerfaqlist">
                                                          <ul>
                                                            <li>
                                                              MySQL, SQL
                                                              joins, SQL
                                                              queries etc.
                                                            </li>

                                                            <li>
                                                              Normalization,
                                                              Persistence,
                                                              ACID property
                                                            </li>
                                                          </ul>
                                                        </div>
                                                      </div>
                                                    </div>
                                                  </div>
                                                </div>

                                                <div className="card">
                                                  <div
                                                    className="card-header faqpadbotm"
                                                    id="datainsidehead30"
                                                  >
                                                    <h2 className="mb-0">
                                                      <button
                                                        type="button"
                                                        className="btn btn-link borderfaq"
                                                        data-toggle="collapse"
                                                        data-target="#collapsinside30"
                                                      >
                                                        <i className="fa fa-angle-down favicons"></i>
                                                        Chapter 2:
                                                        Introduction to NoSQL
                                                        – key/value Model
                                                      </button>
                                                    </h2>
                                                  </div>

                                                  <div
                                                    id="collapsinside30"
                                                    className="collapse"
                                                    aria-labelledby="datainsidehead30"
                                                    data-parent="#code_mgmt_accordioninside5"
                                                  >
                                                    <div className="card-body paddetop">
                                                      <div className="faqinsidecontent">
                                                        <div className="innerfaqlist">
                                                          <ul>
                                                            <li>
                                                              Key-value
                                                              stores, such as
                                                              Redis and
                                                              DynamoDB
                                                            </li>
                                                            <li>
                                                              Document
                                                              databases, such
                                                              as MongoDB and
                                                              CouchDB
                                                            </li>
                                                            <li>
                                                              Wide-column
                                                              databases, such
                                                              as Cassandra and
                                                              HBase
                                                            </li>
                                                            <li>
                                                              Graph databases,
                                                              such as Neo4J
                                                              and Infinite
                                                              Graph
                                                            </li>
                                                          </ul>
                                                        </div>
                                                      </div>
                                                    </div>
                                                  </div>
                                                </div>

                                                <div className="card">
                                                  <div
                                                    className="card-header faqpadbotm"
                                                    id="datainsidehead31"
                                                  >
                                                    <h2 className="mb-0">
                                                      <button
                                                        type="button"
                                                        className="btn btn-link borderfaq"
                                                        data-toggle="collapse"
                                                        data-target="#collapsinside31"
                                                      >
                                                        <i className="fa fa-angle-down favicons"></i>
                                                        Chapter 3: Cassandra,
                                                        MongoDB, Redis etc{" "}
                                                      </button>
                                                    </h2>
                                                  </div>

                                                  <div
                                                    id="collapsinside31"
                                                    className="collapse"
                                                    aria-labelledby="datainsidehead31"
                                                    data-parent="#code_mgmt_accordioninside5"
                                                  >
                                                    <div className="card-body paddetop">
                                                      <div className="faqinsidecontent">
                                                        <div className="innerfaqlist">
                                                          <ul>
                                                            <li>
                                                              Scalability, Low
                                                              Latency, Fault
                                                              Tolerant
                                                            </li>
                                                            <li>
                                                              Cassandra vs
                                                              MongoDB vs Redis
                                                            </li>
                                                            <li>
                                                              Uses and
                                                              application of
                                                              Cassandra
                                                            </li>
                                                            <li>
                                                              Uses and
                                                              application of
                                                              MongoDB
                                                            </li>
                                                            <li>
                                                              Uses and
                                                              application of
                                                              Redis
                                                            </li>
                                                            <li>
                                                              Uses and
                                                              application of
                                                              Memcached
                                                            </li>
                                                            <li>
                                                              Uses and
                                                              application of
                                                              DynamoDB
                                                            </li>
                                                          </ul>
                                                        </div>
                                                      </div>
                                                    </div>
                                                  </div>
                                                </div>

                                                <div className="card">
                                                  <div
                                                    className="card-header faqpadbotm"
                                                    id="datainsidehead32"
                                                  >
                                                    <h2 className="mb-0">
                                                      <button
                                                        type="button"
                                                        className="btn btn-link borderfaq"
                                                        data-toggle="collapse"
                                                        data-target="#collapsinside32"
                                                      >
                                                        <i className="fa fa-angle-down favicons"></i>
                                                        Chapter 4: SQL ,
                                                        No-SQL Queries,
                                                        Scalable database
                                                        models
                                                      </button>
                                                    </h2>
                                                  </div>

                                                  <div
                                                    id="collapsinside32"
                                                    className="collapse"
                                                    aria-labelledby="datainsidehead32"
                                                    data-parent="#code_mgmt_accordioninside5"
                                                  >
                                                    <div className="card-body paddetop">
                                                      <div className="faqinsidecontent">
                                                        <div className="innerfaqlist">
                                                          <ul>
                                                            <li>
                                                              Big Data
                                                              Architecture,
                                                              Database
                                                              Sharding
                                                            </li>

                                                            <li>
                                                              Database Scaling
                                                              – Horizontal vs.
                                                              Vertical{" "}
                                                            </li>
                                                            <li>
                                                              Database Read
                                                              Replicas,
                                                              Database Caching
                                                            </li>
                                                          </ul>
                                                        </div>
                                                      </div>
                                                    </div>
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="col-md-5">
                      <div className="program-highlights-new">
                        <h3>Program Highlights</h3>
                        <ul>
                          <li>
                            <span>
                              <img
                                loading="lazy"
                                src="/react/ai-assets/images//highlight-icon1.png"
                                alt=""
                              />
                            </span>{" "}
                            85+ Hours Live sessions
                          </li>
                          <li>
                            <span>
                              <img
                                loading="lazy"
                                src="/react/ai-assets/images//highlight-icon1.png"
                                alt=""
                              />
                            </span>{" "}
                            1:1 Doubt Session
                          </li>
                          <li>
                            <span>
                              <img
                                loading="lazy"
                                src="/react/ai-assets/images//highlight-icon2.png"
                                alt=""
                              />
                            </span>{" "}
                            3+ Design Projects
                          </li>
                          <li>
                            <span>
                              <img
                                loading="lazy"
                                src="/react/ai-assets/images//highlight-icon2.png"
                                alt=""
                              />
                            </span>{" "}
                            Multiple Batches Options
                          </li>
                          <li>
                            <span>
                              <img
                                loading="lazy"
                                src="/react/ai-assets/images//highlight-icon3.png"
                                alt=""
                              />
                            </span>{" "}
                            Life time accessibility
                          </li>
                          <li>
                            <span>
                              <img
                                loading="lazy"
                                src="/react/ai-assets/images//highlight-icon3.png"
                                alt=""
                              />
                            </span>{" "}
                            Job Referrals Program
                          </li>
                          <li>
                            <span>
                              <img
                                loading="lazy"
                                src="/react/ai-assets/images//highlight-icon4.png"
                                alt=""
                              />
                            </span>{" "}
                            Peer to peer Learning
                          </li>
                          <li>
                            <span>
                              <img
                                loading="lazy"
                                src="/react/ai-assets/images//highlight-icon4.png"
                                alt=""
                              />
                            </span>{" "}
                            Mock Interviews
                          </li>
                          <li>
                            <span>
                              <img
                                loading="lazy"
                                src="/react/ai-assets/images//highlight-icon3.png"
                                alt=""
                              />
                            </span>{" "}
                            Resume Preparation
                          </li>
                          <li>
                            <span>
                              <img
                                loading="lazy"
                                src="/react/ai-assets/images//highlight-icon3.png"
                                alt=""
                              />
                            </span>{" "}
                            Weekly Assignments
                          </li>
                          <li>
                            <span>
                              <img
                                loading="lazy"
                                src="/react/ai-assets/images//highlight-icon2.png"
                                alt=""
                              />
                            </span>{" "}
                            Regular Progress Tests
                          </li>
                          <li>
                            <span>
                              <img
                                loading="lazy"
                                src="/react/ai-assets/images//highlight-icon2.png"
                                alt=""
                              />
                            </span>{" "}
                            Code Explanation
                          </li>
                        </ul>
                      </div>
                      <div className="bookbtn02">
                        <a
                          target="_default"
                          className="booktrialbtn"
                          //data-toggle="modal"
                          href="https://calendly.com/logicmojo/schedule-call-back-from-experts-for-live-classes?month=2026-06"
                        //data-target="#counsellingpopup"
                        >
                          Apply For Live Classes{" "}
                          <i
                            className="fa fa-angle-right"
                            aria-hidden="true"
                          ></i>
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="container d-md-none d-block float-left w-100" ref={overSyllabus}>
          <div
            ref={syllabusSlideshowContainerRef}
            className="syllabus-slides-container"
            id="syllabus-slides-container"
          >
            <Slider {...settings2}>
              <div className="slide">
                <div className="row mt-5">
                  <div className="col-lg-7 col-md-12">

                    <div className="msl_header">
                      <span className="msl_label">Course</span>
                      <h4 className="msl_course_title">
                        LogicMojo AI &amp; ML Course
                      </h4>

                      <div className="msl_syllabus_line">
                        <i className="fa fa-book"></i>
                        <span>Detail Syllabus - Live Classes</span>
                      </div>

                      <div className="msl_duration">
                        <i className="fa fa-clock-o"></i> Duration - 4 months
                      </div>

                      <p className="msl_desc">
                        This course is curated by leading faculties and
                        industry leaders to provide practical learning
                        experience with live interactive classes and projects.
                      </p>

                      <a
                        target="_blank"
                        rel="noopener"
                        href="https://drive.google.com/file/d/1SzaTFL3QiyuRzbtjI7e0dzMDCnLxtr0A/view"
                        className="msl_brochure_btn"
                      >
                        <i className="fa fa-download"></i> Download Brochure
                      </a>
                    </div>

                    <div className="salbustabingmain">
                      <div className="tab modules-tab">
                        <ul
                          className="nav nav-tabs border-0"
                          id="maimlTab"
                          role="tablist"
                        >
                          {aiMlCourseSyllabus.map((mod, m) => {
                            const iconNum = (m % 5) + 1;
                            return (
                              <li
                                className="nav-item"
                                role="presentation"
                                key={`maimltab-${m}`}
                              >
                                <button
                                  className={`nav-link${m === 0 ? " active" : ""}`}
                                  id={`maimlModule${m}-tab`}
                                  data-toggle="tab"
                                  data-target={`#maimlModule${m}`}
                                  type="button"
                                  role="tab"
                                  aria-controls={`maimlModule${m}`}
                                  aria-selected={m === 0 ? "true" : "false"}
                                >
                                  <div className="blueimg2 tab-blueimg">
                                    <img
                                      loading="lazy"
                                      src={`/react/ai-assets/images//salubicon0${iconNum}.png`}
                                      alt=""
                                    />
                                  </div>

                                  <div className="whitimg6  whiteblueimage2 tab-whiteimg">
                                    <img
                                      loading="lazy"
                                      src={`/react/ai-assets/images//salubiconhov0${iconNum}.png`}
                                      alt=""
                                    />
                                  </div>

                                  <p>{mod.cardTitle}</p>
                                  <p>{mod.cardSubtitle}</p>
                                </button>
                              </li>
                            );
                          })}
                        </ul>
                        <div className="tab-content" id="maimlTabContent">
                          {aiMlCourseSyllabus.map((mod, m) => (
                            <div
                              className={`tab-pane fade${m === 0 ? " show active" : ""}`}
                              id={`maimlModule${m}`}
                              role="tabpanel"
                              aria-labelledby={`maimlModule${m}-tab`}
                              key={`maimlpane-${m}`}
                            >
                              <div className="tabinginfodetails">
                                <div className="faq">
                                  <div
                                    className="accordion"
                                    id={`maimlAccordion${m}`}
                                  >
                                    <div className="card">
                                      <div
                                        className="card-header"
                                        id={`maimlModHead${m}`}
                                      >
                                        <h2 className="mb-0">
                                          <button
                                            type="button"
                                            className="btn btn-link"
                                            data-toggle="collapse"
                                            data-target={`#maimlModCollapse${m}`}
                                          >
                                            <i className="fa fa-angle-down"></i>{" "}
                                            {mod.sectionTitle}
                                          </button>
                                        </h2>
                                      </div>

                                      <div
                                        id={`maimlModCollapse${m}`}
                                        className="collapse show"
                                        aria-labelledby={`maimlModHead${m}`}
                                        data-parent={`#maimlAccordion${m}`}
                                      >
                                        <div className="card-body">
                                          <div className="faqcontent">
                                            <div className="faqinside">
                                              <div
                                                className="accordion"
                                                id={`maimlChapAcc${m}`}
                                              >
                                                {mod.chapters.map((ch, c) => (
                                                  <div
                                                    className="card"
                                                    key={`maimlchap-${m}-${c}`}
                                                  >
                                                    <div
                                                      className="card-header faqpadbotm"
                                                      id={`maimlChapHead${m}_${c}`}
                                                    >
                                                      <h2 className="mb-0">
                                                        <button
                                                          type="button"
                                                          className={`btn btn-link borderfaq${c === 0 ? "" : " collapsed"}`}
                                                          data-toggle="collapse"
                                                          data-target={`#maimlChapCollapse${m}_${c}`}
                                                        >
                                                          <i className="fa fa-angle-down favicons"></i>{" "}
                                                          {ch.title}
                                                        </button>
                                                      </h2>
                                                    </div>

                                                    <div
                                                      id={`maimlChapCollapse${m}_${c}`}
                                                      className={`collapse${c === 0 ? " show" : ""}`}
                                                      aria-labelledby={`maimlChapHead${m}_${c}`}
                                                      data-parent={`#maimlChapAcc${m}`}
                                                    >
                                                      <div className="card-body paddetop">
                                                        <div className="faqinsidecontent">
                                                          <div className="topics-grid">
                                                            {ch.topics.map((topic, t) => (
                                                              <div
                                                                className="topic-item"
                                                                style={{
                                                                  animationDelay: `${t * 0.05}s`,
                                                                }}
                                                                key={`maimltopic-${m}-${c}-${t}`}
                                                              >
                                                                <span className="topic-check">
                                                                  <svg viewBox="0 0 24 24">
                                                                    <path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z" />
                                                                  </svg>
                                                                </span>
                                                                <span className="topic-text">
                                                                  {topic}
                                                                </span>
                                                              </div>
                                                            ))}
                                                          </div>
                                                        </div>
                                                      </div>
                                                    </div>
                                                  </div>
                                                ))}
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          ))}
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="col-md-5">
                    <div className="program-highlights-new">
                      <h3>Program Highlights</h3>
                      <ul>
                        <li>
                          <span>
                            <img
                              loading="lazy"
                              src="/react/ai-assets/images//highlight-icon1.png"
                              alt=""
                            />
                          </span>{" "}
                          110+ Hours Live sessions
                        </li>
                        <li>
                          <span>
                            <img
                              loading="lazy"
                              src="/react/ai-assets/images//highlight-icon1.png"
                              alt=""
                            />
                          </span>{" "}
                          1:1 Doubt Session
                        </li>
                        <li>
                          <span>
                            <img
                              loading="lazy"
                              src="/react/ai-assets/images//highlight-icon2.png"
                              alt=""
                            />
                          </span>{" "}
                          4+ Projects
                        </li>
                        <li>
                          <span>
                            <img
                              loading="lazy"
                              src="/react/ai-assets/images//highlight-icon2.png"
                              alt=""
                            />
                          </span>{" "}
                          Multiple Batches Options
                        </li>
                        <li>
                          <span>
                            <img
                              loading="lazy"
                              src="/react/ai-assets/images//highlight-icon3.png"
                              alt=""
                            />
                          </span>{" "}
                          Life time accessibility
                        </li>
                        <li>
                          <span>
                            <img
                              loading="lazy"
                              src="/react/ai-assets/images//highlight-icon3.png"
                              alt=""
                            />
                          </span>{" "}
                          Job Referrals Program
                        </li>
                        <li>
                          <span>
                            <img
                              loading="lazy"
                              src="/react/ai-assets/images//highlight-icon4.png"
                              alt=""
                            />
                          </span>{" "}
                          Peer to peer Learning
                        </li>
                        <li>
                          <span>
                            <img
                              loading="lazy"
                              src="/react/ai-assets/images//highlight-icon4.png"
                              alt=""
                            />
                          </span>{" "}
                          Mock Interviews
                        </li>
                        <li>
                          <span>
                            <img
                              loading="lazy"
                              src="/react/ai-assets/images//highlight-icon3.png"
                              alt=""
                            />
                          </span>{" "}
                          Resume Preparation
                        </li>
                        <li>
                          <span>
                            <img
                              loading="lazy"
                              src="/react/ai-assets/images//highlight-icon3.png"
                              alt=""
                            />
                          </span>{" "}
                          Weekly Assignments
                        </li>
                        <li>
                          <span>
                            <img
                              loading="lazy"
                              src="/react/ai-assets/images//highlight-icon2.png"
                              alt=""
                            />
                          </span>{" "}
                          Regular Progress Tests
                        </li>
                        <li>
                          <span>
                            <img
                              loading="lazy"
                              src="/react/ai-assets/images//highlight-icon2.png"
                              alt=""
                            />
                          </span>{" "}
                          Code Explanation
                        </li>
                      </ul>
                    </div>
                    <div className="bookbtn02">
                      <a
                        target="_default"
                        className="booktrialbtn"
                        //data-toggle="modal"
                        href="https://calendly.com/logicmojo/schedule-call-back-from-experts-for-live-classes?month=2026-06"
                      //data-target="#counsellingpopup"
                      >
                        <img
                          loading="lazy"
                          src="/react/ai-assets/images//callicons.png"
                          alt=""
                          className="callico"
                        />{" "}
                        Apply For Live Classes{" "}
                        <i
                          className="fa fa-angle-right"
                          aria-hidden="true"
                        ></i>
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </Slider>
          </div>
        </div>
      </div>
      </div>
     
      <section className="careerservices-new" id="placement">
      <div className="container clearfix">
        <CareerServices />
        </div>
        </section>

      

   
      
      {/*
      <div className="demandstrip" id="developerdemand">
        <div className="container">
          <div className="featuresdetail" id="SampleLecture">
            <div className="container">
            
              <ul
                className="nav nav-pills mb-3"
                id="pills-tab"
                role="tablist"
              >
                <li className="nav-item" role="presentation">
                  <a
                    className="nav-link active"
                    id="pills-home-tab"
                    data-toggle="pill"
                    href="#pills-home"
                    role="tab"
                    aria-controls="pills-home"
                    aria-selected="true"
                  >
                    LIVE Demo Class Recording
                  </a>
                </li>
              </ul>


              <h2 className="lecturespreview" id="Demo">
                <u>Live Demo Session For 14th Nov Batch</u>
              </h2>

          
              <div className="tab-content" id="pills-tabContent">
                <div
                  className="tab-pane fade active show"
                  id="pills-home"
                  role="tabpanel"
                  aria-labelledby="pills-home-tab"
                >
                  <div className="algorithm-bg">
                    <div className="algorithm-bg-right">
                     
                      <div
                        className="samplevideos"
                        style={{ border: "2px solid #000" }}
                      >
                         <ReactPlayer
                            url="https://player.vimeo.com/video/807213148?title=0&byline=0&portrait=0"
                            width="100%"
                            height="372px"
                            controls={true}
                          /> 

                        <LazyLoad height={"auto"} offsetVertical={300}>
                          <div>
                            <ReactPlayer
                              url="https://player.vimeo.com/video/907160719?title=0&byline=0&portrait=0"
                              width="100%"
                              height="auto"
                              style={{ aspectRatio: 16 / 9 }}
                              controls={true}
                            />
                          </div>
                        </LazyLoad>
                        
                      </div>
                      <div
                        style={{
                          width: 280,
                          margin: 0,
                          marginInline: "auto",
                        }}
                      >
                       
                      </div>
                    </div>

                    <div className="algorithm-bg-left">
                      <h2>
                        DSA, Problem Solving & System Design <br />7 months
                        Course
                      </h2>
                      <p>
                        <b>Live Classes Will Start From 14th Nov</b>.This is a
                        Live Demo Session For Upcoming Batch. Initial 4 months
                        We Focus on Data Structures, Algorithms & Problems
                        Solving Part Where We Prepare Candidates For MAANG
                        Companies Coding Interviews Rounds
                      </p>
                      <p>
                        After Completion of the 4 Months Coding Part then Next
                        3 Months. We Focus on Scalable System Design Part,
                        Archirectures & Internal Design of Many Scalable
                        System Model with HLD + LLD. We prepare Candidates for
                        System Design Rounds Mentor.<br />
                        Trainer/Instructor System Design- <u><a target="default" href="https://www.linkedin.com/in/ranjan-kumar-935582a6">Ranjan Kumar</a></u><br/>
                        Trainer/Instructor DSA  - <u><a target="default" href="https://www.linkedin.com/in/aman-kumar-coder">Aman Kumar</a></u>
                      </p>
                      <div className="algorithmbtngrp"></div>

                    </div>

                  </div>

                </div>
              </div>



            </div>
           

          </div>

        </div>

      </div>
*/}
{/*
      <div className="demandstrip" >
        <div className="container">

          <div className="featuresdetail pt-0" id="SampleLecture">
            <div className="container">
              
              <div className="whatpeoplesaybox">

                <div className="whatpeoplesaybox-top">
                  <div className="top_heading">
                    <h3>Mentor - Ranjan Kumar</h3>
                    <h6> Working in Amazon Seattle(US), Ex-Microsoft</h6>

                  </div>
                  <div className="storybox1">
                    <div className="linkdinlink">
                      <a target="_blank" href="https://www.linkedin.com/in/ranjan-kumar-935582a6/">
                        <img src="/react/ai-assets/images//linkdin.png" alt="" />
                      </a>
                    </div>
                  </div>
                </div>
                <div className="whatpeoplesaybox-dec">Ranjan is currently working at Amazon in Seattle, US.
                  He has held senior developer roles at top product organizations, including Microsoft and Amazon.
                  He is a well-known tutor on the internet. Ranjan completed his Master's degree at Stony Brook University.
                  With over 5 years of teaching experience, Ranjan will be tutoring candidate for the upcoming batch starting on June 8th.</div>


                <div className="whatpeoplesaybox-mid">
                  <div className="postlogic">
                    <div className="scalerbox">
                      <label htmlFor="">Working in</label> <img src="/react/ai-assets/images//amazonlogo.jpg" alt="" />
                    </div>
                  </div>
                </div>

              </div>

              <div className="whatpeoplesaybox">

<div className="whatpeoplesaybox-top">
  <div className="top_heading">
    <h3>Mentor - Aman Kumar</h3>
    <h6> Senior Dev at WalmartLabs </h6>
  </div>
  <div className="storybox1">

    <div className="linkdinlink">
      <a target="_blank" href="https://www.linkedin.com/in/aman-kumar-coder/">
        <img src="/react/ai-assets/images//linkdin.png" alt="" />
      </a>
    </div>
  </div>
</div>
<div className="whatpeoplesaybox-dec">Aman is currently working at WalmartLabs as a Senior Developer.
  He is a well-known tutor on the internet, teaching multiple students online through his YouTube channel.
  Aman has been awarded the India's Top Coder Award on the LeetCode platform.
  With over 5 years of teaching experience, Aman will be tutoring candidates in DSA and Coding Interview Preparation
  for the upcoming batch starting on June 8th.
</div>

<div className="whatpeoplesaybox-mid">
  <div className="postlogic">
    <div className="scalerbox">
      <label htmlFor="">Working in</label> <img src="/react/ai-assets/images//walmartlbslogo.jpg" alt="" />
    </div>
  </div>
</div>

</div>
            </div>
          </div>

        </div>
      </div>
*/}
   

      

     
      <section ref={mentorSection} className="mentor" id="Demo">
      <div class="fewreviewsbg1">
      <div className="container clearfix">
        <div className="container" ref={overDemoClasses}>
          <div className="aiml-demo-head">
            <span className="aiml-demo-head__eyebrow">AI · ML · GenAI · Agentic AI</span>
            <h2 className="aiml-demo-head__title">
              <b>Live AI &amp; GenAI Masterclass</b> for the July / 2026 Batch
            </h2>
            <p className="aiml-demo-head__sub">
              Industry mentors teaching Artificial Intelligence, Machine Learning,
              Generative AI, LLMs, RAG &amp; Agentic AI — built for working professionals.
            </p>
          </div>
          <MentorsProfile ytUrl="https://www.youtube.com/embed/hsMuhsCTr3A?autoplay=1"/>
          <div className="aiml-faculty">
            <style>{aimlFacultyStyles}</style>
            <div className="aiml-faculty__head">
              <span className="aiml-faculty__eyebrow">Meet your mentors</span>
              <h3 className="aiml-faculty__title">Learn from AI, ML &amp; GenAI Industry Leaders</h3>
              <p className="aiml-faculty__sub">
                Practitioners shipping LLM, RAG &amp; Agentic AI systems at top product companies.
              </p>
            </div>

            <div className="aiml-faculty__grid">
              {aimlMentors.map((m, i) => (
                <article className={`aiml-fcard aiml-fcard--${m.accent}`} key={i}>
                  <span className="aiml-fcard__beam" aria-hidden="true" />
                  <div className="aiml-fcard__top">
                    <div className="aiml-fcard__avatar">
                      {m.img ? (
                        <img src={m.img} alt={m.name} loading="lazy" />
                      ) : (
                        <span className="aiml-fcard__initials" role="img" aria-label={m.name}>
                          {m.name.split(" ").map((w) => w[0]).join("").slice(0, 2)}
                        </span>
                      )}
                      <a className="aiml-fcard__li" href={m.linkedin} target="_blank" rel="noreferrer" aria-label={`${m.name} on LinkedIn`}>
                        <svg viewBox="0 0 16 16" width="14" height="14" fill="currentColor"><path d="M0 1.146C0 .513.526 0 1.175 0h13.65C15.474 0 16 .513 16 1.146v13.708c0 .633-.526 1.146-1.175 1.146H1.175C.526 16 0 15.487 0 14.854V1.146zm4.943 12.248V6.169H2.542v7.225h2.401zm-1.2-8.212c.837 0 1.358-.554 1.358-1.248-.015-.709-.52-1.248-1.342-1.248-.822 0-1.359.54-1.359 1.248 0 .694.521 1.248 1.327 1.248h.016zm4.908 8.212V9.359c0-.216.016-.432.08-.586.173-.431.568-.878 1.232-.878.869 0 1.216.662 1.216 1.634v3.865h2.401V9.25c0-2.22-1.184-3.252-2.764-3.252-1.274 0-1.845.7-2.165 1.193v.025h-.016a5.54 5.54 0 0 1 .016-.025V6.169h-2.4c.03.678 0 7.225 0 7.225h2.4z"/></svg>
                      </a>
                    </div>
                    <div className="aiml-fcard__id">
                      <h4>{m.name}</h4>
                      <p>{m.role}</p>
                    </div>
                  </div>

                  <p className="aiml-fcard__desc">{m.desc}</p>

                  <div className="aiml-fcard__tags">
                    {m.tags.map((t) => (
                      <span className="aiml-fcard__tag" key={t}>{t}</span>
                    ))}
                  </div>

                  <div className="aiml-fcard__foot">
                    <img className="aiml-fcard__logo" src={m.logo} alt={m.company} loading="lazy" />
                  </div>
                </article>
              ))}
            </div>
          </div>
          {/* <div className="owl-carousel owl-theme with-nav">
            <div className="item">
              <div className="faculty-box">
                <div className="faculty-img">
                  <img src="assets/images/mac/Ranjan-kumar.jpg" />
                </div>

                <h3 className="name">Ranjan Kumar</h3>
                <p className="title">Full Stack Developer Mentor</p>
                <p className="title">SDE at Amazon</p>
                <p className="description">
                  Ranjan is currently working as a Senior Developer in Amazon.
                  He has a vast experince of teaching Full Stack Development.
                </p>
                <p>Instructor Profile : <a target="_blank" href="https://www.linkedin.com/in/ranjan-kumar-935582a6/">Linkedin</a></p>
              </div>
            </div>

            <div className="item">
              <div className="faculty-box">



                <div className="faculty-img">
                  <img src="assets/images/aman.jpg" />
                </div>

                <h3 className="name">Aman kumar</h3>
                <p className="title">Senior Full Stack Developer Mentor </p>
                <p className="title">SDE3 at WalmartLabs</p>
                <p className="description">
                  Aman working as R & D Group of WalmartLabs as senior full stack Developer.
                </p>
                <p>Instructor Profile : <a target="_blank" href="https://www.linkedin.com/in/aman-kumar-coder/">Linkedin</a></p>


              </div>
            </div>

            <div className="item">
              <div className="faculty-box">
                <div className="faculty-img">
                  <img src="assets/images/mac/ravi-singh.jpg" />
                </div>

                <h3 className="name">Ravi Singh</h3>
                <p className="title">Technical Architect at WalmartLabs</p>
                <p className="description">
                  Ravi has been part of multiple companies, Amazon as well as WalmartLabs. His background involves handling
                  System architecture and design in full stack based projects.
                </p>
                <p>Instructor Profile : <a target="_blank" href="https://www.linkedin.com/in/ravi-singh-a430ab29/">Linkedin</a></p>
              </div>
            </div>
            <div className="item">
              <div className="faculty-box">
                <div className="faculty-img">
                  <img src="assets/images/mac/vishal.jpg" />
                </div>

                <h3 className="name">Vishal Gupta</h3>
                <p className="title">Senior Software Engineer, Walmart Global Tech India</p>
                <p className="description">
                  Vishal is a senior instructor who teaches backend systems and architecture in full stack development.
                  Under his leadership, all candidates will complete 5+ projects on full stack development during the classes.
                </p>
                <p>Instructor Profile : <a target="_blank" href="https://www.linkedin.com/in/connect-vishal-gupta/">Linkedin</a></p>
              </div>
            </div>





          </div> */}

        </div>
        </div>
        </div>
      </section>
     
      <section className="aiml-impact">
        <style>{aimlImpactStyles}</style>
        <span className="aiml-impact__glow aiml-impact__glow--l" aria-hidden="true" />
        <span className="aiml-impact__glow aiml-impact__glow--r" aria-hidden="true" />
        <div className="aiml-impact__inner">
          <div className="aiml-impact__head">
            <span className="aiml-impact__eyebrow">Career Impact</span>
            <h2 className="aiml-impact__title">
              From Software Roles to <b>High-Growth AI Careers</b>
            </h2>
            <p className="aiml-impact__sub">
              Just a few months of live, hands-on training in AI, ML, GenAI &amp; Agentic AI —
              and unlock some of the fastest-growing roles in tech.
            </p>
          </div>

          <div className="aiml-impact__grid">
            {aimlStats.map((s, i) => (
              <div className="aiml-stat" key={i}>
                <div className="aiml-stat__icon" aria-hidden="true">{s.icon}</div>
                <h3 className="aiml-stat__num">{s.num}</h3>
                <p className="aiml-stat__label">{s.label}</p>
              </div>
            ))}
          </div>

          <div className="aiml-impact__banner">
            <span className="aiml-impact__banner-icon" aria-hidden="true">
              <svg viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="currentColor" strokeWidth="2"><path strokeLinecap="round" strokeLinejoin="round" d="M13 2 3 14h7l-1 8 10-12h-7l1-8z"/></svg>
            </span>
            <p>
              AI, ML, GenAI, and Agentic AI roles are among the
              <b> fastest-growing career paths in 2026</b> — master in-demand AI skills
              and unlock high-growth roles across top tech companies.
            </p>
          </div>
        </div>
      </section>

      <section className="aiml-pf" id="fullstackdev">
        <style>{aimlProgramStyles}</style>
        <div className="aiml-pf__bg" aria-hidden="true"></div>
        <span className="aiml-pf__glow aiml-pf__glow--l" aria-hidden="true"></span>
        <span className="aiml-pf__glow aiml-pf__glow--r" aria-hidden="true"></span>

        <div className="aiml-pf__inner">
          <div className="aiml-pf__head">
            <span className="aiml-pf__eyebrow"><i></i>Program Features</span>
            <h2 className="aiml-pf__title">
              Program Features of <b>LogicMojo AI &amp; ML Course</b>
            </h2>
            <p className="aiml-pf__sub">
              Master AI, Machine Learning, Generative AI, LLMs, RAG, and Agentic AI
              with live mentorship, real projects, and career-focused preparation.
            </p>
          </div>

          <div className="aiml-pf__layout">
            <div className="aiml-pf__cards">
              {/* 1. AI Career Eligibility Guidance */}
              <div className="aiml-pf-card">
                <div className="aiml-pf-card__icon" aria-hidden="true">
                  <svg viewBox="0 0 24 24" width="26" height="26" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
                    <circle cx="12" cy="8" r="4" />
                    <path d="M4 21c0-3.3 3.6-6 8-6 1.4 0 2.8.3 4 .8" />
                    <circle cx="18.5" cy="18.5" r="3" />
                    <path d="m20.7 20.7 1.8 1.8" />
                  </svg>
                </div>
                <h4 className="aiml-pf-card__title">AI Career Eligibility Guidance</h4>
                <p className="aiml-pf-card__desc">
                  Personalized profile review to help learners choose the right AI,
                  ML, GenAI, or Agentic AI career path.
                </p>
                <span className="aiml-pf-card__chip">Profile Review</span>
              </div>

              {/* 2. Live Weekend AI Classes */}
              <div className="aiml-pf-card">
                <div className="aiml-pf-card__icon" aria-hidden="true">
                  <svg viewBox="0 0 24 24" width="26" height="26" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
                    <rect x="2.5" y="4" width="19" height="13" rx="2" />
                    <path d="M8 21h8M12 17v4" />
                    <circle cx="12" cy="10.5" r="2.2" />
                    <path d="M6 14c1-1.6 3.2-2.4 6-2.4s5 .8 6 2.4" />
                  </svg>
                </div>
                <h4 className="aiml-pf-card__title">Live Weekend AI Classes</h4>
                <p className="aiml-pf-card__desc">
                  Learn from industry mentors through live weekend classes designed
                  for working professionals.
                </p>
                <span className="aiml-pf-card__chip">Live Mentor-Led</span>
              </div>

              {/* 3. GenAI & LLM Projects */}
              <div className="aiml-pf-card">
                <div className="aiml-pf-card__icon" aria-hidden="true">
                  <svg viewBox="0 0 24 24" width="26" height="26" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M9 3a3 3 0 0 0-3 3 3 3 0 0 0-1.5 5.6A3 3 0 0 0 6 17a3 3 0 0 0 3 3V3z" />
                    <path d="M15 3a3 3 0 0 1 3 3 3 3 0 0 1 1.5 5.6A3 3 0 0 1 18 17a3 3 0 0 1-3 3V3z" />
                    <path d="M12 3v17" />
                  </svg>
                </div>
                <h4 className="aiml-pf-card__title">GenAI &amp; LLM Projects</h4>
                <p className="aiml-pf-card__desc">
                  Build hands-on projects using LLMs, RAG pipelines, embeddings,
                  vector databases, and AI agents.
                </p>
                <span className="aiml-pf-card__chip">10+ Projects</span>
              </div>

              {/* 4. Agentic AI & RAG Systems */}
              <div className="aiml-pf-card">
                <div className="aiml-pf-card__icon" aria-hidden="true">
                  <svg viewBox="0 0 24 24" width="26" height="26" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
                    <circle cx="12" cy="5" r="2.4" />
                    <circle cx="5" cy="18" r="2.4" />
                    <circle cx="19" cy="18" r="2.4" />
                    <path d="M12 7.4 6.6 15.8M12 7.4l5.4 8.4M7.4 18h9.2" />
                  </svg>
                </div>
                <h4 className="aiml-pf-card__title">Agentic AI &amp; RAG Systems</h4>
                <p className="aiml-pf-card__desc">
                  Work on modern AI systems using LangChain, LangGraph, CrewAI,
                  AutoGen, and OpenAI Agents SDK.
                </p>
                <span className="aiml-pf-card__chip">Multi-Agent</span>
              </div>

              {/* 5. 1:1 Mentorship & Doubt Support */}
              <div className="aiml-pf-card">
                <div className="aiml-pf-card__icon" aria-hidden="true">
                  <svg viewBox="0 0 24 24" width="26" height="26" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M4 5h16a1.5 1.5 0 0 1 1.5 1.5v9A1.5 1.5 0 0 1 20 17H9l-4.5 3.5V17H4a1.5 1.5 0 0 1-1.5-1.5v-9A1.5 1.5 0 0 1 4 5z" />
                    <path d="M8 9.5h8M8 12.5h5" />
                  </svg>
                </div>
                <h4 className="aiml-pf-card__title">1:1 Mentorship &amp; Doubt Support</h4>
                <p className="aiml-pf-card__desc">
                  Get mentor guidance, project reviews, and doubt support throughout
                  your AI learning journey.
                </p>
                <span className="aiml-pf-card__chip">1:1 Support</span>
              </div>

              {/* 6. Mock Interviews & Referral Support */}
              <div className="aiml-pf-card">
                <div className="aiml-pf-card__icon" aria-hidden="true">
                  <svg viewBox="0 0 24 24" width="26" height="26" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
                    <rect x="3.5" y="4" width="17" height="14" rx="2" />
                    <path d="M7.5 9h5M7.5 12.5h7" />
                    <path d="m15.5 17.5 2 2 3.5-4" />
                  </svg>
                </div>
                <h4 className="aiml-pf-card__title">Mock Interviews &amp; Referral Support</h4>
                <p className="aiml-pf-card__desc">
                  Prepare for AI Engineer, GenAI Developer, ML Engineer, and Agentic
                  AI roles with career support.
                </p>
                <span className="aiml-pf-card__chip">Career Support</span>
              </div>
            </div>

            <div className="aiml-pf-cta">
              <span className="aiml-pf-cta__orb" aria-hidden="true"></span>
              <svg className="aiml-pf-cta__net" viewBox="0 0 300 360" preserveAspectRatio="none" aria-hidden="true">
                <line x1="30" y1="40" x2="150" y2="120" />
                <line x1="150" y1="120" x2="270" y2="60" />
                <line x1="150" y1="120" x2="90" y2="240" />
                <line x1="150" y1="120" x2="240" y2="220" />
                <line x1="90" y1="240" x2="240" y2="220" />
                <line x1="90" y1="240" x2="60" y2="330" />
                <line x1="240" y1="220" x2="260" y2="330" />
                <circle cx="30" cy="40" r="3.5" />
                <circle cx="150" cy="120" r="4.5" />
                <circle cx="270" cy="60" r="3.5" />
                <circle cx="90" cy="240" r="4" />
                <circle cx="240" cy="220" r="4" />
                <circle cx="60" cy="330" r="3.5" />
                <circle cx="260" cy="330" r="3.5" />
              </svg>

              <div className="aiml-pf-cta__chips" aria-hidden="true">
                <span>LLM</span>
                <span>RAG</span>
                <span>Agents</span>
                <span>GenAI</span>
              </div>

              <h2 className="aiml-pf-cta__title">
                Build Your AI Career With <b>Real-World GenAI Projects</b>
              </h2>
              <p className="aiml-pf-cta__text">
                Learn AI, ML, LLMs, RAG, and Agentic AI through live classes,
                mentor-led projects, mock interviews, and career support.
              </p>

              <ul className="aiml-pf-cta__list">
                <li>
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round"><path d="m5 12 5 5L20 7" /></svg>
                  Live Weekend Classes
                </li>
                <li>
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round"><path d="m5 12 5 5L20 7" /></svg>
                  10+ AI Projects
                </li>
                <li>
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round"><path d="m5 12 5 5L20 7" /></svg>
                  Mock Interviews + Resume Prep
                </li>
              </ul>

              <div className="aiml-pf-cta__actions">
                <a
                  target="_default"
                  href="https://calendly.com/logicmojo/schedule-call-back-from-experts-for-live-classes?month=2026-06"
                  className="aiml-pf-cta__btn"
                >
                  Apply For Live AI Classes
                  <i className="fa fa-angle-right" aria-hidden="true"></i>
                </a>
                <a
                  href="#Syllabus"
                  className="aiml-pf-cta__btn aiml-pf-cta__btn--ghost"
                >
                  View AI Curriculum
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>

      <style>{aimlFeeStyles}</style>
      <section className="aimlfee" id="Fee" ref={overFee}>
        <span className="aimlfee__bg" aria-hidden="true"></span>
        <span className="aimlfee__glow aimlfee__glow--l" aria-hidden="true"></span>
        <span className="aimlfee__glow aimlfee__glow--r" aria-hidden="true"></span>

        <div className="aimlfee__inner">
          <div className="aimlfee__head">
            <span className="aimlfee__eyebrow"><i></i>Admissions Open</span>
            <h2 className="aimlfee__title">
              Advanced AI &amp; ML Course with <b>GenAI, LLMs, RAG &amp; Agentic AI</b>
            </h2>
            <p className="aimlfee__sub">
              A complete live program designed for working professionals to master
              Artificial Intelligence, Machine Learning, Generative AI, LLMs, RAG, and
              Agentic AI with mentorship, hands-on projects, and career support.
            </p>
          </div>

          <div className="aimlfee__hero">
            {/* Pricing highlight card */}
            <div className="aimlfee-price">
              <span className="aimlfee-price__orb" aria-hidden="true"></span>
              <svg className="aimlfee-price__net" viewBox="0 0 320 360" preserveAspectRatio="none" aria-hidden="true">
                <line x1="30" y1="40" x2="160" y2="120" />
                <line x1="160" y1="120" x2="290" y2="60" />
                <line x1="160" y1="120" x2="90" y2="250" />
                <line x1="160" y1="120" x2="250" y2="230" />
                <line x1="90" y1="250" x2="250" y2="230" />
                <line x1="90" y1="250" x2="60" y2="340" />
                <line x1="250" y1="230" x2="270" y2="340" />
                <circle cx="30" cy="40" r="3.5" />
                <circle cx="160" cy="120" r="4.5" />
                <circle cx="290" cy="60" r="3.5" />
                <circle cx="90" cy="250" r="4" />
                <circle cx="250" cy="230" r="4" />
                <circle cx="60" cy="340" r="3.5" />
                <circle cx="270" cy="340" r="3.5" />
              </svg>

              <div className="aimlfee-price__inner">
                <div className="aimlfee-price__top">
                  <div>
                    <p className="aimlfee-price__label">Program Fee</p>
                    <h3 className="aimlfee-price__name">LogicMojo AI &amp; ML Course</h3>
                  </div>
                  <span className="aimlfee-price__badge">
                    <Diya />
                    DIWALI SPECIAL
                  </span>
                </div>

                <span className="aimlfee-price__offerline">
                  <b>Flat 20% OFF</b> Diwali Special Offer
                </span>

                <div className="aimlfee-price__amounts">
                  <s className="aimlfee-price__orig"><span className="lm-sr">Original price </span>₹87,000</s>
                  <p className="aimlfee-price__now">₹69,600</p>
                </div>

                <span className="aimlfee-price__save">
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round"><path d="M20 12V8H6a2 2 0 0 1 0-4h12v4" /><path d="M4 6v12a2 2 0 0 0 2 2h14v-4" /><path d="M18 12a2 2 0 0 0 0 4h4v-4z" /></svg>
                  Save ₹17,400 with the Diwali Special Offer
                </span>

                <div className="aimlfee-price__chips">
                  <span>Live Weekend Classes</span>
                  <span>Job-Focused AI Program</span>
                  <span>Beginner to Advanced</span>
                  <span>GenAI + Agentic AI</span>
                </div>
              </div>
            </div>

            {/* EMI + CTA + trust panel */}
            <div className="aimlfee-emi">
              <div className="aimlfee-emi__head">
                <h3 className="aimlfee-emi__title">No Cost EMI Available</h3>
                <span className="aimlfee-emi__zero">0% Interest</span>
              </div>
              <p className="aimlfee-emi__note">
                Available for 3 Months or 6 Months. Start learning AI now and pay in
                easy monthly installments with 0% interest.
              </p>

              <div className="aimlfee-emi__options">
                <div className="aimlfee-emi__opt">
                  <div className="aimlfee-emi__opt-term">3-Month EMI</div>
                  <div className="aimlfee-emi__opt-amt">₹23,200<span>/mo</span></div>
                </div>
                <div className="aimlfee-emi__opt">
                  <div className="aimlfee-emi__opt-term">6-Month EMI</div>
                  <div className="aimlfee-emi__opt-amt">₹11,600<span>/mo</span></div>
                </div>
              </div>

              <ul className="aimlfee-emi__trust">
                <li>
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round"><rect x="2" y="7" width="20" height="14" rx="2" /><path d="M16 21V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v16" /></svg>
                  Live Weekend Classes
                </li>
                <li>
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round"><path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" /><circle cx="9" cy="7" r="4" /><path d="M22 21v-2a4 4 0 0 0-3-3.87" /><path d="M16 3.13a4 4 0 0 1 0 7.75" /></svg>
                  Dedicated Mentor Support
                </li>
                <li>
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" /><path d="M14 2v6h6" /><path d="m9 15 2 2 4-4" /></svg>
                  Mock Interviews + Resume Prep
                </li>
              </ul>

              <DiwaliNote fee={87000} />

              <div className="aimlfee-cta__row">
                <a
                  target="_default"
                  href="https://calendly.com/logicmojo/schedule-call-back-from-experts-for-live-classes?month=2026-06"
                  className="aimlfee-cta__btn"
                >
                  Apply for Live AI Classes
                  <i className="fa fa-angle-right" aria-hidden="true"></i>
                </a>
                <a
                  target="_default"
                  href="https://calendly.com/logicmojo/schedule-call-back-from-experts-for-live-classes?month=2026-06"
                  className="aimlfee-cta__btn aimlfee-cta__btn--ghost"
                >
                  Request a Call
                </a>
              </div>

              <div className="aimlfee-emi__finance">
                <p>0% Interest Financing Partners</p>
                <ul>
                  <li><img src="/react/ai-assets/images//feelogo1.png" alt="Financing partner" /></li>
                  <li><img src="/react/ai-assets/images//feelogo2.png" alt="Financing partner" /></li>
                  <li><img src="/react/ai-assets/images//feelogo3.png" alt="Financing partner" /></li>
                  <li><img src="/react/ai-assets/images//feelogo4.png" alt="Financing partner" /></li>
                  <li><img src="/react/ai-assets/images//feelogo5.png" alt="Financing partner" /></li>
                </ul>
              </div>
            </div>
          </div>

          {/* Bottom info cards */}
          <div className="aimlfee__cards">
            {/* Card 1: Course duration / structure */}
            <div className="aimlfee-info">
              <div className="aimlfee-info__head">
                <span className="aimlfee-info__icon">
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="9" /><path d="M12 7v5l3 2" /></svg>
                </span>
                <h3 className="aimlfee-info__title">AI &amp; ML Course Duration</h3>
              </div>
              <ul className="aimlfee-feat">
                <li>
                  <span className="aimlfee-feat__ic">
                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round"><rect x="3" y="4" width="18" height="18" rx="2" /><path d="M16 2v4M8 2v4M3 10h18" /></svg>
                  </span>
                  <span><b>7 Months</b> of Live Weekend Classes</span>
                </li>
                <li>
                  <span className="aimlfee-feat__ic">
                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round"><path d="M3 12h4l3 8 4-16 3 8h4" /></svg>
                  </span>
                  <span>Beginner-friendly pathway with <b>guided learning</b></span>
                </li>
                <li>
                  <span className="aimlfee-feat__ic">
                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round"><path d="M9 18V5l12-2v13" /><circle cx="6" cy="18" r="3" /><circle cx="18" cy="16" r="3" /></svg>
                  </span>
                  <span>Structured roadmap from <b>fundamentals to advanced AI systems</b></span>
                </li>
                <li>
                  <span className="aimlfee-feat__ic">
                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round"><path d="M12 2a3 3 0 0 0-3 3v1a3 3 0 0 0 6 0V5a3 3 0 0 0-3-3z" /><path d="M5 21a7 7 0 0 1 14 0" /><circle cx="12" cy="11" r="1" /></svg>
                  </span>
                  <span>Covers <b>Python, ML, Deep Learning, GenAI, LLMs, RAG &amp; Agentic AI</b></span>
                </li>
                <li>
                  <span className="aimlfee-feat__ic">
                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round"><path d="M12 15a7 7 0 1 0-7-7" /><path d="M8 21h8M12 17v4" /><path d="m4.5 9.5 2 2M19.5 9.5l-2 2" /></svg>
                  </span>
                  <span>Includes <b>projects, mock interviews &amp; career preparation</b></span>
                </li>
              </ul>
            </div>

            {/* Card 2: Who can apply */}
            <div className="aimlfee-info">
              <div className="aimlfee-info__head">
                <span className="aimlfee-info__icon">
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round"><path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" /><circle cx="9" cy="7" r="4" /><path d="M23 21v-2a4 4 0 0 0-3-3.87M16 3.13a4 4 0 0 1 0 7.75" /></svg>
                </span>
                <h3 className="aimlfee-info__title">Who Can Apply for the AI &amp; ML Course?</h3>
              </div>
              <div className="aimlfee-role__list">
                {[
                  "Software Developers",
                  "IT Professionals",
                  "QA Engineers",
                  "Data Analysts",
                  "Tech Leads",
                  "Managers",
                  "Architects",
                  "Career Switchers",
                  "Freshers serious about AI",
                ].map((role) => (
                  <span key={role}>
                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.6" strokeLinecap="round" strokeLinejoin="round"><path d="m5 12 5 5L20 7" /></svg>
                    {role}
                  </span>
                ))}
              </div>
              <p className="aimlfee-role__note">
                Ideal for learners who want to build practical AI, ML, GenAI, and
                Agentic AI skills for real job opportunities.
              </p>
            </div>
          </div>
        </div>
      </section>

      <div className={`whatpeoplesaybg wps_redesign ${isVisibleReview ? "wps_visible" : ""}`} id="Review">
        <div className="container" ref={overReview}>
          <div className="wps_header">
            <span className="wps_badge">Testimonials</span>
            <h2 className="wps_title">What People <span>Say</span></h2>
            <p className="wps_subtitle">How it has helped them accelerate their careers to the next level</p>
            <div className="wps_stats_row">
              <div className="wps_stat"><span className="wps_stat_num">4.9</span><span className="wps_stat_label">Avg. Rating</span></div>
              <div className="wps_stat_divider"></div>
              <div className="wps_stat"><span className="wps_stat_num">3200+</span><span className="wps_stat_label">Reviews</span></div>
              <div className="wps_stat_divider"></div>
              <div className="wps_stat"><span className="wps_stat_num">180%</span><span className="wps_stat_label">Avg. Salary Hike</span></div>
            </div>
          </div>

          <div className="review_scroll_sec wps_scroll_wrapper">
            <div className="review_scroll_inner wps_scroll_track wps_track_1">

            

              <div className="whatpeoplesaybox">
                <div className="hikebox">
                  <span>
                    295% <i className="fa fa-line-chart" aria-hidden="true"></i>
                  </span>
                </div>
                <div className="whatpeoplesaybox-top">
                  <img
                    loading="lazy"
                    src="/react/ai-assets/images//anjani.png"
                    alt=""
                  />
                  <div className="top_heading">
                    <h3>Anjani Kumar</h3>
                    <h6>Software Development Engineer - 1</h6>
                  </div>
                </div>
                <div className="whatpeoplesaybox-dec">
                  Very Well-arranged Course and its Amazing Lecture Delivery by
                  Trainers. Expert Team is always Available to solve Any
                  Technical Queries. Logicmojo Live Preparation Training Helps
                  me to Crack Zynga and Now Amazon Interview.
                </div>
                <div className="whatpeoplesaybox-mid">
                  <div className="prelogic">
                    <div className="scalerbox scalerbox_left">
                      <label htmlFor="">Pre Logicmojo</label> Zynga
                    </div>
                  </div>
                  <div className="arrow">
                    <div className="scalerbox-arrow">
                      <i
                        className="fa fa-long-arrow-right"
                        aria-hidden="true"
                      ></i>
                    </div>
                  </div>
                  <div className="postlogic">
                    <div className="scalerbox">
                      <label htmlFor="">Post Logicmojo</label>{" "}
                      <img
                        loading="lazy"
                        style={{ height: "auto" }}
                        src="/react/ai-assets/images//amazonlogo.jpg"
                        alt=""
                      />
                    </div>
                  </div>
                </div>
                <div className="storybox1">
                  <div className="linkdinlink"><a target="_blank" href="https://www.linkedin.com/in/anjani-kumar-singh-77337516a/"><img width="28" height="28" src="/react/ai-assets/images//linkdin.png" alt="" /></a></div>
                </div>
              </div>
              <div className="whatpeoplesaybox">
                <div className="hikebox">
                  <span>
                    160% <i className="fa fa-line-chart" aria-hidden="true"></i>
                  </span>
                </div>
                <div className="whatpeoplesaybox-top">
                  <img
                    loading="lazy"
                    src="/react/ai-assets/images//priya1.png"
                    alt=""
                  />
                  <div className="top_heading">
                    <h3>Priya Singh</h3>
                    <h6>Senior Software Engineer</h6>
                  </div>
                </div>
                <div className="whatpeoplesaybox-dec">
                  {" "}
                  The Course Curriculum is of Best Quality Along with Good
                  Coding Problems that Discussed in the Class. Materials are
                  Helpful even After Completion of the Course.
                </div>
                <div className="whatpeoplesaybox-mid">
                  <div className="prelogic">
                    <div className="scalerbox scalerbox_left">
                      <label htmlFor="">Pre Logicmojo</label> MindTree
                    </div>
                  </div>
                  <div className="arrow">
                    <div className="scalerbox-arrow">
                      <i
                        className="fa fa-long-arrow-right"
                        aria-hidden="true"
                      ></i>
                    </div>
                  </div>
                  <div className="postlogic">
                    <div className="scalerbox">
                      <label htmlFor="">Post Logicmojo</label>{" "}
                      <img
                        loading="lazy"
                        style={{ height: "auto" }}
                        src="/react/ai-assets/images//ciscologo.jpg"
                        alt=""
                      />
                    </div>
                  </div>
                </div>
                <div className="storybox1">
                  <div className="linkdinlink"><a target="_blank" href="https://www.linkedin.com/in/priyasingh2905/"><img width="28" height="28" src="/react/ai-assets/images//linkdin.png" alt="" /></a></div>
                </div>
              </div>

              <div className="whatpeoplesaybox">
                <div className="hikebox">
                  <span>
                    190% <i className="fa fa-line-chart" aria-hidden="true"></i>
                  </span>
                </div>
                <div className="whatpeoplesaybox-top">
                  <img
                    loading="lazy"
                    src="/react/ai-assets/images//afnaan.png"
                    alt=""
                  />
                  <div className="top_heading">
                    <h3>Afnaan Rafique</h3>
                    <h6>Software Engineer 2</h6>
                  </div>
                </div>
                <div className="whatpeoplesaybox-dec">
                  {" "}
                  I have a very great experience with Logicmojo. Learning by
                  doing is a great way to learn something which Logicmojo team
                  encouraged me to do so. The course has a big contribution to
                  my success.
                </div>
                <div className="whatpeoplesaybox-mid">
                  <div className="prelogic">
                    <div className="scalerbox scalerbox_left">
                      <label htmlFor="">Pre Logicmojo</label> GlobalLogic
                    </div>
                  </div>
                  <div className="arrow">
                    <div className="scalerbox-arrow">
                      <i
                        className="fa fa-long-arrow-right"
                        aria-hidden="true"
                      ></i>
                    </div>
                  </div>
                  <div className="postlogic">
                    <div className="scalerbox">
                      <label htmlFor="">Post Logicmojo</label>{" "}
                      <img
                        loading="lazy"
                        style={{ height: "auto" }}
                        src="/react/ai-assets/images//paypalLogo.jpg"
                        alt=""
                      />
                    </div>
                  </div>
                </div>
              </div>

              <div className="whatpeoplesaybox">
                <div className="hikebox">
                  <span>
                    270% <i className="fa fa-line-chart" aria-hidden="true"></i>
                  </span>
                </div>
                <div className="whatpeoplesaybox-top">
                  <img
                    loading="lazy"
                    src="/react/ai-assets/images//piyush.png"
                    alt=""
                  />
                  <div className="top_heading">
                    <h3>Piyush Mittal</h3>
                    <h6>Senior Developer</h6>
                  </div>
                </div>
                <div className="whatpeoplesaybox-dec">
                  {" "}
                  The Course Curriculum is of the Best Quality Along with the
                  Best Learning Experience from my Tutor. Best Course to Prepare
                  For MAANG Companies Interview. I Cracked Paytm, Adobe, Intuit,
                  and Microsoft. Finally joined Microsoft at 1.3 Cr LPA
                  Hyderabad MS IDC
                </div>
                <div className="whatpeoplesaybox-mid">
                  <div className="prelogic">
                    <div className="scalerbox scalerbox_left">
                      <label htmlFor="">Pre Logicmojo</label> Paytm
                    </div>
                  </div>
                  <div className="arrow">
                    <div className="scalerbox-arrow">
                      <i
                        className="fa fa-long-arrow-right"
                        aria-hidden="true"
                      ></i>
                    </div>
                  </div>
                  <div className="postlogic">
                    <div className="scalerbox">
                      <label htmlFor="">Post Logicmojo</label>{" "}
                      <img
                        loading="lazy"
                        style={{ height: "auto" }}
                        src="/react/ai-assets/images//microsoftlogo.jpg"
                        alt=""
                      />
                    </div>
                  </div>
                </div>
              </div>

            </div>

            <div className="review_scroll_inner wps_scroll_track wps_track_2">

              <div className="whatpeoplesaybox">
                <div className="hikebox">
                  <span>
                    170% <i className="fa fa-line-chart" aria-hidden="true"></i>
                  </span>
                </div>
                <div className="whatpeoplesaybox-top">
                  <img
                    loading="lazy"
                    src="/react/ai-assets/images//diwakar.png"
                    alt=""
                  />
                  <div className="top_heading">
                    <h3>Diwakar Choudhary</h3>
                    <h6>Staff Engineer/Manager</h6>
                  </div>
                </div>
                <div className="whatpeoplesaybox-dec">
                  {" "}
                  Excellent Course for Interview Preparation, Very Straight to
                  the Point ,In-Depth Coverage of Every Point in Live Classes.
                  Speecially Focus on Practical Implementation of Every Coding &
                  Architectiral Problems.
                </div>
                <div className="whatpeoplesaybox-mid">
                  <div className="prelogic">
                    <div className="scalerbox scalerbox_left">
                      <label htmlFor="">Pre Logicmojo</label> Cirtix
                    </div>
                  </div>
                  <div className="arrow">
                    <div className="scalerbox-arrow">
                      <i
                        className="fa fa-long-arrow-right"
                        aria-hidden="true"
                      ></i>
                    </div>
                  </div>
                  <div className="postlogic">
                    <div className="scalerbox">
                      <label htmlFor="">Post Logicmojo</label>{" "}
                      <img
                        loading="lazy"
                        style={{ height: "auto" }}
                        src="/react/ai-assets/images//walmartlbslogo.jpg"
                        alt=""
                      />
                    </div>
                  </div>
                </div>
              </div>
             
              <div className="whatpeoplesaybox">
                <div className="hikebox">
                  <span>
                    130% <i className="fa fa-line-chart" aria-hidden="true"></i>
                  </span>
                </div>
                <div className="whatpeoplesaybox-top">
                  <img
                    loading="lazy"
                    src="/react/ai-assets/images//rajnish.jpg"
                    alt=""
                  />
                  <div className="top_heading">
                    <h3>Rajnish Kumar</h3>
                    <h6>Staff Engineer</h6>
                  </div>
                </div>
                <div className="whatpeoplesaybox-dec">
                  {" "}
                  Great course! Definitely helped me open some new doors in
                  understanding how algorithms work and implementing solutions
                  for the different exercises. Live Courses are recommended for
                  Working Professionals.
                </div>
                <div className="whatpeoplesaybox-mid">
                  <div className="prelogic">
                    <div className="scalerbox scalerbox_left">
                      <label htmlFor="">Pre Logicmojo</label> Cred
                    </div>
                  </div>
                  <div className="arrow">
                    <div className="scalerbox-arrow">
                      <i
                        className="fa fa-long-arrow-right"
                        aria-hidden="true"
                      ></i>
                    </div>
                  </div>
                  <div className="postlogic">
                    <div className="scalerbox">
                      <label htmlFor="">Post Logicmojo</label>{" "}
                      <img
                        loading="lazy"
                        style={{ height: "auto" }}
                        src="/react/ai-assets/images//flipcart.jpg"
                        alt=""
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="wps_cta_wrap">
            <a
              target="_default"
              href="https://logicmojo.com/reviews"
              className="wps_cta_btn"
            >
              View All Success Stories <i className="fa fa-arrow-right"></i>
            </a>
          </div>

        </div>

      </div>

      <div className="businessstrip">
        <img
          loading="lazy"
          src="/react/ai-assets/images//busniessstrip.jpg"
          alt=""
        />

        <div className="businessdeils">
          <div className="container">
            <div className="row">
              <div className="col-lg-7 col-md-7">
                <h1>
                  Learn from MAANG companies <br />
                  Experts & Transform your Career
                </h1>
              </div>

              <div className="col-lg-5 col-md-5">
                <a
                  target="_default"
                  href="https://calendly.com/logicmojo/schedule-call-back-from-experts-for-live-classes?month=2026-06"
                  //data-toggle="modal"
                  className="exportbtn"
                //data-target="#counsellingpopup"
                >
                  <img
                    loading="lazy"
                    src="/react/ai-assets/images//callicons.png"
                    alt=""
                    className="callico"
                  />{" "}
                  Apply For Live Classes
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="wrokexpstrip menucontent" id="workexp" ref={overCurriculum}>
        <div className="container">
          <h3>
            Learn AI, Machine Learning, Generative AI &amp; Agentic AI from
            scratch
          </h3>

          <h2>How to get placed in product companies </h2>

          <div className="workexpinfo">
            <div className="row">
              <div className="col-lg-3 col-md-6">
                <div className="expinfobg">
                  <div className="expicons">
                    <img
                      loading="lazy"
                      src="/react/ai-assets/images//howtoapply1.png"
                      alt=""
                    />
                  </div>

                  <h4>
                    Attend free demo class <br />
                    from your mentor{" "}
                  </h4>

                  <p>
                    Just click on Free Trial
                    <br /> for attending demo class{" "}
                  </p>
                </div>
              </div>

              <div className="col-lg-3 col-md-6">
                <div className="expinfobg">
                  <div className="expicons">
                    <img
                      loading="lazy"
                      src="/react/ai-assets/images//howtoapply2.png"
                      alt=""
                    />
                  </div>

                  <h4>
                    Join the <br /> course
                  </h4>

                  <p>
                    Talk to our Experts for any queries and join the course{" "}
                  </p>
                </div>
              </div>

              <div className="col-lg-3 col-md-6">
                <div className="expinfobg">
                  <div className="expicons">
                    <img
                      loading="lazy"
                      src="/react/ai-assets/images//howtoapply3.png"
                      alt=""
                    />
                  </div>

                  <h4>
                    Attend live sessions
                    <br />
                    regularly
                  </h4>

                  <p>
                    Attend sessions regularly and <br />
                    complete all assignments{" "}
                  </p>
                </div>
              </div>

              <div className="col-lg-3 col-md-6">
                <div className="expinfobg expend">
                  <div className="expicons">
                    <img
                      loading="lazy"
                      src="/react/ai-assets/images//howtoapply4.png"
                      alt=""
                    />
                  </div>

                  <h4>
                    Get Job assistance and <br />
                    certification
                  </h4>

                  <p>
                    Get job assistance & certification
                    <br /> after completion of the course{" "}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="modal" id="myvid1">
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-body">
              {/* <ReactPlayer
                  src="https://player.vimeo.com/video/610387030?h=0ef367f77e"
                  width="100%"
                  height="400px"
                  controls={true}
                /> */}
              <LazyLoad height={400} offsetVertical={300}>
                <div>
                  <ReactPlayer
                    src="https://player.vimeo.com/video/890545193"
                    width="100%"
                    height="400px"
                    controls={true}
                  />
                </div>
              </LazyLoad>
            </div>
          </div>
        </div>
      </div>

      <div className="modal" id="myvid2">
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-body">
              {/* <ReactPlayer
                  src="https://player.vimeo.com/video/610388947?h=2b749e6eca"
                  width="100%"
                  height="360px"
                  controls={true}
                /> */}
              <LazyLoad height={360} offsetVertical={300}>
                <div>
                  <ReactPlayer
                    src="https://player.vimeo.com/video/890545193"
                    width="100%"
                    height="360px"
                    controls={true}
                  />
                </div>
              </LazyLoad>
            </div>
          </div>
        </div>
      </div>

      <div className="modal" id="myvid3">
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-body">
              {/* <ReactPlayer
                  src="https://player.vimeo.com/video/610389810?h=9d5422ded0"
                  width="100%"
                  height="400px"
                  controls={true}
                /> */}
              <LazyLoad height={400} offsetVertical={300}>
                <div>
                  <ReactPlayer
                    src="https://player.vimeo.com/video/868175222?h=9d5422ded0"
                    width="100%"
                    height="400px"
                    controls={true}
                  />
                </div>
              </LazyLoad>
            </div>
          </div>
        </div>
      </div>

      <div className="modal" id="myvid4">
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-body">
              {/* <ReactPlayer
                  src="https://player.vimeo.com/video/610388947?h=2b749e6eca"
                  width="100%"
                  height="400px"
                  controls={true}
                /> */}
              <LazyLoad height={400} offsetVertical={300}>
                <div>
                  <ReactPlayer
                    src="https://player.vimeo.com/video/868175222?h=2b749e6eca"
                    width="100%"
                    height="400px"
                    controls={true}
                  />
                </div>
              </LazyLoad>
            </div>
          </div>
        </div>
      </div>

      <div className="d-none">
        <div className="coursesbg" id="PopularCourses">
          <div className="container">
            <h1>Popular Course</h1>

            <h6 className="text-center">Select Language</h6>

            <ul className="nav nav-pills mb-3" id="pills-tab" role="tablist">
              <li className="nav-item" role="presentation">
                <a
                  className="nav-link active"
                  id="pills-home-tab02"
                  data-toggle="pill"
                  href="#pills-home02"
                  role="tab"
                  aria-controls="pills-home"
                  aria-selected="true"
                >
                  {" "}
                  Java
                </a>
              </li>

              <li className="nav-item" role="presentation">
                <a
                  className="nav-link"
                  id="pills-profile-tab02"
                  data-toggle="pill"
                  href="#pills-profile02"
                  role="tab"
                  aria-controls="pills-profile"
                  aria-selected="false"
                >
                  C++
                </a>
              </li>

              <li className="nav-item" role="presentation">
                <a
                  className="nav-link"
                  id="pills-Doubt-tab03"
                  data-toggle="pill"
                  href="#pills-Doubt02"
                  role="tab"
                  aria-controls="pills-Doubt"
                  aria-selected="false"
                >
                  {" "}
                  Python
                </a>
              </li>
            </ul>

            <div className="tab-content" id="pills-tabContent">
              <div
                className="tab-pane fade active show"
                id="pills-home02"
                role="tabpanel"
                aria-labelledby="pills-home-tab02"
              >
                <div className="coursesboxmain">
                  <div className="row">
                    <div className="col-lg-6 col-md-12">
                      <div className="coursesbox">
                        <div className="col-lg-4 col-md-4">
                          <div className="popheader01">
                            DIWALI SPECIAL 20% OFF{" "}
                          </div>
                        </div>

                        <div className="coursesbox-img">
                          {" "}
                          <img
                            loading="lazy"
                            src="/react/ai-assets/images//popularcoursimg.jpg"
                            alt=""
                          />{" "}
                          <span>For Working Professionals</span>
                        </div>

                        <div className="coursesbox-content">
                          <h3>
                            Cracking the Coding &amp; System <br /> Design
                            Interview
                          </h3>

                          <p>
                            <u>
                              Complete Course of Data Structures, Algorithms &
                              System Design
                            </u>
                          </p>
                          <p>
                            Accesibility: Life Time Access Course (260+
                            Lectures)
                          </p>

                          <p>
                            Eligibility : 1+ to 15 year of work exp.in any
                            domain
                          </p>

                          <p>Mode: Online</p>

                          <div className="row popbtns">
                            <div className="col-lg-6 col-md-6 col-sm-6 col-12">
                              <h6>Code Explanation : Java</h6>

                              <a
                                target="_blank"
                                rel="noopener"
                                href="https://logicmojo.com/cracking_interview"
                                className="chckbtns"
                              >
                                Check syllabus
                              </a>
                            </div>

                            <div className="col-lg-6 col-md-6 col-sm-6 col-12">
                              <h6>Course Fee : 5000/-</h6>

                              <h6>Course Fee : 69$ </h6>

                              <a
                                href="https://logicmojo.com/purchase/38"
                                className="chckbtns02"
                              >
                                Enroll now
                              </a>

                              <a
                                href="javascript:void(0);"
                                className="course_id_session chckbtns02"
                                data-course_id="38"
                              >
                                Enroll now
                              </a>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="col-lg-6 col-md-12">
                      <div className="coursesbox">
                        <div className="col-lg-4 col-md-4">
                          <div className="popheader01">
                            DISCOUNT UPTO 30%{" "}
                          </div>
                        </div>

                        <div className="coursesbox-img">
                          {" "}
                          <img
                            loading="lazy"
                            src="/react/ai-assets/images//popularcoursimg02.jpg"
                            alt=""
                          />{" "}
                          <span>For Freshers Candidates</span>
                        </div>

                        <div className="coursesbox-content">
                          <h3>Cracking the Placement Interviews</h3>
                          <p>
                            <u>
                              Complete Course of Data Structures, Algorithms &
                              Competitive Programming
                            </u>
                          </p>

                          <p>
                            Accesibility: Life Time Access Course (240+
                            Lectures)
                          </p>

                          <p>
                            Eligibility : Undergraduates, Fresher, 1 Year exp
                          </p>

                          <p>Mode: Online</p>

                          <div className="row popbtns">
                            <div className="col-lg-6 col-md-6 col-sm-6 col-12">
                              <h6>Code Explanation : Java</h6>

                              <a
                                target="_blank"
                                rel="noopener"
                                href="https://logicmojo.com/java-freshers-course"
                                className="chckbtns"
                              >
                                Check syllabus
                              </a>
                            </div>

                            <div className="col-lg-6 col-md-6 col-sm-6 col-12">
                              <h6>Course Fee : 4000/-</h6>

                              <h6>Course Fee : 49$ </h6>

                              <a
                                href="https://logicmojo.com/purchase/43"
                                className="chckbtns02"
                              >
                                Enroll now
                              </a>

                              <a
                                href="javascript:void(0);"
                                className="course_id_session chckbtns02"
                                data-course_id="43"
                              >
                                Enroll now
                              </a>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div
                className="tab-pane fade"
                id="pills-profile02"
                role="tabpanel"
                aria-labelledby="pills-profile-tab02"
              >
                <div className="coursesboxmain">
                  <div className="row">
                    <div className="col-lg-6 col-md-12">
                      <div className="coursesbox">
                        <div className="col-lg-4 col-md-4">
                          <div className="popheader01">
                            DISCOUNT UPTO 30%{" "}
                          </div>
                        </div>

                        <div className="coursesbox-img">
                          {" "}
                          <img
                            loading="lazy"
                            src="/react/ai-assets/images//popularcoursimg03.jpg"
                            alt=""
                          />{" "}
                          <span>For Working Professionals</span>
                        </div>

                        <div className="coursesbox-content">
                          <h3>
                            Cracking the Coding &amp; System <br /> Design
                            Interview
                          </h3>
                          <p>
                            <u>
                              Complete Course of Data Structures, Algorithms &
                              System Design
                            </u>
                          </p>

                          <p>
                            Accesibility: Life Time Access Course (260+
                            Lectures)
                          </p>

                          <p>
                            Eligibility : 1+ to 15 year of work exp.in any
                            domain
                          </p>

                          <p>Mode: Online</p>

                          <div className="row popbtns">
                            <div className="col-lg-6 col-md-6 col-sm-6 col-12">
                              <h6>Code Explanation : C/C++</h6>

                              <a
                                target="_blank"
                                rel="noopener"
                                href="https://logicmojo.com/cpp-experienced-course"
                                className="chckbtns"
                              >
                                Check syllabus
                              </a>
                            </div>

                            <div className="col-lg-6 col-md-6 col-sm-6 col-12">
                              <h6>Course Fee : 5000/-</h6>

                              <a
                                href="https://logicmojo.com/purchase/47"
                                className="chckbtns02"
                              >
                                Enroll now
                              </a>

                              <a
                                href="javascript:void(0);"
                                className="course_id_session chckbtns02"
                                data-course_id="47"
                              >
                                Enroll now
                              </a>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="col-lg-6 col-md-12">
                      <div className="coursesbox">
                        <div className="col-lg-4 col-md-4">
                          <div className="popheader01">
                            DISCOUNT UPTO 30%{" "}
                          </div>
                        </div>
                        <div className="coursesbox-img">
                          {" "}
                          <img
                            loading="lazy"
                            src="/react/ai-assets/images//popularcoursimg04.jpg"
                            alt=""
                          />{" "}
                          <span>For Freshers Candidates</span>
                        </div>

                        <div className="coursesbox-content">
                          <h3>Cracking the Placement Interviews</h3>
                          <p>
                            <u>
                              Complete Course of Data Structures, Algorithms &
                              Competitive Programming
                            </u>
                          </p>

                          <p>
                            Accesibility: Life Time Access Course (240+
                            Lectures)
                          </p>

                          <p>
                            Eligibility : Undergraduates, Fresher, 1 Year exp
                          </p>

                          <p>Mode: Online</p>

                          <div className="row popbtns">
                            <div className="col-lg-6 col-md-6 col-sm-6 col-12">
                              <h6>Code Explanation : C/C++</h6>

                              <a
                                target="_blank"
                                rel="noopener"
                                href="https://logicmojo.com/cpp-freshers-course"
                                className="chckbtns"
                              >
                                Check syllabus
                              </a>
                            </div>

                            <div className="col-lg-6 col-md-6 col-sm-6 col-12">
                              <h6>Course Fee : 4000/-</h6>

                              <h6>Course Fee :49$ </h6>

                              <a
                                href="https://logicmojo.com/purchase/46"
                                className="chckbtns02"
                              >
                                enroll now
                              </a>

                              <a
                                href="javascript:void(0);"
                                className="course_id_session chckbtns02"
                                data-course_id="46"
                              >
                                enroll now
                              </a>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div
                className="tab-pane fade"
                id="pills-Doubt02"
                role="tabpanel"
                aria-labelledby="pills-Doubt-tab03"
              >
                <div className="coursesboxmain">
                  <div className="row">
                    <div className="col-lg-6 col-md-12">
                      <div className="coursesbox">
                        <div className="col-lg-4 col-md-4">
                          <div className="popheader01">
                            DISCOUNT UPTO 30%{" "}
                          </div>
                        </div>

                        <div className="coursesbox-img">
                          {" "}
                          <img
                            loading="lazy"
                            src="/react/ai-assets/images//popularcoursimg05.jpg"
                            alt=""
                          />{" "}
                          <span>For Working Professionals</span>
                        </div>

                        <div className="coursesbox-content">
                          <h3>
                            Cracking the Coding &amp; System <br /> Design
                            Interview
                          </h3>
                          <p>
                            <u>
                              Complete Course of Data Structures, Algorithms &
                              System Design
                            </u>
                          </p>

                          <p>
                            Accesibility: Life Time Access Course (260+
                            Lectures)
                          </p>

                          <p>
                            Eligibility : 1+ to 15 year of work exp.in any
                            domain
                          </p>

                          <p>Mode: Online</p>

                          <div className="row popbtns">
                            <div className="col-lg-6 col-md-6 col-sm-6 col-12">
                              <h6>Code Explanation : Python</h6>

                              <a
                                target="_blank"
                                rel="noopener"
                                href="https://logicmojo.com/python-experienced-course"
                                className="chckbtns"
                              >
                                Check syllabus
                              </a>
                            </div>

                            <div className="col-lg-6 col-md-6 col-sm-6 col-12">
                              <h6>Course Fee : 5000/-</h6>

                              <h6>Course Fee : 69$ </h6>

                              <a
                                href="https://logicmojo.com/purchase/45"
                                className="chckbtns02"
                              >
                                Enroll now
                              </a>

                              <a
                                href="javascript:void(0);"
                                className="course_id_session chckbtns02"
                                data-course_id="45"
                              >
                                Enroll now
                              </a>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="col-lg-6 col-md-12">
                      <div className="coursesbox">
                        <div className="col-lg-4 col-md-4">
                          <div className="popheader01">
                            DISCOUNT UPTO 30%{" "}
                          </div>
                        </div>
                        <div className="coursesbox-img">
                          {" "}
                          <img
                            loading="lazy"
                            src="/react/ai-assets/images//popularcoursimg06.jpg"
                            alt=""
                          />{" "}
                          <span> For Freshers Candidates</span>
                        </div>

                        <div className="coursesbox-content">
                          <h3>Cracking the Placement Interviews</h3>
                          <p>
                            <u>
                              Complete Course of Data Structures, Algorithms &
                              Competitive Programming
                            </u>
                          </p>

                          <p>
                            Accesibility: Life Time Access Course (240+
                            Lectures)
                          </p>

                          <p>
                            Eligibility : Undergraduates, Fresher, 1 Year exp
                          </p>

                          <p>Mode: Online</p>

                          <div className="row popbtns">
                            <div className="col-lg-6 col-md-6 col-sm-6 col-12">
                              <h6>Code Explanation : Python</h6>

                              <a
                                target="_blank"
                                rel="noopener"
                                href="https://logicmojo.com/python-freshers-course"
                                className="chckbtns"
                              >
                                Check syllabus
                              </a>
                            </div>

                            <div className="col-lg-6 col-md-6 col-sm-6 col-12">
                              <h6>Course Fee : 4000/-</h6>

                              <h6>Course Fee : 49$ </h6>

                              <a
                                href="https://logicmojo.com/purchase/44"
                                className="chckbtns02"
                              >
                                Enroll now
                              </a>

                              <a
                                href="javascript:void(0);"
                                className="course_id_session chckbtns02"
                                data-course_id="44"
                              >
                                Enroll now
                              </a>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="featuresdetail d-none">
        <div className="container">
          <h1>Course Features In Details - Self Paced Course</h1>
          <h5>
            The most effective immersive learning experience with our
            self-paced course
          </h5>

          <ul className="nav nav-pills mb-3" id="pills-tab" role="tablist">
            <li className="nav-item" role="presentation">
              <a
                className="nav-link active"
                id="pills-home-tab"
                data-toggle="pill"
                href="#pills-home"
                role="tab"
                aria-controls="pills-home"
                aria-selected="true"
              >
                Interview Preparation
              </a>
            </li>
            <li className="nav-item" role="presentation">
              <a
                className="nav-link"
                id="pills-profile-tab"
                data-toggle="pill"
                href="#pills-profile"
                role="tab"
                aria-controls="pills-profile"
                aria-selected="false"
              >
                Assignments Discussion
              </a>
            </li>
            <li className="nav-item" role="presentation">
              <a
                className="nav-link"
                id="pills-Doubt-tab"
                data-toggle="pill"
                href="#pills-Doubt"
                role="tab"
                aria-controls="pills-Doubt"
                aria-selected="false"
              >
                Doubt Clearing Session
              </a>
            </li>
            <li className="nav-item" role="presentation">
              <a
                className="nav-link"
                id="pills-contact-tab"
                data-toggle="pill"
                href="#pills-contact"
                role="tab"
                aria-controls="pills-contact"
                aria-selected="false"
              >
                Job Assistance
              </a>
            </li>
            <li className="nav-item" role="presentation">
              <a
                className="nav-link"
                id="pills-Mock-tab"
                data-toggle="pill"
                href="#pills-Mock"
                role="tab"
                aria-controls="pills-Mock"
                aria-selected="false"
              >
                Mock Interview
              </a>
            </li>
          </ul>
          <div className="tab-content" id="pills-tabContent">
            <div
              className="tab-pane fade show active"
              id="pills-home"
              role="tabpanel"
              aria-labelledby="pills-home-tab"
            >
              <div className="row">
                <div className="col-lg-5 col-md-12">
                  <div className="detailleft">
                    <h2>
                      <img
                        loading="lazy"
                        src="/react/ai-assets/images//bluecheckmark.png"
                        alt=""
                      />
                      <label>
                        Finish Complete Interview Preparation 2-3 Months
                      </label>
                    </h2>
                    <ul className="detailtext">
                      <li>
                        It's not about solving every problem of every topic
                        but it's about practicing similar problems to
                        understand the tricks. Once you know the tricks then
                        any problems can be solved easily.
                      </li>
                      <li>
                        Each topic explains from a very basic to advanced
                        level by using multiple examples.{" "}
                      </li>
                      <li>
                        More focus is on Tricks,Techniques and implementation
                        than theory.Become master in Data structures,
                        Algorithms & System Design in 2-3 Months of
                        preparation.
                      </li>
                    </ul>
                    <h2>
                      <img
                        loading="lazy"
                        src="/react/ai-assets/images//bluecheckmark.png"
                        alt=""
                      />
                      <label>Become an expert in DSA & System Design</label>
                    </h2>
                    <ul className="detailtext">
                      <li>
                        Many times Working professionals or Freshers
                        candidates devalue the importance of learning data
                        structures, algorithms & system design considering it
                        as complicated. However they soon get a reality check
                        when they enter the real-world for job hunting.
                      </li>
                      <li>
                        Big Tech Giants like Amazon, Google, Microsoft or any
                        product companies always ask questions related to
                        algorithms, data structures & system design to check
                        the problem-solving & system design abilities of the
                        candidates
                      </li>
                    </ul>
                  </div>
                </div>
                <div className="col-lg-7 col-md-12">
                  <div
                    className="detailright"
                    style={{ margin: "80px 0 0 0" }}
                  >
                    {/* <ReactPlayer
                        src="https://player.vimeo.com/video/610387030?h=0ef367f77e"
                        width="100%"
                        height="400px"
                        controls={true}
                      /> */}
                    <LazyLoad height={400} offsetVertical={300}>
                      <div>
                        <ReactPlayer
                          src="https://player.vimeo.com/video/868175222?h=0ef367f77e"
                          width="100%"
                          height="400px"
                          controls={true}
                        />
                      </div>
                    </LazyLoad>
                  </div>
                </div>
              </div>
            </div>
            <div
              className="tab-pane fade"
              id="pills-profile"
              role="tabpanel"
              aria-labelledby="pills-profile-tab"
            >
              <div className="row">
                <div className="col-lg-5 col-md-12">
                  <div className="detailleft">
                    <h2>
                      <img
                        loading="lazy"
                        src="/react/ai-assets/images//bluecheckmark.png"
                        alt=""
                      />
                      <label>Flexible Preparation Course</label>
                    </h2>
                    <ul className="detailtext">
                      <li>
                        No Strict Timing or Sharp Deadlines to Complete the
                        course.
                      </li>
                      <li>
                        Consistent 2 hours of everyday regular preparation is
                        the key to Solid Foundation.
                      </li>
                      <li>
                        Most of the working professionals have working office
                        hours, as well as freshers students, have Academic
                        schedules. So, You can prepare this course according
                        to Schedule & Pace.
                      </li>
                      <li>
                        Ask your doubts any time with experts. Use Lectures
                        for understanding the concepts and assignments for
                        practice.
                      </li>
                    </ul>
                    <h2>
                      <img
                        loading="lazy"
                        src="/react/ai-assets/images//bluecheckmark.png"
                        alt=""
                      />
                      <label>Lectures & Assignments</label>
                    </h2>
                    <ul className="detailtext">
                      <li>
                        We have assignments with every lecture on every topic.
                      </li>
                      <li>
                        After understanding lectures give it a shot to
                        assignments that are based on similar concepts of
                        lectures.{" "}
                      </li>
                      <li>
                        Even if you can't able to crack assignments by
                        yourself, we have all assignments in detail discussion
                        with code explanation.
                      </li>
                      <li>
                        In this course, we teach all techniques of solving
                        algorithms with the help of (Lectures + Assignments)
                        combo.
                      </li>
                    </ul>
                  </div>
                </div>
                <div className="col-lg-7 col-md-12">
                  <div
                    className="detailright"
                    style={{ margin: "80px 0 0 0" }}
                  >
                    {/* <ReactPlayer
                        src="https://player.vimeo.com/video/610388947?h=2b749e6eca"
                        width="100%"
                        height="400px"
                        controls={true}
                      /> */}
                    <LazyLoad height={400} offsetVertical={300}>
                      <div>
                        <ReactPlayer
                          src="https://player.vimeo.com/video/868175222?h=2b749e6eca"
                          width="100%"
                          height="400px"
                          controls={true}
                        />
                      </div>
                    </LazyLoad>
                  </div>
                </div>
              </div>
            </div>

            <div
              className="tab-pane fade"
              id="pills-Doubt"
              role="tabpanel"
              aria-labelledby="pills-Doubt-tab"
            >
              <div className="row">
                <div className="col-lg-5 col-md-12">
                  <div className="detailleft">
                    <h2>
                      <img
                        loading="lazy"
                        src="/react/ai-assets/images//bluecheckmark.png"
                        alt=""
                      />
                      <label>Doubt clearing program</label>
                    </h2>
                    <ul className="detailtext">
                      <li>Ask your doubts anytime.</li>
                      <li>
                        No need to wait for a specific time to clarify your
                        doubts.{" "}
                      </li>
                      <li>Dedicated mentor is assigned to you</li>
                      <li>
                        Doubt clearing program is executed by experts having
                        of 10+ years industry experience .
                      </li>
                      <li>
                        Every lecture & assignment has doubts clearing option
                        where users can ask their doubts related to that
                        lecture.{" "}
                      </li>
                      <li>
                        Also, Subscribers can include code,voice screen record
                        or screenshot. All queries will be answered by our
                        experts.
                      </li>
                    </ul>
                  </div>
                </div>
                <div className="col-lg-7 col-md-12">
                  <div
                    className="detailright"
                    style={{ margin: "80px 0 0 0" }}
                  >
                    {/* <ReactPlayer
                        src="https://player.vimeo.com/video/610389810?h=2b749e6eca"
                        width="100%"
                        height="400px"
                        controls={true}
                      /> */}
                    <LazyLoad height={400} offsetVertical={300}>
                      <div>
                        <ReactPlayer
                          src="https://player.vimeo.com/video/868175222?h=2b749e6eca"
                          width="100%"
                          height="400px"
                          controls={true}
                        />
                      </div>
                    </LazyLoad>
                  </div>
                </div>
              </div>
            </div>

            <div
              className="tab-pane fade"
              id="pills-contact"
              role="tabpanel"
              aria-labelledby="pills-contact-tab"
            >
              <div className="row">
                <div className="col-lg-5 col-md-12">
                  <div className="detailleft">
                    <h2>
                      <img
                        loading="lazy"
                        src="/react/ai-assets/images//bluecheckmark.png"
                        alt=""
                      />
                      <label>Get Interview Calls from Top Tech </label>
                    </h2>
                    <ul className="detailtext">
                      <li>
                        Weekly coding test is the gateway for top tech
                        companies interviews.{" "}
                      </li>
                      <li>
                        You can perform these tests any time during your
                        preparation.
                      </li>
                      <li>
                        All performers are eligible for our Job referral
                        program in top tech companies
                      </li>
                      <li>
                        We refer candidates resume and schdule interviews
                        through our partnered consultancies and contacts in
                        Top Product Based software companies.
                      </li>
                    </ul>
                    <h2>
                      <img
                        loading="lazy"
                        src="/react/ai-assets/images//bluecheckmark.png"
                        alt=""
                      />
                      <label>Learn Coding with Practice </label>
                    </h2>
                    <ul className="detailtext">
                      <li>
                        For every lecture, we provide a complete code solution
                        in your favourite editor in Java, Python & C++.{" "}
                      </li>
                      <li>
                        For assignments you can also Practice code in editor.
                      </li>
                    </ul>
                  </div>
                </div>
                <div className="col-lg-7 col-md-12">
                  <div className="detailright">
                    <img
                      loading="lazy"
                      src="/react/ai-assets/images//jobassimg.jpg"
                      alt=""
                    />
                  </div>
                </div>
              </div>
            </div>
            <div
              className="tab-pane fade"
              id="pills-Mock"
              role="tabpanel"
              aria-labelledby="pills-Doubt-Mock"
            >
              <div className="row">
                <div className="col-lg-5 col-md-12">
                  <div className="detailleft">
                    <h2>
                      <img
                        loading="lazy"
                        src="/react/ai-assets/images//bluecheckmark.png"
                        alt=""
                      />
                      <label>Online Weekly Competitive Coding Test</label>
                    </h2>
                    <ul className="detailtext">
                      <li>
                        It is also very important to test subscribers progress
                        while preparing for the course. We have online coding
                        tests for specific topics every week in Data Structure
                        & Algorithms.
                      </li>
                      <li>
                        We keep track of your progress during the course
                        preparation program.{" "}
                      </li>
                      <li>
                        These Online tests for every topic will brush up
                        coding skills.
                      </li>
                    </ul>
                    <h2>
                      <img
                        loading="lazy"
                        src="/react/ai-assets/images//bluecheckmark.png"
                        alt=""
                      />
                      <label>Mock Interview</label>
                    </h2>
                    <ul className="detailtext">
                      <li>
                        Before appearing for an actual interview, It is
                        important to have multiple rounds of mock interviews.{" "}
                      </li>
                      <li>
                        All the performant subscribers will be eligible for
                        Mock interviews as well as Job referral program.
                      </li>
                    </ul>
                    <p>
                      <b>
                        Analyzing every code of all lectures & assignments
                        with step by step execution with diagrams and
                        pointers. You can analyse by yourself every code line
                        by line
                      </b>
                    </p>
                  </div>
                </div>
                <div className="col-lg-7 col-md-12">
                  <div
                    className="detailright"
                    style={{ margin: "80px 0 0 0" }}
                  >
                    {/* <ReactPlayer
                        src="https://player.vimeo.com/video/610389468?h=ab6b428720"
                        width="100%"
                        height="400px"
                        controls={true}
                      /> */}
                    <LazyLoad height={400} offsetVertical={300}>
                      <div>
                        <ReactPlayer
                          src="https://player.vimeo.com/video/610389468?h=ab6b428720"
                          width="100%"
                          height="400px"
                          controls={true}
                        />
                      </div>
                    </LazyLoad>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* <div className="first_step_main">
          <div
            className="webbg"
            style={{
              width: "100%!important",
              float: "left!important",
              background: "#0d4a9b!important",
              padding: "0!important",
              minheight: "550px!important",
            }}
          >
            <div className="container">
              <div className="webinfodiv webinar_text">
                <div className="webimag">
                  <img loading="lazy" src="/react/ai-assets/images//web1.png" alt="" />
                </div>

                <h1 className="">
                  <b>Attend Live Classes on </b> Advanced Data structures,
                  Algorithms, Problem Solving & System Design (HLD+LLD)
                </h1>

                <div style={{ width: "280px", margin: "50px auto" }}>
                  <a
                    target="_blank"
                    href="https://calendly.com/logicmojo/schedule-call-back-from-experts-for-live-classes?month=2026-06"
                    className="booktrialbtn1"
                  >
                    Apply For Live Classes
                    <i
                      className="fa fa-angle-right arrowclass"
                      aria-hidden="true"
                    ></i>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div> */}

      <div className="mobiletabingshow d-none">
        <div className="container">
          <div className="faqmobile">
            <div className="accordion" id="accordionExample">
              <div className="card">
                <div className="card-header" id="heading001">
                  <h2 className="mb-0">
                    <button
                      type="button"
                      className="btn btn-link collapsed"
                      data-toggle="collapse"
                      data-target="#collapse001"
                    >
                      <i className="fa fa-angle-down"></i> Interview
                      Preparation
                    </button>
                  </h2>
                </div>
                <div
                  id="collapse001"
                  className="collapse"
                  aria-labelledby="heading001"
                  data-parent="#accordionExample"
                >
                  <div className="card-body">
                    <div className="faqcontent">
                      <div className="row">
                        <div className="col-lg-5 col-md-12">
                          <div className="detailleft">
                            <h2>
                              <img
                                loading="lazy"
                                src="/react/ai-assets/images//bluecheckmark.png"
                                alt=""
                              />
                              <label>
                                Finish Complete Interview Preparationin 2-3
                                Months
                              </label>
                            </h2>
                            <ul className="detailtext">
                              <li>
                                This course will make your interview
                                preparation process very easy.
                              </li>
                              <li>
                                It's not about solving every problem of every
                                topic but it's about practicing similar
                                problems to understand the tricks. Once you
                                know the tricks then any problems can be
                                solved easily.
                              </li>
                              <li>
                                We have 260+ Lectures of All topics of data
                                structure , Algorithms & System Design.
                              </li>
                              <li>
                                Each topic explains from a very basic to
                                advanced level by using multiple examples.{" "}
                              </li>
                              <li>
                                More focus is on Tricks,Techniques and
                                implementation than theory.Become master in
                                Data structures, Algorithms & System Design in
                                2-3 Months of preparation.
                              </li>
                            </ul>
                            <h2>
                              <img
                                loading="lazy"
                                src="/react/ai-assets/images//bluecheckmark.png"
                                alt=""
                              />
                              <label>
                                Become expert in DSA & System Design
                              </label>
                            </h2>
                            <ul className="detailtext">
                              <li>
                                Many times Working professionals or Freshers
                                candidates devalue the importance of learning
                                data structures, algorithms & system design
                                considering it as complicated. However they
                                soon get a reality check when they enter the
                                real-world for job hunting.
                              </li>
                              <li>
                                Big Tech Giants like Amazon, Google, Microsoft
                                or any product companies always ask questions
                                related to algorithms, data structures &
                                system design to check the problem-solving &
                                system design abilities of the candidates
                              </li>
                            </ul>
                          </div>
                        </div>
                        <div className="col-lg-7 col-md-12">
                          <div className="detailright">
                            <span>
                              <button
                                type="button"
                                className="btn btn-primary firsttab"
                                data-toggle="modal"
                                data-target="#myvid1"
                              >
                                <img
                                  loading="lazy"
                                  src="/react/ai-assets/images//youtube_icon.png"
                                  alt=""
                                />
                              </button>
                            </span>
                            <img
                              loading="lazy"
                              src="/react/ai-assets/images//vidoimg.png"
                              alt=""
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="card">
                <div className="card-header" id="heading002">
                  <h2 className="mb-0">
                    <button
                      type="button"
                      className="btn btn-link"
                      data-toggle="collapse"
                      data-target="#collapse002"
                    >
                      <i className="fa fa-angle-down favicons"></i>{" "}
                      Assignments Discussion
                    </button>
                  </h2>
                </div>
                <div
                  id="collapse002"
                  className="collapse"
                  aria-labelledby="heading002"
                  data-parent="#accordionExample"
                >
                  <div className="card-body">
                    <div className="faqcontent">
                      <div className="row">
                        <div className="col-lg-5 col-md-12">
                          <div className="detailleft">
                            <h2>
                              <img
                                loading="lazy"
                                src="/react/ai-assets/images//bluecheckmark.png"
                                alt=""
                              />
                              <label>Flexible Preparation Course</label>
                            </h2>
                            <ul className="detailtext">
                              <li>
                                No Strict Timing or Sharp Deadlines to
                                Complete the course.
                              </li>
                              <li>
                                Consistent 2 hours of everyday regular
                                preparation is the key to Solid Foundation.
                              </li>
                              <li>
                                Most of the working professionals have working
                                office hours, as well as freshers students,
                                have Academic schedules. So, You can prepare
                                this course according to Schedule & Pace.
                              </li>
                              <li>
                                Ask your doubts any time with experts. Use
                                Lectures for understanding the concepts and
                                assignments for practice.
                              </li>
                            </ul>
                            <h2>
                              <img
                                loading="lazy"
                                src="/react/ai-assets/images//bluecheckmark.png"
                                alt=""
                              />
                              <label>Lectures & Assignments</label>
                            </h2>
                            <ul className="detailtext">
                              <li>
                                We have assignments with every lecture on
                                every topic.
                              </li>
                              <li>
                                After understanding lectures give it a shot to
                                assignments that are based on similar concepts
                                of lectures.{" "}
                              </li>
                              <li>
                                Even if you can't able to crack assignments by
                                yourself, we have all assignments in detail
                                discussion with code explanation.
                              </li>
                              <li>
                                In this course, we teach all techniques of
                                solving algorithms with the help of (Lectures
                                + Assignments) combo.
                              </li>
                            </ul>
                          </div>
                        </div>
                        <div className="col-lg-7 col-md-12">
                          <div className="detailright">
                            <span>
                              <button
                                type="button"
                                className="btn btn-primary"
                                data-toggle="modal"
                                data-target="#myvid4"
                              >
                                <img
                                  loading="lazy"
                                  src="/react/ai-assets/images//youtube_icon.png"
                                  alt=""
                                />
                              </button>
                            </span>
                            <img
                              loading="lazy"
                              src="/react/ai-assets/images//vidoimg.png"
                              alt=""
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="card">
                <div className="card-header" id="heading003">
                  <h2 className="mb-0">
                    <button
                      type="button"
                      className="btn btn-link collapsed"
                      data-toggle="collapse"
                      data-target="#collapse003"
                    >
                      <i className="fa fa-angle-down"></i> Doubt Clearing
                      Session
                    </button>
                  </h2>
                </div>
                <div
                  id="collapse003"
                  className="collapse"
                  aria-labelledby="heading003"
                  data-parent="#accordionExample"
                >
                  <div className="card-body">
                    <div className="faqcontent">
                      <div className="row">
                        <div className="col-lg-5 col-md-12">
                          <div className="detailleft">
                            <h2>
                              <img
                                loading="lazy"
                                src="/react/ai-assets/images//bluecheckmark.png"
                                alt=""
                              />
                              <label>Doubt clearing program</label>
                            </h2>
                            <ul className="detailtext">
                              <li>Get your doubts resolved anytime.</li>
                              <li>
                                No need to wait for specific time for clarify
                                your doubts.{" "}
                              </li>
                              <li>Dedicated mentor is assigned to you</li>
                              <li>
                                Doubt clearing program is executed by experts
                                having 10+ years industry experince .
                              </li>
                              <li>
                                Every lectures & assignments has doubts
                                clearing option where user can ask there
                                doubts related to that lecture.{" "}
                              </li>
                              <li>
                                Also, Subscribers can include code,voice
                                screen record or screenshot. All queries will
                                answered by our experts.
                              </li>
                            </ul>
                          </div>
                        </div>
                        <div className="col-lg-7 col-md-12">
                          <div className="detailright">
                            <img
                              loading="lazy"
                              src="/react/ai-assets/images//doubtclearing.gif"
                              alt=""
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="card">
                <div className="card-header" id="heading004">
                  <h2 className="mb-0">
                    <button
                      type="button"
                      className="btn btn-link collapsed"
                      data-toggle="collapse"
                      data-target="#collapse004"
                    >
                      <i className="fa fa-angle-down"></i>Job Assistance
                    </button>
                  </h2>
                </div>
                <div
                  id="collapse004"
                  className="collapse"
                  aria-labelledby="heading004"
                  data-parent="#accordionExample"
                >
                  <div className="card-body">
                    <div className="faqcontent">
                      <div className="row">
                        <div className="col-lg-5 col-md-12">
                          <div className="detailleft">
                            <h2>
                              <img
                                loading="lazy"
                                src="/react/ai-assets/images//bluecheckmark.png"
                                alt=""
                              />
                              <label>
                                Get Interview Calls from Top Tech{" "}
                              </label>
                            </h2>
                            <ul className="detailtext">
                              <li>
                                Weekly coding test is the gateway for top tech
                                companies interviews.{" "}
                              </li>
                              <li>
                                You can perform these tests any time during
                                your preparation.
                              </li>
                              <li>
                                All performers are eligible for our Job
                                referral program in top tech companies
                              </li>
                              <li>
                                We refer candidates resume and schdule
                                interviews through our partnered consultancies
                                and contacts in Top Product Based software
                                companies.
                              </li>
                            </ul>
                            <h2>
                              <img
                                loading="lazy"
                                src="/react/ai-assets/images//bluecheckmark.png"
                                alt=""
                              />
                              <label>Learn Coding with Practice </label>
                            </h2>
                            <ul className="detailtext">
                              <li>
                                For every lecture, we provide a complete code
                                solution in your favourite editor in Java,
                                Python & C++.{" "}
                              </li>
                              <li>
                                For assignments you can also Practice code in
                                editor.
                              </li>
                            </ul>
                          </div>
                        </div>
                        <div className="col-lg-7 col-md-12">
                          <div className="detailright">
                            <img
                              loading="lazy"
                              src="/react/ai-assets/images//jobassimg.jpg"
                              alt=""
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="card">
                <div className="card-header" id="heading005">
                  <h2 className="mb-0">
                    <button
                      type="button"
                      className="btn btn-link collapsed"
                      data-toggle="collapse"
                      data-target="#collapse005"
                    >
                      <i className="fa fa-angle-down"></i> Mock Interview
                    </button>
                  </h2>
                </div>
                <div
                  id="collapse005"
                  className="collapse"
                  aria-labelledby="heading005"
                  data-parent="#accordionExample"
                >
                  <div className="card-body">
                    <div className="faqcontent">
                      <div className="row">
                        <div className="col-lg-5 col-md-12">
                          <div className="detailleft">
                            <h2>
                              <img
                                loading="lazy"
                                src="/react/ai-assets/images//bluecheckmark.png"
                                alt=""
                              />
                              <label>
                                Online Weekly Competitive Coding Test
                              </label>
                            </h2>
                            <ul className="detailtext">
                              <li>
                                It is also very important to test subscribers
                                progress while preparing for the course. We
                                have online coding tests for specific topics
                                every week in Data Structure & Algorithms.
                              </li>
                              <li>
                                We keep track of your progress during the
                                course preparation program.{" "}
                              </li>
                              <li>
                                These Online tests for every topic will brush
                                up coding skills.
                              </li>
                            </ul>
                            <h2>
                              <img
                                loading="lazy"
                                src="/react/ai-assets/images//bluecheckmark.png"
                                alt=""
                              />
                              <label>Mock Interview</label>
                            </h2>
                            <ul className="detailtext">
                              <li>
                                Before appearing for an actual interview, It
                                is important to have multiple rounds of mock
                                interviews.{" "}
                              </li>
                              <li>
                                All the performant subscribers will be
                                eligible for Mock interviews as well as Job
                                referral program.
                              </li>
                            </ul>
                          </div>
                        </div>
                        <div className="col-lg-7 col-md-12">
                          <div
                            className="detailright"
                            style={{ margin: "20px 0 0 0" }}
                          >
                            {/* <video
                                width="100%"
                                height="450"
                                autoPlay=""
                                loop=""
                                muted=""
                                playsInline=""
                              >
                                <source
                                  src="/react/ai-assets/images//animationCount3.webm"
                                  type="video/webm"
                                />
                                <source
                                  src="/react/ai-assets/images//animationCount3.mp4"
                                  type="video/mp4"
                                />
                              </video> */}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* <div className="viewletstrip d-none" id="SampleLecture">
          <div className="container">
            <h1>View Sample Lectures - Self Paced Course</h1>

            <div className="letvideoshow">
              <div className="row">
                <div className="col-lg-4 col-md-4">
                  <div className="letvdiv">
                    <div className="leavdos">
                      <iframe
                        src="https://player.vimeo.com/video/634479536?title=0&byline=0&portrait=0"
                        width="100%"
                        height="230"
                        frameBorder="0"
                        allow="autoplay; fullscreen; picture-in-picture"
                        allowFullScreen
                      ></iframe>
                    </div>

                    <h3>
                      Searching Algorithm <br /> in an Array
                    </h3>

                    <span className="codejava">
                      Code In:
                      <a
                        target="_blank"
                        rel="noopener"
                        href="https://logicmojo.com/home-problem/1/1/1"
                        className="javabtns"
                      >
                        JAVA
                      </a>
                    </span>

                    <span className="codeassign">
                      <a
                        className="assignbtns"
                        style={{
                          margin: "0",
                          display: "inline-block",
                          float: "right",
                        }}
                        href="javascript:void(0);"
                        onClick="openAssModal('myCModal1','6a55b67c981a4ebe9553fce88f308173');"
                      >
                        Assignment
                      </a>
                    </span>
                  </div>
                </div>

                <div className="col-lg-4 col-md-4">
                  <div className="letvdiv">
                    <div className="leavdos">
                      <iframe
                        src="https://player.vimeo.com/video/688826925"
                        width="100%"
                        height="230"
                        frameBorder="0"
                        allow="autoplay; fullscreen; picture-in-picture"
                        allowFullScreen
                      ></iframe>
                    </div>

                    <h3>
                      Design Airline <br />
                      Reservation System{" "}
                    </h3>

                    <span className="codeassign">
                      <a
                        className="assignbtns"
                        style={{
                          margin: "0",
                          display: "inline-block",
                          float: "right",
                        }}
                        href="javascript:void(0);"
                        onClick="openAssModal('myCModal2','0ad8f8d1279f4b90ae700f4c71bd9f6d');"
                      >
                        Assignment
                      </a>
                    </span>
                  </div>
                </div>

                <div className="col-lg-4 col-md-4">
                  <div className="letvdiv">
                    <div className="leavdos">
                      <iframe
                        src="https://player.vimeo.com/video/634401870?title=0&byline=0&portrait=0"
                        width="100%"
                        height="230"
                        frameBorder="0"
                        allow="autoplay; fullscreen; picture-in-picture"
                        allowFullScreen
                      ></iframe>
                    </div>

                    <h3>
                      Maximum Value in an array of Increasing <br /> and
                      Decreasing using Binary Search
                    </h3>

                    <span className="codejava">
                      Code In:
                      <a
                        target="_blank"
                        rel="noopener"
                        href="https://logicmojo.com/home-problem/3/1/2"
                        className="javabtns"
                      >
                        Python
                      </a>
                    </span>

                    <span className="codeassign">
                      <a
                        className="assignbtns"
                        style={{
                          margin: "0",
                          display: "inline-block",
                          float: "right",
                        }}
                        href="javascript:void(0);"
                        onClick="openAssModal('myCModal3','3ebd4e62c29c4019bd6c2976ae70d06b');"
                      >
                        Assignment
                      </a>
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div> */}

      <div className="gethired-stepsbg">
        <div className="container">
          <ul
            className="nav nav-pills mb-3 d-none"
            id="pills-tab"
            role="tablist"
          >
            <li className="nav-item" role="presentation">
              <a
                className="nav-link active"
                id="pills-home-tab02"
                data-toggle="pill"
                href="#tab0001"
                role="tab"
                aria-controls="pills-home"
                aria-selected="true"
              >
                Live Classes
              </a>
            </li>

            <li className="nav-item" role="presentation">
              <a
                className="nav-link"
                id="pills-profile-tab02"
                data-toggle="pill"
                href="#tab0002"
                role="tab"
                aria-controls="pills-profile"
                aria-selected="false"
              >
                Self Paced Courses
              </a>
            </li>
          </ul>

          <div className="tab-content" id="pills-tabContent">
            <div
              className="tab-pane fade active show"
              id="tab0001"
              role="tabpanel"
              aria-labelledby="tab0001"
            >
              <div className="liveprogram-innerbg">
                <h1>
                  <span
                    style={{
                      width: "100%",
                      textalign: "center",
                      float: "left",
                      margin: "-70px 0px 0px 0px",
                    }}
                  >
                    Job Focused Live interactive{" "}
                    <span style={{ color: "red" }}>
                      {" "}
                      sessions to help realize{" "}
                    </span>{" "}
                    your dreams
                  </span>
                </h1>
              </div>
              <h3>Learn and get hired in simple steps - Live Classes</h3>

              <div className="stepsrowbg">
                <ul>
                  <li>
                    <div className="stepsrowbg-icon">
                      <span>
                        <img
                          loading="lazy"
                          src="/react/ai-assets/images//stepsicon1.png"
                          className="stepsnormal"
                          alt=""
                        />{" "}
                        <img
                          loading="lazy"
                          src="/react/ai-assets/images//stepsicon1-hover.png"
                          className="stepshover"
                          alt=""
                        />
                      </span>
                    </div>

                    <div className="stepsrowbg-text">
                      <h4>Acquire Expertise</h4>

                      <p>
                        Learn Data Structures, Algorithms & problem-solving
                        techniques from industry veterans in a Live session
                        and enjoy an immersive learning experience.{" "}
                      </p>
                      <br />
                    </div>
                  </li>

                  <li>
                    <div className="stepsrowbg-icon">
                      <span>
                        <img
                          loading="lazy"
                          src="/react/ai-assets/images//stepsicon2.png"
                          className="stepsnormal"
                          alt=""
                        />{" "}
                        <img
                          loading="lazy"
                          src="/react/ai-assets/images//stepsicon2-hover.png"
                          className="stepshover"
                          alt=""
                        />
                      </span>
                    </div>

                    <div className="stepsrowbg-text">
                      <h4>Missed your classes</h4>

                      <p>
                        If you miss any classes, No problem. Just after every
                        class, you will get video access to all classes for
                        lifetime access.
                      </p>
                    </div>
                  </li>

                  <li>
                    <div className="stepsrowbg-icon">
                      <span>
                        <img
                          loading="lazy"
                          src="/react/ai-assets/images//stepsicon3.png"
                          className="stepsnormal"
                          alt=""
                        />{" "}
                        <img
                          loading="lazy"
                          src="/react/ai-assets/images//stepsicon3-hover.png"
                          className="stepshover"
                          alt=""
                        />
                      </span>
                    </div>

                    <div className="stepsrowbg-text">
                      <h4>1:1 doubt clearing sessions</h4>

                      <p>
                        Attend the Live 1:1 doubt clearing sessions/mentorship
                        sessions. <br />
                        In case you missed asking doubts in classes, attend
                        separate 1:1 doubts solving classes{" "}
                      </p>
                    </div>
                  </li>

                  <li>
                    <div className="stepsrowbg-icon">
                      <span>
                        <img
                          loading="lazy"
                          src="/react/ai-assets/images//stepsicon4.png"
                          className="stepsnormal"
                          alt=""
                        />{" "}
                        <img
                          loading="lazy"
                          src="/react/ai-assets/images//stepsicon4-hover.png"
                          className="stepshover"
                          alt=""
                        />
                      </span>
                    </div>

                    <div className="stepsrowbg-text">
                      <h4>Assignments for practice</h4>

                      <p>
                        Learn AI &amp; ML by practice. Get assignments from the
                        mentor for self attempt
                      </p>
                    </div>
                  </li>
                </ul>
              </div>

              <div className="stepsbgimg">
                <img
                  loading="lazy"
                  src="/react/ai-assets/images//liveclassesimg.png"
                  alt=""
                />
              </div>

              <div className="stepsrowbg">
                <ul>
                  <li>
                    <div className="stepsrowbg-icon">
                      <span>
                        <img
                          loading="lazy"
                          src="/react/ai-assets/images//stepsicon5.png"
                          className="stepsnormal"
                          alt=""
                        />{" "}
                        <img
                          loading="lazy"
                          src="/react/ai-assets/images//stepsicon5-hover.png"
                          className="stepshover"
                          alt=""
                        />
                      </span>
                    </div>

                    <div className="stepsrowbg-text">
                      <h4>Flexible batches</h4>

                      <p>
                        Attend multiple batches with multiple trainers. If you
                        missed any session or topics, attend any batches as
                        per your flexibility. Even after course completion,
                        you can repeat any classes for 1 year.
                      </p>
                    </div>
                  </li>

                  <li>
                    <div className="stepsrowbg-icon">
                      <span>
                        <img
                          loading="lazy"
                          src="/react/ai-assets/images//stepsicon6.png"
                          className="stepsnormal"
                          alt=""
                        />{" "}
                        <img
                          loading="lazy"
                          src="/react/ai-assets/images//stepsicon6-hover.png"
                          className="stepshover"
                          alt=""
                        />
                      </span>
                    </div>

                    <br />
                    <div className="stepsrowbg-text">
                      <h4>Job assistance program </h4>

                      <p>
                        Be attentive with regular classes & solve all
                        assignments. After completion of the course, you will
                        be eligible for the job referrals program
                      </p>
                    </div>
                  </li>

                  <li>
                    <div className="stepsrowbg-icon">
                      <span>
                        <img
                          loading="lazy"
                          src="/react/ai-assets/images//stepsicon7.png"
                          className="stepsnormal"
                          alt=""
                        />{" "}
                        <img
                          loading="lazy"
                          src="/react/ai-assets/images//stepsicon7-hover.png"
                          className="stepshover"
                          alt=""
                        />
                      </span>
                    </div>

                    <div className="stepsrowbg-text">
                      <br />
                      <h4>Mock Interview sessions</h4>

                      <p>
                        Be attentive with regular classes & solve all
                        assignments. After completion of the course, you will
                        be eligible for the mock interview session
                      </p>
                    </div>
                  </li>

                  <li>
                    <div className="stepsrowbg-icon">
                      <span>
                        <img
                          loading="lazy"
                          src="/react/ai-assets/images//stepsicon8.png"
                          className="stepsnormal"
                          alt=""
                        />{" "}
                        <img
                          loading="lazy"
                          src="/react/ai-assets/images//stepsicon8-hover.png"
                          className="stepshover"
                          alt=""
                        />
                      </span>
                    </div>

                    <div className="stepsrowbg-text">
                      <br />
                      <h4>Peer to Peer Learning</h4>

                      <p>
                        Slack group for peer-to-peer learning & discussion
                        with batchmates. Hackerrank for 1:1 tests & GitHub for
                        Code review
                      </p>
                    </div>
                  </li>
                </ul>
              </div>
            </div>

            <div
              className="tab-pane fade"
              id="tab0002"
              role="tabpanel"
              aria-labelledby="tab0002"
            >
              <h3 className="mt-5">
                Job Focused Programs to help realize your dreams
              </h3>

              <h3>Learn and get hired in simple steps - Self Paced Course</h3>

              <div className="stepsrowbg">
                <ul>
                  <li>
                    <div className="stepsrowbg-icon">
                      <span>
                        <img
                          loading="lazy"
                          src="/react/ai-assets/images//stepsicon1.png"
                          className="stepsnormal"
                          alt=""
                        />{" "}
                        <img
                          loading="lazy"
                          src="/react/ai-assets/images//stepsicon1-hover.png"
                          className="stepshover"
                          alt=""
                        />
                      </span>
                    </div>

                    <div className="stepsrowbg-text">
                      <h4>Acquire Expertise</h4>

                      <p>
                        self-paced course to learn Data Structures, algorithms
                        & system design from industry veterans and enjoy an
                        immersive learning experience.{" "}
                      </p>
                    </div>
                  </li>

                  <li>
                    <div className="stepsrowbg-icon">
                      <span>
                        <img
                          loading="lazy"
                          src="/react/ai-assets/images//stepsicon2.png"
                          className="stepsnormal"
                          alt=""
                        />{" "}
                        <img
                          loading="lazy"
                          src="/react/ai-assets/images//stepsicon2-hover.png"
                          className="stepshover"
                          alt=""
                        />
                      </span>
                    </div>

                    <div className="stepsrowbg-text">
                      <h4>Revise concepts with Assignments</h4>

                      <p>
                        Practice assignments in an editor, Can't solve it? All
                        assignments also have detailed explanations.
                      </p>
                    </div>
                  </li>

                  <li>
                    <div className="stepsrowbg-icon">
                      <span>
                        <img
                          loading="lazy"
                          src="/react/ai-assets/images//stepsicon3.png"
                          className="stepsnormal"
                          alt=""
                        />{" "}
                        <img
                          loading="lazy"
                          src="/react/ai-assets/images//stepsicon3-hover.png"
                          className="stepshover"
                          alt=""
                        />
                      </span>
                    </div>

                    <div className="stepsrowbg-text">
                      <h4>Ask your Doubts Anytime</h4>

                      <p>
                        Getting Stuck While Coding? Get all your doubts
                        resolved. <br />
                        Ask any queries in any lectures as well as assignments
                        from experts{" "}
                      </p>
                    </div>
                  </li>
                </ul>
              </div>

              <div className="stepsbgimg">
                <img
                  loading="lazy"
                  src="/react/ai-assets/images//stepsimg.png"
                  alt=""
                />
              </div>

              <div className="stepsrowbg">
                <ul>
                  <li>
                    <div className="stepsrowbg-icon">
                      <span>
                        <img
                          loading="lazy"
                          src="/react/ai-assets/images//stepsicon5.png"
                          className="stepsnormal"
                          alt=""
                        />{" "}
                        <img
                          loading="lazy"
                          src="/react/ai-assets/images//stepsicon5-hover.png"
                          className="stepshover"
                          alt=""
                        />
                      </span>
                    </div>

                    <div className="stepsrowbg-text">
                      <h4>Online weekly coding env</h4>

                      <p>
                        Check your progress & feel the competitive environment
                        every week with an online coding test.
                      </p>
                    </div>
                  </li>

                  <li>
                    <div className="stepsrowbg-icon">
                      <span>
                        <img
                          loading="lazy"
                          src="/react/ai-assets/images//stepsicon6.png"
                          className="stepsnormal"
                          alt=""
                        />{" "}
                        <img
                          loading="lazy"
                          src="/react/ai-assets/images//stepsicon6-hover.png"
                          className="stepshover"
                          alt=""
                        />
                      </span>
                    </div>

                    <div className="stepsrowbg-text">
                      <h4>Job assistance </h4>

                      <p>
                        Get ready for the final battle? All consistent
                        performers in the weekly test will get referrals in
                        tech company's interviews.
                      </p>
                    </div>
                  </li>

                  <li>
                    <div className="stepsrowbg-icon">
                      <span>
                        <img
                          loading="lazy"
                          src="/react/ai-assets/images//stepsicon7.png"
                          className="stepsnormal"
                          alt=""
                        />{" "}
                        <img
                          loading="lazy"
                          src="/react/ai-assets/images//stepsicon7-hover.png"
                          className="stepshover"
                          alt=""
                        />
                      </span>
                    </div>

                    <div className="stepsrowbg-text">
                      <h4>Code Execution environment</h4>

                      <p>
                        We have integrated an online code execution
                        environment editor for practicing all lectures &
                        assignments with test cases & solution{" "}
                      </p>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
          </div>

          <div className="tab-content">
            <div style={{ width: "250px", margin: "0 auto" }}>
              <a
                target="_default"
                href="https://calendly.com/logicmojo/schedule-call-back-from-experts-for-live-classes?month=2026-06"
                className="booktrialbtn1"
              //data-toggle="modal"
              //data-target="#counsellingpopup"
              >
                Apply For Live Classes
                <i
                  className="fa fa-angle-right arrowclass"
                  aria-hidden="true"
                ></i>
              </a>
            </div>
          </div>
        </div>
      </div>


      {/* <div className="viewletstrip d-none" id="SampleLecture">
        <div className="container">
          <h1>View Sample Lectures</h1>

          <div className="letvideoshow">
            <div className="row">
              <div className="col-lg-4 col-md-4">
                <div className="letvdiv">
                  <div className="leavdos">
                    <iframe
                      src="https://player.vimeo.com/video/634479536?title=0&byline=0&portrait=0"
                      width="100%"
                      height="230"
                      frameBorder="0"
                      allow="autoplay; fullscreen; picture-in-picture"
                      allowFullScreen
                    ></iframe>
                  </div>

                  <h3>
                    Searching Algorithm <br /> in an Array
                  </h3>

                  <span className="codejava">
                    Code In:
                    <a
                      target="_blank"
                      rel="noopener"
                      href="https://logicmojo.com/home-problem/1/1/1"
                      className="javabtns"
                    >
                      JAVA
                    </a>
                  </span>

                  <span className="codeassign">
                    <a
                      className="assignbtns"
                      style={{
                        margin: "0",
                        display: "inline-block",
                        float: "right",
                      }}
                      href="javascript:void(0);"
                      onClick="openAssModal('myCModal1','6a55b67c981a4ebe9553fce88f308173');"
                    >
                      Assignment
                    </a>
                  </span>
                </div>
              </div>

              <div className="col-lg-4 col-md-4">
                <div className="letvdiv">
                  <div className="leavdos">
                    <iframe
                      src="https://player.vimeo.com/video/688826925"
                      width="100%"
                      height="230"
                      frameBorder="0"
                      allow="autoplay; fullscreen; picture-in-picture"
                      allowFullScreen
                    ></iframe>
                  </div>

                  <h3>
                    Design Airline <br />
                    Reservation System{" "}
                  </h3>

                  <span className="codeassign">
                    <a
                      className="assignbtns"
                      style={{
                        margin: "0",
                        display: "inline-block",
                        float: "right",
                      }}
                      href="javascript:void(0);"
                      onClick="openAssModal('myCModal2','0ad8f8d1279f4b90ae700f4c71bd9f6d');"
                    >
                      Assignment
                    </a>
                  </span>
                </div>
              </div>

              <div className="col-lg-4 col-md-4">
                <div className="letvdiv">
                  <div className="leavdos">
                    <iframe
                      src="https://player.vimeo.com/video/634401870?title=0&byline=0&portrait=0"
                      width="100%"
                      height="230"
                      frameBorder="0"
                      allow="autoplay; fullscreen; picture-in-picture"
                      allowFullScreen
                    ></iframe>
                  </div>

                  <h3>
                    Maximum Value in an array of Increasing <br /> and
                    Decreasing using Binary Search
                  </h3>

                  <span className="codejava">
                    Code In:
                    <a
                      target="_blank"
                      rel="noopener"
                      href="https://logicmojo.com/home-problem/3/1/2"
                      className="javabtns"
                    >
                      Python
                    </a>
                  </span>

                  <span className="codeassign">
                    <a
                      className="assignbtns"
                      style={{
                        margin: "0",
                        display: "inline-block",
                        float: "right",
                      }}
                      href="javascript:void(0);"
                      onClick="openAssModal('myCModal3','3ebd4e62c29c4019bd6c2976ae70d06b');"
                    >
                      Assignment
                    </a>
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div> */}

      <div className="gethired-stepsbg">
        <div className="container">
          <ul className="nav nav-tabs justify-center" role="tablist">
            {learnTracks.map((track) => (
              <li className="nav-item" key={track.key}>
                <button
                  type="button"
                  role="tab"
                  aria-selected={learnTab === track.key}
                  aria-controls={`learn-${track.key}`}
                  className={`nav-link${learnTab === track.key ? " active" : ""}`}
                  onClick={() => setLearnTab(track.key)}
                >
                  {track.label}
                </button>
              </li>
            ))}
          </ul>

          <div className="tab-content">
            {learnTracks
              .filter((track) => track.key === learnTab)
              .map((track) => {
                const chapters = track.module.chapters.map((ch, i) => ({
                  no: i + 1,
                  title: ch.title.replace(/^Chapter \d+:\s*/, ""),
                  desc: ch.topics.join(", ") + ".",
                }));
                return (
                  <div className="tab-pane fade active show" id={`learn-${track.key}`} role="tabpanel" key={track.key}>
                    <div className="bootcampstrip">
                      <div className="container">
                        <h3>
                          What you’ll learn in {track.label} in <span>Live Course</span>
                        </h3>
                        <div className="bootinfo">
                          <div className="row">
                            {/* One ordered grid: two per row on desktop, 1 → N stacked on mobile */}
                            {chapters.map((c) => (
                              <div className="col-lg-6 col-md-6" key={c.no}>
                                <div className="boocambg">
                                  <div className="row">
                                    <div className="col-lg-2 col-md-2 col-sm-2 col-3">
                                      <div className="ranks">{c.no}</div>
                                    </div>
                                    <div className="col-lg-8 col-md-8 col-sm-10 col-9 introinfo">
                                      <h5>{c.title}</h5>
                                      <p>{c.desc}</p>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            ))}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                );
              })}
          </div>

          <div style={{ clear: "both" }}></div>

          <div className="col-lg-12 col-md-5 fullstripshow">
            <a
              target="_default"
              href="https://calendly.com/logicmojo/schedule-call-back-from-experts-for-live-classes?month=2026-06"
              //data-target="#counsellingpopup"
              //data-toggle="modal"
              className="applnowbtn"
            >
              {" "}
              Apply For Live Classes
            </a>
          </div>
        </div>
      </div>

      <div className="coursemodule-bg d-none">
        <div className="container" id="modules">
          <h4>Course Modules</h4>
          <div className="levelrow">
            <div className="levelbox">
              <h2>Level 1</h2>
              <a href="#modules">
                <span>
                  <img
                    loading="lazy"
                    src="/react/ai-assets/images//level1-icon1.png"
                    alt=""
                  />
                </span>
                Arrays Linked-List
              </a>
              <a href="#modules">
                <span>
                  <img
                    loading="lazy"
                    src="/react/ai-assets/images//level1-icon2.png"
                    alt=""
                  />
                </span>
                Doubly Linked-List
              </a>
              <a href="#modules">
                <span>
                  <img
                    loading="lazy"
                    src="/react/ai-assets/images//level1-icon3.png"
                    alt=""
                  />
                </span>
                Binary Tree
              </a>
              <a href="#modules">
                <span>
                  <img
                    loading="lazy"
                    src="/react/ai-assets/images//level1-icon4.png"
                    alt=""
                  />
                </span>
                Binary Search Tree
              </a>
              <a href="#modules">
                <span>
                  <img
                    loading="lazy"
                    src="/react/ai-assets/images//level1-icon5.png"
                    alt=""
                  />
                </span>
                N-ary Tree
              </a>
              <a href="#modules">
                <span>
                  <img
                    loading="lazy"
                    src="/react/ai-assets/images//level1-icon6.png"
                    alt=""
                  />
                </span>
                MAANG Interviews Questions
              </a>
            </div>

            <div className="levelbox">
              <h2>Level 2</h2>
              <a href="#modules">
                <span>
                  <img
                    loading="lazy"
                    src="/react/ai-assets/images//level2-icon1.png"
                    alt=""
                  />
                </span>
                Stack/Queue
              </a>
              <a href="#modules">
                <span>
                  <img
                    loading="lazy"
                    src="/react/ai-assets/images//level2-icon2.png"
                    alt=""
                  />
                </span>
                Hashing/Heap
              </a>
              <a href="#modules">
                <span>
                  <img
                    loading="lazy"
                    src="/react/ai-assets/images//level5-icon1.png"
                    alt=""
                  />
                </span>
                Trie/Prefix <br />
                Tree
              </a>
              <a href="#modules">
                <span>
                  <img
                    loading="lazy"
                    src="/react/ai-assets/images//level2-icon4.png"
                    alt=""
                  />
                </span>
                Greedy Algorithms
              </a>
              <a href="#modules">
                <span>
                  <img
                    loading="lazy"
                    src="/react/ai-assets/images//level2-icon5.png"
                    alt=""
                  />
                </span>
                String Problems
              </a>
              <a href="#modules">
                <span>
                  <img
                    loading="lazy"
                    src="/react/ai-assets/images//level1-icon6.png"
                    alt=""
                  />
                </span>
                MAANG Interviews Questions
              </a>
            </div>

            <div className="levelbox">
              <h2>Level 3</h2>
              <a href="#modules">
                <span>
                  <img
                    loading="lazy"
                    src="/react/ai-assets/images//level2-icon3.png"
                    alt=""
                  />
                </span>
                Backtracking <br />
                /Recursion
              </a>
              <a href="#modules">
                <span>
                  <img
                    loading="lazy"
                    src="/react/ai-assets/images//level3-icon1.png"
                    alt=""
                  />
                </span>
                Graph Theory
              </a>
              <a href="#modules">
                <span>
                  <img
                    loading="lazy"
                    src="/react/ai-assets/images//level3-icon2.png"
                    alt=""
                  />
                </span>
                Dynamic Programming
              </a>
              <a href="#modules">
                <span>
                  <img
                    loading="lazy"
                    src="/react/ai-assets/images//level1-icon4.png"
                    alt=""
                  />
                </span>
                Advanced DSA Problems{" "}
              </a>
              <a href="#modules">
                <span>
                  <img
                    loading="lazy"
                    src="/react/ai-assets/images//level5-icon2.png"
                    alt=""
                  />
                </span>
                OOPS Concepts/Design
              </a>
              <a href="#modules">
                <span>
                  <img
                    loading="lazy"
                    src="/react/ai-assets/images//level1-icon6.png"
                    alt=""
                  />
                </span>
                MAANG Interviews Questions
              </a>
            </div>

            <div className="levelbox">
              <h2>Level 4</h2>
              <a href="#modules">
                <span>
                  <img
                    loading="lazy"
                    src="/react/ai-assets/images//level4-icon1.png"
                    alt=""
                  />
                </span>
                Scalable System Design
              </a>
              <a href="#modules">
                <span>
                  <img
                    loading="lazy"
                    src="/react/ai-assets/images//level4-icon2.png"
                    alt=""
                  />
                </span>
                HLD System Design
              </a>
              <a href="#modules">
                <span>
                  <img
                    loading="lazy"
                    src="/react/ai-assets/images//level4-icon3.png"
                    alt=""
                  />
                </span>
                LLD System Design
              </a>
              <a href="#modules">
                <span>
                  <img
                    loading="lazy"
                    src="/react/ai-assets/images//level4-icon4.png"
                    alt=""
                  />
                </span>
                Design Patterns
              </a>
              <a href="#modules">
                <span>
                  <img
                    loading="lazy"
                    src="/react/ai-assets/images//level4-icon4.png"
                    alt=""
                  />
                </span>
                Design Backend System
              </a>
              <a href="#modules">
                <span>
                  <img
                    loading="lazy"
                    src="/react/ai-assets/images//level4-icon4.png"
                    alt=""
                  />
                </span>
                System Design Projects
              </a>
            </div>

            <div className="levelbox">
              <h2>Level 5</h2>
              <a href="#modules">
                <span>
                  <img
                    loading="lazy"
                    src="/react/ai-assets/images//level5-icon1.png"
                    alt=""
                  />
                </span>
                Distributed System <br />
                Architecture
              </a>
              <a href="#modules">
                <span>
                  <img
                    loading="lazy"
                    src="/react/ai-assets/images//level5-icon3.png"
                    alt=""
                  />
                </span>
                Micro-service Architecture
              </a>
              <a href="#modules">
                <span>
                  <img
                    loading="lazy"
                    src="/react/ai-assets/images//level5-icon3.png"
                    alt=""
                  />
                </span>
                Big Data
              </a>
              <a href="#modules">
                <span>
                  <img
                    loading="lazy"
                    src="/react/ai-assets/images//level5-icon4.png"
                    alt=""
                  />
                </span>
                Distributed Components
              </a>
              <a href="#modules">
                <span>
                  <img
                    loading="lazy"
                    src="/react/ai-assets/images//level3-icon2.png"
                    alt=""
                  />
                </span>
                SQL/No-SQL
              </a>
              <a href="#modules">
                <span>
                  <img
                    loading="lazy"
                    src="/react/ai-assets/images//level5-icon1.png"
                    alt=""
                  />
                </span>
                Cloud Technology
              </a>
            </div>
          </div>
        </div>
      </div>


      <div className="howitworksetion">
        <div className="container">
          <br />
          <br />
          <div className="highlevehead">
            <h2>
              Live Classes - Mock Interview & Job Assistance{" "}
              <span> HOW IT WORKS </span>{" "}
            </h2>
          </div>
          <div className="stepboxes">
            <div className="row">
              <div className="col-lg-3 col-sm-6">
                <div className="howworkinfo">
                  <div className="worktop">
                    <h2>Step</h2>
                    <h3>01</h3>
                  </div>
                  <div className="wrokdetails">
                    <div className="workicon">
                      <img
                        loading="lazy"
                        src="/react/ai-assets/images//workicon01.png"
                        alt=""
                      />
                    </div>
                    <h5>
                      {" "}
                      Attend Classes <br />
                      Regularly{" "}
                    </h5>
                    <p>
                      Be regular with the classes. After every session, all
                      lectures and assignments discussed in class posted on the
                      HackerRank platform. Candidates should try to solve all
                      lectures and assignments in the HackeRank.
                    </p>
                  </div>
                </div>
              </div>
              <div className="col-lg-3 col-sm-6">
                <div className="howworkinfo">
                  <div className="worktop bg02">
                    <h2>Step</h2>
                    <h3>02</h3>
                  </div>
                  <div className="wrokdetails">
                    <div className="workicon">
                      <img
                        loading="lazy"
                        src="/react/ai-assets/images//workicon02.png"
                        alt=""
                      />
                    </div>
                    <h5>Peer to Peer Learning</h5>
                    <p>
                      Participate in solving problems with all your batchmates
                      in live classes. Ask any doubts in the doubt clearing
                      session. You will be part of the slack channel where all
                      study materials will be shared. All your practice code
                      will be shared in your GitHub Account for peer reviews.
                    </p>
                  </div>
                </div>
              </div>
              <div className="col-lg-3 col-sm-6">
                <div className="howworkinfo">
                  <div className="worktop bg03">
                    <h2>Step</h2>
                    <h3>03</h3>
                  </div>
                  <div className="wrokdetails">
                    <div className="workicon">
                      <img
                        loading="lazy"
                        src="/react/ai-assets/images//workicon03.png"
                        alt=""
                      />
                    </div>
                    <h5>
                      Mock Interview & <br />
                      Resume Guidelines{" "}
                    </h5>
                    <p>
                      After completion of 7-month live classes or 4-month live
                      classes, now you will be eligible for mock interviews and
                      resume preparation benefits. Top Tech developer will take
                      your series of mock interviews and give your feedback.
                      Then we will update your resume for Job referrals.
                    </p>
                  </div>
                </div>
              </div>
              <div className="col-lg-3 col-sm-6">
                <div className="howworkinfo">
                  <div className="worktop bg04">
                    <h2>Step</h2>
                    <h3>04</h3>
                  </div>
                  <div className="wrokdetails">
                    <div className="workicon">
                      <img
                        loading="lazy"
                        src="/react/ai-assets/images//workicon01.png"
                        alt=""
                      />
                    </div>
                    <h5>
                      Job Referral <br />
                      Program{" "}
                    </h5>
                    <p>
                      Get ready for job referrals in product companies. Now we
                      will refer your resume to product companies. Your
                      interview will be scheduled and based on preparation nail
                      the interview and land your dream job.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/*
      <div style={{ float: "left", width: "100%" }}>
        <div className="container">
          <h3>Popular Self-Paced Courses</h3>

          <br />
          <div className="row justify-content-center align-items-top">
            <div className="col-md-6">
              <div className="popularcourses-boxbg">
                <div className="popularcourses-boxbg-top">
                  <h4>• For Working Professionals</h4>
                  <div className="popularcourses-header">
                    <div className="popularcourses-header-img">
                      <img
                        loading="lazy"
                        src="/react/ai-assets/images//job-switch-program.png"
                        alt=""
                      />
                    </div>
                    <div className="popularcourses-header-text">
                      <h2>Cracking the Coding Interviews</h2>
                      <p>
                        Self-Paced Complete Course for Learning Data structures,
                        Algorithms & Design Problems For Cracking the Interviews
                        of Top Tech Companies
                      </p>
                    </div>
                  </div>
                </div>
                <div className="popularcourses-boxbg-bottom">
                  <div className="popularcourses-boxbg-bottom-top">
                    <ul>
                      <li>
                        <span>
                          <img
                            loading="lazy"
                            src="/react/ai-assets/images//lockicon.png"
                            alt=""
                          />
                        </span>
                        <div className="popularcourses-boxbg-bottom-top-text">
                          <h4>Curriculum</h4>
                          <p>260+ Lectures</p>
                        </div>
                      </li>
                      <li>
                        <span>
                          <img
                            loading="lazy"
                            src="/react/ai-assets/images//doration-icon.png"
                            alt=""
                          />
                        </span>
                        <div className="popularcourses-boxbg-bottom-top-text">
                          <h4>Duration</h4>
                          <p>Life Time Access Course</p>
                        </div>
                      </li>
                      <li>
                        <span>
                          <img
                            loading="lazy"
                            src="/react/ai-assets/images//youtubeicon.png"
                            alt=""
                          />
                        </span>
                        <div className="popularcourses-boxbg-bottom-top-text">
                          <h4>Mode</h4>
                          <p>Video Lectures</p>
                        </div>
                      </li>
                      <li>
                        <span>
                          <img
                            loading="lazy"
                            src="/react/ai-assets/images//additional-curriculum-icon.png"
                            alt=""
                          />
                        </span>
                        <div className="popularcourses-boxbg-bottom-top-text">
                          <h4>Additional Curriculum </h4>
                          <p>Doubt Support Available</p>
                        </div>
                      </li>
                    </ul>
                  </div>
                  <div className="popularcourses-boxbg-bottom-mid">
                    <ul>
                      <li>
                        <img
                          loading="lazy"
                          src="/react/ai-assets/images//rightmark.png"
                          alt=""
                        />
                        <h3>Complete code explanation in</h3>
                        <a href="#">JAVA, Python & C++</a>
                        <br />
                        <a href="#" style={{ color: "red" }}>
                          Diwali Special Offer
                        </a>
                        <br />
                        <a href="#" style={{ color: "red" }}>
                          Flat 20% OFF
                        </a>
                      </li>
                      <li>
                        <img
                          loading="lazy"
                          src="/react/ai-assets/images//rightmark.png"
                          alt=""
                        />
                        <h3>Additional Syllabus Cover</h3>

                        <a href="#">
                          Learn Data Structures, Algorithms & Design, Docker
                          code deployment, Behaviour Questions
                        </a>
                      </li>
                    </ul>
                  </div>
                  <div className="popularcourses-boxbg-bottom-bottom">
                    <ul>
                      <li>
                        <a
                          href="#"
                          data-toggle="modal"
                          data-target="#chooseLanguageExperienced"
                        >
                          Learn More
                          <i
                            className="fa fa-angle-right"
                            aria-hidden="true"
                          ></i>
                        </a>
                      </li>

                      <li>
                        <a 
                          className="booktrialbtn"
                          data-toggle="modal"
                          href="#EnrollModal1"
                        >
                          Enroll Now{" "}
                          <i
                            className="fa fa-angle-right"
                            aria-hidden="true"
                          ></i>
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>

            <div className="col-md-6">
              <div className="popularcourses-boxbg">
                <div className="popularcourses-boxbg-top">
                  <h4>• For Freshers Candidates</h4>
                  <div className="popularcourses-header">
                    <div className="popularcourses-header-img">
                      <img
                        loading="lazy"
                        src="/react/ai-assets/images//job-switch-program.png"
                        alt=""
                      />
                    </div>
                    <div className="popularcourses-header-text">
                      <h2>Cracking the Placement Interviews</h2>

                      <p>
                        Self-paced video course for learning data structures
                        Algorithms & competitive Programming for cracking the
                        interviews of Top Tech companies
                      </p>
                    </div>
                  </div>
                </div>
                <div className="popularcourses-boxbg-bottom">
                  <div className="popularcourses-boxbg-bottom-top">
                    <ul>
                      <li>
                        <span>
                          <img
                            loading="lazy"
                            src="/react/ai-assets/images//lockicon.png"
                            alt=""
                          />
                        </span>
                        <div className="popularcourses-boxbg-bottom-top-text">
                          <h4>Curriculum</h4>
                          <p>240+ Lectures</p>
                        </div>
                      </li>
                      <li>
                        <span>
                          <img
                            loading="lazy"
                            src="/react/ai-assets/images//doration-icon.png"
                            alt=""
                          />
                        </span>
                        <div className="popularcourses-boxbg-bottom-top-text">
                          <h4>Duration</h4>
                          <p>Life Time Access Course</p>
                        </div>
                      </li>
                      <li>
                        <span>
                          <img
                            loading="lazy"
                            src="/react/ai-assets/images//youtubeicon.png"
                            alt=""
                          />
                        </span>
                        <div className="popularcourses-boxbg-bottom-top-text">
                          <h4>Mode</h4>
                          <p>Video Lectures</p>
                        </div>
                      </li>
                      <li>
                        <span>
                          <img
                            loading="lazy"
                            src="/react/ai-assets/images//additional-curriculum-icon.png"
                            alt=""
                          />
                        </span>
                        <div className="popularcourses-boxbg-bottom-top-text">
                          <h4>Course Features</h4>
                          <p>Doubt Support Available</p>
                        </div>
                      </li>
                    </ul>
                  </div>
                  <div className="popularcourses-boxbg-bottom-mid">
                    <ul>
                      <li>
                        <img
                          loading="lazy"
                          src="/react/ai-assets/images//rightmark.png"
                          alt=""
                        />
                        <h3>Complete code explanation in</h3>
                        <a href="#">JAVA, Python & C++</a>
                        <br />

                        <a href="#" style={{ color: "red" }}>
                          Diwali Special Offer
                        </a>
                        <a href="#" style={{ color: "red" }}>
                          Flat 20% OFF
                        </a>
                      </li>
                      <li>
                        <img
                          loading="lazy"
                          src="/react/ai-assets/images//rightmark.png"
                          alt=""
                        />
                        <h3>Additional Syllabus Cover </h3>
                        <a href="#">
                          Learn OOPS basic Operating Systems Code Deployments{" "}
                        </a>
                      </li>
                    </ul>
                  </div>
                  <div className="popularcourses-boxbg-bottom-bottom">
                    <ul>
                      <li>
                        <a
                          href="#"
                          data-toggle="modal"
                          data-target="#chooseLanguageFreshers"
                        >
                          Learn More{" "}
                          <i
                            className="fa fa-angle-right"
                            aria-hidden="true"
                          ></i>
                        </a>
                      </li>

                      <li>
                        <a 
                          className="booktrialbtn"
                          data-toggle="modal"
                          href="#EnrollModal1"
                        >
                          Enroll Now{" "}
                          <i
                            className="fa fa-angle-right"
                            aria-hidden="true"
                          ></i>
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
                                */}

      <section className="newsstrip">
        <div className="container">
          <div className="row">
            <div className="col-lg-3 col-md-4 col-sm-4">
              <div className="newsleftinfo">
                <h5>
                  Logicmojo in <br />
                  the News
                </h5>
              </div>
            </div>

            <div className="col-lg-9 col-md-8 col-sm-8">
              <div className="newsrightdetails">
                <div className="row">
                  <div className="col-lg-6 col-md-6">
                    <div className="newsdetilsbox">
                      <div className="newslogos">
                        <a
                          target="_default"
                          href="https://www.business-standard.com/content/specials/edtech-firm-logicmojo-comes-up-with-a-platform-for-riveting-live-learning-122051600891_1.html"
                        >
                          <img
                            loading="lazy"
                            src="/react/ai-assets/images//newslogo01.jpg"
                            alt=""
                          />
                        </a>
                      </div>
                      <p>
                        Logicmojo Platform: A Revolutionary Interactive
                        Programming Experience
                      </p>
                    </div>
                  </div>

                  <div className="col-lg-6 col-md-6">
                    <div className="newsdetilsbox">
                      <div className="newslogos">
                        <a
                          target="_default"
                          href="https://www.hindustantimes.com/brand-stories/logicmojo-an-edtech-firm-launches-a-platform-for-interactive-and-live-learning-101653369123410.html"
                        >
                          <img
                            loading="lazy"
                            src="/react/ai-assets/images//newslogo02.jpg"
                            alt=""
                          />
                        </a>
                      </div>
                      <p>
                        Smart Concise Preparation with Practice and Revision is
                        the Key
                      </p>
                    </div>
                  </div>

                  <div className="col-lg-6 col-md-6">
                    <div className="newsdetilsbox">
                      <div className="newslogos">
                        <a href="https://yourstory.com/companies/logicmojo">
                          <img
                            loading="lazy"
                            src="/react/ai-assets/images//newslogo03.jpg"
                            alt=""
                          />
                        </a>
                      </div>
                      <p>
                        Logicmojo : Explore and Practice With Industry Experts
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <div className="coursefaqstrip" id="FAQ">
        <div className="container">
          <h2> FAQs</h2>

          <div className="faqfullinfo">
            <div className="row">
              <div className="col-lg-10 col-md-12">
                <div className="faq">
                  <div className="accordion" id="accordionExample5">

                    <div className="card">
                      <div className="card-header" id="headingOne1">
                        <h2 className="mb-0">
                          <button
                            type="button"
                            className="btn btn-link collapsed"
                            data-toggle="collapse"
                            data-target="#collapseOne1"
                          >
                            <i className="fa fa-angle-down"></i> What is the
                            difference between Live Couse and Self Paced Course
                            ?
                          </button>
                        </h2>
                      </div>

                      <div
                        id="collapseOne1"
                        className="collapse"
                        aria-labelledby="headingOne1"
                        data-parent="#accordionExample5"
                      >
                        <div className="card-body">
                          <div className="faqcontent">
                            <div className="listfaq">
                              <ul>
                                <br />

                                <b>
                                  <p>
                                    <u>Live Course Features</u>
                                  </p>
                                </b>
                                <li>
                                  Instructor from MAANG companies Live classroom
                                  program
                                </li>
                                <li>
                                  Practise code, build AI projects and discuss
                                  solutions in live class with batchmates &
                                  Instructor
                                </li>
                                <li>
                                  Live doubts sessions for solving all your
                                  queries
                                </li>
                                <li>
                                  Job referrals to everyone after course
                                  completion in product companies{" "}
                                </li>
                                <li>
                                  After every session all lectures & assignments
                                  will be updated in Hackerrank platform for
                                  practise{" "}
                                </li>
                                <li>
                                  The candidate uploads all practiced code to
                                  Github for review. Constantly follow up on the
                                  progress.
                                </li>
                                <li>Mock Interview Sessions</li>
                                <li>Resume Preparation Session</li>
                              </ul>
                              <p>
                                <b>
                                  Note : For the live session, if candidates are
                                  not serious about solving Lectures/Assignments
                                  even after multiple follow up. Then they can't
                                  continue with the batch and a refund will be
                                  processed.
                                </b>
                              </p>

                              <ul>
                                <br />
                                <br />

                                <b>
                                  <p>
                                    <u>Self-Paced Features</u>
                                  </p>
                                </b>
                                <li>Pre-recorded video lectures </li>
                                <li>Prepare as per your own pace and time.</li>
                                <li>
                                  Ask your doubts using ask query messaging
                                  system.
                                </li>
                                <li>
                                  Weekly coding test to filter top performance
                                  candidates{" "}
                                </li>
                                <li>
                                  Job referrals for consistent toppers in weekly
                                  tests.
                                </li>
                              </ul>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>


                    <div className="card">
                      <div className="card-header" id="headingThree">
                        <h2 className="mb-0">
                          <button
                            type="button"
                            className="btn btn-link collapsed"
                            data-toggle="collapse"
                            data-target="#collapseThree"
                          >
                            <i className="fa fa-angle-down"></i>How Discount &
                            EMI process works ?
                          </button>
                        </h2>
                      </div>

                      <div
                        id="collapseThree"
                        className="collapse"
                        aria-labelledby="headingThree"
                        data-parent="#accordionExample5"
                      >
                        <div className="card-body">
                          <div className="faqcontent">
                            <p>
                              There is a Diwali Special Offer of flat 20% OFF on
                              all courses. After discount you can choose no cost
                              EMI option for 3 months,6 months, 9 months or 1
                              year.
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="card d-none">
                      <div className="card-header" id="headingFour">
                        <h2 className="mb-0">
                          <button
                            type="button"
                            className="btn btn-link collapsed"
                            data-toggle="collapse"
                            data-target="#collapseFour"
                          >
                            <i className="fa fa-angle-down"></i>How much time
                            does it take to finish the system design interview
                            questions?
                          </button>
                        </h2>
                      </div>

                      <div
                        id="collapseFour"
                        className="collapse"
                        aria-labelledby="headingFour"
                        data-parent="#accordionExample5"
                      >
                        <div className="card-body">
                          <div className="faqcontent">
                            <p>
                              <b>2 Months to 2.5 Months</b>
                            </p>

                            <p>
                              {" "}
                              If you just spend 2 hours every day in this course
                              then in 2 to 2.5 months of time frame your
                              preparation of coding and system design interview
                              questions will be done.
                            </p>

                            <p>
                              You dont even need to refer to any other resources
                              just finish this course and you are good to go for
                              Top Tech Interviews
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="card">
                      <div className="card-header" id="headingFive">
                        <h2 className="mb-0">
                          <button
                            type="button"
                            className="btn btn-link collapsed"
                            data-toggle="collapse"
                            data-target="#collapseFive"
                          >
                            <i className="fa fa-angle-down"></i>Is all courses
                            avilable for Life time ?
                          </button>
                        </h2>
                      </div>

                      <div
                        id="collapseFive"
                        className="collapse"
                        aria-labelledby="headingFive"
                        data-parent="#accordionExample5"
                      >
                        <div className="card-body">
                          <div className="faqcontent">
                            <p>
                              <b>Yes!!</b>
                            </p>

                            <p>
                              Yes, both live session class recording lectures as
                              well as self-paced course content is life time
                              access content.
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="card">
                      <div className="card-header" id="headingsix">
                        <h2 className="mb-0">
                          <button
                            type="button"
                            className="btn btn-link collapsed"
                            data-toggle="collapse"
                            data-target="#collapseSix"
                          >
                            <i className="fa fa-angle-down"></i> Preparation
                            sequence of this Course ?
                          </button>
                        </h2>
                      </div>

                      <div
                        id="collapseSix"
                        className="collapse"
                        aria-labelledby="headingsix"
                        data-parent="#accordionExample5"
                      >
                        <div className="card-body">
                          <div className="faqcontent">
                            <div className="faqlistimg">
                              <img
                                loading="lazy"
                                src="/react/ai-assets/images//faqdigrame.jpg"
                                alt=""
                              />{" "}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="card">
                      <div className="card-header" id="heading207">
                        <h2 className="mb-0">
                          <button
                            type="button"
                            className="btn btn-link collapsed"
                            data-toggle="collapse"
                            data-target="#collapse207"
                          >
                            <i className="fa fa-angle-down"></i> How to enroll
                            in this course ?
                          </button>
                        </h2>
                      </div>

                      <div
                        id="collapse207"
                        className="collapse"
                        aria-labelledby="heading207"
                        data-parent="#accordionExample5"
                      >
                        <div className="card-body">
                          <div className="faqcontent">
                            <p>
                              Just Click on <b>"Enroll Now"</b> and join the
                              live session batch. For self-paced course just
                              select self-paced course and join
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="card">
                      <div className="card-header" id="heading08">
                        <h2 className="mb-0">
                          <button
                            type="button"
                            className="btn btn-link collapsed"
                            data-toggle="collapse"
                            data-target="#collapse08"
                          >
                            <i className="fa fa-angle-down"></i> Doubt clearing
                            session and Online Weekly Code ?
                          </button>
                        </h2>
                      </div>

                      <div
                        id="collapse08"
                        className="collapse"
                        aria-labelledby="heading08"
                        data-parent="#accordionExample5"
                      >
                        <div className="card-body">
                          <div className="faqcontent">
                            <p>
                              Users can participate in Online Weekly Code{" "}
                              <b>forever</b> but Doubt clearing session will be
                              available for
                              <b>6 months period </b>{" "}
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="card">
                      <div className="card-header" id="heading09">
                        <h2 className="mb-0">
                          <button
                            type="button"
                            className="btn btn-link collapsed"
                            data-toggle="collapse"
                            data-target="#collapse09"
                          >
                            <i className="fa fa-angle-down"></i> What is the
                            eligibility for a job assistance program?
                          </button>
                        </h2>
                      </div>

                      <div
                        id="collapse09"
                        className="collapse"
                        aria-labelledby="heading09"
                        data-parent="#accordionExample5"
                      >
                        <div className="card-body">
                          <div className="faqcontent">
                            <p>
                              After completion of the course, candidates will be
                              eligible to appear for the mock interview process.
                              These will be live technical mock interviews
                              conducted by a Technical Manager.
                            </p>

                            <p>
                              Each candidate will be given 2 mock interview
                              opportunities. To become eligible for the job
                              referral program, candidates need to successfully
                              clear the mock interviews.
                            </p>

                            <p>
                              Once the candidate clears the mock interview
                              process, the next step will be resume preparation
                              and review, followed by job referrals based on the
                              candidate&apos;s performance and eligibility.
                            </p>

                            <p>
                              <strong>Please note:</strong> The eligibility to
                              appear for mock interviews for job referrals is
                              valid only for 3 months from the course completion
                              date. This means candidates must appear for and
                              clear the mock interview within 3 months after the
                              course ends. After this period, the mock interview
                              and job referral eligibility will expire.
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="card">
                      <div className="card-header" id="heading091">
                        <h2 className="mb-0">
                          <button
                            type="button"
                            className="btn btn-link collapsed"
                            data-toggle="collapse"
                            data-target="#collapse091"
                          >
                            <i className="fa fa-angle-down"></i> What are the
                            criteria for changing the batch?
                          </button>
                        </h2>
                      </div>

                      <div
                        id="collapse091"
                        className="collapse"
                        aria-labelledby="heading091"
                        data-parent="#accordionExample5"
                      >
                        <div className="card-body">
                          <div className="faqcontent">
                            <p>
                              Candidates can request a batch change <b>while their
                              current batch is still in progress</b> if they are
                              unable to attend classes due to a genuine reason,
                              such as a medical emergency, marriage, or an
                              onsite work opportunity.
                            </p>
                            <p>Note : A candidate can switch batches only once. After that, batch switching is not allowed under any circumstances.</p>

                            <p>
                              <b>Once the batch has been completed, switching to
                              another batch is not allowed</b>, as all scheduled
                              classes for the enrolled batch have already been
                              delivered.
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="card">
                      <div className="card-header" id="heading10">
                        <h2 className="mb-0">
                          <button
                            type="button"
                            className="btn btn-link collapsed"
                            data-toggle="collapse"
                            data-target="#collapse10"
                          >
                            <i className="fa fa-angle-down"></i> What is the Ask
                            Query Feature?
                          </button>
                        </h2>
                      </div>

                      <div
                        id="collapse10"
                        className="collapse"
                        aria-labelledby="heading10"
                        data-parent="#accordionExample5"
                      >
                        <div className="card-body">
                          <div className="faqcontent">
                            <p>
                              We have the "Ask query" option with every lecture
                              and every assignment in the course. You can ask
                              your doubt using it anytime.
                            </p>

                            <p>
                              {" "}
                              Let's say you are practicing some assignment and
                              you can't figure it out or you are trying some
                              lecture code yourself and all test cases are not
                              passing you can paste your code, send images and
                              ask your doubts.
                            </p>

                            <p>
                              Our trainer including the expert developers having
                              10+ experienced will execute your code or analyze
                              your doubts give a detailed response to your
                              query.{" "}
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="card">
                      <div className="card-header" id="heading11">
                        <h2 className="mb-0">
                          <button
                            type="button"
                            className="btn btn-link collapsed"
                            data-toggle="collapse"
                            data-target="#collapse11"
                          >
                            <i className="fa fa-angle-down"></i> Is all problems
                            in this course explains with code also?
                          </button>
                        </h2>
                      </div>

                      <div
                        id="collapse11"
                        className="collapse"
                        aria-labelledby="heading11"
                        data-parent="#accordionExample5"
                      >
                        <div className="card-body">
                          <div className="faqcontent">
                            <p>
                              Yes, every problem in this course is explained
                              with code and examples. Our main intension is to
                              make the programming skills of our candidates
                              strong. So line by line code explains while
                              solving any problems
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="card">
                      <div className="card-header" id="heading12">
                        <h2 className="mb-0">
                          <button
                            type="button"
                            className="btn btn-link collapsed"
                            data-toggle="collapse"
                            data-target="#collapse12"
                          >
                            <i className="fa fa-angle-down"></i> Is the complete
                            course is available after the subscription or any
                            batch system is there?
                          </button>
                        </h2>
                      </div>

                      <div
                        id="collapse12"
                        className="collapse"
                        aria-labelledby="heading12"
                        data-parent="#accordionExample5"
                      >
                        <div className="card-body">
                          <div className="faqcontent">
                            <p>
                              We don't put any constraint of the batch system in
                              our course, as soon as aspirant subscribe for the
                              course complete course content will be available.
                            </p>

                            <p>
                              {" "}
                              Batch System always restricts aspirants for
                              accessing the complete course. If a student has an
                              interview after a few weeks and he/she want to
                              prepare for advanced topics, then the batch system
                              will not allow accessing the course content
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="card">
                      <div className="card-header" id="heading13">
                        <h2 className="mb-0">
                          <button
                            type="button"
                            className="btn btn-link collapsed"
                            data-toggle="collapse"
                            data-target="#collapse13"
                          >
                            <i className="fa fa-angle-down"></i> Can I acces the
                            course by using Mobile or Tablet?
                          </button>
                        </h2>
                      </div>

                      <div
                        id="collapse13"
                        className="collapse"
                        aria-labelledby="heading13"
                        data-parent="#accordionExample5"
                      >
                        <div className="card-body">
                          <div className="faqcontent">
                            <p>
                              Yes, you can access the complete course in Mobile
                              or Tablet.
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="col-lg-4 col-md-12">
                <div className="rightfaqdiv">&nbsp;</div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="gettouchbg" id="Contact" ref={overContacts}>
        <h1>Get in touch with us</h1>

        <div className="gettouchbg-bottom">
          <div className="container">
            <div className="gettouchbg-bottom-inner">
              <div className="row justify-content-center">
                <div className="col-md-4">
                  <div className="gettouchbg-box">
                    <div className="gettouchbg-box-left">
                      <span>
                        <a
                          href="https://api.whatsapp.com/send?phone=+918088975867&text=Hi%20Logicmojo"
                          target="_blank"
                          rel="noopener"
                          style={{ color: "#0b4189" }}
                        >
                          <i className="fa fa-whatsapp" aria-hidden="true"></i>
                        </a>
                      </span>
                    </div>

                    <div className="gettouchbg-box-right">
                      <label htmlFor="">Chat with Us:</label>

                      <p>
                        <a
                          href="https://api.whatsapp.com/send?phone=+918088975867&text=Hi%20Logicmojo"
                          target="_blank"
                          rel="noopener"
                        >
                          WhatsApp
                        </a>
                      </p>
                    </div>
                  </div>
                </div>


                <div className="col-md-4">
                  <div className="gettouchbg-box">
                    <div className="gettouchbg-box-left">
                      <span>
                        <i className="fa fa-phone" aria-hidden="true"></i>
                      </span>
                    </div>

                    <div className="gettouchbg-box-right">
                      <label htmlFor="">Phone:</label>

                      <p>
                        <a href="tel:+91 80889-75867">+91 80889-75867</a>
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <LearningLibrary />
      
 {/*
      <div className="quicklinkstrip">
        <div className="container">
          <h2>Logicmojo Learning Library</h2>
          <div className="quickshow">
            <div className="row">
              <div className="col-lg-3 col-md-6">
                <div className="quicklinks">
                  <ul>

                    <li>
                      <a href="https://logicmojo.com/datascience-course">
                        Data Science Course
                      </a>
                    </li>
                    <li>
                      <a href="https://logicmojo.com/artificial-intelligence-course">
                        Artificial Intellegence Course
                      </a>
                    </li>

                    <li>
                      <a href="https://logicmojo.com/data-structures-and-algorithms">
                        DSA Course
                      </a>
                    </li>
                    <li>
                      <a href="https://logicmojo.com/data-structures-interview-questions">
                        Data Structures Interview Questions
                      </a>
                    </li>
                    <li>
                      <a href="https://logicmojo.com/amazon-interview-questions">
                        Amazon Interview Questions
                      </a>
                    </li>
                    <li>
                      <a href="https://logicmojo.com/java-interview-questions">
                        Java Interview Questions
                      </a>
                    </li>
                    <li>
                      <a href="https://logicmojo.com/python-interview-questions">
                        Python Interview Questions
                      </a>
                    </li>
                    <li>
                      <a href="https://logicmojo.com/cpp-interview-question">
                        C++ Interview Questions
                      </a>
                    </li>
                    <li>
                      <a href="https://logicmojo.com/multithreading-in-java">
                        multithreading in java
                      </a>
                    </li>
                    <li>
                      <a href="https://logicmojo.com/oops-concepts-in-cpp">
                        Oops concepts in C++
                      </a>
                    </li>
                    <li>
                      <a href="https://logicmojo.com/data-structures-queue">
                        Queue Data Structures
                      </a>
                    </li>
                    <li>
                      <a href="https://logicmojo.com/collections-problems-in-java">
                        collections Concepts in java
                      </a>
                    </li>
                    <li>
                      <a href="https://logicmojo.com/hashing-in-data-structure">
                        Hashing in Data Structures
                      </a>
                    </li>
                    <li>
                      <a href="https://logicmojo.com/tcs-interview-questions">
                        tcs interview questions
                      </a>
                    </li>
                    <li>
                      <a href="https://logicmojo.com/binary-tree-data-structure">
                        Binary Tree data structure
                      </a>
                    </li>
                    <li>
                      <a href="https://logicmojo.com/microservices-interview-questions">
                        microservices interview questions
                      </a>
                    </li>
                    <li>
                      <a href="https://logicmojo.com/design-patterns-in-java">
                        Design Patterns in java
                      </a>
                    </li>
                    <li>
                      <a href="https://logicmojo.com/kafka-tutorial">
                        Kafka Tutorial
                      </a>
                    </li>
                    <li>
                      <a href="https://logicmojo.com/aws-interview-questions">
                        Aws Interview Questions
                      </a>
                    </li>
                    <li>
                      <a href="https://logicmojo.com/linux-interview-questions">
                        Linux Interview Questions
                      </a>
                    </li>
                    <li>
                      <a href="https://logicmojo.com/best-paying-jobs-in-technology">
                        Best Paying Jobs In Technology
                      </a>
                    </li>
                    <li>
                      <a href="https://logicmojo.com/method-overriding-in-java">
                        Method Overriding in Java
                      </a>
                    </li>
                    <li>
                      <a href="https://logicmojo.com/interface-in-java">
                        Interface In Java
                      </a>
                    </li>
                    <li>
                      <a href="https://logicmojo.com/method-overloading-in-java">
                        Method Overloading In Java
                      </a>
                    </li>
                    <li>
                      <a href="https://logicmojo.com/logistic-regression-machine-learning">
                        Logistic Regression Machine Learning
                      </a>
                    </li>
                    <li>
                      <a href="https://logicmojo.com/threads-in-java">
                        Threads In Java
                      </a>
                    </li>
                    <li>
                      <a href="https://logicmojo.com/lambdafunction-in-python">
                        Lambda Functions In Python
                      </a>
                    </li>
                    <li>
                      <a href="https://logicmojo.com/normalization-in-dbms">
                        Normalization in DBMS
                      </a>
                    </li>
                    <li>
                      <a href="https://logicmojo.com/data-types-in-java">
                        Data Types in Java
                      </a>
                    </li>
                    <li>
                      <a href="https://logicmojo.com/convolutional-neural-network">
                        Convolutional Neural Network
                      </a>
                    </li>
                    <li>
                      <a href="https://logicmojo.com/cpp-stl">
                        C++ STL Library
                      </a>
                    </li>
                    <li>
                      <a href="https://logicmojo.com/fibonacci-series-in-C">
                        Fibonacci Series in C
                      </a>
                    </li>
                    <li>
                      <a href="https://logicmojo.com/sql-group-by">
                        Sql Group By
                      </a>
                    </li>
                    <li>
                      <a href="https://logicmojo.com/insertion-sort">
                        Insertion Sort
                      </a>
                    </li>
                    <li>
                      <a href="https://logicmojo.com/view-in-sql">SQL View</a>
                    </li>
                    <li>
                      <a href="https://logicmojo.com/sql-constraints">
                        SQL Constraints
                      </a>
                    </li>
                    <li>
                      <a href="https://logicmojo.com/amazon-leadership-principles">
                        Amazon Leadership Principles
                      </a>
                    </li>
                    <li>
                      <a href="https://logicmojo.com/artificial-intelligence-and-machine-learning">
                        Artificial Intelligence and Machine Learning
                      </a>
                    </li>
                  </ul>
                </div>
              </div>

              <div className="col-lg-3 col-md-6">
                <div className="quicklinks">
                  <ul>
                    <li>
                      <a href="https://logicmojo.com/full-stack-developer">
                        Full Stack DeveloperInterview
                      </a>
                    </li>
                    <li>
                      <a href="https://logicmojo.com/sql-interview-questions">
                        SQL Interview Questions
                      </a>
                    </li>
                    <li>
                      <a href="https://logicmojo.com/data-science-introduction">
                        Data Science Introduction
                      </a>
                    </li>
                    <li>
                      <a href="https://logicmojo.com/what-is-data-science">
                        What is Data Science ?
                      </a>
                    </li>
                    <li>
                      <a href="https://logicmojo.com/what-is-data-analytics">
                        What is Data Analytics ?
                      </a>
                    </li>

                    <li>
                      <a href="https://logicmojo.com/spring-boot-interview-questions">
                        Spring Boot Interview Questions
                      </a>
                    </li>
                    <li>
                      <a href="https://logicmojo.com/angular-interview-questions">
                        Angular Interview Questions
                      </a>
                    </li>
                    <li>
                      <a href="https://logicmojo.com/java8-feature-questions">
                        Java8 Features
                      </a>
                    </li>
                    <li>
                      <a href="https://logicmojo.com/microsoft-interview-questions">
                        Microsoft Interview Questions
                      </a>
                    </li>
                    <li>
                      <a href="https://logicmojo.com/stack-in-data-structure">
                        Stack in Data Structures
                      </a>
                    </li>
                    <li>
                      <a href="https://logicmojo.com/graph-data-structure">
                        Graph Data Structures
                      </a>
                    </li>
                    <li>
                      <a href="https://logicmojo.com/exception-handling-in-java-problems">
                        Exception Handling in java
                      </a>
                    </li>
                    <li>
                      <a href="https://logicmojo.com/selenium-interview-questions">
                        Selenium interview questions
                      </a>
                    </li>
                    <li>
                      <a href="https://logicmojo.com/accenture-interview-questions">
                        Accenture interview questions
                      </a>
                    </li>
                    <li>
                      <a href="https://logicmojo.com/osi-model">OSI Model</a>
                    </li>
                    <li>
                      <a href="https://logicmojo.com/distributed-systems">
                        Distributed Systems
                      </a>
                    </li>
                    <li>
                      <a href="https://logicmojo.com/data-analyst-salary">
                        Data Analyst Salary
                      </a>
                    </li>
                    <li>
                      <a href="https://logicmojo.com/angular-vs-react">
                        Angular vs React
                      </a>
                    </li>
                    <li>
                      <a href="https://logicmojo.com/manual-testing-interview-questions">
                        Manual Testing Interview Questions
                      </a>
                    </li>
                    <li>
                      <a href="https://logicmojo.com/networking-interview-questions">
                        Networking Interview Questions
                      </a>
                    </li>
                    <li>
                      <a href="https://logicmojo.com/dot-net-interview-questions">
                        Net Interview Questions
                      </a>
                    </li>
                    <li>
                      <a href="https://logicmojo.com/jenkins-interview-questions">
                        Jenkins Interview Questions
                      </a>
                    </li>
                    <li>
                      <a href="https://logicmojo.com/friend-function-in-cpp">
                        Friend Function in CPP
                      </a>
                    </li>
                    <li>
                      <a href="https://logicmojo.com/access-modifiers-in-java">
                        Access Modifiers In Java
                      </a>
                    </li>
                    <li>
                      <a href="https://logicmojo.com/constructor-in-java">
                        Constructor In Java
                      </a>
                    </li>
                    <li>
                      <a href="https://logicmojo.com/abstraction-in-java">
                        Abstraction In Java
                      </a>
                    </li>
                    <li>
                      <a href="https://logicmojo.com/what-is-an-array">
                        What is an Array
                      </a>
                    </li>
                    <li>
                      <a href="https://logicmojo.com/functions-of-operating-system">
                        Functions of Operating System
                      </a>
                    </li>
                    <li>
                      <a href="https://logicmojo.com/include-stdio-h">
                        Include Studio H
                      </a>
                    </li>
                    <li>
                      <a href="https://logicmojo.com/online-gdb-compiler">
                        Online Gdb Compiler
                      </a>
                    </li>
                    <li>
                      <a href="https://logicmojo.com/reverse-a-string-in-java">
                        Reverse a String
                      </a>
                    </li>
                    <li>
                      <a href="https://logicmojo.com/wrapper-class-in-java">
                        Wrapper Class in Java
                      </a>
                    </li>
                    <li>
                      <a href="https://logicmojo.com/fibonacci-series-in-Java">
                        Fibonacci Series in Java
                      </a>
                    </li>
                    <li>
                      <a href="https://logicmojo.com/structure-in-c">
                        Structure in C
                      </a>
                    </li>
                    <li>
                      <a href="https://logicmojo.com/software-engineer-salary">
                        Software Engineer Salary
                      </a>
                    </li>
                    <li>
                      <a href="https://logicmojo.com/python-for-data-science">
                        Python for Data Science
                      </a>
                    </li>
                    <li>
                      <a href="https://logicmojo.com/decision-tree-machine-learning">
                        Decision Tree Machine Learning
                      </a>
                    </li>
                    <li>
                      <a href="https://logicmojo.com/data-science-projects">
                        Data Science Projects
                      </a>
                    </li>
                    <li>
                      <a href="https://logicmojo.com/applications-of-artificial-intelligence">
                        Applications of Artificial Intelligence
                      </a>
                    </li>
                  </ul>
                </div>
              </div>

              <div className="col-lg-3 col-md-6">
                <div className="quicklinks">
                  <ul>
                    <li>
                      <a href="https://logicmojo.com/data-scientist-salary">
                        Data Scientist Salary
                      </a>
                    </li>
                    <li>
                      <a href="https://logicmojo.com/javascript-interview-questions">
                        Javascript Interview Questions
                      </a>
                    </li>
                    <li>
                      <a href="https://logicmojo.com/oops-interview-questions">
                        oops Interview Questions
                      </a>
                    </li>
                    <li>
                      <a href="https://logicmojo.com/react-js-interview-questions">
                        reactJS Interview Questions
                      </a>
                    </li>
                    <li>
                      <a href="https://logicmojo.com/oops-concepts-in-java">
                        oops concepts in java
                      </a>
                    </li>
                    <li>
                      <a href="https://logicmojo.com/puzzles-questions">
                        Puzzles in Interviews
                      </a>
                    </li>
                    <li>
                      <a href="https://logicmojo.com/python-dictionary">
                        Python Dictionary
                      </a>
                    </li>
                    <li>
                      <a href="https://logicmojo.com/tree-data-structure">
                        Tree Data Structures
                      </a>
                    </li>
                    <li>
                      <a href="https://logicmojo.com/data-structures-in-java">
                        Data Structures in Java
                      </a>
                    </li>
                    <li>
                      <a href="https://logicmojo.com/data-structures-in-c-problems">
                        Data Structures in C
                      </a>
                    </li>
                    <li>
                      <a href="https://logicmojo.com/data-science-interview-questions">
                        Data science interview questions
                      </a>
                    </li>
                    <li>
                      <a href="https://logicmojo.com/highest-paying-jobs-in-india">
                        Highest Paying jobs in india
                      </a>
                    </li>
                    <li>
                      <a href="https://logicmojo.com/python-exception-handling">
                        Exception in Python
                      </a>
                    </li>
                    <li>
                      <a href="https://logicmojo.com/nosql-database">
                        Nosql Database
                      </a>
                    </li>
                    <li>
                      <a href="https://logicmojo.com/mysql-interview-questions">
                        Mysql Interview Questions
                      </a>
                    </li>
                    <li>
                      <a href="https://logicmojo.com/machine-learning-interview-questions">
                        Machine Learning Interview Questions
                      </a>
                    </li>
                    <li>
                      <a href="https://logicmojo.com/kubernetes-interview-questions">
                        Kubernetes Interview Questions
                      </a>
                    </li>
                    <li>
                      <a href="https://logicmojo.com/power-bi-interview-questions">
                        Power Bi Interview Questions
                      </a>
                    </li>
                    <li>
                      <a href="https://logicmojo.com/html-interview-questions">
                        Html Interview Questions
                      </a>
                    </li>
                    <li>
                      <a href="https://logicmojo.com/polymorphism-in-java">
                        Polymorphism In Java
                      </a>
                    </li>
                    <li>
                      <a href="https://logicmojo.com/inline-function-cpp">
                        Inline Function In C++
                      </a>
                    </li>
                    <li>
                      <a href="https://logicmojo.com/operator-overloading-in-cpp">
                        Operator Overloading in c++
                      </a>
                    </li>
                    <li>
                      <a href="https://logicmojo.com/abstract-class-in-java">
                        Abstract Class in Java
                      </a>
                    </li>
                    <li>
                      <a href="https://logicmojo.com/packages-in-java">
                        Packages In Java
                      </a>
                    </li>
                    <li>
                      <a href="https://logicmojo.com/quick-sort-algorithm">
                        Quick Sort Algorithm
                      </a>
                    </li>
                    <li>
                      <a href="https://logicmojo.com/what-is-deep-learning">
                        What is Deep Learning
                      </a>
                    </li>
                    <li>
                      <a href="https://logicmojo.com/spring-Initializr">
                        Spring Initializr
                      </a>
                    </li>
                    <li>
                      <a href="https://logicmojo.com/in-hand-salary-calculator">
                        In Hand Salary Calculator
                      </a>
                    </li>
                    <li>
                      <a href="https://logicmojo.com/sql-query-update">
                        Sql Update Query
                      </a>
                    </li>
                    <li>
                      <a href="https://logicmojo.com/sliding-window-algorithm">
                        Sliding Window Algorithm
                      </a>
                    </li>
                    <li>
                      <a href="https://logicmojo.com/operators-in-c">
                        Operators in C
                      </a>
                    </li>
                    <li>
                      <a href="https://logicmojo.com/index-in-sql">
                        Index in SQL
                      </a>
                    </li>
                    <li>
                      <a href="https://logicmojo.com/cpp-string">C++ String</a>
                    </li>
                    <li>
                      <a href="https://logicmojo.com/hypothesis-testing">
                        Hypothesis Testing
                      </a>
                    </li>
                    <li>
                      <a href="https://logicmojo.com/example-of-AI">
                        Examples of Artificial Intellegence
                      </a>
                    </li>

                    <li>
                      <a href="https://logicmojo.com/data-science-and-artificial-intelligence">
                        Data Science and Artificial Intelligence
                      </a>
                    </li>

                    <li>
                      <a href="https://logicmojo.com/full-stack-developer-salary">
                        Full Stack Developer Salary
                      </a>
                    </li>
                    <li>
                      <a href="https://logicmojo.com/data-analytics-courses">
                        Data Analytics Courses
                      </a>
                    </li>
                    <li>
                      <a href="https://logicmojo.com/full-stack-developer-course">
                        Full Stack Developer Course
                      </a>
                    </li>
                  </ul>
                </div>
              </div>

              <div className="col-lg-3 col-md-6">
                <div className="quicklinks">
                  <ul>
                    <li>
                      <a href="https://logicmojo.com/python-for-loop">
                        Python For Loops
                      </a>
                    </li>
                    <li>
                      <a href="https://logicmojo.com/python-list">
                        Python List
                      </a>
                    </li>
                    <li>
                      <a href="https://logicmojo.com/python-tuple">
                        Python Tuple
                      </a>
                    </li>
                    <li>
                      <a href="https://logicmojo.com/difference-between-compiler-and-interpreter">
                        Compiler Interpreter difference
                      </a>
                    </li>
                    <li>
                      <a href="https://logicmojo.com/dbms-interview-questions">
                        Dbms Interview questions
                      </a>
                    </li>
                    <li>
                      <a href="https://logicmojo.com/c-interview-question">
                        C Interview questions
                      </a>
                    </li>
                    <li>
                      <a href="https://logicmojo.com/types-of-operating-system">
                        Types of operating system
                      </a>
                    </li>
                    <li>
                      <a href="https://logicmojo.com/linked-list-data-structure">
                        LinkedList in Data Structure
                      </a>
                    </li>
                    <li>
                      <a href="https://logicmojo.com/python-data-structures-problems">
                        Python Data Structures
                      </a>
                    </li>
                    <li>
                      <a href="https://logicmojo.com/oops-concepts-in-python">
                        OOPS concepts in Python
                      </a>
                    </li>

                    <li>
                      <a href="https://logicmojo.com/sorting-algorithms">
                        Sorting Algorithms
                      </a>
                    </li>
                    <li>
                      <a href="https://logicmojo.com/array-data-structure">
                        Array data structure
                      </a>
                    </li>
                    <li>
                      <a href="https://logicmojo.com/system-design">
                        System Design
                      </a>
                    </li>
                     <li><a href="https://logicmojo.com/data-science-course">Data Science Course</a></li>  
                    <li>
                      <a href="https://logicmojo.com/collections-in-java">
                        Collections in Java
                      </a>
                    </li>
                    <li>
                      <a href="https://logicmojo.com/artifical-neural-network">
                        Artifical Neural Network
                      </a>
                    </li>
                    <li>
                      <a href="https://logicmojo.com/devops-interview-questions">
                        Devops Interview Questions
                      </a>
                    </li>
                    <li>
                      <a href="https://logicmojo.com/salesforce-interview-questions">
                        Salesforce Interview Questions
                      </a>
                    </li>
                    <li>
                      <a href="https://logicmojo.com/tableau-interview-questions">
                        Tableau Interview Questions
                      </a>
                    </li>
                    <li>
                      <a href="https://logicmojo.com/inheritance-in-java">
                        Inheritance In Java
                      </a>
                    </li>
                    <li>
                      <a href="https://logicmojo.com/constructor-in-cpp">
                        Constructor In C++
                      </a>
                    </li>
                    <li>
                      <a href="https://logicmojo.com/function-overloading-in-cpp">
                        Function Overloading in C++
                      </a>
                    </li>
                    <li>
                      <a href="https://www.logicmojo.com/features-of-java">
                        Features Of Java
                      </a>
                    </li>
                    <li>
                      <a href="https://logicmojo.com/garbage-collection-in-java">
                        Garbage Collection In Java
                      </a>
                    </li>
                    <li>
                      <a href="https://logicmojo.com/how-to-introduce-yourself-in-an-interview">
                        How to Introduce Yourself in an Interview
                      </a>
                    </li>
                    <li>
                      <a href="https://logicmojo.com/include-iostream">
                        Include IOstream
                      </a>
                    </li>
                    <li>
                      <a href="https://logicmojo.com/pointer-in-C">
                        Pointer In C
                      </a>
                    </li>
                    <li>
                      <a href="https://logicmojo.com/datatypes-in-c">
                        Data Types in C
                      </a>
                    </li>
                    <li>
                      <a href="https://logicmojo.com/encapsulation-in-cpp">
                        Encapsulation in c++
                      </a>
                    </li>
                    <li>
                      <a href="https://logicmojo.com/joins-in-sql">Sql Join</a>
                    </li>
                    <li>
                      <a href="https://logicmojo.com/function-in-c">
                        Function in C
                      </a>
                    </li>
                    <li>
                      <a href="https://logicmojo.com/regression-testing">
                        Regression Testing
                      </a>
                    </li>
                    <li>
                      <a href="https://logicmojo.com/correlation-coefficient">
                        Correlation Coefficient
                      </a>
                    </li>
                    <li>
                      <a href="https://logicmojo.com/supervised-and-unsupervised-learning">
                        Supervised and Unsupervised Learning
                      </a>
                    </li>
                    <li>
                      <a href="https://logicmojo.com/data-science-course-fees">
                        Data Science Course Fees
                      </a>
                    </li>
                    <li>
                      <a href="https://logicmojo.com/java-operators">
                        Java operators
                      </a>
                    </li>

                    <li>
                      <a href="https://logicmojo.com/big-data-analytics">
                        Big Data Analytics
                      </a>
                    </li>

                    <li>
                      <a href="https://logicmojo.com/digital-signature">
                        digital-signature
                      </a>
                    </li>
                  </ul>
                </div>
              </div>

              <div className="col-lg-3 col-md-6">
                <div className="quicklinks">
                  <ul></ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
*/}

      <div className="endfooter">
        <div className="container">
          <div className="row">
            <div className="col-lg-12 col-md-12">
              <div className="footerlinks">
                <ul>
                  <li>
                    <a href="https://logicmojo.com/blog">Blogs</a>
                  </li>
                  <li>
                    <a href="#faqs">FAQ</a>
                  </li>
                  <li>
                    <a href="#">Interview</a>
                  </li>
                  <li>
                    <a href="https://logicmojo.com/tips">tips</a>
                  </li>
                  <li>
                    <a href="https://logicmojo.com/about_us">About us</a>
                  </li>
                  <li>
                    <a href="https://logicmojo.com/review">Customer Review</a>
                  </li>
                  <li>
                    <a href="https://logicmojo.com/refund_policy">
                      Return & Refund Policy
                    </a>
                  </li>
                  <li>
                    <a href="https://logicmojo.com/cancellation_policy">
                      Cancellation Policy
                    </a>
                  </li>
                  <li>
                    <a href="https://logicmojo.com/privacy_policy">
                      Privacy Policy
                    </a>
                  </li>
                  <li>
                    <a href="https://logicmojo.com/terms_condition">
                      Terms & Condition
                    </a>
                  </li>
                  <br />
                  <p>Address : Vidya Vikas School Rd, New Kaverappa Layout, Kaverappa Layout, Kadubeesanahalli, Panathur, Bengaluru, Karnataka 560103</p><br />
                  <p>Email: info@logicmojo.com</p>
                </ul>
                <span>
                  ©{" "}
                  <a href="#" className="linkss">
                    Logicmojo.
                  </a>{" "}
                  ALL RIGHTS RESERVED
                </span>{" "}
              </div>
            </div>

            <div className="col-lg-3 col-md-3">
              <div className="livechatdiv">
                {" "}
                <a href="#">
                  <img
                    loading="lazy"
                    src="/react/ai-assets/images//livehcat.png"
                    alt=""
                  />
                </a>{" "}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Home;
